webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accSubtr = exports.accAdd = exports.accMul = exports.accDiv = exports.generateRoutesFromMenu = exports.readFile = exports.showMessage = exports.toFixedNum = exports.isEmpty = exports.parseToDate = exports.compareDate = exports.mGetDate = exports.formatDate = exports.removeLoginInfo = exports.removeStore = exports._getCookie = exports._getAllCookie = exports.getStore = exports._getStore = exports.setStore = undefined;

var _getIterator2 = __webpack_require__(303);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__(81);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

exports.export2Excel = export2Excel;
exports.export2ExcelTitle = export2ExcelTitle;

var _cookie = __webpack_require__(291);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setStore = exports.setStore = function setStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
        content = (0, _stringify2.default)(content);
    }
    window.localStorage.setItem(name, content);
};

var _getStore = exports._getStore = function _getStore(name) {
    if (!name) return null;
    var value = window.localStorage.getItem('userinfo');
    if (value !== null) {
        try {
            var _obj = JSON.parse(value);
            if ((typeof _obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(_obj)) == 'object') {
                for (var key in _obj) {
                    if (name == key) {
                        return _obj[key];
                    }
                }
            } else return _obj;
        } catch (e) {
            return obj;
        }
    }
    return null;
};
var getStore = exports.getStore = function getStore(name) {
    if (!name) return;
    var value = window.localStorage.getItem(name);
    if (value !== null) {
        try {
            value = JSON.parse(value);
        } catch (e) {
            value = value;
        }
    }
    return value;
};
var _getAllCookie = exports._getAllCookie = function _getAllCookie() {
    var value = (0, _cookie.getCookie)("zbt_");
    return value;
};
var _getCookie = exports._getCookie = function _getCookie(name) {
    if (!name) return;
    var value = (0, _cookie.getCookie)("zbt_");
    if (value) {
        value = value.split(',');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var i = _step.value;

                if (i.indexOf(name) != -1) {
                    return i.split(':')[1];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return null;
};
var removeStore = exports.removeStore = function removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
};

var removeLoginInfo = exports.removeLoginInfo = function removeLoginInfo() {
    localStorage.removeItem('userinfo');
    localStorage.removeItem('menuData');
    (0, _cookie.delCookie)("zbt_");
};

var formatDate = exports.formatDate = function formatDate(date, type) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    var milliseconds = date.getMilliseconds() < 10 ? "0" + date.getMilliseconds() : date.getMilliseconds();
    if (type == 1) {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds + "." + milliseconds;
    } else if (type == 2) {
        return year + "" + month + "" + day + "" + hour + "" + minutes + "" + seconds;
    } else if (type == 3) {
        return year + "-" + month + "-" + day;
    } else {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    }
};
var mGetDate = exports.mGetDate = function mGetDate(year, month) {
    var d = new Date(year, month, 0);
    return d.getDate();
};
var compareDate = exports.compareDate = function compareDate(date1, date2) {
    date1 = date1.toString();
    date2 = date2.toString();
    var arys1 = new Array();
    var arys2 = new Array();
    if (date1 != null && date2 != null) {
        arys1 = date1.split('/');
        var time1 = parseInt(arys1[0] + arys1[1] + arys1[2]);
        arys2 = date2.split('-');
        var time2 = parseInt(arys2[0] + arys2[1] + arys2[2]);
        if (time1 > time2) {
            return false;
        } else {
            return true;
        }
    }
};
var parseToDate = exports.parseToDate = function parseToDate(timeValue) {
    var result = "";
    var year = timeValue.substr(0, 4);
    var month = timeValue.substr(4, 2);
    var date = timeValue.substr(6, 2);
    var hour = timeValue.substr(8, 2);
    var minute = timeValue.substr(10, 2);
    var second = timeValue.substr(12, 2);
    result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    return result;
};
function export2Excel(columns, list, listName) {
    __webpack_require__.e/* require.ensure */(0).then((function () {
        var _require = __webpack_require__(494),
            export_json_to_excel = _require.export_json_to_excel;

        var tHeader = [];
        var filterVal = [];

        if (!columns) {
            return;
        }
        columns.forEach(function (item) {
            tHeader.push(item.title);
            filterVal.push(item.key);
        });
        var data = list.map(function (v) {
            return filterVal.map(function (j) {
                return v[j];
            });
        });
        export_json_to_excel(tHeader, data, listName);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}
function export2ExcelTitle(columns, list, listName) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
        var _require2 = __webpack_require__(494),
            export_json_to_excel = _require2.export_json_to_excel;

        var tHeader = [];
        var filterVal = [];
        var titleList = [];
        if (!columns) {
            return;
        }

        columns.forEach(function (item) {

            titleList.push(item.title);
            filterVal.push(item.key);
        });
        var data = list.map(function (v) {
            return filterVal.map(function (j) {
                return v[j];
            });
        });
        tHeader = data[0];
        data.splice(0, 1);

        export_json_to_excel(tHeader, data, listName);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}
var isEmpty = exports.isEmpty = function isEmpty(keys) {
    if (typeof keys === "string") {
        keys = keys.replace(/\"|&nbsp;|\\/g, '').replace(/(^\s*)|(\s*$)/g, "");
        if (keys == "" || keys == null || keys == "null" || keys === "undefined") {
            return true;
        } else {
            return false;
        }
    } else if (typeof keys === "undefined") {
        return true;
    } else if (typeof keys === "number") {
        return false;
    } else if (typeof keys === "boolean") {
        return false;
    } else if ((typeof keys === 'undefined' ? 'undefined' : (0, _typeof3.default)(keys)) == "object") {
        if ((0, _stringify2.default)(keys) == "{}") {
            return true;
        } else if (keys == null) {
            return true;
        } else {
            return false;
        }
    }

    if (keys instanceof Array && keys.length == 0) {
        return true;
    }
};

var toFixedNum = exports.toFixedNum = function toFixedNum(num) {
    var tonum = Number(num).toFixed(2);
    return tonum;
};

var showMessage = exports.showMessage = function showMessage() {
    undefined.$message({
        showClose: true,
        message: '对不起，您暂无此操作权限~',
        type: 'success'
    });
};

var readFile = exports.readFile = function readFile(file) {
    if (!/image\/\w+/.test(file.raw.type)) {
        alert("只能选择图片");
        return false;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        var filedata = {
            filename: file.name,
            filebase64: e.target.result
        };
        alert(e.target.result);
    };
};

var generateRoutesFromMenu = exports.generateRoutesFromMenu = function generateRoutesFromMenu() {
    var menuData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var componentNew = arguments[2];

    for (var i = 0; i < menuData.length; i++) {
        var menuobj = menuData[i];
        var component = menuData[i].component;
        if (component && component !== 'content') {
            componentNew = __webpack_require__(1312)("./" + menuData[i].component + '.vue');
        } else {
            componentNew = __webpack_require__(1311)("./" + menuData[i].component + '.vue');
        }
        menuobj['component'] = componentNew;
        routes.push(menuobj);
        generateRoutesFromMenu(menuobj.children);
    }
    return routes;
};
var accDiv = exports.accDiv = function accDiv(arg1, arg2) {
    var t1 = 0,
        t2 = 0,
        r1,
        r2;
    try {
        t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
        t2 = arg2.toString().split(".")[1].length;
    } catch (e) {}

    r1 = Number(arg1.toString().replace(".", ""));

    r2 = Number(arg2.toString().replace(".", ""));
    return r1 / r2 * Math.pow(10, t2 - t1);
};
var accMul = exports.accMul = function accMul(arg1, arg2) {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length;
    } catch (e) {}
    try {
        m += s2.split(".")[1].length;
    } catch (e) {}
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
};
var accAdd = exports.accAdd = function accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
};
var accSubtr = exports.accSubtr = function accSubtr(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));

    n = r1 >= r2 ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.axios = undefined;

var _axios = __webpack_require__(595);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.axios = _axios2.default;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOrderList = getOrderList;
exports.getOrderInfo = getOrderInfo;
exports.uploadOrderInfo = uploadOrderInfo;
exports.getStoreList = getStoreList;
exports.getStoreListProduct = getStoreListProduct;
exports.updateOrderTotal = updateOrderTotal;
exports.updateBox = updateBox;
exports.createOrder = createOrder;
exports.cancelOrder = cancelOrder;
exports.sendOrder = sendOrder;
exports.sendOrderList = sendOrderList;
exports.sendSerOrders = sendSerOrders;
exports.sendPreviewOrders = sendPreviewOrders;
exports.getNowDate = getNowDate;
exports.searchOrderByExpress = searchOrderByExpress;
exports.updateOrderExpress = updateOrderExpress;
exports.orderSupplement = orderSupplement;
exports.supplementOrder = supplementOrder;
exports.getSendOrderInfo = getSendOrderInfo;
exports.updateExtraInfo = updateExtraInfo;
exports.updateDelivery = updateDelivery;
exports.getFeedbackList = getFeedbackList;
exports.getSelectBatchList = getSelectBatchList;
exports.exportOutCountryOrder = exportOutCountryOrder;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOrderList(data) {
    return (0, _request2.default)({
        url: '/order/list',
        method: 'post',
        data: data
    });
}
function getOrderInfo(data) {
    return (0, _request2.default)({
        url: '/order/orderInfo',
        method: 'post',
        data: data
    });
}
function uploadOrderInfo(data) {
    return (0, _request2.default)({
        url: '/order/update',
        method: 'post',
        data: data
    });
}
function getStoreList(data) {
    return (0, _request2.default)({
        url: '/order/store/list',
        method: 'post',
        data: data
    });
}
function getStoreListProduct(data) {
    return (0, _request2.default)({
        url: '/order/store/products',
        method: 'post',
        data: data
    });
}
function updateOrderTotal(data) {
    return (0, _request2.default)({
        url: '/order/updateOrderTotal',
        method: 'post',
        data: data
    });
}
function updateBox(data) {
    return (0, _request2.default)({
        url: '/order/updateBox',
        method: 'post',
        data: data
    });
}

function createOrder(data) {
    return (0, _request2.default)({
        url: '/order/createOrder',
        method: 'post',
        data: data
    });
}
function cancelOrder(data) {
    return (0, _request2.default)({
        url: '/order/cancelOrder',
        method: 'post',
        data: data
    });
}
function sendOrder(data) {
    return (0, _request2.default)({
        url: '/send/order',
        method: 'post',
        data: data
    });
}
function sendOrderList(data) {
    return (0, _request2.default)({
        url: '/send/orderList',
        method: 'post',
        data: data
    });
}
function sendSerOrders(data) {
    return (0, _request2.default)({
        url: '/send/userOrders',
        method: 'post',
        data: data
    });
}
function sendPreviewOrders(data) {
    return (0, _request2.default)({
        url: '/send/previewOrders',
        method: 'post',
        data: data
    });
}
function getNowDate(data) {
    return (0, _request2.default)({
        url: '/system/date',
        method: 'post',
        data: data
    });
}

function searchOrderByExpress(data) {
    return (0, _request2.default)({
        url: '/order/searchOrderByExpress',
        method: 'post',
        data: data
    });
}

function updateOrderExpress(data) {
    return (0, _request2.default)({
        url: '/order/updateOrderExpress',
        method: 'post',
        data: data
    });
}

function orderSupplement(data) {
    return (0, _request2.default)({
        url: '/order/supplement',
        method: 'post',
        data: data
    });
}

function supplementOrder(data) {
    return (0, _request2.default)({
        url: '/order/supplementOrder',
        method: 'post',
        data: data
    });
}

function getSendOrderInfo(data) {
    return (0, _request2.default)({
        url: '/send/getSendOrderInfo',
        method: 'post',
        data: data
    });
}

function updateExtraInfo(data) {
    return (0, _request2.default)({
        url: '/send/updateExtraInfo',
        method: 'post',
        data: data
    });
}

function updateDelivery(data) {
    return (0, _request2.default)({
        url: '/delivery/updateDelivery',
        method: 'post',
        data: data
    });
}

function getFeedbackList(data) {
    return (0, _request2.default)({
        url: 'wx/delivery/getDeliveryInfo',
        method: 'post',
        data: data
    });
}

function getSelectBatchList(data) {
    return (0, _request2.default)({
        url: '/send/batchNumber',
        method: 'post',
        data: data
    });
}

function exportOutCountryOrder(data) {
    return (0, _request2.default)({
        url: '/order/export',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(304);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(197);

var _axios2 = _interopRequireDefault(_axios);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _index = __webpack_require__(292);

var _index2 = _interopRequireDefault(_index);

var _elementUi = __webpack_require__(293);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var service = _axios2.default.create({
  baseURL: "https://admin.shhfxd.com/api/" + 'v1',
  timeout: 60000 });

service.interceptors.request.use(function (config) {

  config.headers = {
    'Authorization': mUtils.getStore("token"),
    'Content-Type': 'application/json; charset=UTF-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Method': 'POST,GET',
    'dataType': 'jsonp'
  };
  return config;
}, function (error) {
  console.log('error=====>', error);
  _promise2.default.reject(error);
});

service.interceptors.response.use(function (response) {
  var that = undefined;
  var res = response.data;

  if (response.headers.authorization) {
    if (mUtils.getStore('zm')) {
      if (mUtils.getStore('token')) {
        mUtils.removeStore('token');

        mUtils.setStore('token', response.headers.authorization);
      } else {
        mUtils.setStore('token', response.headers.authorization);
      }
    } else {
      if (mUtils.getStore('token')) {
        mUtils.removeStore('token');

        mUtils.setStore('token', response.headers.authorization);
      } else {
        mUtils.setStore('token', response.headers.authorization);
      }
    }
  }
  return response;
}, function (error) {
  return _promise2.default.reject(error);
});

exports.default = service;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deliveryList = deliveryList;
exports.deliveryAdd = deliveryAdd;
exports.deliveryUpdate = deliveryUpdate;
exports.deleteDeliverP = deleteDeliverP;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deliveryList(data) {
    return (0, _request2.default)({
        url: '/delivery/list',
        method: 'post',
        data: data
    });
}

function deliveryAdd(data) {
    return (0, _request2.default)({
        url: '/delivery/add',
        method: 'post',
        data: data
    });
}

function deliveryUpdate(data) {
    return (0, _request2.default)({
        url: '/delivery/update',
        method: 'post',
        data: data
    });
}

function deleteDeliverP(data) {
    return (0, _request2.default)({
        url: '/delivery/delete',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1126)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1218),
  /* scopeId */
  "data-v-02f536d4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAppointList = getAppointList;
exports.timeList = timeList;
exports.deliveryList = deliveryList;
exports.comfirmBt = comfirmBt;
exports.cancelBt = cancelBt;
exports.cancelTime = cancelTime;
exports.getSettlementSheet = getSettlementSheet;
exports.confirmSettlement = confirmSettlement;
exports.getDeliveryList = getDeliveryList;
exports.updateDelivery = updateDelivery;
exports.getFeedbackList = getFeedbackList;
exports.postDeliveryFeedback = postDeliveryFeedback;
exports.mulOutStoreToPay = mulOutStoreToPay;
exports.deliverMulOutStoreToPay = deliverMulOutStoreToPay;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAppointList(data) {
    return (0, _request2.default)({
        url: '/appoint/appointList',
        method: 'post',
        data: data
    });
}
function timeList(data) {
    return (0, _request2.default)({
        url: '/appoint/list',
        method: 'post',
        data: data
    });
}
function deliveryList(data) {
    return (0, _request2.default)({
        url: '/delivery/list',
        method: 'post',
        data: data
    });
}
function comfirmBt(data) {
    return (0, _request2.default)({
        url: '/appoint/determine',
        method: 'post',
        data: data
    });
}
function cancelBt(data) {
    return (0, _request2.default)({
        url: '/appoint/cancel',
        method: 'post',
        data: data
    });
}
function cancelTime(data) {
    return (0, _request2.default)({
        url: '/appoint/cancelPeriod',
        method: 'post',
        data: data
    });
}
function getSettlementSheet(data) {
    return (0, _request2.default)({
        url: '/appoint/appointSendDetail',
        method: 'post',
        data: data
    });
}
function confirmSettlement(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/settlementBySendId',
        method: 'post',
        data: data
    });
}
function getDeliveryList(data) {
    return (0, _request2.default)({
        url: '/delivery/deliveryList',
        method: 'post',
        data: data
    });
}
function updateDelivery(data) {
    return (0, _request2.default)({
        url: '/delivery/updateDelivery',
        method: 'post',
        data: data
    });
}
function getFeedbackList(data) {
    return (0, _request2.default)({
        url: '/delivery/getFeedbackList',
        method: 'post',
        data: data
    });
}
function postDeliveryFeedback(data) {
    return (0, _request2.default)({
        url: '/delivery/deliveryFeedback',
        method: 'post',
        data: data
    });
}

function mulOutStoreToPay(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/batchSettlementBySendId',
        method: 'post',
        data: data
    });
}

function deliverMulOutStoreToPay(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/batchConfirmSettlement',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.addDay = addDay;
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

function addDay(dateTemp, days) {
  var dateTemp = dateTemp.split("-");
  var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]);
  var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
  var rDate = new Date(millSeconds);
  var year = rDate.getFullYear();
  var month = rDate.getMonth() + 1;
  if (month < 10) month = "0" + month;
  var date = rDate.getDate();
  if (date < 10) date = "0" + date;
  return year + "-" + month + "-" + date;
}

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.combinedBox = combinedBox;
exports.boxList = boxList;
exports.boxDelivery = boxDelivery;
exports.boxDetails = boxDetails;
exports.faceSheet = faceSheet;
exports.allocationCentrePut = allocationCentrePut;
exports.allocationCentreInformation = allocationCentreInformation;
exports.settlementSheet = settlementSheet;
exports.setReservation = setReservation;
exports.confirmSettlement = confirmSettlement;
exports.deliverOutTopay = deliverOutTopay;
exports.volumeDelivery = volumeDelivery;
exports.cancelBox = cancelBox;
exports.multiIntoStore = multiIntoStore;
exports.mulIntoStore = mulIntoStore;
exports.mulOutStoreToPay = mulOutStoreToPay;
exports.excelBatchBoxing = excelBatchBoxing;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function combinedBox(data) {
    return (0, _request2.default)({
        url: '/box/combinedBox',
        method: 'post',
        data: data
    });
}

function boxList(data) {
    return (0, _request2.default)({
        url: '/box/boxList',
        method: 'post',
        data: data
    });
}

function boxDelivery(data) {
    return (0, _request2.default)({
        url: '/box/delivery',
        method: 'post',
        data: data
    });
}

function boxDetails(data) {
    return (0, _request2.default)({
        url: '/box/boxDetails',
        method: 'post',
        data: data
    });
}

function faceSheet(data) {
    return (0, _request2.default)({
        url: '/box/faceSheet',
        method: 'post',
        data: data
    });
}

function allocationCentrePut(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/put',
        method: 'post',
        data: data
    });
}

function allocationCentreInformation(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/information',
        method: 'post',
        data: data
    });
}

function settlementSheet(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/settlementSheet',
        method: 'post',
        data: data
    });
}
function setReservation(data) {
    return (0, _request2.default)({
        url: '/appoint/reservation',
        method: 'post',
        data: data
    });
}

function confirmSettlement(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/confirmSettlement',
        method: 'post',
        data: data
    });
}

function deliverOutTopay(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/batchConfirmSettlement',
        method: 'post',
        data: data
    });
}

function volumeDelivery(data) {
    return (0, _request2.default)({
        url: '/box/volumeDelivery',
        method: 'post',
        data: data
    });
}
function cancelBox(data) {
    return (0, _request2.default)({
        url: '/box/unPacking',
        method: 'post',
        data: data
    });
}

function multiIntoStore(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/batchPut',
        method: 'post',
        data: data
    });
}

function mulIntoStore(data) {
    return (0, _request2.default)({
        url: '/box/batchEnter',
        method: 'post',
        data: data
    });
}

function mulOutStoreToPay(data) {
    return (0, _request2.default)({
        url: '/allocationCentre/batchSettlementBySendId',
        method: 'post',
        data: data
    });
}

function excelBatchBoxing(file) {
    var formData = new FormData();
    formData.append('file', file);

    return (0, _request2.default)({
        url: '/box/excelBatchBoxing',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
var goodType = exports.goodType = function goodType(type) {
   var str = "";
   switch (type) {
      case 1:
         str = "海运";
         break;
      case 2:
         str = "海运大件";
         break;
      case 3:
         str = "空运";
         break;
   }
   return str;
};

var orderStatus = exports.orderStatus = function orderStatus(status) {
   var str = "";
   switch (status) {
      case 1:
         str = "待入库";
         break;
      case 2:
         str = "已入库";
         break;
      case 3:
         str = "已出库";
         break;
      case 4:
         str = "已结单";
         break;
      case -1:
         str = "已取消";
         break;
      case 7:
         str = "（分拨）已入库";
         break;
      case 8:
         str = "（分拨）已出库";
         break;
      case 9:
         str = "（派送）已入库";
         break;
   }
   return str;
};

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAccountList = getAccountList;
exports.upDateAccountList = upDateAccountList;
exports.addAccountList = addAccountList;
exports.getRateList = getRateList;
exports.updateRate = updateRate;
exports.getUesrBalance = getUesrBalance;
exports.getVipCode = getVipCode;
exports.deposit = deposit;
exports.adjustBalance = adjustBalance;
exports.getDiscount = getDiscount;
exports.updateDis = updateDis;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAccountList(data) {
    return (0, _request2.default)({
        url: '/account/list',
        method: 'post',
        data: data
    });
}

function upDateAccountList(data) {
    return (0, _request2.default)({
        url: '/account/update',
        method: 'post',
        data: data
    });
}

function addAccountList(data) {
    return (0, _request2.default)({
        url: '/account/add',
        method: 'post',
        data: data
    });
}
function getRateList(data) {
    return (0, _request2.default)({
        url: '/rate/list',
        method: 'post',
        data: data
    });
}
function updateRate(data) {
    return (0, _request2.default)({
        url: '/rate/update',
        method: 'post',
        data: data
    });
}
function getUesrBalance(data) {
    return (0, _request2.default)({
        url: '/userBalance/list',
        method: 'post',
        data: data
    });
}
function getVipCode(data) {
    return (0, _request2.default)({
        url: '/user/selectByCode',
        method: 'post',
        data: data
    });
}
function deposit(data) {
    return (0, _request2.default)({
        url: '/userBalance/deposit',
        method: 'post',
        data: data
    });
}
function adjustBalance(data) {
    return (0, _request2.default)({
        url: '/userBalance/adjustBalance',
        method: 'post',
        data: data
    });
}
function getDiscount(data) {
    return (0, _request2.default)({
        url: '/discount/show',
        method: 'post',
        data: data
    });
}
function updateDis(data) {
    return (0, _request2.default)({
        url: '/discount/update',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPrice = getPrice;
exports.updatePrice = updatePrice;
exports.expressList = expressList;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPrice(data) {
    return (0, _request2.default)({
        url: '/common/systemPrice',
        method: 'post',
        data: data
    });
}
function updatePrice(data) {
    return (0, _request2.default)({
        url: '/common/updatePrice',
        method: 'post',
        data: data
    });
}
function expressList(data) {
    return (0, _request2.default)({
        url: '/common/expressList',
        method: 'get',
        data: data
    });
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.upload = upload;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function upload(data) {
    return (0, _request2.default)({
        url: '/file/upload',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateStore = updateStore;
exports.getStore = getStore;
exports.getStoreList = getStoreList;
exports.storeAdd = storeAdd;
exports.storeUpdate = storeUpdate;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateStore(data) {
    return (0, _request2.default)({
        url: '/common/updateStore',
        method: 'post',
        data: data
    });
}
function getStore(data) {
    return (0, _request2.default)({
        url: '/common/getStore',
        method: 'post',
        data: data
    });
}

function getStoreList(data) {
    return (0, _request2.default)({
        url: '/store/list',
        method: 'post',
        data: data
    });
}

function storeAdd(data) {
    return (0, _request2.default)({
        url: '/store/add',
        method: 'post',
        data: data
    });
}

function storeUpdate(data) {
    return (0, _request2.default)({
        url: '/store/update',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAdminList = getAdminList;
exports.adminAdd = adminAdd;
exports.adminDelete = adminDelete;
exports.updatePwd = updatePwd;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAdminList(data) {
    return (0, _request2.default)({
        url: '/web/admin/list',
        method: 'post',
        data: data
    });
}

function adminAdd(data) {
    return (0, _request2.default)({
        url: '/web/admin/add',
        method: 'post',
        data: data
    });
}

function adminDelete(data) {
    return (0, _request2.default)({
        url: '/web/admin/delete',
        method: 'post',
        data: data
    });
}
function updatePwd(data) {
    return (0, _request2.default)({
        url: '/web/admin/updatePwd',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.agreementInfo = agreementInfo;
exports.add = add;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function agreementInfo(data) {
    return (0, _request2.default)({
        url: '/agree/agreementInfo',
        method: 'post',
        data: data
    });
}

function add(data) {
    return (0, _request2.default)({
        url: '/agree/add',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCustomerList = getCustomerList;
exports.updateUserInfo = updateUserInfo;
exports.del = del;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCustomerList(data) {
    return (0, _request2.default)({
        url: '/user/list',
        method: 'post',
        data: data
    });
}

function updateUserInfo(data) {
    return (0, _request2.default)({
        url: '/user/updateUserInfo',
        method: 'post',
        data: data
    });
}

function del(data) {
    return (0, _request2.default)({
        url: '/user/delete',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = debounce;
function debounce(fn, delay, isImmediate) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    if (isImmediate && timer === null) {
      fn.apply(context, args);
      timer = 0;
      return;
    }
    timer = setTimeout(function () {
      fn.apply(context, args);
      timer = null;
    }, delay);
  };
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.goodList = goodList;
exports.add = add;
exports.del = del;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function goodList(data) {
    return (0, _request2.default)({
        url: '/good/list',
        method: 'post',
        data: data
    });
}

function add(data) {
    return (0, _request2.default)({
        url: '/good/add',
        method: 'post',
        data: data
    });
}
function del(data) {
    return (0, _request2.default)({
        url: '/good/del',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getWayBillList = getWayBillList;
exports.getCustomerList = getCustomerList;
exports.getUserBalance = getUserBalance;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWayBillList(data) {
    return (0, _request2.default)({
        url: '/report/order',
        method: 'post',
        data: data
    });
}

function getCustomerList(data) {
    return (0, _request2.default)({
        url: '/user/select/list',
        method: 'post',
        data: data
    });
}

function getUserBalance(data) {
    return (0, _request2.default)({
        url: '/report/balance',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function getDPI() {
	var arrDPI = new Array();
	if (window.screen.deviceXDPI) {
		arrDPI[0] = window.screen.deviceXDPI;
		arrDPI[1] = window.screen.deviceYDPI;
	} else {
		var tmpNode = document.createElement("DIV");
		tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
		document.body.appendChild(tmpNode);
		arrDPI[0] = parseInt(tmpNode.offsetWidth);
		arrDPI[1] = parseInt(tmpNode.offsetHeight);
		tmpNode.parentNode.removeChild(tmpNode);
	}
	return arrDPI;
}

function pxToMm(value) {
	var inch = value / getDPI()[0];
	var c_value = inch * 25.4;
	return c_value;
};
var mmToPx = exports.mmToPx = function mmToPx(value) {
	var inch = value / 25.4;
	var c_value = inch * getDPI()[0];
	return c_value;
};

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1143)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1181)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1259),
  /* scopeId */
  "data-v-b5c11994",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.delCookie = delCookie;
function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) c_end = document.cookie.length;
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return null;
}

function delCookie(c_name) {
    setCookie(c_name, "", -1);
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1269);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _login = __webpack_require__(437);

var _login2 = _interopRequireDefault(_login);

var _ = __webpack_require__(283);

var _2 = _interopRequireDefault(_);

var _orderList = __webpack_require__(442);

var _orderList2 = _interopRequireDefault(_orderList);

var _addOrder = __webpack_require__(438);

var _addOrder2 = _interopRequireDefault(_addOrder);

var _repertoryList = __webpack_require__(453);

var _repertoryList2 = _interopRequireDefault(_repertoryList);

var _goOutList = __webpack_require__(452);

var _goOutList2 = _interopRequireDefault(_goOutList);

var _priceContort = __webpack_require__(435);

var _priceContort2 = _interopRequireDefault(_priceContort);

var _houserAddress = __webpack_require__(434);

var _houserAddress2 = _interopRequireDefault(_houserAddress);

var _adminList = __webpack_require__(444);

var _adminList2 = _interopRequireDefault(_adminList);

var _customerList = __webpack_require__(446);

var _customerList2 = _interopRequireDefault(_customerList);

var _agree = __webpack_require__(456);

var _agree2 = _interopRequireDefault(_agree);

var _notice = __webpack_require__(457);

var _notice2 = _interopRequireDefault(_notice);

var _dispatchList = __webpack_require__(441);

var _dispatchList2 = _interopRequireDefault(_dispatchList);

var _dispatchList3 = __webpack_require__(422);

var _dispatchList4 = _interopRequireDefault(_dispatchList3);

var _workOrderList = __webpack_require__(459);

var _workOrderList2 = _interopRequireDefault(_workOrderList);

var _workOrderRemark = __webpack_require__(460);

var _workOrderRemark2 = _interopRequireDefault(_workOrderRemark);

var _priceGoods = __webpack_require__(436);

var _priceGoods2 = _interopRequireDefault(_priceGoods);

var _checkExpress = __webpack_require__(440);

var _checkExpress2 = _interopRequireDefault(_checkExpress);

var _list = __webpack_require__(424);

var _list2 = _interopRequireDefault(_list);

var _list3 = __webpack_require__(458);

var _list4 = _interopRequireDefault(_list3);

var _order = __webpack_require__(426);

var _order2 = _interopRequireDefault(_order);

var _orderList3 = __webpack_require__(427);

var _orderList4 = _interopRequireDefault(_orderList3);

var _deliveryList = __webpack_require__(421);

var _deliveryList2 = _interopRequireDefault(_deliveryList);

var _fastIn = __webpack_require__(423);

var _fastIn2 = _interopRequireDefault(_fastIn);

var _newCustomer = __webpack_require__(425);

var _newCustomer2 = _interopRequireDefault(_newCustomer);

var _list5 = __webpack_require__(430);

var _list6 = _interopRequireDefault(_list5);

var _order3 = __webpack_require__(431);

var _order4 = _interopRequireDefault(_order3);

var _fastInStorage = __webpack_require__(429);

var _fastInStorage2 = _interopRequireDefault(_fastInStorage);

var _outStorage = __webpack_require__(432);

var _outStorage2 = _interopRequireDefault(_outStorage);

var _account = __webpack_require__(447);

var _account2 = _interopRequireDefault(_account);

var _flows = __webpack_require__(450);

var _flows2 = _interopRequireDefault(_flows);

var _charge = __webpack_require__(449);

var _charge2 = _interopRequireDefault(_charge);

var _adjust = __webpack_require__(448);

var _adjust2 = _interopRequireDefault(_adjust);

var _rate = __webpack_require__(451);

var _rate2 = _interopRequireDefault(_rate);

var _boxOrderList = __webpack_require__(439);

var _boxOrderList2 = _interopRequireDefault(_boxOrderList);

var _demo = __webpack_require__(428);

var _demo2 = _interopRequireDefault(_demo);

var _face = __webpack_require__(433);

var _face2 = _interopRequireDefault(_face);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{ path: '/404', name: 'page404', component: _2.default }, {
	path: '/',
	name: '登录',
	component: _login2.default,
	meta: {
		title: '后台系统-登录',
		navHidden: true
	}
}, {
	path: '/face',
	name: '面单',
	component: _face2.default,
	meta: {
		title: '面单',
		navHidden: true
	}
}, {
	path: '/',
	name: '订单列表',
	component: __webpack_require__(52),
	redirect: '/orderList',
	children: [{
		path: '/orderList',
		name: '订单列表',
		component: _orderList2.default
	}, {
		path: '/addOrder',
		name: '创建订单',
		component: _addOrder2.default
	}, {
		path: '/dispathchList',
		name: '发货单',
		component: _dispatchList2.default
	}, {
		path: '/demo',
		name: '发货单',
		component: _demo2.default
	}, {
		path: '/order/box',
		name: '合箱列表',
		component: _boxOrderList2.default
	}]
}, {
	path: '/',
	name: '货运',
	component: __webpack_require__(52),
	redirect: '/priceContort',
	children: [{
		path: '/priceContort',
		name: '价格管理',
		component: _priceContort2.default
	}, {
		path: '/houserAddress',
		name: '仓库地址',
		component: _houserAddress2.default
	}, {
		path: '/priceGoods',
		name: '货物价格',
		component: _priceGoods2.default
	}, {
		path: '/checkExpress',
		name: '快递收货',
		component: _checkExpress2.default
	}, {
		path: '/transport/list',
		name: '货运管理',
		component: _list4.default
	}]
}, {
	path: '/',
	name: '库存',
	component: __webpack_require__(52),
	redirect: '/repertoryList',
	children: [{
		path: '/repertoryList',
		name: '库存列表',
		component: _repertoryList2.default
	}, {
		path: '/goOutList',
		name: '出入记录',
		component: _goOutList2.default
	}]
}, {
	path: '/',
	name: '派送',
	component: __webpack_require__(52),
	redirect: '/delivery/list',
	children: [{
		path: '/delivery/list',
		name: '地址配置',
		component: _list2.default
	}, {
		path: '/delivery/order',
		name: '物流管理',
		component: _order2.default
	}, {
		path: '/delivery/order/list',
		name: '订单管理',
		component: _orderList4.default
	}, {
		path: '/delivery/deliveryList',
		name: '派送列表',
		component: _deliveryList2.default
	}, {
		path: '/delivery/fastIn',
		name: '扫码入库',
		component: _fastIn2.default
	}, {
		path: '/delivery/fastIn',
		name: '扫码入库',
		component: _fastIn2.default
	}, {
		path: '/delivery/dispathchList',
		name: '发货单',
		component: _dispatchList4.default
	}, {
		path: '/delivery/newCustomer',
		name: '客户列表',
		component: _newCustomer2.default
	}]
}, {
	path: '/',
	name: '中心仓库',
	component: __webpack_require__(52),
	redirect: '/distribution/list',
	children: [{
		path: '/distribution/list',
		name: '中心仓库管理',
		component: _list6.default
	}, {
		path: '/distribution/order',
		name: '物流管理',
		component: _order4.default
	}, {
		path: '/distribution/fastInStorage',
		name: '扫码入库',
		component: _fastInStorage2.default
	}, {
		path: '/distribution/outStorage',
		name: '扫码出库',
		component: _outStorage2.default
	}]
}, {
	path: '/',
	name: '充值',
	component: __webpack_require__(52),
	redirect: '/recharge/account',
	children: [{
		path: '/recharge/account',
		name: '财务账号',
		component: _account2.default
	}, {
		path: '/recharge/Flows',
		name: '财务流动',
		component: _flows2.default
	}, {
		path: '/recharge/Charge',
		name: '充值',
		component: _charge2.default
	}, {
		path: '/recharge/Adjust',
		name: '调账',
		component: _adjust2.default
	}, {
		path: '/recharge/rate',
		name: '汇率',
		component: _rate2.default
	}]
}, {
	path: '/',
	name: '设置',
	component: __webpack_require__(52),
	redirect: '/system/agree',
	children: [{
		path: '/system/agree',
		name: '协议条款',
		component: _agree2.default
	}, {
		path: '/system/notice',
		name: '首页公告',
		component: _notice2.default
	}]
}, {
	path: '/',
	name: '人员',
	component: __webpack_require__(52),
	redirect: '/adminList',
	children: [{
		path: '/adminList',
		name: '员工列表',
		component: _adminList2.default
	}, {
		path: '/customerList',
		name: '客户列表',
		component: _customerList2.default
	}, {
		path: '/announcement',
		name: '通知公告',
		component: __webpack_require__(445)
	}, {
		path: '/announcement/newOrEdit',
		name: '通知公告',
		component: __webpack_require__(443)
	}]
}, {
	path: '/',
	name: '工单',
	component: __webpack_require__(52),
	redirect: '/workOrderList',
	children: [{
		path: '/workOrderList',
		name: '工单列表',
		component: _workOrderList2.default
	}, {
		path: '/workOrderRemark',
		name: '工单须知',
		component: _workOrderRemark2.default
	}]
}, {
	path: '/',
	name: '统计',
	component: __webpack_require__(52),
	redirect: '/statistical/runningWater',
	children: [{
		path: '/statistical/wayBill',
		name: '运单',
		component: __webpack_require__(455)
	}, {
		path: '/statistical/cost',
		name: '费用',
		component: __webpack_require__(454)
	}]
}];

exports.default = new _vueRouter2.default({
	routes: routes,
	strict: "production" !== 'production'
});

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.webLogin = webLogin;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function webLogin(data) {
    return (0, _request2.default)({
        url: '/login/index',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.demandList = demandList;
exports.agreementInfo = agreementInfo;
exports.add = add;
exports.check = check;
exports.update = update;
exports.demandFeedback = demandFeedback;
exports.demandFeedbackList = demandFeedbackList;

var _request = __webpack_require__(32);

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function demandList(data) {
    return (0, _request2.default)({
        url: '/demand/list',
        method: 'post',
        data: data
    });
}

function agreementInfo(data) {
    return (0, _request2.default)({
        url: '/agree/agreementInfo',
        method: 'post',
        data: data
    });
}
function add(data) {
    return (0, _request2.default)({
        url: '/agree/add',
        method: 'post',
        data: data
    });
}
function check(data) {
    return (0, _request2.default)({
        url: '/demand/check',
        method: 'post',
        data: data
    });
}
function update(data) {
    return (0, _request2.default)({
        url: '/demand/update',
        method: 'post',
        data: data
    });
}

function demandFeedback(data) {
    return (0, _request2.default)({
        url: '/web/demand/add',
        method: 'post',
        data: data
    });
}

function demandFeedbackList(data) {
    return (0, _request2.default)({
        url: '/web/demand/demandFeedbackList',
        method: 'post',
        data: data
    });
}

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1171)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1252),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1170)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1251),
  /* scopeId */
  "data-v-6e69bf84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1151)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1238),
  /* scopeId */
  "data-v-4a23240a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1163)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1246),
  /* scopeId */
  "data-v-5ebb18ed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1168)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1249),
  /* scopeId */
  "data-v-67c95b73",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1179)
__webpack_require__(1178)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1257),
  /* scopeId */
  "data-v-9adad8c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1174)
__webpack_require__(1173)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1254),
  /* scopeId */
  "data-v-79b51fd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1125)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1217),
  /* scopeId */
  "data-v-021a9833",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1133)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1223),
  /* scopeId */
  "data-v-1da3c8ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1180)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1258),
  /* scopeId */
  "data-v-ac57983e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1184)
__webpack_require__(1182)
__webpack_require__(1183)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1260),
  /* scopeId */
  "data-v-b94c0702",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1189)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1265),
  /* scopeId */
  "data-v-de14c96e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1175)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1255),
  /* scopeId */
  "data-v-7c05e39a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1159)
__webpack_require__(1157)
__webpack_require__(1158)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1243),
  /* scopeId */
  "data-v-59d9cf90",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1134)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1224),
  /* scopeId */
  "data-v-1dc2c98d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1129)
__webpack_require__(1128)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1220),
  /* scopeId */
  "data-v-09a9427f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1191)
__webpack_require__(1190)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1266),
  /* scopeId */
  "data-v-df35bd6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1146)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1234),
  /* scopeId */
  "data-v-3c905f20",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1186)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1262),
  /* scopeId */
  "data-v-bf5a1d2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1194)
__webpack_require__(1193)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1268),
  /* scopeId */
  "data-v-fbd83d04",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1192)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1267),
  /* scopeId */
  "data-v-f09e795c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)
__webpack_require__(1138)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1227),
  /* scopeId */
  "data-v-262c4599",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1187)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1263),
  /* scopeId */
  "data-v-c5023eee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1155)
__webpack_require__(1154)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1241),
  /* scopeId */
  "data-v-5184b68b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1148)
__webpack_require__(1147)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1235),
  /* scopeId */
  "data-v-44171231",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1156)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1242),
  /* scopeId */
  "data-v-58b13e44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1219),
  /* scopeId */
  "data-v-046accf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1169)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1250),
  /* scopeId */
  "data-v-6cea9f5b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1188)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1264),
  /* scopeId */
  "data-v-ce1b6c16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1149)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1236),
  /* scopeId */
  "data-v-477468f7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1228),
  /* scopeId */
  "data-v-262e399c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1172)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1253),
  /* scopeId */
  "data-v-71c63666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1130)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1221),
  /* scopeId */
  "data-v-0dd27c70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1167)
__webpack_require__(1166)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1248),
  /* scopeId */
  "data-v-63931fc1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1177)
__webpack_require__(1176)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1256),
  /* scopeId */
  "data-v-7fe8a507",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1160)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1244),
  /* scopeId */
  "data-v-5a74f111",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1137)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1226),
  /* scopeId */
  "data-v-2383ee82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1132)
__webpack_require__(1131)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1222),
  /* scopeId */
  "data-v-1990d308",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1136)
__webpack_require__(1135)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1225),
  /* scopeId */
  "data-v-20715d38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1152)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1239),
  /* scopeId */
  "data-v-4b8b0574",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1162)
__webpack_require__(1161)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1245),
  /* scopeId */
  "data-v-5d519129",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1165)
__webpack_require__(1164)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1247),
  /* scopeId */
  "data-v-626c1b6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(461);

var _vuex2 = _interopRequireDefault(_vuex);

var _user = __webpack_require__(593);

var _user2 = _interopRequireDefault(_user);

var _page = __webpack_require__(591);

var _page2 = _interopRequireDefault(_page);

var _menu = __webpack_require__(589);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    modules: {
        user: _user2.default,
        page: _page2.default,
        menu: _menu2.default
    }
});

/***/ }),
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */,
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1153)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1240),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1198);

var _jquery2 = _interopRequireDefault(_jquery);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _login = __webpack_require__(301);

var login = _interopRequireWildcard(_login);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'App',
  provide: function provide() {
    return {

      reload: this.reload
    };
  },
  data: function data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
      RouterState: true
    };
  },
  created: function created() {
    var that = this;
  },
  mounted: function mounted() {
    var _this = this;

    var that = this;

    window.onresize = function () {
      return function () {
        if (mUtils.getStore('lketg')) {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight;
          that.windowWidth = window.fullWidth;
          var win_size = {
            width: that.windowWidth,
            height: that.windowHeight
          };

          _this.$store.dispatch('set_win_content', win_size);
        } else {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth - 180;
          that.windowHeight = window.fullHeight;
          that.windowWidth = window.fullWidth;
          var _win_size = {
            width: that.windowWidth,
            height: that.windowHeight
          };

          _this.$store.dispatch('set_win_content', _win_size);
        }
      }();
    };
  },

  methods: {
    reload: function reload() {
      var _this2 = this;

      this.RouterState = false;
      this.$nextTick(function () {
        _this2.RouterState = true;
      });
    }
  }
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
	data: function data() {
		return {
			windowWidth: document.documentElement.clientWidth,
			windowHeight: document.documentElement.clientHeight,
			lketg: false,
			companyId: mUtils.getStore('companyId'),
			changeBarDirection: false,
			levelList: null
		};
	},
	created: function created() {
		this.getBreadcrumb();
	},

	methods: {
		handleLeftMenu: function handleLeftMenu() {
			var that = this;
			that.changeBarDirection = !that.changeBarDirection;
			this.$store.dispatch('setLeftCollapse');
			this.$store.dispatch('handleLeftMenu');
			this.$store.dispatch('dropName');
			this.setSize();
			if (this.lketg) {
				that.left = 'left';
				that.lketg = !that.lketg;
				mUtils.setStore('lketg', that.lketg);
			} else {
				that.left = 'right';
				that.lketg = !that.lketg;
				mUtils.setStore('lketg', that.lketg);
			}
		},
		setSize: function setSize() {
			var win_size = {};
			var that = this;
			if (this.lketg) {

				window.fullHeight = document.documentElement.clientHeight - 50;
				window.fullWidth = document.documentElement.clientWidth - 141;
				that.windowHeight = window.fullHeight;
				that.windowWidth = window.fullWidth;
				win_size = {
					width: that.windowWidth,
					height: that.windowHeight
				};
			} else {

				win_size = {
					width: this.$store.state.menu.sidebar.opened ? document.body.clientWidth - 15 : document.body.clientWidth - 15,
					height: document.body.clientHeight - 50
				};
			}

			this.$store.dispatch('set_win_content', win_size);
		},
		getBreadcrumb: function getBreadcrumb() {
			var matched = this.$route.matched.filter(function (item) {
				return item.name;
			});
			var first = matched[0];
			if (first && first.path == '/index') {
				matched = {};
			} else if (first && (first.path == '/userList' || first.path == '/infoList')) {
				matched = [matched[0]];
			}
			this.levelList = matched;
		}
	},
	watch: {
		$route: function $route() {
			this.getBreadcrumb();
		}
	}
};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'content',
    data: function data() {
        return {};
    },

    methods: {},
    created: function created() {},
    mounted: function mounted() {}
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _utils = __webpack_require__(15);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'head-nav',

    data: function data() {
        return {
            userName: '',
            itemList: [],
            popupMessage: [],
            unReadNum: 0,
            deliveryP: ''
        };
    },
    created: function created() {
        this.userName = mUtils._getCookie("userName");
        this.realeName = mUtils.getStore("userinfo").realName;
        this.getDeliveryP();
    },

    inject: ['reload'],
    methods: {
        modifyPwd: function modifyPwd() {
            this.$router.push({ path: '/modifyPwd' });
        },
        logout: function logout() {
            mUtils.removeLoginInfo();
            this.$router.push('/');
        },
        showInfoList: function showInfoList() {
            this.$router.push({ path: '/modifyPersonInfo' });
        },
        getDeliveryP: function getDeliveryP() {
            var _this = this;

            book.deliveryList({ type: 2 }).then(function (res) {
                if (res.status !== 200) {
                    return _this.$message.error("获取用户失败：" + res.msg);
                }
                if (res.data.code !== 0) {
                    return _this.$message.error("获取错误：" + res.data.msg);
                }
                if (res.data.data.list !== {}) {
                    var data = res.data.data.list;
                    _this.addressList = data;
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].contact == _this.realeName) {
                            _this.deliveryP = data[i].deliveryTitle;
                            localStorage.setItem("deliveryP", (0, _stringify2.default)(_this.deliveryP));
                            return;
                        }
                        var value = null;
                        localStorage.setItem("deliveryP", (0, _stringify2.default)(value));
                    }
                }
            });
        },
        setDialogInfo: function setDialogInfo(cmditem) {
            if (!cmditem) {
                this.$message('菜单选项缺少command属性');
                return;
            }
            switch (cmditem) {
                case 'info':
                    this.showInfoList();
                    break;
                case 'pass':
                    this.modifyPwd();
                    break;
                case 'logout':
                    this.logout();
                    break;
            }
        }
    }
};

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headNav = __webpack_require__(419);

var _headNav2 = _interopRequireDefault(_headNav);

var _leftMenu = __webpack_require__(420);

var _leftMenu2 = _interopRequireDefault(_leftMenu);

var _bread = __webpack_require__(418);

var _bread2 = _interopRequireDefault(_bread);

var _mUtils = __webpack_require__(5);

var mutils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'home',
    data: function data() {
        return {
            win_size: {
                height: '',
                width: ''
            },
            roleId: ''
        };
    },

    components: {
        HeadNav: _headNav2.default, LeftMenu: _leftMenu2.default, Bread: _bread2.default
    },
    methods: {
        setSize: function setSize() {
            this.win_size = {
                height: document.body.clientHeight - 73,
                width: document.body.clientWidth - 143
            };

            this.$store.dispatch('set_win_content', this.win_size);
        }
    },
    created: function created() {
        this.setSize();
        this.roleId = Number(mutils._getStore("roleId"));
    },
    mounted: function mounted() {
        var _this = this;

        window.onresize = function () {
            _this.setSize();
        };
    }
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mutils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  name: "left-Menu",
  data: function data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
      lketg: false,
      left: "left",

      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      roleId: "",
      Roleid: "",
      menuList: [{
        permissionName: "订单",
        msg: 1,
        actionPic: "fa-shopping-cart",
        child: [{
          permissionName: "订单列表",
          pmUrl: "/orderList",
          cmsg: 1
        }, {
          permissionName: "创建订单",
          pmUrl: "/addOrder",
          cmsg: 1
        }, {
          permissionName: "发货单",
          pmUrl: "/dispathchList",
          cmsg: 1
        }, {
          permissionName: "快递收货",
          pmUrl: "/checkExpress",
          cmsg: 1
        }]
      }, {
        permissionName: "库存",
        actionPic: "fa-archive",
        msg: 1,
        child: [{
          permissionName: "出入记录",
          pmUrl: "/goOutList",
          cmsg: 1
        }, {
          permissionName: "库存列表",
          pmUrl: "/repertoryList",
          cmsg: 1
        }]
      }, {
        permissionName: "货运",
        actionPic: "fa-truck",
        msg: 1,
        child: [{
          permissionName: "仓库管理",
          pmUrl: "/houserAddress",
          cmsg: 1
        }, {
          permissionName: "货物价格",
          pmUrl: "/priceGoods",
          cmsg: 1
        }, {
          permissionName: "货运管理",
          pmUrl: "/transport/list",
          cmsg: 1
        }]
      }, {
        permissionName: "人员",
        actionPic: "fa-user-circle",
        msg: 1,
        child: [{
          permissionName: "客户列表",
          pmUrl: "/customerList",
          cmsg: 1
        }, {
          permissionName: "员工管理",
          pmUrl: "/adminList",
          cmsg: 1
        }, {
          permissionName: "通知公告",
          pmUrl: "/announcement",
          cmsg: 1
        }]
      }, {
        permissionName: "工单",
        actionPic: "fa-user-circle",
        msg: 1,
        child: [{
          permissionName: "工单列表",
          pmUrl: "/workOrderList",
          cmsg: 1
        }, {
          permissionName: "工单须知",
          pmUrl: "/workOrderRemark",
          cmsg: 1
        }]
      }, {
        permissionName: "加拿大分舵",
        actionPic: "el-icon-s-promotion",
        msg: 1,
        msg2: 3,
        child: [{
          permissionName: "地址配置",
          pmUrl: "/delivery/list",
          cmsg: 1
        }, {
          permissionName: "物流管理",
          pmUrl: "/delivery/order",
          cmsg: 1,
          cmsg2: 3
        }, {
          permissionName: "扫码入库",
          pmUrl: "/delivery/fastIn",
          cmsg: 1,
          cmsg2: 3
        }, {
          permissionName: "发货单",
          pmUrl: "/delivery/dispathchList",
          cmsg: 1,
          cmsg2: 3
        }, {
          permissionName: "客户列表",
          pmUrl: "/delivery/newCustomer",
          cmsg: 1,
          cmsg2: 3
        }]
      }, {
        permissionName: "加拿大中心仓",
        actionPic: "el-icon-s-shop",
        msg: 1,
        msg2: 2,
        child: [{
          permissionName: "中心仓库管理",
          pmUrl: "/distribution/list",
          cmsg: 1
        }, {
          permissionName: "物流管理",
          pmUrl: "/distribution/order",
          cmsg: 1,
          cmsg2: 2
        }, {
          permissionName: "扫码入库",
          pmUrl: "/distribution/fastInStorage",
          cmsg: 1,
          cmsg2: 2
        }, {
          permissionName: "派送列表",
          pmUrl: "/delivery/deliveryList",
          cmsg: 1,
          cmsg2: 2
        }, {
          permissionName: "扫码出库",
          pmUrl: "/distribution/outStorage",
          cmsg: 1,
          cmsg2: 3
        }]
      }, {
        permissionName: "充值",
        actionPic: "el-icon-s-finance",
        msg: 1,
        child: [{
          permissionName: "财务账号",
          pmUrl: "/recharge/account",
          cmsg: 1
        }, {
          permissionName: "财务流动",
          pmUrl: "/recharge/flows",
          cmsg: 1
        }, {
          permissionName: "充值",
          pmUrl: "/recharge/charge",
          cmsg: 1
        }, {
          permissionName: "调账",
          pmUrl: "/recharge/adjust",
          cmsg: 1
        }, {
          permissionName: "汇率",
          pmUrl: "/recharge/rate",
          cmsg: 1
        }]
      }, {
        permissionName: "设置",
        actionPic: "el-icon-setting",
        msg: 1,
        child: [{
          permissionName: "协议条款",
          pmUrl: "/system/agree",
          cmsg: 1
        }, {
          permissionName: "首页公告",
          pmUrl: "/system/notice",
          cmsg: 1
        }]
      }, {
        permissionName: "统计",
        actionPic: "el-icon-tickets",
        msg: 1,
        msg2: 3,
        child: [{
          permissionName: "运单",
          pmUrl: "/statistical/wayBill",
          cmsg: 1,
          cmsg2: 3
        }, {
          permissionName: "费用",
          pmUrl: "/statistical/cost",
          cmsg: 1,
          cmsg2: 3
        }]
      }],

      isCollapse: false
    };
  },

  watch: {
    "$store.state.menu.isDropname": function $storeStateMenuIsDropname() {
      this.isCollapse = this.$store.state.menu.isCollapse;
    },
    windowHeight: function windowHeight(val) {
      var that = this;
    },
    windowWidth: function windowWidth(val) {
      var that = this;
    }
  },

  mounted: function mounted() {
    var that = this;

    window.onresize = function () {
      return function () {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight;
        that.windowWidth = window.fullWidth;
      }();
    };
  },

  computed: {
    nowIndex: function nowIndex() {
      if (this.$route.path.replace("/", "") == "productList") {
        return "2-1";
      } else if (this.$route.path.replace("/", "") == "newProduct") {
        return "2-2";
      } else if (this.$route.path.replace("/", "") == "hsCoding") {
        return "3-3";
      } else if (this.$route.path.replace("/", "") == "newOrder") {
        return "3-1";
      } else if (this.$route.path.replace("/", "") == "salesOrder") {
        return "3-2";
      } else if (this.$route.path.replace("/", "") == "purchaseOrderList") {
        return "3-3";
      } else if (this.$route.path.replace("/", "") == "shippingAssistant") {
        return "4-1";
      } else if (this.$route.path.replace("/", "") == "orderDelivery") {
        return "4-2";
      } else if (this.$route.path.replace("/", "") == "preliminaryRecord") {
        return "4-3";
      } else if (this.$route.path.replace("/", "") == "purchaseASaleContract") {
        return "6-4";
      } else if (this.$route.path.replace("/", "") == "customer") {
        return "5-1";
      } else if (this.$route.path.replace("/", "") == "factory") {
        return "5-2";
      } else if (this.$route.path.replace("/", "") == "employee") {
        return "5-3";
      } else if (this.$route.path.replace("/", "") == "addRateTax") {
        return "6-1";
      } else if (this.$route.path.replace("/", "") == "orderStatistics") {
        return "6-2";
      } else if (this.$route.path.replace("/", "") == "shipmentStatistics") {
        return "6-3";
      } else if (this.$route.path.replace("/", "") == "companyInformation") {
        return "7-1";
      } else if (this.$route.path.replace("/", "") == "orderStatisticsDelivery") {
        return "6-2";
      } else if (this.$route.path.replace("/", "") == "shipmentStatisticsDelivery") {
        return "6-3";
      }
    }
  },

  created: function created() {
    this.roleId = Number(mutils._getCookie("roleId"));
    this.Roleid = Number(mutils._getStore("roleId"));
  },

  methods: {
    handleLeftMenu: function handleLeftMenu() {
      var that = this;
      this.$store.dispatch("setLeftCollapse");
      this.$store.dispatch("handleLeftMenu");
      this.$store.dispatch("dropName");
      this.setSize();
      if (this.lketg) {
        that.left = "left";
        that.lketg = !that.lketg;
        mutils.setStore("lketg", that.lketg);
      } else {
        that.left = "right";
        that.lketg = !that.lketg;
        mutils.setStore("lketg", that.lketg);
      }
    },
    setSize: function setSize() {
      var win_size = {};
      var that = this;
      if (this.lketg) {
        window.fullHeight = document.documentElement.clientHeight - 50;
        window.fullWidth = document.documentElement.clientWidth - 141;
        that.windowHeight = window.fullHeight;
        that.windowWidth = window.fullWidth;
        win_size = {
          width: that.windowWidth,
          height: that.windowHeight
        };
      } else {
        win_size = {
          width: this.$store.state.menu.sidebar.opened ? document.body.clientWidth - 15 : document.body.clientWidth - 15,
          height: document.body.clientHeight - 50
        };
      }

      this.$store.dispatch("set_win_content", win_size);
    },
    handleOpen: function handleOpen(key, keyPath) {},
    handleClose: function handleClose(key, keyPath) {}
  }
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

var _mUtils = __webpack_require__(5);

var mutils = _interopRequireWildcard(_mUtils);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			productId: null,
			orderNo: null,
			detailData: [],
			templateList: [],
			productLight: [],
			orderInfo: null,
			operatorName: null,
			companyInfo: []
		};
	},
	created: function created() {
		this.productId = this.$route.query.productId || 0;
		this.orderNo = this.$route.query.orderNo || "";

		if (this.orderNo) {
			this.getOrderInfo();
		} else {
			this.getProductDetail();
		}

		this.operatorName = mutils.getUserName();
		this.getCompanyInfo();
	},

	methods: {
		print: function print() {
			javascript: window.print();
		},
		repalce: function repalce(str) {
			if (!str) return "";
			return decodeURIComponent(str).replace(new RegExp(/\n/g), "<br/>");
		},
		getCompanyInfo: function getCompanyInfo() {
			var that = this;
			that.$sub.post('/v1/travel/company/getCompanyInfo', {
				userId: mutils.getUserId(),
				token: mutils.getToken()
			}).then(function (res) {
				that.companyInfo = res.data.data;
			});
		},
		getProductDetail: function getProductDetail() {
			var that = this;
			that.$sub.post('/v1/travel/product/getProductDetail', {
				userId: mutils.getUserId(),
				token: mutils.getToken(),
				productId: that.productId
			}).then(function (res) {
				var data = res.data.data;
				if (data != null) {
					data.productName = decodeURIComponent(data.productName);
					data.companyName = decodeURIComponent(data.companyName);
					var templateList = [];
					if (data.productTemplateList != null) {
						data.productTemplateList.forEach(function (item, index) {
							item.productDate = "第" + (index + 1) + "天";
							item.title = decodeURIComponent(item.title);
							item.hotelName = decodeURIComponent(item.hotelName);
							item.remark = decodeURIComponent(item.remark);

							item.can = item.isBreakfast == 1 ? "早餐" : "";
							item.can += item.isLunch == 1 ? "中餐" : "";
							item.can += item.isDinner == 1 ? "晚餐" : "";

							templateList.push(item);
						});
					}
					that.templateList = templateList;
				}
				that.detailData = data;
			});
		},
		getOrderInfo: function getOrderInfo() {
			var that = this;

			that.$sub.post('/v1/travel/order/orderInfo', {
				userId: mutils.getUserId(),
				token: mutils.getToken(),
				orderNo: that.orderNo
			}).then(function (res) {
				that.orderInfo = res.data.data;
				that.productId = that.orderInfo.productId;
				that.getProductDetail();
			});
		},
		getObj: function getObj(obj) {
			if (obj == "") return [];
			obj = decodeURIComponent(obj);
			var arr = obj.split('\n');
			var list = [];
			for (var i = 0; i < arr.length; i++) {
				var parameter = {};
				parameter.value = arr[i];
				list.push(parameter);
			}
			return (0, _stringify2.default)(obj);
		},

		exportWord: function exportWord() {
			var _this = this;

			JSZipUtils.getBinaryContent("/static/route.docx", function (error, content) {
				if (error) {
					throw error;
				}

				var zip = new JSZip(content);

				var doc = new window.docxtemplater().loadZip(zip);

				doc.setOptions({
					linebreaks: true
				});

				doc.setData({
					companyName: _this.detailData.companyName,
					companyTel: _this.detailData.companyTel,
					companyFax: _this.detailData.companyFax,
					companyAddress: _this.detailData.companyAddress,
					productId: _this.detailData.productId,
					productName: _this.detailData.productName,
					startCity: _this.detailData.startCity,
					travelDay: _this.detailData.travelDay,
					startDate: _this.orderInfo && _this.orderInfo.startDate || "",
					backDate: _this.orderInfo && _this.orderInfo.backDay || "",
					goTraffic: _this.detailData.goTraffic,
					backTraffic: _this.detailData.backTraffic,
					collectionTime: _this.detailData.collectionTime || "",
					collectionPlace: _this.detailData.collectionPlace || "",
					giveTel: _this.detailData.giveTel || "",
					giveId: _this.detailData.giveId || "",
					adminPrice: _this.detailData.adminPrice || 0,
					childPrice: _this.detailData.childPrice || 0,
					housePrice: _this.detailData.housePrice || 0,
					summary: decodeURIComponent(_this.detailData.productDetail.summary || ""),
					signUp: decodeURIComponent(_this.detailData.productDetail.signUp || ""),
					inclustionItems: decodeURIComponent(_this.detailData.productDetail.inclustionItems || ""),
					noInclustionItems: decodeURIComponent(_this.detailData.productDetail.noInclustionItems || ""),
					childPlan: decodeURIComponent(_this.detailData.productDetail.childPlan || ""),
					shopPlan: decodeURIComponent(_this.detailData.productDetail.shopPlan || ""),
					mayPlan: decodeURIComponent(_this.detailData.productDetail.mayPlan || ""),
					givePlan: decodeURIComponent(_this.detailData.productDetail.givePlan || ""),
					attentions: decodeURIComponent(_this.detailData.productDetail.attentions || ""),
					otherPlan: decodeURIComponent(_this.detailData.productDetail.otherPlan || ""),
					reminder: decodeURIComponent(_this.detailData.productDetail.reminder || ""),
					operatorName: _this.operatorName,
					currentDate: _this.detailData.currentDate || "",
					tableTemplate: _this.templateList
				});

				try {
					doc.render();
				} catch (error) {
					var e = {
						message: error.message,
						name: error.name,
						stack: error.stack,
						properties: error.properties
					};

					throw error;
				}

				var out = doc.getZip().generate({
					type: "blob",
					mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				});

				saveAs(out, _this.detailData.productName + ".docx");
			});
		}
	}
};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    }
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _set = __webpack_require__(600);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(603);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _utils = __webpack_require__(15);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _unit = __webpack_require__(206);

var unit = _interopRequireWildcard(_unit);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    boxId: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      httpImg: "",
      mianDialog: {
        show: true,
        title: "面单",
        width: "300",
        height: "260",
        boxId: null,
        boxInfo: {},
        list: []
      },
      printObj: {
        id: "printContent",
        popTitle: "",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      imgURL: null,
      vipCodeArr: []
    };
  },
  created: function created() {
    var that = this;
    that.httpImg = "https://cn2ca-1370214517.cos.ap-nanjing.myqcloud.com/";
    that.mianDialog.width = unit.mmToPx(100);
  },

  methods: {
    close: function close() {
      this.$emit('closeFaceDialog', false);
    },
    getFaceSheet: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this = this;

        var that, param;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;

                if (that.boxId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                param = {};

                param.boxId = that.boxId;
                _context.next = 7;
                return boxApi.faceSheet(param).then(function (res) {
                  if (res.data.code != 0) {
                    return that.$message.error(res.data.msg || "获取异常");
                  }
                  that.mianDialog.boxInfo = res.data.data;
                  var list = res.data.data.orderPojoList || [];
                  if (list != null && list.length > 0) {
                    if (list.length > 8) {
                      list = list.slice(0, 8);
                    }
                    that.mianDialog.list = list;
                    console.log(148, that.mianDialog.list);
                    var vipCodeArr = [];
                    that.mianDialog.list.forEach(function (vipCode) {
                      vipCodeArr.push(vipCode.vipCode);
                    });
                    _this.vipCodeArr = [].concat((0, _toConsumableArray3.default)(new _set2.default(vipCodeArr)));
                    console.log(153, vipCodeArr, _this.vipCodeArr);
                  }

                  _this.imgURL = _this.httpImg + _this.mianDialog.boxInfo.img;
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFaceSheet() {
        return _ref.apply(this, arguments);
      }

      return getFaceSheet;
    }(),
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodType: function goodType(_goodType) {
      return StringUtils.goodType(_goodType);
    },
    flashPiture: function flashPiture() {
      this.imgURL = this.imgURL + '?' + Math.random();
    },
    getOrderName: function getOrderName(value) {
      if (value.length > 6) {
        return value.substring(0, 7) + "...";
      } else {
        return value;
      }
    }
  }
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      activeName: "1",
      orderNo: "",
      userName: "",
      batchNum: "",
      bookText: "",
      accountDia: false,
      warningDia: false,
      listDia: false,
      orderMsg: [],
      user: [],
      overdueList: [],
      overdueDlist: [],
      accountList: [],
      mainList: [],
      orderList: [],
      listRow: [],
      sendId: "",
      status: "",
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 50],
        layout: "total, sizes, prev, pager, next, jumper" },
      search: {
        goodType: null
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],
      isChina: null,
      multipleSelection: [],

      batchList: [],

      timeout: null,

      checkedRecStatus: null,

      receOptions: [{ value: "0", label: "未签收" }, { value: "1", label: "已签收" }],
      loading: false,

      deliverAddress: null,
      deliverAddressArr: [],

      roleId: null
    };
  },
  created: function created() {
    this.getAppointList();
    this.judgeIsChina();
    this.getBatchList();
    this.getAdressId();
  },
  mounted: function mounted() {
    var userinfo = mUtils.getStore('userinfo');

    if (userinfo.roleId == 3) {
      this.roleId = 3;
      this.deliverAddress = userinfo.adminId;
    }
  },

  methods: {
    init: function init(index) {
      return index + 2;
    },
    changeDate: function changeDate(date, type) {
      return mUtils.formatDate(new Date(date), type);
    },
    changeDateCopy: function changeDateCopy(date, type) {
      if (!this.isChina) {
        date += 86400000;
      }
      return mUtils.formatDate(new Date(date), type);
    },
    itemChangedHM: function itemChangedHM(one, two) {
      var start = null;
      var end = null;
      if (!this.isChina) {
        start = this.changeToTimeCopy(one);
        end = this.changeToTimeCopy(two);
      } else {
        start = this.changeToTime(one);
        end = this.changeToTime(two);
      }
      return start + "-" + end;
    },
    changeToTime: function changeToTime(datetimes) {
      var date = new Date(datetimes);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },
    changeToTimeCopy: function changeToTimeCopy(datetimes) {
      var that = this;
      var date = new Date(datetimes);
      var isChinaStr = date.toString();
      var result = isChinaStr.indexOf("+") != -1;

      var dateStr = date.toString();
      var arr = dateStr.split("GMT");
      var twoNum = arr[1].substring(1, 3);
      var howMany = 0;
      if (twoNum[0] == 0) {
        howMany = twoNum[1];
      } else {
        howMany = twoNum;
      }

      if (!result) {
        var newDatetimes = datetimes += (8 + howMany) * 3600 * 1000;
        date = new Date(newDatetimes);
      }

      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },
    spanC: function spanC(status) {
      this.bookText = status == 1 ? "bookTextN" : "bookTextP";
    },
    getAppointList: function getAppointList(type) {
      var _this = this;

      var that = this;
      var param = {
        sendNo: this.orderNo,
        userName: this.userName,
        batchNumber: that.batchNum ? this.batchNum.trim() : "",
        goodType: this.search.goodType,
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        isReceipt: that.checkedRecStatus || null,
        deliveryId: null
      };

      if (that.deliverAddress) {
        that.deliverAddressArr.forEach(function (dItem, index) {
          if (dItem.adminId == that.deliverAddress) {
            param.deliveryId = dItem.addressId;
          }
        });
      }

      this.mainList = [];
      if (type) {
        param.pageIndex = 1;
        this.paginations.page_index = 1;
      }

      book.getAppointList(param).then(function (res) {
        if (res.status == 200) {
          _this.mainList = res.data.data.list;
          _this.paginations.total = res.data.data.pageCount;
        }
      });
    },
    settlementBt: function settlementBt() {
      this.confirmSettlement();
      this.accountDia = false;
    },
    confirmSettlement: function confirmSettlement() {
      var _this2 = this;

      var param = {
        sendId: this.sendId,
        balanceRemark: "预约自提结算"
      };
      book.confirmSettlement(param).then(function (res) {
        if (res.status !== 200) return _this2.$message.error("出库结算失败: " + res.msg);
        if (res.data.code !== 0) {
          return _this2.$message.error("出库结算失败: " + res.data.msg);
        }
        _this2.getAppointList();
        _this2.$message.success("出库结算成功");
      });
    },
    cancelSearch: function cancelSearch() {
      this.getAppointList();
    },
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    showAccountDia: function showAccountDia(row) {
      var _this3 = this;

      this.status = row.status;
      this.sendId = row.sendId;
      var param = {
        sendId: row.sendId
      };
      book.getSettlementSheet(param).then(function (res) {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            _this3.$message.error("获取出库面单失败");
            return;
          } else if (res.data.data == {}) {
            return _this3.$message.error("获取出库面单失败: 无出库面单数据");
          }
          _this3.accountList[0] = res.data.data !== {} ? res.data.data : [];
          _this3.listRow = _this3.accountList[0].orderPojoList ? _this3.accountList[0].orderPojoList : [];

          _this3.settlementBt();
        }
      });
    },
    showOrder: function showOrder(row) {
      var _this4 = this;

      var param = {
        sendId: row.sendId
      };
      book.getSettlementSheet(param).then(function (res) {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            _this4.$message.error("获取订单详情失败：" + res.data.msg);
            return;
          } else if (res.data.data == {}) {
            return _this4.$message.error("获取订单详情失败: 无出库面单数据");
          }
          _this4.orderMsg = res.data.data !== {} ? res.data.data : [];
          _this4.orderList = _this4.orderMsg.orderPojoList ? _this4.orderMsg.orderPojoList : [];
          _this4.user = _this4.orderMsg.user ? _this4.orderMsg.user : [];
          _this4.listDia = true;
        }
      });
    },
    handleSizeChange: function handleSizeChange(page_size) {
      this.paginations.page_size = page_size;
      this.getAppointList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.paginations.page_index = page;
      this.getAppointList();
    },
    judgeIsChina: function judgeIsChina() {
      var date = new Date();
      var isChinaStr = date.toString();
      var result = isChinaStr.indexOf("中国") != -1;
      this.isChina = result;
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    remoteMethod: function remoteMethod(value) {
      var _this5 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this5.getBatchList(value);
      }, 500);
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.getAppointList();
    },
    batchChange: function batchChange() {
      this.getAppointList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    mulOutStoreToPay: function mulOutStoreToPay() {
      var _this6 = this;

      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      var sendIds = [];
      that.multipleSelection.forEach(function (value) {
        sendIds.push(value.sendId);
      });
      param.sendIds = sendIds;
      param.balanceRemark = "预约自提结算";
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });

      book.mulOutStoreToPay(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        _this6.getAppointList();
      });
    },
    getAdressId: function getAdressId() {
      var _this7 = this;

      var uselist = mUtils.getStore("userinfo");
      var realName = uselist.realName;
      var roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this7.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this7.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this7.deliverAddressArr = res.data.data.list;
        }
      });
    }
  }
};

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _methods;

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      addDateDialog: false,
      addTimeDialog: false,
      deleteTimeDialog: false,
      appointRow: [],
      appointindex: "",
      appointmentTimeList: {
        msg: ""
      },
      realName: "",
      addressId: "",
      roleId: "",
      chooseTime: "",
      selTime: {
        startTime: "",
        endTime: "",
        timequantumInfo: ""
      },
      orderList: [],
      dataList: [],
      deliveryDate: {
        addressId: null
      },
      addressList: [],
      bookPerNum: "",
      totalPerson: 0,
      value1: [new Date(2021, 9, 10, 0, 0), new Date(2021, 9, 10, 23, 59)],
      time1: "",
      time2: "",
      result: "",
      deliverAddress: "",
      SingleAddressId: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getAdressId();
  },
  beforeUpdate: function beforeUpdate() {},

  watch: {},
  methods: (_methods = {
    test: function test() {
      this.visible = true;
    },
    newTimeChange: function newTimeChange(value1) {
      if (!value1) {
        this.selTime.startTime = "";
        this.selTime.endTime = "";
        return;
      }

      this.time1 = this.changeToTime(new Date(mUtils.formatDate(value1[0])).getTime());
      this.time2 = this.changeToTime(new Date(mUtils.formatDate(value1[1])).getTime());
      this.selTime.startTime = this.changeToTime(new Date(mUtils.formatDate(value1[0])).getTime());
      this.selTime.endTime = this.changeToTime(new Date(mUtils.formatDate(value1[1])).getTime());
    },
    changeToTime: function changeToTime(timeStamp) {
      var date = new Date(timeStamp);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },
    addressChange: function addressChange() {
      this.addressId = this.deliveryDate.addressId;
      this.getTimeList();
    },
    getTimeList: function getTimeList(SingleAddressId) {
      var _this = this;

      var param = {
        addressId: SingleAddressId || this.addressId
      };
      book.timeList(param).then(function (res) {
        if (res.status == 200) {
          _this.orderList = res.data.data.list;

          _this.putEffectiveTime();
        } else if (res.status !== 200) {
          _this.$message.error("获取预约列表失败");
        }
      });
    },
    putEffectiveTime: function putEffectiveTime() {
      this.dataList = [];
      for (var i = 0; i < this.orderList.length; i++) {
        if (this.orderList[i].status == 1 || this.orderList[i].status == undefined) {
          this.dataList.push(this.orderList[i]);
        }
      }
      this.appointmentTimeList.msg = this.putTime(this.dataList);
    },
    getToday: function getToday(day1) {
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var month = day2.getMonth() + 1 < 10 ? "0" + (day2.getMonth() + 1) : day2.getMonth() + 1;
      var date = day2.getDate() < 10 ? "0" + day2.getDate() : day2.getDate();
      var s2 = day2.getFullYear() + "-" + month + "-" + date;
      if (day1 === undefined) {
        return;
      }
      var date1 = day1.replace(/\-/g, "/");
      var date2 = s2.replace(/\-/g, "/");
      return date1 >= date2;
    },
    addTime: function addTime() {
      this.addDateDialog = false;
      var day = this.chooseTime;
      var date = new Date(day);
      var isChinaStr = date.toString();
      var result = isChinaStr.indexOf("中国") != -1;
      this.result = result;
      var date2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
      if (!result) {
        date2 += 86400000;
      }
      if (this.getToday(day)) {
        this.orderList.push({
          appointmentTimeId: this.orderList.length + 1,
          appointmentTime: date2,
          addressId: this.SingleAddressId || this.addressId,
          periodPojoList: [],
          maxCount: 0,
          useCount: 0
        }), this.putEffectiveTime();
        this.appointmentTimeList.msg = this.appointmentTimeList.msg + "," + day;
      } else {}
    },
    getAdressId: function getAdressId() {
      var _this2 = this;

      var uselist = mUtils.getStore("userinfo");
      this.realName = uselist.realName || "";
      this.roleId = uselist.roleId;
      this.deliverAddress = uselist.adminId;

      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this2.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this2.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data.list !== {}) {
          var data = res.data.data.list;
          _this2.addressList = data;
          for (var i = 0; i < data.length; i++) {

            if (data[i].adminId == _this2.deliverAddress) {
              _this2.addressId = data[i].addressId;
              if (_this2.roleId !== 1) _this2.addressList.forEach(function (dItem, index) {
                if (dItem.adminId == _this2.deliverAddress) {
                  _this2.SingleAddressId = dItem.addressId;
                  _this2.getTimeList(dItem.addressId);
                }
              });

              return;
            }
          }
        }
      });
    },
    checkTimeExit: function checkTimeExit(obj, day, value) {
      if (value == "appointmentTime") {
        for (var i = 0; i < obj.length; i++) {
          if (this.changeDate(obj[i]) == day && obj[i].status !== -1) {
            return false;
          }
        }
        return true;
      } else if (value == "period") {
        for (var i = 0; i < obj.length; i++) {
          if (obj[i].period == day) return false;
        }
        return true;
      }
    },
    showAddDateDia: function showAddDateDia(day) {
      var temRoleId = mUtils.getStore("roleID") || null;

      if (this.addressId == "" && temRoleId == 1) {
        this.$message({
          message: "请选择派送地址",
          type: "warning"
        });
        return;
      }

      if (this.getToday(day) && this.checkTimeExit(this.orderList, day, "appointmentTime")) {
        this.chooseTime = day;
        this.addDateDialog = true;
      } else {
        this.$message({
          message: "该日期无法选择，已选或是今天之前的时间",
          type: "error"
        });
      }
    },
    showSelTimeDia: function showSelTimeDia(row) {
      this.selTime.startTime = "";
      this.selTime.endTime = "";
      this.bookPerNum = "";
      this.timequantumInfo = row;
      this.value1 = [new Date(2021, 9, 10, 0, 0), new Date(2021, 9, 10, 23, 59)], this.addTimeDialog = true;
    },
    showDeleteTimeDia: function showDeleteTimeDia(row, index) {
      this.deleteTimeDialog = true;
      this.appointRow = row;
      this.appointindex = index;
    },
    closeDeleteTimeDia: function closeDeleteTimeDia() {
      this.deleteTimeDialog = false;
      this.appointRow = [];
      this.appointindex = [];
    },
    deleteTimeDiaComfirm: function deleteTimeDiaComfirm() {
      var _this3 = this;

      var param = {
        appointmentPeriodId: this.appointRow.periodPojoList[this.appointindex].appointmentPeriodId
      };
      book.cancelTime(param).then(function (res) {
        if (res.status == 200) {
          _this3.appointRow = [];
          _this3.appointindex = [];
          _this3.getTimeList();
          _this3.$message.success("删除时间段成功");
        } else if (res.status !== 200) {
          _this3.$message.error("删除时间段失败");
        }
      });
      this.deleteTimeDialog = false;
    },
    addTimeQuantum: function addTimeQuantum() {
      var realMaxCount = this.bookPerNum;

      var timestr = this.selTime.startTime + this.selTime.endTime;

      var newtimestr = this.changTimeStr(timestr);

      if (!this.checkTimeExit(this.timequantumInfo.periodPojoList, newtimestr, "period")) {
        return this.$message({
          message: "该时段无法选择，已存在",
          type: "error"
        });
      }
      this.timequantumInfo.periodPojoList.push({
        appointmentTimeId: this.timequantumInfo.periodPojoList.length + 1,

        period: newtimestr,
        appointmentCount: 0,
        maxCount: realMaxCount
      });
      this.addTimeDialog = false;
      this.selTime.startTime = "";
      this.selTime.endTime = "";
    },
    changTimeStr: function changTimeStr(str) {
      var str1 = str.substring(0, 5);
      var str2 = str.substring(5, 10);
      var newStr = str1 + "-" + str2;
      return newStr;
    },
    changeDate: function changeDate(row) {
      var time = row.appointmentTime;


      if (!this.result) {
        time += 46800000;
      }

      return mUtils.formatDate(new Date(time), 3);
    },
    putTime: function putTime(obj) {
      var arr = [];
      for (var i = 0; i < obj.length; i++) {
        arr.push(this.changeDate(obj[i]));
      }
      return arr.toString();
    },
    changeTimeQ: function changeTimeQ(date, time) {
      var arr = [];
      var date3 = null;
      var date4 = null;
      var date5 = null;

      if (time.length == 0) return arr;
      for (var i = 0; i < time.length; i++) {
        var str1 = time[i].period.substring(0, 5) + ":00";
        var str2 = time[i].period.substring(6, 11) + ":00";

        var basic = 1609430400000;
        var str1FiveStr = time[i].period.substring(0, 5);
        var str2FiveStr = time[i].period.substring(6, 11);
        var min1 = 0;
        var min2 = 0;
        if (str1FiveStr[0] == "0") {
          min1 += str1FiveStr[1] * 1 * 60;
        } else {
          var frontTwoStr = str1FiveStr.substring(0, 2);
          min1 += frontTwoStr * 1 * 60;
        }

        if (str1FiveStr[3] == "0") {
          min1 += str1FiveStr[4] * 1;
        } else {
          var behindTwoStr = str1FiveStr.substring(3, 5);
          min1 += behindTwoStr * 1;
        }

        if (str2FiveStr[0] == "0") {
          min2 += str2FiveStr[1] * 1 * 60;
        } else {
          var frontTwoStr2 = str2FiveStr.substring(0, 2);
          min2 += frontTwoStr2 * 1 * 60;
        }

        if (str2FiveStr[3] == "0") {
          min2 += str2FiveStr[4] * 1;
        } else {
          var behindTwoStr2 = str2FiveStr.substring(3, 5);
          min2 += behindTwoStr2 * 1;
        }

        var startStamp = min1 * 60 * 1000 + basic;
        var endStamp = min2 * 60 * 1000 + basic;

        arr[i] = {
          expireTime: endStamp,
          startTime: startStamp,
          period: time[i].period,
          remark: time[i].remark == undefined ? "" : time[i].remark,
          maxCount: this.timequantumInfo.periodPojoList[i].maxCount
        };
      }
      return arr;
    }
  }, (0, _defineProperty3.default)(_methods, "putTime", function putTime(obj) {
    var arr = [];
    for (var i = 0; i < obj.length; i++) {
      arr.push(this.changeDate(obj[i]));
    }
    return arr.toString();
  }), (0, _defineProperty3.default)(_methods, "sendData", function sendData(row) {
    var _this4 = this;

    var howMany = 0;
    row.periodPojoList && row.periodPojoList.forEach(function (json) {
      howMany += json.maxCount * 1;
    });
    this.totalPerson = howMany;
    var param = {
      appointmentTime: row.appointmentTime,
      addressId: this.SingleAddressId || row.addressId,
      periodParamList: this.changeTimeQ(row.appointmentTime, row.periodPojoList),
      maxCount: howMany
    };

    if (this.changeTimeQ(row.appointmentTime, row.periodPojoList).length < 1) return this.$message.error("添加日期失败：未配置预约时间");
    if (param.maxCount - 0 < 1) return this.$message.error("添加日期失败：未配置预约人数");

    book.comfirmBt(param).then(function (res) {
      if (res.status == 200 && res.data.code == 0) {
        _this4.$message.success("配置(修改)日期数据成功");
        _this4.getTimeList(_this4.SingleAddressId);
      } else if (res.status !== 200 || res.data.code != 0) {
        _this4.$message.error("配置(修改)日期数据失败");
      }
    });
  }), (0, _defineProperty3.default)(_methods, "cancelData", function cancelData(row) {
    var _this5 = this;

    var param = {
      appointmentTimeId: row.appointmentTimeId
    };
    book.cancelBt(param).then(function (res) {
      if (res.status == 200) {
        _this5.$message.success("取消日期数据成功");
        _this5.getTimeList(_this5.SingleAddressId);
      } else if (res.status !== 200) {
        _this5.$message.error("取消日期数据失败");
      }
    });
  }), _methods)
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _typeof2 = __webpack_require__(81);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      activeName: "1",
      orderNo: "",
      userName: "",
      deliveryNumber: "",
      deliveryBatch: null,
      checkedStatus: "",
      sendId: "",
      deliveryId: "",
      editDialog: false,
      accountDia: false,
      warningDia: false,
      deliverList: [],
      feedbackList: [],
      content: "",
      listRow: [],
      orderMsg: [],
      user: [],
      mainList: [],
      listDia: false,
      overdueDlist: [],
      disposeList: [],
      disposingList: [],
      disposedList: [],
      cancelList: [],
      editLsit: [],
      orderList: [],
      sendNo: "",
      accountList: [],
      ruleForm: {
        price: ""
      },
      rules: {
        price: [{ required: true, message: "请输入派送费用", trigger: "blur" }]
      },
      search: {
        goodType: null
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],
      status: {
        statusType: null
      },
      statusTypeSelect: [{
        statusType: 0,
        statusName: "待处理"
      }, {
        statusType: 1,
        statusName: "处理中"
      }, {
        statusType: 2,
        statusName: "已处理"
      }, {
        statusType: -1,
        statusName: "已取消"
      }],

      howManyTotal: 0,
      listArr: [],
      columnsOrder: [{ title: "派送编号", key: "deliveryNumber" }, { title: "运单", key: "orderCount" }, { title: "客户", key: "realName" }, { title: "vip号", key: "vipCode" }, { title: "货物类型", key: "goodType" }, { title: "发货单号", key: "sendNo" }, { title: "批次", key: "sendRemark" }, { title: "箱号", key: "boxNumber" }, { title: "状态", key: "status" }, { title: "总运费", key: "amount" }, { title: "提出时间", key: "createTime" }, { title: "体积CBM", key: "volume" }, { title: "重量KG", key: "productWeight" }, { title: "箱数", key: "unMixingTank" }, { title: "混箱数", key: "mixingTank" }, { title: "收货人电话", key: "mobile" }, { title: "收货地址", key: "address" }],

      lookWhichRow: null,
      dialog: {
        show: false,
        updaAddDia: false
      },
      tableData: [{
        remark: "sdad",
        predictTotal: "100",
        rate: 10,
        productWeight: 12
      }],

      isUpdateFeeShow: false,
      feeInput: "",
      textarea: "",

      paramSendId: ""
    }, (0, _defineProperty3.default)(_ref, "lookWhichRow", null), (0, _defineProperty3.default)(_ref, "paramDeliverId", ""), (0, _defineProperty3.default)(_ref, "phone", ""), (0, _defineProperty3.default)(_ref, "address", ""), (0, _defineProperty3.default)(_ref, "paramSendNo", ""), (0, _defineProperty3.default)(_ref, "paramStatus", ""), (0, _defineProperty3.default)(_ref, "paramUserId", ""), (0, _defineProperty3.default)(_ref, "mobileText", ""), (0, _defineProperty3.default)(_ref, "addressText", ""), (0, _defineProperty3.default)(_ref, "paginations", {
      page_index: 1,
      total: 0,
      page_size: 10,
      page_sizes: [5, 10, 20, 100],
      layout: "total, sizes, prev, pager, next, jumper" }), (0, _defineProperty3.default)(_ref, "multipleSelection", []), (0, _defineProperty3.default)(_ref, "batchList", []), (0, _defineProperty3.default)(_ref, "timeout", null), (0, _defineProperty3.default)(_ref, "checkedRecStatus", null), (0, _defineProperty3.default)(_ref, "receOptions", [{ value: "0", label: "未签收" }, { value: "1", label: "已签收" }]), (0, _defineProperty3.default)(_ref, "loading", false), (0, _defineProperty3.default)(_ref, "expectTime", ""), (0, _defineProperty3.default)(_ref, "pickerOptions", {
      disabledDate: function disabledDate(time) {
        return time.getTime() < Date.now() - 3600 * 1000 * 24;
      }
    }), (0, _defineProperty3.default)(_ref, "isDisabledStatus", ""), _ref;
  },
  created: function created() {
    this.getDeliveryList();
    this.getBatchList();
  },

  methods: {
    init: function init() {},
    handleClick: function handleClick(res) {
      var that = this;
      this.mainList = [];
      if (res == "1") {
        this.mainList = this.overdueDlist;
        that.checkedStatus = "";
      } else if (res == "2") {
        this.mainList = this.disposeList;
        that.checkedStatus = "0";
      } else if (res == "3") {
        this.mainList = this.disposingList;
        that.checkedStatus = "1";
      } else if (res == "4") {
        this.mainList = this.disposedList;
        that.checkedStatus = "2";
      }

      this.res = res;
      this.getDeliveryList("select");
    },
    getDeliveryList: function getDeliveryList(isSelect) {
      var _this = this;

      if (this.res == undefined || this.res == "" || this.res == "1") {
        this.activeName = "1";
      } else if (this.res == "2") {
        this.activeName = "2";
      } else if (this.res == "3") {
        this.activeName = "3";
      } else {
        this.activeName = "4";
      }
      var param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        orderNo: this.orderNo ? this.orderNo : "",
        userName: this.userName ? this.userName : "",
        deliveryNumber: this.deliveryNumber ? this.deliveryNumber : "",
        status: this.checkedStatus ? this.checkedStatus : "",
        batchNumber: this.deliveryBatch ? this.deliveryBatch.trim() : null,
        isReceipt: this.checkedRecStatus || null
      };

      if (isSelect == "select") {
        param.pageIndex = 1;
        this.paginations.page_index = 1;
      }

      this.mainList = [];
      this.disposeList = [];
      this.disposingList = [];
      this.disposedList = [];
      this.cancelList = [];
      book.getDeliveryList(param).then(function (res) {
        if (res.status !== 200) return _this.$message.error("获取派送列表失败: " + res.msg);
        if (res.data.code !== 0) {
          return _this.$message.error("获取派送列表失败: " + res.msg);
        }
        _this.deliverList = res.data.data.list;
        _this.paginations.total = res.data.data.pageCount;
        _this.howManyTotal = res.data.data.pageCount;
        _this.mainList = _this.deliverList;
        _this.deliverData();
      });
    },
    deliverData: function deliverData() {
      this.overdueDlist = [];
      if (this.mainList == undefined) return;
      for (var i = 0; i < this.mainList.length; i++) {

        this.overdueDlist.push(this.mainList[i]);
      }

      this.mainList = this.overdueDlist;
      this.partList();
    },
    updateDelivery: function updateDelivery() {
      var _this2 = this;

      console.log(1141, (0, _typeof3.default)(this.expectTime));
      console.log(1144, this.expectTime);
      var param = {
        deliveryId: this.deliveryId ? this.deliveryId : "",
        status: this.status.statusType ? this.status.statusType : 0,
        price: this.ruleForm.price
      };

      if (typeof this.expectTime == "number") {
        param.expectTime = this.expectTime;
      } else if ((0, _typeof3.default)(this.expectTime) == "object") {
        param.expectTime = new Date(mUtils.formatDate(this.expectTime)).getTime();
      } else {
        param.expectTime = "";
      }
      var boolean = "";
      this.$refs.RuleForm[0].validate(function (vali) {
        boolean = vali;
      });
      if (boolean) {
        book.updateDelivery(param).then(function (res) {
          if (res.status !== 200) return _this2.$message.error("更新派送列表失败: " + res.msg);
          if (res.data.code !== 0) {
            {
              return _this2.$message.error("更新派送列表失败: " + res.msg);
            }
          }
          _this2.$message.success("更新派送列表成功");
          _this2.expectTime = "";
          _this2.getDeliveryList();
        });
        this.editDialog = false;
      }
    },
    changeToTime: function changeToTime(datetimes) {
      var date = new Date(datetimes);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      var h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
      var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
      var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      var str = Y + M + D + " " + h + m + s;
      return str;
    },
    getFeedbackList: function getFeedbackList(type) {
      var _this3 = this;

      var param = {
        sendNo: this.sendNo
      };
      this.feedbackList = [];
      book.getFeedbackList(param).then(function (res) {
        if (res.status !== 200) return _this3.$message.error("获取消息列表失败: " + res.msg);
        if (res.data.code !== 0) {
          {
            return _this3.$message.error("获取消息列表失败: " + res.msg);
          }
        }
        _this3.feedbackList = res.data.data.list;
        if (type == 1) _this3.$message.success("刷新消息成功");
      });
    },
    postDeliveryFeedback: function postDeliveryFeedback() {
      var _this4 = this;

      var param = {
        deliveryId: this.deliveryId,
        content: this.content
      };
      if (this.content == "") return this.$message.error("请输入内容");
      book.postDeliveryFeedback(param).then(function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(res) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(res.status !== 200)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", _this4.$message.error("发送反馈消息列表失败: " + res.msg));

                case 2:
                  if (!(res.data.code !== 0)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", _this4.$message.error("发送反馈消息列表失败: " + res.msg));

                case 4:
                  _context.next = 6;
                  return _this4.getFeedbackList();

                case 6:
                  _this4.content = "";
                  _this4.$message.success("发送反馈消息成功");

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    showOrder: function showOrder(row) {
      var _this5 = this;

      var param = {
        sendId: row.sendId
      };
      book.getSettlementSheet(param).then(function (res) {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            _this5.$message.error("获取订单详情失败：" + res.data.msg);
            return;
          } else if (res.data.data == {}) {
            return _this5.$message.error("获取订单详情失败: 无出库面单数据");
          }
          _this5.orderMsg = res.data.data !== {} ? res.data.data : [];
          _this5.orderList = _this5.orderMsg.orderPojoList ? _this5.orderMsg.orderPojoList : [];
          _this5.user = _this5.orderMsg.user ? _this5.orderMsg.user : [];
          _this5.listDia = true;
        }
      });
    },
    onLook: function onLook(val) {
      var that = this;
      that.dialog.show = true;
      that.lookWhichRow = val;
      that.getPreviewOrders(val);
    },
    updateAddress: function updateAddress(val) {
      var that = this;
      that.dialog.updaAddDia = true;
      that.paramDeliverId = val.deliveryId;
      that.paramSendNo = val.sendNo;
      that.paramStatus = val.status;
      that.paramUserId = val.userId;
      var params = {
        sendNo: that.paramSendNo,
        userId: that.paramUserId
      };

      order.getFeedbackList(params).then(function (res) {
        if (res.data.code !== 0) return;
        if (res.data.data) {
          that.phone = that.mobileText = res.data.data.mobile;
          that.address = that.addressText = res.data.data.address;
        }
      });
    },
    closeUpdaAddDialog: function closeUpdaAddDialog() {
      var that = this;
      that.dialog.updaAddDia = false;
      that.phone = "";
      that.address = "";
    },
    certainUpdaAddDialog: function certainUpdaAddDialog() {
      var that = this;

      if (!that.phone || !that.address) {
        that.$message.warning("电话或者地址不能为空");
        return;
      }

      var param = {
        deliveryId: that.paramDeliverId,
        mobile: that.phone,
        address: that.address,
        status: that.paramStatus
      };
      order.updateDelivery(param).then(function (res) {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
        } else {
          that.$message.error("修改失败");
        }
        that.dialog.updaAddDia = false;
        that.phone = "";
        that.address = "";
      });
    },
    getPreviewOrders: function getPreviewOrders(val) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        sendId: val.sendId,
        userId: val.userId
      };
      var standard = 0,
          countTotal = 0,
          orderName = "";

      order.getSendOrderInfo(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            that.volumeTotal = 0;
            that.weightTotal = 0;
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              that.volumeTotal = value.productSize - 0 + that.volumeTotal;
              that.weightTotal = value.productWeight - 0 + that.weightTotal;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              }
            });
          }
          var obj = {};
          var arr = [];

          obj.index = "VIP号：";
          obj.productName = res.data.data.vipCode;
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = "总";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = that.volumeTotal;
          obj.productWeight = that.weightTotal;
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = res.data.data.demandMoney || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = true;
          obj.predictTotal = "额外费用";
          obj.remark = res.data.data.sendPojo.extraPrice || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用备注";
          obj.remark = res.data.data.sendPojo.extraPriceRemark || "";
          that.feeInput = res.data.data.sendPojo.extraPrice || 0;
          that.textarea = res.data.data.sendPojo.extraPriceRemark || "";

          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          var newAmount = res.data.data.sendPojo.amount;
          obj.remark = newAmount ? newAmount.toFixed(2) : 0;
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = "混箱数";
          obj.productName = res.data.data.mixingTankCount;


          var MixTank = res.data.data.mixingTank;
          var mixBoxNumberStr = "";
          if (MixTank.length > 0) {
            MixTank.forEach(function (tank, index) {
              mixBoxNumberStr += " " + tank.boxNumber;
            });
          }

          obj.expressNo = mixBoxNumberStr;
          obj.productVolume = " 123";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          that.paramSendId = res.data.data.sendPojo.sendId;

          obj = {};
          obj.index = "箱数";

          obj.productName = res.data.data.unMixingTanksCount;

          var unMixTank = res.data.data.unMixingTanks;
          var unBoxNumberStr = "";
          unMixTank.forEach(function (unTank, index) {
            unBoxNumberStr += " " + unTank.boxNumber;
          });

          obj.expressNo = unBoxNumberStr;
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
          if (that.toEcelce) {
            var columns = [{ title: "#", key: "index" }, { title: "订单名", key: "productName" }, { title: "运单号", key: "expressNo" }, { title: "体积 CBM", key: "productSize" }, { title: "重量 KG ", key: "productWeight" }, { title: "折扣率 %", key: "rate" }, { title: "费用 CAD", key: "predictTotal" }, { title: "订单备注", key: "remark" }];

            mUtils.export2ExcelTitle(columns, that.tableData, that.orderTitle);
            that.toEcelce = false;
          }
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    updateExtraFee: function updateExtraFee() {
      var that = this;
      that.isUpdateFeeShow = true;
    },
    closeUpdateDialog: function closeUpdateDialog() {
      var that = this;
      that.isUpdateFeeShow = false;
    },
    certainUpdateDialog: function certainUpdateDialog() {
      var _this6 = this;

      var that = this;

      if (that.feeInput == "") {
        that.$message.warning("额外费用不能为空");
        return;
      }

      var param = {
        sendId: that.paramSendId,
        extraPrice: that.feeInput,
        extraPriceRemark: that.textarea
      };
      order.updateExtraInfo(param).then(function (res) {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
          that.getPreviewOrders(_this6.lookWhichRow);
        } else {
          that.$message.error("修改失败");
        }
        that.isUpdateFeeShow = false;
        that.feeInput = "";
        that.textarea = "";
      });
    },
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    changeDate: function changeDate(row, type) {
      if (type == 1) return mUtils.formatDate(new Date(row.createTime), 4);else if (type == 2) return mUtils.formatDate(new Date(row.statementTime), 4);else if (type == 4) return mUtils.formatDate(new Date(row), 4);
    },
    showEditDia: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(row) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.deliveryId = row.deliveryId;
                this.sendNo = row.sendNo;
                this.status.statusType = row.status;
                this.isDisabledStatus = row.status;
                this.ruleForm.price = row.price;
                this.editLsit[0] = row;
                this.expectTime = "";
                if (row.expectTime) {
                  this.expectTime = row.expectTime;
                }
                _context2.next = 10;
                return this.getFeedbackList();

              case 10:
                this.editDialog = true;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function showEditDia(_x2) {
        return _ref3.apply(this, arguments);
      }

      return showEditDia;
    }(),
    showAccountDia: function showAccountDia(row) {
      var _this7 = this;

      this.ruleForm.price = row.price;
      this.sendId = row.sendId;
      var param = {
        sendId: row.sendId
      };
      book.getSettlementSheet(param).then(function (res) {
        if (res.status !== 200) return _this7.$message.error("获取出库面单失败:" + res.msg);
        if (res.data.code1 == 0) return _this7.$message.error("获取出库面单失败:" + res.data.msg);
        if (res.data.data.sendNo == null) return _this7.$message.error("获取出库面单失败:无出库面单数据");
        _this7.accountList[0] = res.data.data;
        _this7.listRow = _this7.accountList[0].orderPojoList ? _this7.accountList[0].orderPojoList : [];

        _this7.settlementBt();
      });
    },
    partList: function partList() {
      for (var i = 0; i < this.deliverList.length; i++) {
        if (this.deliverList[i].status == 0) {
          this.disposeList[this.disposeList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == 1) {
          this.disposingList[this.disposingList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == 2) {
          this.disposedList[this.disposedList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == -1) {
          this.cancelList[this.cancelList.length] = this.deliverList[i];
        }
      }
    },
    settlementBt: function settlementBt() {
      this.confirmSettlement();
      this.accountDia = false;
    },
    confirmSettlement: function confirmSettlement() {
      var _this8 = this;

      var param = {
        sendId: this.sendId,
        balanceRemark: "预约派送结算",
        sign: 1
      };

      book.confirmSettlement(param).then(function (res) {
        if (res.status !== 200) return _this8.$message.error("出库结算失败: " + res.data.msg);
        if (res.data.code !== 0) {
          return _this8.$message.error("出库结算失败: " + res.data.msg);
        }
        _this8.$message.success("出库结算成功");
        _this8.getDeliveryList();
      });
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      this.getHowMangTotal();
    },
    getHowMangTotal: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var that, param, howManyPage, listArr, i, orderName;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = this;
                param = {
                  pageIndex: 1,
                  pageSize: 400,
                  orderNo: this.orderNo ? this.orderNo : "",
                  userName: this.userName ? this.userName : "",
                  deliveryNumber: this.deliveryNumber ? this.deliveryNumber : "",
                  status: this.checkedStatus ? this.checkedStatus : ""
                };
                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                listArr = [];
                i = 1;

              case 5:
                if (!(i <= howManyPage)) {
                  _context3.next = 12;
                  break;
                }

                param.pageIndex = i;
                _context3.next = 9;
                return book.getDeliveryList(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        every.createTime = mUtils.formatDate(new Date(every.createTime)).substring(0, 19);

                        if (every.goodType == 1) {
                          every.goodType = "海运";
                        } else if (every.goodType == 2) {
                          every.goodType = "海运大件";
                        } else if (every.goodType == 3) {
                          every.goodType = "空运";
                        } else {
                          every.goodType = "";
                        }

                        if (every.status == 0) {
                          every.status = "待处理";
                        } else if (every.status == 1) {
                          every.status = "处理中";
                        } else if (every.status == -1) {
                          every.status = "已取消";
                        } else if (every.status == 2) {
                          every.status = "已处理";
                        } else {
                          every.status = "";
                        }

                        listArr.push(every);
                      });
                    }
                  }
                });

              case 9:
                i++;
                _context3.next = 5;
                break;

              case 12:

                that.listArr = listArr;
                orderName = "派送列表Excel";

                mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getHowMangTotal() {
        return _ref4.apply(this, arguments);
      }

      return getHowMangTotal;
    }(),
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.mainList.length = that.paginations.page_size * 1;
      if (that.res == undefined || that.res == "1") {
        that.checkedStatus = "";
      } else if (that.res == 2) {
        that.checkedStatus = "0";
      } else if (that.res == 3) {
        that.checkedStatus = "1";
      } else {
        that.checkedStatus = "2";
      }
      that.getDeliveryList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      if (that.res == undefined || that.res == "1") {
        that.checkedStatus = "";
      } else if (that.res == 2) {
        that.checkedStatus = "0";
      } else if (that.res == 3) {
        that.checkedStatus = "1";
      } else {
        that.checkedStatus = "2";
      }
      that.getDeliveryList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    mulOutStoreToPay: function mulOutStoreToPay() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      var sendIds = [];
      that.multipleSelection.forEach(function (obj) {
        sendIds.push(obj.sendId);
      });
      param.sendIds = sendIds;
      param.balanceRemark = "预约派送结算";
      param.sign = 1;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });

      book.mulOutStoreToPay(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getDeliveryList();
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.getDeliveryList();
    },
    batchChange: function batchChange() {
      this.getDeliveryList();
    },
    remoteMethod: function remoteMethod(value) {
      var _this9 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this9.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      vipCode: "",
      newDate: "",

      orderG: "",
      volumeTotal: 0,
      weightTotal: 0,
      toEcelce: false,
      orderTitle: "",
      remark: "",
      batchNum: "",

      deliverAddress: null,
      deliverAddressArr: [],
      value1: "",
      activeName: "first",
      columns: [{ title: "商品名称", key: "orderNo" }, { title: "数量", key: "productNum" }, { title: "库位", key: "shelves" }, { title: "入库时间", key: "storeTime" }, { title: "关联运单号", key: "expressNo" }, { title: "关联订单编号", key: "orderNo" }, { title: "客户", key: "userName" }, { title: "客户VIP号", key: "vipCode" }],

      NowDate: "",
      dialog: {
        show: false
      },

      orderNOA: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      orderList: [],
      orderListExport: [],
      tableData: [{
        remark: "sdad",
        predictTotal: "100",
        rate: 10,
        productWeight: 12
      }],

      howManyTotal: 0,
      listArr: [],
      columnsOrder: [{ title: "发货编号", key: "sendNo" }, { title: "发货时间", key: "sendTime" }, { title: "发货VIP号", key: "vipCode" }, { title: "用户名", key: "realName" }, { title: "订单数量", key: "orderCount" }, { title: "实收费用CAD", key: "amount" }, { title: "余额", key: "userBalance" }, { title: "批次", key: "remark" }, { title: "操作时间", key: "operatorTime" }],

      isUpdateFeeShow: false,
      feeInput: "",
      textarea: "",

      paramSendId: "",
      lookWhichRow: null,
      chukuTime: null,
      startDate: null,
      endDate: null,
      totalFee: "",
      sendNo: null,

      batchList: [],

      timeout: null,

      checkedRecStatus: null,

      receOptions: [{ value: 0, label: "未签收" }, { value: 1, label: "已签收" }],
      loading: false,

      detailBalance: 0,

      roleId: null
    };
  },
  created: function created() {
    var that = this;
    that.getStoreList();
    this.getBatchList();
    this.getAdressId();
  },
  mounted: function mounted() {
    var userinfo = mUtils.getStore('userinfo');

    if (userinfo.roleId == 3) {
      this.roleId = 3;
      this.deliverAddress = userinfo.adminId;
    }
  },

  methods: {
    getPreviewOrders: function getPreviewOrders(val) {
      var _this2 = this;

      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        sendId: val.sendId,
        userId: val.userId
      };
      var standard = 0,
          countTotal = 0,
          orderName = "";

      order.getSendOrderInfo(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            that.volumeTotal = 0;
            that.weightTotal = 0;
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              that.volumeTotal = value.productSize - 0 + that.volumeTotal;
              that.weightTotal = value.productWeight - 0 + that.weightTotal;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              }
            });
          }
          var obj = {};
          var arr = [];

          obj.index = "VIP号：";

          if (res.data.data && res.data.data.vipCode) {
            obj.productName = res.data.data.vipCode;
          } else {
            obj.productName = "";
          }
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.boxNumber = "箱号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.userBalance = "余额";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = "总";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = that.volumeTotal;
          obj.productWeight = that.weightTotal;
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = res.data.data.demandMoney || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = true;
          obj.predictTotal = "额外费用";
          obj.remark = res.data.data.sendPojo.extraPrice || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用备注";
          obj.remark = res.data.data.sendPojo.extraPriceRemark || "";
          that.feeInput = res.data.data.sendPojo.extraPrice || 0;
          that.textarea = res.data.data.sendPojo.extraPriceRemark || "";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          var newAmount = res.data.data.sendPojo.amount;
          obj.remark = newAmount ? newAmount.toFixed(2) : 0;
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = "混箱数";
          obj.productName = res.data.data.mixingTankCount;


          var MixTank = res.data.data.mixingTank;

          obj.productVolume = " 123";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          that.paramSendId = res.data.data.sendPojo.sendId;

          obj = {};
          obj.index = "箱数";
          obj.productName = res.data.data.unMixingTanksCount;

          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
          that.tableData.map(function (everyObj, eIndex) {
            if (eIndex == 2) {
              everyObj.userBalance = _this2.detailBalance;
              return everyObj;
            }
          });
          if (that.toEcelce) {
            var columns = [{ title: "#", key: "index" }, { title: "订单名", key: "productName" }, { title: "运单号", key: "expressNo" }, { title: "箱号", key: "boxNumber" }, { title: "体积 CBM", key: "productSize" }, { title: "重量 KG ", key: "productWeight" }, { title: "折扣率 %", key: "rate" }, { title: "费用 CAD", key: "predictTotal" }, { title: "余额", key: "userBalance" }, { title: "订单备注", key: "remark" }];

            mUtils.export2ExcelTitle(columns, that.tableData, that.orderTitle);
            that.toEcelce = false;
          }
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    onLook: function onLook(val) {
      var that = this;
      that.dialog.show = true;
      that.lookWhichRow = val;
      if (val.userBalance !== undefined) {
        this.detailBalance = val.userBalance;
      } else {
        this.detailBalance = "";
      }
      that.getPreviewOrders(val);
    },
    onTOEcexlce: function onTOEcexlce(val) {
      var that = this;
      that.toEcelce = true;
      that.orderTitle = val.vipCode + "-" + val.sendTime;
      if (val.userBalance !== undefined) {
        this.detailBalance = val.userBalance;
      } else {
        this.detailBalance = "";
      }
      that.getPreviewOrders(val);
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getStoreList: function getStoreList(dataA) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        vipCode: that.vipCode ? that.vipCode : "",
        startDate: that.startDate ? that.startDate : "",
        endDate: that.endDate ? that.endDate : "",
        remark: that.remark ? that.remark : null,
        sendNo: that.sendNo ? that.sendNo : null,
        batchNumber: that.batchNum ? that.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,

        deliveryId: null
      };

      if (that.deliverAddress) {
        that.deliverAddressArr.forEach(function (dItem, index) {
          if (dItem.adminId == that.deliverAddress) {
            data.deliveryId = dItem.addressId;
          }
        });
      }

      dataA == "1" ? data.pageIndex = 1 : "";
      dataA == "1" ? that.paginations.page_index = 1 : "";
      order.sendOrderList(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, i) {
              if (val.user && val.user.vipCode) {
                val.vipCode = val.user.vipCode || "";
              } else {
                val.vipCode = "";
              }

              if (val.user && val.user.realName) {
                val.realName = val.user.realName || "";
              } else {
                val.realName = "";
              }
              val.createTime = mUtils.formatDate(new Date(val.createTime)).substring(0, 16);
              val.sendTime = mUtils.formatDate(new Date(val.sendTime)).substring(0, 10);
              val.operatorTime = mUtils.formatDate(new Date(val.operatorTime)).substring(0, 16);
            });
            that.orderList = res.data.data.list;
            that.orderList.map(function (newObj) {
              if (newObj.user && newObj.user.balance !== undefined) {
                newObj.userBalance = newObj.user.balance || "0";
              } else {
                newObj.userBalance = "";
              }
            });

            that.paginations.total = res.data.data.pageCount;
            that.totalFee = res.data.data.total;
            that.howManyTotal = res.data.data.pageCount;
          } else {
            that.orderList = [];
            that.paginations.total = 0;
            that.totalFee = 0;
            that.howManyTotal = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });
    },
    outDepot: function outDepot() {
      this.getStoreList("1");
    },
    getDate: function getDate(chukuTime) {
      if (!chukuTime) {
        this.startDate = "";
        this.endDate = "";
        this.getStoreList("1");
        return;
      }
      this.startDate = new Date(mUtils.formatDate(chukuTime[0])).getTime();
      var tempEndDate = new Date(mUtils.formatDate(chukuTime[1])).getTime();
      tempEndDate *= 1;
      tempEndDate += 86399000;
      this.endDate = tempEndDate;
      this.getStoreList("1");
    },
    sendNoBlur: function sendNoBlur() {
      this.getStoreList("1");
    },
    vipCodeBlur: function vipCodeBlur() {
      this.getStoreList("1");
    },
    remarkBlur: function remarkBlur() {
      this.getStoreList("1");
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      that.getAllData();
    },
    getAllData: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var that, data, howManyPage, listArr, i, orderName;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                data = {
                  pageIndex: 1,
                  pageSize: 400,
                  vipCode: that.vipCode ? that.vipCode : "",
                  startDate: that.startDate ? that.startDate : "",
                  endDate: that.endDate ? that.endDate : "",
                  remark: that.remark ? that.remark : null,
                  sendNo: that.sendNo ? that.sendNo : null,
                  batchNumber: that.batchNum ? that.batchNum.trim() : null,
                  isReceipt: that.checkedRecStatus || null,

                  deliveryId: null
                };

                if (that.deliverAddress) {
                  that.deliverAddressArr.forEach(function (dItem, index) {
                    if (dItem.adminId == that.deliverAddress) {
                      data.deliveryId = dItem.addressId;
                    }
                  });
                }

                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                listArr = [];
                i = 1;

              case 6:
                if (!(i <= howManyPage)) {
                  _context.next = 13;
                  break;
                }

                data.pageIndex = i;
                _context.next = 10;
                return order.sendOrderList(data).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        every.sendTime = mUtils.formatDate(new Date(every.sendTime)).substring(0, 10);
                        every.operatorTime = mUtils.formatDate(new Date(every.operatorTime)).substring(0, 16);
                        if (every.user && every.user.vipCode) {
                          every.vipCode = every.user.vipCode;
                        }
                        if (every.user && every.user.realName) {
                          every.realName = every.user.realName;
                        }
                        listArr.push(every);
                      });
                    }
                  }
                });

              case 10:
                i++;
                _context.next = 6;
                break;

              case 13:
                that.listArr = listArr;
                that.listArr.map(function (newObj) {
                  if (newObj.user && newObj.user.balance !== undefined) {
                    newObj.userBalance = newObj.user.balance || "0";
                  } else {
                    newObj.userBalance = "";
                  }
                });
                orderName = "发货单Excel";

                mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllData() {
        return _ref.apply(this, arguments);
      }

      return getAllData;
    }(),
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;

      that.paginations.page_size = page_size;

      that.getStoreList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getStoreList();
    },
    updateExtraFee: function updateExtraFee() {
      var that = this;
      that.isUpdateFeeShow = true;
    },
    closeUpdateDialog: function closeUpdateDialog() {
      var that = this;
      that.isUpdateFeeShow = false;
    },
    certainUpdateDialog: function certainUpdateDialog() {
      var _this3 = this;

      var that = this;

      if (that.feeInput == "") {
        that.$message.warning("额外费用不能为空");
        return;
      }

      var param = {
        sendId: that.paramSendId,
        extraPrice: that.feeInput,
        extraPriceRemark: that.textarea
      };
      order.updateExtraInfo(param).then(function (res) {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
          that.getPreviewOrders(_this3.lookWhichRow);
        } else {
          that.$message.error("修改失败");
        }
        that.isUpdateFeeShow = false;
        that.feeInput = "";
        that.textarea = "";
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.getStoreList("1");
    },
    batchChange: function batchChange() {
      this.getStoreList("1");
    },
    remoteMethod: function remoteMethod(value) {
      var _this4 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.getBatchList(value);
      }, 500);
    },
    banlanceShow: function banlanceShow(row) {
      if (row.user && row.user.balance !== undefined) {
        return row.user.balance;
      }
    },
    getAdressId: function getAdressId() {
      var _this5 = this;

      var uselist = mUtils.getStore("userinfo");
      var realName = uselist.realName;
      var roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this5.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this5.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this5.deliverAddressArr = res.data.data.list;
        }
      });
    }
  }
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _debounce = __webpack_require__(203);

var deApi = _interopRequireWildcard(_debounce);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "vipCode") text = "请输入VIP号";else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      total: null,
      orderInfo: [],
      disable: false,
      isSearch: false,
      boxNumber: '',
      datalist: [],
      deliveryTitle: '',
      viewDialog: {
        boxContainerNumber: ''
      },
      realName: '',
      msg: "",
      dialog: {
        show: false
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: ""
        },
        form_rules: {
          vipCode: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          expressCompany: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },

      tobeIntoList: [],
      hasIntoList: [],
      isExistMark: false,
      isRepeatMark: false,
      isPassMark: false,
      orderNum: "",
      falseMark: false,
      trueMark: true
    };
  },
  created: function created() {
    this.getAdressId();
    this.getTobeIntoStorList();
    this.getHasIntoStorList();
  },

  watch: {
    boxNumber: function boxNumber() {
      if (this.boxNumber.length == 16) {
        this.confirm();
      }
      if (this.boxNumber.length > 16) {
        this.boxNumber.slice(0, 16);
      }
    }
  },
  methods: {
    init: function init() {
      this.isSearch = false;
      this.dialog.show = false;
      this.viewDialog = '';
      this.orderInfo = [];
      this.msg = "";
    },
    inputC: function inputC() {},
    confirm: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var that, param, timers, orderNum, ruleOne, resultOne, ruleTwo, resultTwo, timer;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.boxNumber == '')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.dialog.show == false)) {
                  _context.next = 37;
                  break;
                }

                this.msg = "";
                that = this;
                param = {};

                param.pageIndex = 1;
                param.pageSize = 20;
                param.status = 8;
                param.goodType = null;
                param.boxNumber = that.boxNumber.replace(/\s/g, "");
                param.vipCode = '';
                param.deliveryTitle = '';

                if (!(that.boxNumber !== '')) {
                  _context.next = 35;
                  break;
                }

                _context.next = 16;
                return boxApi.boxList(param).then(function (res) {
                  if (res.status !== 200) {
                    return that.$message.error('获取订单异常：' + res.msg);
                  }
                  if (res.data.code != 0) {
                    return that.$message.error(res.data.msg || "获取合箱列表异常");
                  }
                  if (res.data.data.pageCount !== 0) that.orderInfo = res.data.data.list[0] || [];
                });

              case 16:
                if (!(that.orderInfo !== [] && that.orderInfo.boxNumber == that.boxNumber.replace(/\s/g, ""))) {
                  _context.next = 24;
                  break;
                }

                this.getBoxInfo();
                that.$message({
                  message: "入库成功!",
                  type: "success"
                });

                that.isPassMark = true;
                clearTimeout(timers);
                timers = setTimeout(function () {
                  that.isPassMark = false;
                }, 0);
                _context.next = 35;
                break;

              case 24:
                orderNum = this.boxNumber.trim();


                this.getTobeIntoStorList();
                this.getHasIntoStorList();
                that.orderNum = orderNum;

                ruleOne = function ruleOne(json) {
                  return json.boxNumber == orderNum;
                };

                resultOne = that.tobeIntoList.some(ruleOne);

                ruleTwo = function ruleTwo(json) {
                  return json.boxNumber == orderNum;
                };

                resultTwo = that.hasIntoList.some(ruleTwo);

                if (!resultOne && !resultTwo) {
                  that.isExistMark = true;
                  that.boxNumber = "";
                }

                if (!resultOne && resultTwo) {
                  that.isRepeatMark = true;
                  clearTimeout(timer);
                  timer = setTimeout(function () {
                    that.isRepeatMark = false;
                  }, 1200);

                  that.boxNumber = "";
                }

                return _context.abrupt("return");

              case 35:
                _context.next = 38;
                break;

              case 37:
                this.submit();

              case 38:
                this.dialog.show = true;

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm() {
        return _ref.apply(this, arguments);
      }

      return confirm;
    }(),
    closed: function closed() {
      var inputDom = document.getElementById('inputBox');
      inputDom.focus();
    },
    getTobeIntoStorList: function getTobeIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "8";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return;
        }
        that.tobeIntoList = res.data.data.list || [];
      });
    },
    getHasIntoStorList: function getHasIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "20";
      param.status = "9";
      param.goodType = null;
      param.orderNo = null;
      param.userName = null;
      order.getOrderList(param).then(function (res) {
        if (res.data.code != 0) return;
        that.hasIntoList = res.data.data.list || [];
      });
    },
    cancel: function cancel() {
      this.init();
    },
    openFail: function openFail() {
      var audioPar = document.getElementsByClassName("audioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/rukuFail.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openRepeat: function openRepeat() {
      var audioPar = document.getElementsByClassName("repeAudioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/repeatRuku.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openPass: function openPass() {
      this.confirm();


      var audioPar = document.getElementsByClassName("passAudioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/rukuSuccess.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
      this.dialog.show = false;
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      var param = {};
      param.boxId = this.orderInfo.boxId;
      param.status = 9;
      param.type = 2;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.allocationCentrePut(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }


        that.boxNumber = '';
        that.cancel();
        that.dialog.show = false;
        _this.getTobeIntoStorList();
        _this.getHasIntoStorList();
      });
    },
    getBoxInfo: function getBoxInfo() {
      var that = this;
      var param = {};
      param.boxId = that.orderInfo.boxId;
      boxApi.allocationCentreInformation(param).then(function (res) {
        if (res.data.code != 0) {
          that.datalist = [];
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.total = res.data.data.totalFreight;
        that.datalist = res.data.data.orderPojoList;
      });
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    getOrderList: function getOrderList() {
      var that = this;
      var data = {
        pageIndex: 1,
        pageSize: 10,
        status: 9,
        orderNo: '',
        userName: '',
        goodType: null,
        deliveryTitle: this.deliveryTitle
      };
      order.getOrderList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        } else if (res.data.code == 0) {

          that.tableData = res.data.data.list;
        } else {
          that.$message.error("获取订单列表失败");
        }
      });
    },
    getAdressId: function getAdressId() {
      var _this2 = this;

      var uselist = mUtils.getStore('userinfo');
      this.realName = uselist.realName;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this2.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this2.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data.list !== {}) {
          var data = res.data.data.list;
          _this2.addressList = data;
          for (var i = 0; i < data.length; i++) {
            if (data[i].contact == _this2.realName) {
              _this2.deliveryTitle = data[i].deliveryTitle;
              _this2.getOrderList();
              return;
            }
          }
        }
        _this2.getOrderList();
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    document.getElementById('inputBox').addEventListener("keydown", deApi.debounce(function (e) {
      if (e.keyCode == 27) {
        _this3.cancel();
      } else if (e.keyCode == 13) {
        _this3.confirm();
      }
    }, 300, true));
  }
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _img = __webpack_require__(131);

var img = _interopRequireWildcard(_img);

var _utils = __webpack_require__(15);

var _admin = __webpack_require__(200);

var admin = _interopRequireWildcard(_admin);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "contact") text = "请输入负责人姓名";else if (rule.field == "tel") text = "请输入负责人电话";else if (rule.field == "deliveryTitle") text = "请输入派送点";else if (rule.field == "boxSign") text = "请输入派送点编号";else if (rule.field == "address") text = "请输入派送点详细地址";else if (rule.field == "userName") text = "请输入用户名";else if (rule.field == "password") text = "请输入用户密码";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改",
        step: 1,
        data: {
          adminId: "",
          addressId: null,
          deliveryTitle: "",
          boxSign: "",
          address: "",
          contact: "",
          tel: "",
          contactPhoto: "",
          imageUrl: "",
          userName: "",
          password: ""
        },
        form_rules: {
          contact: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          tel: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          deliveryTitle: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          boxSign: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }, { min: 4, max: 4, message: "长度为 4 个字符", trigger: "blur" }],
          address: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          userName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          password: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      deliveryList: [] };
  },
  created: function created() {
    var that = this;
    that.getDeliveryList();
  },

  methods: {
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getDeliveryList();
    },
    add: function add() {
      this.editDialog.show = true;
      this.editDialog.step = 1;
      this.editDialog.title = "添加";
      this.editDialog.data = {
        addressId: null,
        contact: "",
        tel: "",
        deliveryTitle: "",
        boxSign: "",
        address: "",
        contactPhoto: "",
        imageUrl: "",
        userName: "",
        password: ""
      };
    },
    edit: function edit(row) {
      this.editDialog.show = true;
      this.editDialog.step = 3;
      this.editDialog.title = "修改";
      this.editDialog.data = {
        addressId: row.addressId,
        contact: row.contact,
        tel: row.tel,
        deliveryTitle: row.deliveryTitle,
        boxSign: row.boxSign,
        address: row.address,
        adminId: row.adminId,
        contactPhoto: row.contactPhoto,
        imageUrl: row.contactPhoto,
        userName: row.userName,
        password: row.password
      };
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          var data = {
            addressId: that.editDialog.data.addressId,
            contact: that.editDialog.data.contact,
            tel: that.editDialog.data.tel,
            deliveryTitle: that.editDialog.data.deliveryTitle,
            boxSign: that.editDialog.data.boxSign,
            address: that.editDialog.data.address,
            contactPhoto: that.editDialog.data.contactPhoto,
            userName: that.editDialog.data.userName,
            adminId: that.editDialog.data.adminId,
            password: that.$md5(that.editDialog.data.password),
            type: 2,
            roleId: 3
          };
          if (!data.addressId) {
            data.password = that.$md5(that.editDialog.data.password);
          }
          var loading = _this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          if (data.addressId) {
            loading.close();
            deliveryApi.deliveryUpdate(data).then(function (res) {
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getDeliveryList();
              that.editDialog.show = false;
            });
          } else {
            deliveryApi.deliveryAdd(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getA();
              that.getDeliveryList();
              that.editDialog.show = false;
            });
          }
        }
      });
    },
    getA: function getA() {
      var data = {
        pageIndex: 1,
        pageSize: 1,
        userName: ""
      };
      var that = this;
      admin.getAdminList(data).then(function (res) {
        if (res.data.code == 1202) {
          return;
        }
        if (res.data.code != 0) {
          return;
        } else {
          that.adminId = res.data.data.list[0].adminId;
          that.changePassword();
        }
      });
    },
    changePassword: function changePassword() {
      var data = {
        adminId: this.adminId,
        password: this.$md5(this.editDialog.data.password),
        operatorId: mUtils.getStore("userinfo").adminId
      };
      admin.updatePwd(data).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {} else if (res.data.code == 120) {} else {}
          return;
        } else {}
      });
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        console.log(res);
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];

          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    deleteData: function deleteData(addressId) {
      var _this2 = this;

      var data = {
        addressId: addressId
      };
      deliveryApi.deleteDeliverP(data).then(function (res) {
        if (res.data.code == 1202) {
          _this2.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          _this2.$message.success("删除分拨点成功");
          _this2.getDeliveryList();
        } else {
          _this2.$message.error("删除分拨点失败: " + res.data.msg);
        }
      });
    },
    updateStatus: function updateStatus(addressId, rowStatus) {
      var _this3 = this;

      var data = {
        addressId: addressId
      };

      if (rowStatus == 1) {
        data.status = 2;
      } else {
        data.status = 1;
      }
      deliveryApi.deleteDeliverP(data).then(function (res) {
        if (res.data.code == 1202) {
          _this3.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          _this3.$message.success("分拨点状态修改成功");
          _this3.getDeliveryList();
        } else {
          _this3.$message.error("分拨点状态修改失败: " + res.data.msg);
        }
      });
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getDeliveryList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getDeliveryList();
    },

    handleLicenseImgFile: function handleLicenseImgFile(file) {
      var that = this;
      var formData = new FormData();
      formData.append("file", file.file);

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        loading.close();
        if (res.data.code == 0) {
          that.editDialog.data.contactPhoto = res.data.data.data.url;
          that.editDialog.data.imageUrl = res.data.data.data.path;
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {},
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    }
  }
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _customer = __webpack_require__(202);

var customer = _interopRequireWildcard(_customer);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "realName") text = "用户名";else if (rule.field == "mobile") text = "手机号";else if (rule.field == "demandCount") text = "工单配额";else if (rule.field == "deliveryId") text = "派送点";
        return callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "demandCount") {
          var reg = /^\d+$|^\d*\.\d+$/g;
          if (!reg.test(value)) {
            callback(new Error("只能输入数字和小数点"));
          }
        }
        return callback();
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改用户",
        data: {
          userId: null,
          realName: "",
          mobile: "",
          remark: "",
          demandCount: "",
          deliveryId: null
        },
        form_rules: {
          realName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          mobile: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          demandCount: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          deliveryId: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },
      deleteDialog: {
        show: false,
        title: "删除用户"
      },
      deliveryList: [],
      galVal: "",
      radio: "",
      searchData: {
        keyWord: "",
        keyWordB: "",
        keyWordC: ""
      },
      dialog: {
        show: false,
        showB: false
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      customerList: [],
      sortWay: "1" };
  },
  created: function created() {
    var that = this;
    that.userId = that.$route.query.userId || "";
    that.getCustomer();
    that.getDeliveryList();
  },


  methods: {
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getCustomer();
    },
    editUser: function editUser(row) {
      this.editDialog.show = true;
      this.editDialog.data = {
        userId: row.userId,
        realName: row.realName,
        mobile: row.mobile,
        demandCount: row.demandCount,
        remark: row.remark,
        deliveryId: row.deliveryId || null
      };
    },
    delAppendUser: function delAppendUser(row) {
      this.deleteDialog.show = true;
      this.editDialog.data = {
        userId: row.userId
      };
    },
    routerTo: function routerTo() {
      this.$router.push("/recharge/charge");
    },
    submitUser: function submitUser() {
      var that = this;
      var data = {};
      data.userId = that.editDialog.data.userId;
      data.realName = that.editDialog.data.realName;
      data.mobile = that.editDialog.data.mobile;
      data.demandCount = that.editDialog.data.demandCount;
      data.remark = that.editDialog.data.remark;
      data.deliveryId = that.editDialog.data.deliveryId;
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          customer.updateUserInfo(data).then(function (res) {
            if (res.data.code == 1202) {
              that.$router.push("/login");
              return;
            }
            if (res.data.code != 0) {
              that.$message.error(res.data.msg || "操作失败");
              return;
            }
            that.$message({
              message: "操作成功",
              type: "success"
            });

            that.getCustomer();
            that.editDialog.show = false;
          });
        }
      });
    },
    deleteUser: function deleteUser() {
      var that = this;
      var data = {};
      data.userId = that.editDialog.data.userId;

      customer.del(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success"
        });

        that.getCustomer();
        that.deleteDialog.show = false;
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getCustomer: function getCustomer() {
      var that = this;
      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        nickname: that.searchData.keyWord ? that.searchData.keyWord : null,
        realName: that.searchData.keyWordB ? that.searchData.keyWordB : null,
        mobile: that.searchData.keyWordC ? that.searchData.keyWordC : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        sort: that.sortWay
      };
      var val = JSON.parse(localStorage.getItem("userinfo"));
      if (val.roleId !== 1) {
        data.adminId = val.adminId;
      }
      customer.getCustomerList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.customerList = res.data.data.list;

          that.customerList && that.customerList.length > 0 && that.customerList.forEach(function (val, i) {
            val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
          });
          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDate: function getDate(value1) {
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;

      that.getCustomer();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getCustomer();
    },
    sortBalance: function sortBalance(column) {
      if (this.sortWay == "1") {
        this.sortWay = "2";
        this.getCustomer(1);
      } else if (this.sortWay == "2") {
        this.sortWay = "1";
        this.getCustomer(1);
      } else {
        return;
      }
    }
  }
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _utils = __webpack_require__(15);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      search: {
        boxNumber: "",
        deliveryTitle: "",
        vipCode: "",
        goodType: null,
        orderNumber: null,
        batchNum: null
      },

      batchList: [],

      timeout: null,

      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],
      activeName: "8",
      viewDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxContainerNumber: null,
        boxInfo: {},
        list: []
      },
      detailDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: {},
        list: []
      },
      outDialog: {
        show: false,
        boxId: null
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      dataList: [],
      deliveryAddressList: [],
      multipleSelection: [],
      loading: false
    };
  },
  created: function created() {
    var that = this;
    that.activeName = that.$route.query.activeName ? that.$route.query.activeName : that.activeName;
    that.getBoxList();
    that.getDeliveryList();
    var accountObj = JSON.parse(localStorage.getItem("userinfo"));
    this.accountObj = accountObj;
    this.getBatchList();
  },

  methods: {
    init: function init() {
      this.paginations.page_index = 1;
      this.getBoxList();
    },
    handleClick: function handleClick(tab, event) {
      if (this.activeName != 8) {
        this.$router.push("/delivery/order/list?activeName=" + this.activeName);
        return;
      }
      this.getBoxList();
    },
    getBoxList: function getBoxList() {
      var that = this;
      var param = {};
      param.pageIndex = that.paginations.page_index;
      param.pageSize = that.paginations.page_size;
      param.status = that.activeName;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.orderNumber = that.search.orderNumber;
      param.batchNumber = that.search.batchNum ? that.search.batchNum.trim() : "";

      param.deliveryTitle = that.search.deliveryTitle;
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.dataList = res.data.data.list || [];
        that.paginations.total = res.data.data.pageCount;
      });
    },
    submit: function submit() {
      var that = this;
      var param = {};
      param.boxId = this.viewDialog.boxId;
      param.status = 9;
      param.type = 2;
      param.containerName = that.viewDialog.boxContainerNumber;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.allocationCentrePut(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.viewDialog.show = false;
      });
    },
    outSubmit: function outSubmit() {
      var that = this;
      var param = {};
      param.boxId = this.outDialog.boxId;
      param.status = 8;
      param.type = 1;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.boxDelivery(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    outBoxHanlder: function outBoxHanlder(row) {
      this.outDialog.show = true;
      this.outDialog.boxId = row.boxId;
    },
    outHanlder: function outHanlder(row) {
      this.viewDialog.boxId = row.boxId;
      this.getBoxInfo();
      this.viewDialog.show = true;
    },
    viewHandler: function viewHandler(row) {
      this.detailDialog.boxId = row.boxId;
      this.getBoxDetail();
      this.detailDialog.show = true;
    },
    getBoxInfo: function getBoxInfo() {
      var that = this;
      var param = {};
      param.boxId = that.viewDialog.boxId;
      boxApi.allocationCentreInformation(param).then(function (res) {
        if (res.data.code != 0) {
          that.viewDialog.list = [];
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.viewDialog.boxInfo = res.data.data;
        that.viewDialog.boxContainerNumber = that.viewDialog.boxInfo ? that.viewDialog.boxInfo.boxContainerNumber : "";
        that.viewDialog.list = res.data.data.orderPojoList || [];
      });
    },
    getBoxDetail: function getBoxDetail() {
      var that = this;
      var param = {};
      param.boxId = that.detailDialog.boxId;
      boxApi.boxDetails(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.detailDialog.boxInfo = res.data.data;
        that.detailDialog.list = res.data.data.orderPojoList || [];
      });
    },
    stringGoodType: function stringGoodType(goodType) {
      return StringUtils.goodType(goodType);
    },
    strStatus: function strStatus(status) {
      var str = "";
      switch (status) {
        case 8:
          str = "待入库";
          break;
      }
      return str;
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getBoxList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getBoxList();
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code != 0) {
          return;
        }
        if (res.data.code == 0) {
          that.deliveryAddressList = res.data.data.list;
        }
      });
    },
    selectable: function selectable(row, index) {
      if (this.activeName == "7") {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    mulIntoStore: function mulIntoStore() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      param.status = 9;
      var boxPojos = [];
      that.multipleSelection.forEach(function (item) {
        boxPojos.push(item.boxId);
      });
      param.boxIds = boxPojos;


      boxApi.multiIntoStore(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.init();
    },
    batchChange: function batchChange() {
      this.init();
    },
    remoteMethod: function remoteMethod(value) {
      var _this = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      activeName: "9",
      search: {
        goodType: null,
        orderNo: null,
        userName: null,
        addressId: null,
        statementStartDate: null,
        deliveryEndDate: null,
        orderNumber: null,
        batchNum: null
      },
      tableData: [],
      expressNo: "",
      viewDialog: {
        show: false,
        title: "出库结算",
        orderId: null,
        orderInfo: {
          detailList: []
        },
        list: []
      },
      user: [],
      bool: false,
      columns: [{ title: "订单编号", key: "orderNo" }, { title: "名称", key: "productName" }, { title: "派送点", key: "deliveryTitle" }, { title: "货物类型", key: "goodName" }, { title: "客户", key: "userName" }, { title: "vip号", key: "vipCode" }, { title: "联系方式", key: "userTel" }, { title: "批次", key: "batchNumber" }, { title: "箱号", key: "boxNumber" }, { title: "物流公司", key: "expressCompany" }, { title: "运单号", key: "expressNo" }, { title: "商品价值", key: "predictTotal" }, { title: "体积", key: "productVolume" }, { title: "重量", key: "productWeight" }, { title: "尺寸", key: "measure" }, { title: "状态", key: "dealStatus" }, { title: "运费", key: "total" }, { title: "工单费(CAD)", key: "demandMoney" }, { title: "派送费(CAD)", key: "deliveryAmount" }, { title: "额外费用(CAD)", key: "extraPrice" }, { title: "额外费用备注", key: "extraPriceRemark" }, { title: "下单时间", key: "addDate" }, { title: "所在箱", key: "boxNumber" }, { title: "用户备注", key: "userRemark" }, { title: "订单备注", key: "remark" }],
      bookTip: false,
      detailDialog: {
        show: false,
        title: "查看详情",
        orderNo: null,
        orderInfo: {},
        list: [],
        feeInfo: {}
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      postCount: 0,
      excelList: [],
      excelList2: [],
      newDate: "",

      chukuTime: null,
      totalFee: "",
      totalNum: "",

      accountObj: null,
      multipleSelection: [],
      loading: false,

      batchList: [],

      timeout: null,

      checkedRecStatus: null,

      receOptions: [{ value: "0", label: "未签收" }, { value: "1", label: "已签收" }],
      deliverAddress: "",
      deliverAddressArr: [] };
  },
  created: function created() {
    var that = this;
    that.activeName = that.$route.query.activeName ? that.$route.query.activeName : that.activeName;
    var accountObj = JSON.parse(localStorage.getItem("userinfo"));
    this.accountObj = accountObj;
    this.getAdressId();
    this.getOrderList();
    this.getBatchList();
  },

  methods: {
    init: function init() {
      this.paginations.page_index = 1;
      this.getOrderList();
    },
    getOrderList: function getOrderList(dataA) {
      var that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: that.activeName,
        orderNo: that.search.orderNo,
        userName: that.search.userName,
        goodType: that.search.goodType ? that.search.goodType : null,
        sendTime: that.newDate ? that.newDate : "",
        deliveryStartDate: that.statementStartDate ? that.statementStartDate : "",
        deliveryEndDate: that.deliveryEndDate ? that.deliveryEndDate : "",
        orderNumber: that.search.orderNumber ? that.search.orderNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null
      };
      order.getOrderList(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              val.storeDate = "";

              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
                val.storeDate = mUtils.formatDate(new Date(val.storeTime)).substring(0, 10);
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils.formatDate(new Date(val.deliveryTime)).substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils.formatDate(new Date(val.statementTime)).substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            that.tableData = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
            that.totalFee = res.data.data.total;
            that.totalNum = res.data.data.num;
          } else {
            that.tableData = [];
            that.paginations.total = 0;
            that.totalFee = 0;
            that.totalNum = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    getOrderListB: function getOrderListB(page, callback, pageCount) {
      var that = this;

      var status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "4") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      var data = {
        pageIndex: page,
        pageSize: pageCount,
        status: that.activeName,
        orderNo: that.search.orderNo,
        userName: that.search.userName,
        goodType: that.search.goodType ? that.search.goodType : null,
        deliveryEndDate: that.deliveryEndDate ? that.deliveryEndDate : null,
        deliveryStartDate: that.statementStartDate ? that.statementStartDate : null,
        orderNumber: that.search.orderNumber ? that.search.orderNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null
      };

      order.getOrderList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              val.goodName = that.goodTypeName(val.goodType) + "-" + val.goodName;
              if (val.remark) {
                val.remark = val.remark;
              }
              if (val.userRemark) {
                val.userRemark = val.userRemark;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            that.postCount++;
            callback(res.data.data.list, res.data.data.pageCount, page);
          } else {
            that.orderMoneyB = that.orderMoneyB;
            callback([], res.data.data.pageCount, page);
          }
        } else {
          callback();
          that.$message.error("导出订单列表失败");
        }
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    add0: function add0(m) {
      return m < 10 ? "0" + m : m;
    },
    format: function format(shijianchuo) {
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + "-" + this.add0(m) + "-" + this.add0(d);
    },
    exportToExcel: function exportToExcel() {
      var _this = this;

      var that = this;
      var orderName = "";
      that.orderMoneyB = [];
      that.pagTotal = false;
      that.postCount = 0;
      var pageCountt = 400;
      that.excelList = [];
      that.excelList2 = [];
      var nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
      if (that.activeName == "first") {} else if (that.activeName == "8") {
        orderName = "待入库" + nowTime;
      } else if (that.activeName == "9") {
        orderName = "已入库" + nowTime;
      } else if (that.activeName == "4") {
        orderName = "(派送)已出库" + nowTime;
      }

      if (that.paginations.total) {
        (function () {
          that.pageIndex = Math.ceil(that.paginations.total / pageCountt);

          var loading = _this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          that.bool = false;

          var _loop = function _loop(i) {
            that.pageIndexB = i;
            that.getOrderListB(that.pageIndexB, function (val, pageCount, index) {
              that.excelList[index - 1] = val;
              if (i == that.pageIndex && that.bool == false) {
                for (var _i = 0; _i < that.excelList.length; _i++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[_i]);
                }
                mUtils.export2Excel(that.columns, that.excelList2, orderName);

                loading.close();
                that.bool = true;
              } else if (pageCount <= that.orderMoneyB.length && that.bool == false) {
                loading.close();
                for (var _i2 = 0; _i2 < that.excelList.length; _i2++) {
                  that.excelList2 = that.excelList2.concat(that.excelList[_i2]);
                }
                mUtils.export2Excel(that.columns, that.excelList2, orderName);
                that.bool = true;
              }
            }, pageCountt);
          };

          for (var i = 1; i <= that.pageIndex; i++) {
            _loop(i);
          }
        })();
      }
    },
    outHandler: function outHandler(row) {
      this.viewDialog.orderId = row.orderId;

      this.viewDialog.orderInfo = row;
      this.viewDialog.list = [];
      this.getSettlementSheet();
      this.submit();
    },
    getSettlementSheet: function getSettlementSheet(id) {
      var that = this;
      var param = {};
      param.orderId = that.viewDialog.orderId;
      boxApi.settlementSheet(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取异常");
        }
        that.viewDialog.orderInfo = res.data.data;
        that.viewDialog.list = that.viewDialog.orderInfo.orderPojoList ? that.viewDialog.orderInfo.orderPojoList : that.viewDialog.orderInfo.detailList;
        that.user = res.data.data.user ? res.data.data.user : [];
      });
    },
    setReservation: function setReservation() {
      var _this2 = this;

      var that = this;
      var param = {};
      if (mUtils.getStore("userinfo")) {
        var userDetail = mUtils.getStore("userinfo");
        if (userDetail.roleId !== 1) {
          this.deliverAddress = userDetail.adminId;
          that.deliverAddressArr.forEach(function (dItem, index) {
            if (dItem.adminId == _this2.deliverAddress) {
              param.addressId = dItem.addressId || "";
            }
          });
        }
      }

      boxApi.setReservation(param).then(function (res) {
        if (res.status !== 200) return _this2.$message.error(res.msg);
        if (res.data.code !== 0) return _this2.$message.error(res.data.msg ? res.data.msg : "接口出错, 请联系工作人员");
        _this2.getOrderList();
        return _this2.$message.success("预约提醒成功");
      });
      this.bookTip = false;
    },
    submit: function submit() {
      var that = this;
      var param = {};
      param.orderId = this.viewDialog.orderId;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.confirmSettlement(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getOrderList();
        that.viewDialog.show = false;
      });
    },
    handleClick: function handleClick() {
      if (this.activeName == 8) {
        this.$router.push("/delivery/order?activeName=" + this.activeName);
        return;
      }
      this.search.batchNum = "";
      this.init();
    },
    viewHandler: function viewHandler(row) {
      this.detailDialog.orderNo = row.orderNo;
      this.getOrderDetail();
      this.detailDialog.show = true;
    },
    getOrderDetail: function getOrderDetail() {
      var that = this;
      var param = {};
      param.orderNo = that.detailDialog.orderNo;
      order.getOrderInfo(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取异常");
        }
        that.detailDialog.orderInfo = res.data.data;
        that.detailDialog.list = res.data.data.detailList || [];
        that.detailDialog.feeInfo = res.data.data.response || {};
      });
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodTypeName: function goodTypeName(goodType) {
      return StringUtils.goodType(goodType);
    },
    orderStatus: function orderStatus(status) {
      return StringUtils.orderStatus(status);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getOrderList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getOrderList();
    },
    getDate: function getDate(chukuTime) {
      if (!chukuTime) {
        this.statementStartDate = "";
        this.deliveryEndDate = "";
        this.init();
        return;
      }
      this.statementStartDate = new Date(mUtils.formatDate(chukuTime[0])).getTime();
      this.deliveryEndDate = new Date(mUtils.formatDate(chukuTime[1])).getTime() + 86399000;
      this.init();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    mulOutStoreToPay: function mulOutStoreToPay() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      var orderIds = [];
      that.multipleSelection.forEach(function (obj) {
        orderIds.push(obj.orderId);
      });
      param.orderIds = orderIds;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });

      boxApi.deliverOutTopay(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getOrderList();
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.init();
    },
    batchChange: function batchChange() {
      this.init();
    },
    remoteMethod: function remoteMethod(value) {
      var _this3 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this3.getBatchList(value);
      }, 500);
    },
    getAdressId: function getAdressId() {
      var _this4 = this;

      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this4.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this4.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this4.deliverAddressArr = res.data.data.list;
        }
      });
    }
  }
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            keyword: ""
        };
    },

    methods: {
        inputHandler: function inputHandler() {
            var that = this;
            if (!that.keyword) return;
            setTimeout(function () {
                console.log(that.keyword);
            }, 200);
        }
    }
};

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _debounce = __webpack_require__(203);

var deApi = _interopRequireWildcard(_debounce);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "vipCode") text = "请输入VIP号";else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      expressNo: "",
      orderInfo: [],
      disable: false,
      isSearch: false,
      boxNumber: "",
      datalist: [],
      historyList: [],
      viewDialog: {
        boxContainerNumber: ""
      },
      msg: "",
      dialog: {
        show: false
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: ""
        },
        form_rules: {
          vipCode: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          expressCompany: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },
      tobeIntoList: [],
      hasIntoList: [],
      isExistMark: false,
      isRepeatMark: false,
      isPassMark: false,
      orderNum: "",
      trueMark: true,
      falseMark: false
    };
  },
  created: function created() {
    this.init();
    this.getBoxList();
    this.getTobeIntoStorList();
    this.getHasIntoStorList();
  },


  watch: {
    boxNumber: function boxNumber() {
      if (this.boxNumber.length == 16) {
        this.confirm();
      }
      if (this.boxNumber.length > 16) {
        this.boxNumber.slice(0, 16);
      }
    }
  },

  methods: {
    init: function init() {
      this.isSearch = null;
      this.dialog.show = false;
      this.viewDialog = "";
      this.orderInfo = [];
      this.msg = "";
    },
    inputC: function inputC() {},
    confirm: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this = this;

        var that, param, orderNum, ruleOne, resultOne, ruleTwo, resultTwo, _timer, timer;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.boxNumber == "")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.dialog.show == false)) {
                  _context.next = 36;
                  break;
                }

                this.msg = "";
                that = this;
                param = {};

                param.pageIndex = 1;
                param.pageSize = 20;
                param.status = 3;
                param.goodType = null;
                param.boxNumber = that.boxNumber.replace(/\s/g, "");
                param.vipCode = "";
                param.deliveryTitle = "";

                if (!(that.boxNumber !== "")) {
                  _context.next = 34;
                  break;
                }

                _context.next = 16;
                return boxApi.boxList(param).then(function (res) {
                  if (res.status !== 200) {
                    return that.$message.error("获取订单异常：" + res.msg);
                  }
                  if (res.data.code != 0) {
                    return that.$message.error(res.data.msg || "获取合箱列表异常");
                  }
                  if (res.data.data.pageCount !== 0) that.orderInfo = res.data.data.list[0] || [];
                });

              case 16:
                if (!(that.orderInfo !== [] && that.orderInfo.boxNumber == that.boxNumber.replace(/\s/g, ""))) {
                  _context.next = 20;
                  break;
                }

                this.getBoxInfo();
                _context.next = 31;
                break;

              case 20:
                orderNum = this.boxNumber.trim();


                this.getTobeIntoStorList();
                this.getHasIntoStorList();

                that.orderNum = orderNum;

                ruleOne = function ruleOne(json) {
                  return json.boxNumber == orderNum;
                };

                resultOne = that.tobeIntoList.some(ruleOne);

                ruleTwo = function ruleTwo(json) {
                  return json.boxNumber == orderNum;
                };

                resultTwo = that.hasIntoList.some(ruleTwo);

                if (!resultOne && !resultTwo) {
                  that.isExistMark = true;
                  that.boxNumber = "";
                }

                if (!resultOne && resultTwo) {
                  that.isRepeatMark = true;
                  clearTimeout(_timer);
                  _timer = setTimeout(function () {
                    that.isRepeatMark = false;
                  }, 1200);

                  that.boxNumber = "";
                }

                return _context.abrupt("return");

              case 31:
                this.dialog.show = true;
                clearTimeout(timer);
                timer = setTimeout(function () {
                  _this.confirm();
                }, 2000);

              case 34:
                _context.next = 37;
                break;

              case 36:
                if (this.dialog.show) {
                  this.dialog.show = false;
                  this.submit();
                }

              case 37:
                this.dialog.show = true;

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm() {
        return _ref.apply(this, arguments);
      }

      return confirm;
    }(),
    closed: function closed() {
      var inputDom = document.getElementById('inputBox');
      inputDom.focus();
    },
    getTobeIntoStorList: function getTobeIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "3";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.tobeIntoList = res.data.data.list || [];
      });
    },
    getHasIntoStorList: function getHasIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "7";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.hasIntoList = res.data.data.list || [];
      });
    },
    reHandleClose: function reHandleClose(done) {},
    succHandleClose: function succHandleClose(done) {},
    cancel: function cancel() {
      this.init();
    },
    openFail: function openFail() {
      var audioPar = document.getElementsByClassName("audioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/rukuFail.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openRepeat: function openRepeat() {
      var audioPar = document.getElementsByClassName("repeAudioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/repeatRuku.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    submit: function submit() {
      var _this2 = this;

      var that = this;
      var param = {};
      param.boxId = this.orderInfo.boxId;
      param.status = 7;
      param.type = 1;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      if (that.dialog.show == false) {
        var loading = this.$loading({
          lock: true,
          text: "loading",
          spinner: "el-icon-loading",
          background: "rgba(0,0,0,0.7)"
        });
        boxApi.allocationCentrePut(param).then(function (res) {
          loading.close();
          if (res.data.code != 0) {
            return that.$message.error(res.data.msg || "操作异常");
          }
          that.$message({
            message: "入库成功!",
            type: "success"
          });

          that.isPassMark = true;

          clearTimeout(timers);
          var timers = setTimeout(function () {
            that.isPassMark = false;
          }, 0);

          _this2.getBoxList();
          that.boxNumber = "";
          that.cancel();

          _this2.getTobeIntoStorList();
          _this2.getHasIntoStorList();
        });
      }
    },
    getBoxInfo: function getBoxInfo() {
      var that = this;
      var param = {};
      param.boxId = that.orderInfo.boxId;
      boxApi.allocationCentreInformation(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.datalist = res.data.data.orderPojoList;
      });
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    getBoxList: function getBoxList() {
      var that = this;
      var param = {};
      param.pageIndex = 1;
      param.pageSize = 10;
      param.status = 7;
      param.goodType = "";
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.historyList = res.data.data.list || [];
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    document.getElementById("inputBox").addEventListener("keydown", deApi.debounce(function (e) {
      if (e.keyCode == 27) {
        _this3.cancel();
      } else if (e.keyCode == 13) {
        _this3.confirm();
      }
    }, 300, true));
  },
  destroyed: function destroyed() {}
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _img = __webpack_require__(131);

var img = _interopRequireWildcard(_img);

var _admin = __webpack_require__(200);

var admin = _interopRequireWildcard(_admin);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "contact") text = "请输入负责人姓名";else if (rule.field == "tel") text = "请输入负责人电话";else if (rule.field == "deliveryTitle") text = "请输入分拨点";else if (rule.field == "address") text = "请输入分拨点详细地址";else if (rule.field == "userName") text = "请输入用户名";else if (rule.field == "password") text = "请输入用户密码";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改",
        passwordBoolean: true,
        step: 1,
        data: {
          addressId: null,
          deliveryTitle: "",
          address: "",
          contact: "",
          adminId: '',
          tel: "",
          contactPhoto: "",
          imageUrl: "",
          userName: "",
          password: ""
        },
        form_rules: {
          contact: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          tel: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          deliveryTitle: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          address: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          userName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          password: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      deliveryList: [] };
  },
  created: function created() {
    var that = this;
    that.getDeliveryList();
    that.rightCheck();
  },

  methods: {
    rightCheck: function rightCheck() {
      var Id = mUtils.getStore('roleID');
      if (Id == 2) this.$router.push('/distribution/order');
    },
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getDeliveryList();
    },
    add: function add() {
      this.editDialog.show = true;
      this.editDialog.step = 1;
      this.editDialog.title = "添加";
      this.editDialog.data = {
        addressId: null,
        contact: "",
        tel: "",
        deliveryTitle: "",
        address: "",
        contactPhoto: "",
        imageUrl: "",
        userName: "",
        password: ""
      };
    },
    edit: function edit(row) {
      this.editDialog.show = true;
      this.editDialog.step = 3;
      this.editDialog.title = "修改";
      this.editDialog.data = {
        addressId: row.addressId,
        contact: row.contact,
        tel: row.tel,
        deliveryTitle: row.deliveryTitle,
        address: row.address,
        adminId: row.adminId,
        contactPhoto: row.contactPhoto,
        imageUrl: row.contactPhoto,
        userName: row.userName,
        password: row.password
      };
    },
    submit: function submit() {
      var _this = this;

      var that = this;
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          var data = {
            addressId: that.editDialog.data.addressId,
            contact: that.editDialog.data.contact,
            tel: that.editDialog.data.tel,
            deliveryTitle: that.editDialog.data.deliveryTitle,
            address: that.editDialog.data.address,
            contactPhoto: that.editDialog.data.contactPhoto,
            userName: that.editDialog.data.userName,
            type: 1,
            roleId: 2,
            adminId: that.editDialog.data.adminId,
            password: that.$md5(that.editDialog.data.password)
          };

          var loading = _this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          if (data.addressId) {
            deliveryApi.deliveryUpdate(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getDeliveryList();
              that.editDialog.show = false;
            });
          } else {
            deliveryApi.deliveryAdd(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getDeliveryList();
              that.getA();
              that.editDialog.show = false;
            });
          }
        }
      });
    },
    getA: function getA() {
      var data = {
        pageIndex: 1,
        pageSize: 1,
        userName: ''
      };
      var that = this;
      admin.getAdminList(data).then(function (res) {
        if (res.data.code == 1202) {
          return;
        }
        if (res.data.code != 0) {
          return;
        } else {
          that.adminId = res.data.data.list[0].adminId;
          that.changePassword();
        }
      });
    },
    changePassword: function changePassword() {
      var data = {
        adminId: this.adminId,
        password: this.$md5(this.editDialog.data.password),
        operatorId: mUtils.getStore("userinfo").adminId
      };
      console.log(this.adminId);
      var that = this;
      admin.updatePwd(data).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {} else if (res.data.code == 120) {} else {}
          return;
        } else {}
      });
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 1;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    deleteData: function deleteData(addressId) {
      var _this2 = this;

      var data = {
        addressId: addressId,
        status: -1
      };
      deliveryApi.deleteDeliverP(data).then(function (res) {
        if (res.data.code == 1202) {
          _this2.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          _this2.$message.success("删除分拨点成功");
          _this2.getDeliveryList();
        } else {
          _this2.$message.error("删除分拨点失败: " + res.data.msg);
        }
      });
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getDeliveryList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getDeliveryList();
    },

    handleLicenseImgFile: function handleLicenseImgFile(file) {
      var that = this;
      var formData = new FormData();
      formData.append("file", file.file);

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code == 0) {
          that.editDialog.data.contactPhoto = res.data.data.data.url;
          that.editDialog.data.imageUrl = res.data.data.data.path;
        }
      });
      loading.close();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {},
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    }
  }
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _utils = __webpack_require__(15);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      multipleSelection: [],
      activeName: "3",
      viewDialog: {
        show: false,
        title: "签收入库",
        boxId: null,
        boxContainerNumber: null,
        boxInfo: {},
        list: []
      },
      detailDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: {},
        list: []
      },
      outDialog: {
        show: false,
        content: "您确定出库吗？",
        boxId: null
      },
      intoDialog: {
        show: false,
        content: "您确定入库吗？",
        boxId: null
      },
      search: {
        boxNumber: "",
        deliveryTitle: "",
        vipCode: "",
        goodType: null,
        orderNumber: null,
        batchNum: ""
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      dataList: [],
      deliveryAddressList: [],
      accountObj: null,

      batchList: [],

      timeout: null,
      loading: false
    };
  },
  created: function created() {
    var that = this;
    that.getBoxList();
    that.getDeliveryList();
    var accountObj = JSON.parse(localStorage.getItem("userinfo"));
    this.accountObj = accountObj;
    this.getBatchList();
  },

  methods: {
    init: function init() {
      this.paginations.page_index = 1;
      this.getBoxList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectable: function selectable(row, index) {
      if (this.activeName == "7") {
        return true;
      } else if (this.activeName == "3") {
        return true;
      } else {
        return false;
      }
    },
    handleClick: function handleClick(tab, event) {
      this.$refs.table.clearSelection();
      this.getBoxList();
    },
    getBoxList: function getBoxList(size, page) {
      var that = this;
      var param = {};
      param.pageIndex = that.paginations.page_index;
      param.pageSize = that.paginations.page_size;
      param.status = that.activeName;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.orderNumber = that.search.orderNumber;
      param.batchNumber = that.search.batchNum ? that.search.batchNum.trim() : "";

      param.deliveryTitle = that.search.deliveryTitle;
      if (page) {
        param.pageIndex = page;
        that.paginations.page_index = page;
      }
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.dataList = res.data.data.list || [];
        that.paginations.total = res.data.data.pageCount;
      });
    },
    submit: function submit() {
      var that = this;
      var param = {};
      param.boxId = this.viewDialog.boxId;
      param.status = 7;
      param.type = 1;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.allocationCentrePut(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.viewDialog.show = false;
      });
    },
    outSubmit: function outSubmit() {
      var that = this;
      var param = {};
      param.boxId = this.outDialog.boxId;
      param.status = 8;
      param.type = 1;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.boxDelivery(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    batchOutSubmit: function batchOutSubmit() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      param.status = 8;
      var boxPojos = [];
      that.multipleSelection.forEach(function (item) {
        var obj = {};
        obj.boxId = item.boxId;
        obj.status = 8;
        boxPojos.push(obj);
      });
      param.boxPojos = boxPojos;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.volumeDelivery(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    outBoxHanlder: function outBoxHanlder(row) {
      if (row != null) {
        this.outDialog.show = true;
        this.outDialog.boxId = row.boxId;
        this.outDialog.content = "您确定出库吗？";
      } else {
        if (this.multipleSelection == null || this.multipleSelection.length == 0) {
          this.$message.error("请选择");
          return;
        }
        this.outDialog.show = true;
        this.outDialog.boxId = null;
        this.outDialog.content = "您确定批量出库吗？";
      }
    },
    intoBoxHanlder: function intoBoxHanlder(row) {
      if (row != null) {
        this.intoDialog.show = true;
        this.intoDialog.boxId = row.boxId;
        this.intoDialog.content = "您确定入库吗？";
      } else {
        if (this.multipleSelection == null || this.multipleSelection.length == 0) {
          this.$message.error("请选择");
          return;
        }
        this.intoDialog.show = true;
        this.intoDialog.boxId = null;
        this.intoDialog.content = "您确定批量入库吗？";
      }
    },
    batchIntoSubmit: function batchIntoSubmit() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      param.status = 7;
      var boxPojos = [];
      that.multipleSelection.forEach(function (item) {
        boxPojos.push(item.boxId);
      });
      param.boxIds = boxPojos;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.mulIntoStore(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.intoDialog.show = false;
      });
    },
    outHanlder: function outHanlder(row) {
      this.viewDialog.boxId = row.boxId;
      this.getBoxInfo();
      this.viewDialog.show = true;
    },
    viewHandler: function viewHandler(row) {
      this.detailDialog.boxId = row.boxId;
      this.getBoxDetail();
      this.detailDialog.show = true;
    },
    getBoxInfo: function getBoxInfo() {
      var that = this;
      var param = {};
      param.boxId = that.viewDialog.boxId;
      boxApi.allocationCentreInformation(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.viewDialog.boxInfo = res.data.data;
        that.viewDialog.boxContainerNumber = that.viewDialog.boxInfo ? that.viewDialog.boxInfo.boxContainerNumber : "";
        that.viewDialog.list = res.data.data.orderPojoList || [];
      });
    },
    getBoxDetail: function getBoxDetail() {
      var that = this;
      var param = {};
      param.boxId = that.detailDialog.boxId;
      boxApi.boxDetails(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.detailDialog.boxInfo = res.data.data;
        that.detailDialog.list = res.data.data.orderPojoList || [];
      });
    },
    stringGoodType: function stringGoodType(goodType) {
      return StringUtils.goodType(goodType);
    },
    strStatus: function strStatus(status) {
      var str = "";
      switch (status) {
        case 3:
          str = "待入库";
          break;
        case 7:
          str = "已入库";
          break;
        case 8:
          str = "已出库";
          break;
      }
      return str;
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;

      that.getBoxList(page_size, "1");
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getBoxList();
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code != 0) {
          return;
        }
        if (res.data.code == 0) {
          that.deliveryAddressList = res.data.data.list;
        }
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.init();
    },
    batchChange: function batchChange() {
      this.init();
    },
    remoteMethod: function remoteMethod(value) {
      var _this = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _debounce = __webpack_require__(203);

var deApi = _interopRequireWildcard(_debounce);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "vipCode") text = "请输入VIP号";else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      expressNo: "",
      orderInfo: [],
      disable: false,
      isSearch: false,
      boxNumber: "",
      datalist: [],
      historyList: [],
      viewDialog: {
        boxContainerNumber: ""
      },
      msg: "",
      dialog: {
        show: false
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: ""
        },
        form_rules: {
          vipCode: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          expressCompany: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },
      tobeIntoList: [],
      hasIntoList: [],
      isExistMark: false,
      isRepeatMark: false,
      isPassMark: false,
      orderNum: "",
      hasOutList: [],

      falseMark: false,
      trueMark: true
    };
  },
  created: function created() {
    this.init();
    this.getBoxList();
    this.getTobeIntoStorList();
    this.getHasIntoStorList();
    this.getHasOutStorList();
  },


  watch: {
    boxNumber: function boxNumber() {
      if (this.boxNumber.length == 16) {
        this.confirm();
      }
      if (this.boxNumber.length > 16) {
        this.boxNumber.slice(0, 16);
      }
    }
  },

  methods: {
    init: function init() {
      this.isSearch = null;
      this.dialog.show = false;
      this.viewDialog = "";
      this.orderInfo = [];
      this.msg = "";
    },
    inputC: function inputC() {},
    confirm: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this = this;

        var that, param, orderNum, ruleOne, resultOne, ruleTwo, resultTwo, _timer, timer;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.boxNumber == "")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(this.dialog.show == false)) {
                  _context.next = 37;
                  break;
                }

                this.msg = "";
                that = this;
                param = {};

                param.pageIndex = 1;
                param.pageSize = 20;
                param.status = 7;
                param.goodType = null;
                param.boxNumber = that.boxNumber.replace(/\s/g, "");
                param.vipCode = "";
                param.deliveryTitle = "";

                if (!(that.boxNumber !== "")) {
                  _context.next = 35;
                  break;
                }

                _context.next = 16;
                return boxApi.boxList(param).then(function (res) {
                  if (res.status !== 200) {
                    return that.$message.error("获取订单异常：" + res.msg);
                  }
                  if (res.data.code != 0) {
                    return that.$message.error(res.data.msg || "获取合箱列表异常");
                  }
                  if (res.data.data.pageCount !== 0) that.orderInfo = res.data.data.list[0] || [];
                });

              case 16:
                if (!(that.orderInfo !== [] && that.orderInfo.boxNumber == that.boxNumber.replace(/\s/g, ""))) {
                  _context.next = 20;
                  break;
                }

                this.getBoxInfo();
                _context.next = 32;
                break;

              case 20:
                orderNum = this.boxNumber.trim();


                this.getTobeIntoStorList();
                this.getHasIntoStorList();
                this.getHasOutStorList();

                that.orderNum = orderNum;

                ruleOne = function ruleOne(json) {
                  return json.boxNumber == orderNum;
                };

                resultOne = that.hasIntoList.some(ruleOne);

                ruleTwo = function ruleTwo(json) {
                  return json.boxNumber == orderNum;
                };

                resultTwo = that.hasOutList.some(ruleTwo);

                if (!resultOne && !resultTwo) {
                  that.isExistMark = true;
                  that.boxNumber = "";
                }

                if (!resultOne && resultTwo) {
                  that.isRepeatMark = true;
                  clearTimeout(_timer);
                  _timer = setTimeout(function () {
                    that.isRepeatMark = false;
                  }, 1200);

                  that.boxNumber = "";
                }

                return _context.abrupt("return");

              case 32:
                this.dialog.show = true;
                clearTimeout(timer);
                timer = setTimeout(function () {
                  _this.confirm();
                }, 2000);

              case 35:
                _context.next = 38;
                break;

              case 37:
                if (this.dialog.show) {
                  this.dialog.show = false;
                  this.submit();
                }

              case 38:
                this.dialog.show = true;

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm() {
        return _ref.apply(this, arguments);
      }

      return confirm;
    }(),
    closed: function closed() {
      var inputDom = document.getElementById('inputBox');
      inputDom.focus();
    },
    getTobeIntoStorList: function getTobeIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "3";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.tobeIntoList = res.data.data.list || [];
      });
    },
    getHasIntoStorList: function getHasIntoStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "7";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.hasIntoList = res.data.data.list || [];
      });
    },
    getHasOutStorList: function getHasOutStorList() {
      var that = this;
      var param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "8";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.hasOutList = res.data.data.list || [];
        that.historyList = res.data.data.list || [];
      });
    },
    reHandleClose: function reHandleClose(done) {},
    succHandleClose: function succHandleClose(done) {},
    cancel: function cancel() {
      this.init();
    },
    openFail: function openFail() {
      var audioPar = document.getElementsByClassName("audioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/chukuFail.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openRepeat: function openRepeat() {
      var audioPar = document.getElementsByClassName("repeAudioPar")[0];
      var audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/repeatChuku.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    submit: function submit() {
      var _this2 = this;

      var that = this;
      var param = {};
      param.boxId = this.orderInfo.boxId;

      param.status = 8;

      param.type = 1;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      if (that.dialog.show == false) {
        var loading = this.$loading({
          lock: true,
          text: "loading",
          spinner: "el-icon-loading",
          background: "rgba(0,0,0,0.7)"
        });

        boxApi.boxDelivery(param).then(function (res) {

          loading.close();
          if (res.data.code != 0) {
            return that.$message.error(res.data.msg || "操作异常");
          }
          that.$message({
            message: "出库成功!",
            type: "success"
          });

          that.isPassMark = true;

          clearTimeout(timers);
          var timers = setTimeout(function () {
            that.isPassMark = false;
          }, 0);

          _this2.getBoxList();
          that.boxNumber = "";
          that.cancel();

          _this2.getTobeIntoStorList();
          _this2.getHasIntoStorList();
          _this2.getHasOutStorList();
        });
      }
    },
    getBoxInfo: function getBoxInfo() {
      var that = this;
      var param = {};
      param.boxId = that.orderInfo.boxId;
      boxApi.allocationCentreInformation(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.datalist = res.data.data.orderPojoList;
      });
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    getBoxList: function getBoxList() {
      var that = this;
      var param = {};
      param.pageIndex = 1;
      param.pageSize = 10;
      param.status = 7;
      param.goodType = "";
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    document.getElementById("inputBox").addEventListener("keydown", deApi.debounce(function (e) {
      if (e.keyCode == 27) {
        _this3.cancel();
      } else if (e.keyCode == 13) {
        _this3.confirm();
      }
    }, 300, true));
  },
  destroyed: function destroyed() {}
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _unit = __webpack_require__(206);

var unit = _interopRequireWildcard(_unit);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    data: function data() {
        return {
            width: "300",
            height: "260",
            printObj: {
                id: "printContent",
                popTitle: "",
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
            }
        };
    },
    created: function created() {
        var that = this;
        that.width = unit.mmToPx(80);
        that.height = unit.mmToPx(60);
    }
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _address = __webpack_require__(199);

var address = _interopRequireWildcard(_address);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {

      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "contacts") {
          text = "收货人";
        } else if (rule.field == "tel") {
          text = "电话";
        } else if (rule.field == "address") {
          text = "地址";
        } else if (rule.field == "contactsO") {
          text = "联系人";
        } else if (rule.field == "telO") {
          text = "电话";
        } else if (rule.field == "addressO") {
          text = "地址";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "editPrice") {
          var numReg = /^[0-9]$/;
          if (!numReg.test(value)) {

            callback(new Error("请输入数字"));
          } else {
            if (numReg > 0) {
              callback(new Error("请输入大于0数字"));
            }
          }
        }
        return callback();
      }
    };

    return {
      editStatus: true,
      salePrice: '3.8',
      stores: {
        contacts: '',
        tel: '',
        address: '',
        contactsO: '',
        telO: '',
        addressO: '',

        form_rules: {
          contacts: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }],
          tel: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }],
          address: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }],
          contactsO: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }],
          telO: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }],
          addressO: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }]
        }
      }
    };
  },
  created: function created() {
    var that = this;
    that.getStore();
  },

  methods: {
    getStore: function getStore() {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var data = {
        storeType: 1

      };

      address.getStore(data).then(function (res) {
        if (res.data.code == 0) {

          that.stores.contacts = res.data.data.contacts;
          that.stores.address = res.data.data.address;
          that.stores.tel = res.data.data.tel;
        } else {
          that.$message.error('获取失败 !');
        }
      });
      var dataA = {
        storeType: 2

      };

      address.getStore(dataA).then(function (res) {
        if (res.data.code == 0) {
          that.stores.contactsO = res.data.data.contacts;
          that.stores.addressO = res.data.data.address;
          that.stores.telO = res.data.data.tel;
        } else {
          that.$message.error('获取失败 !');
        }
      });
      loading.close();
    },
    onsub: function onsub() {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.search.validate(function (valid) {
        validd = valid;

        return true;
      });

      if (validd) {
        var obj = {};
        obj.storeType = 1;
        obj.address = that.stores.address;
        obj.contacts = that.stores.contacts;
        obj.tel = that.stores.tel;
        var arr = [];
        arr.push(obj);
        obj = {};
        obj.storeType = 2;
        obj.address = that.stores.addressO;
        obj.contacts = that.stores.contactsO;
        obj.tel = that.stores.telO;
        arr.push(obj);
        var data = {
          storeList: arr,
          operatorId: mUtils.getStore('userinfo').adminId

        };

        address.updateStore(data).then(function (res) {
          if (res.data.code == 0) {

            that.$message.success('提交成功 !');
            that.getStore();
          } else {
            that.$message.error('提交错误 !');
          }
        });
        loading.close();
      } else {
        that.$message.error('表单输入错误 !');
        loading.close();
        return false;
      }
    },
    edit: function edit() {
      var that = this;
      that.editPrice = that.salePrice;
      that.editStatus = false;
    },
    editB: function editB() {
      var that = this;

      that.editStatus = true;
    }
  }
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _confirm = __webpack_require__(130);

var confirm = _interopRequireWildcard(_confirm);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {

      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "editPrice") {
          text = "价格系数不能为空";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "sytemPrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "editPrice") {
          var numReg = /^[0-9]+.[0-9]+$/;
          if (!numReg.test(value)) {

            callback(new Error("请输入数字"));
          } else {
            if (value < 0) {
              callback(new Error("请输入大于0数字"));
            }
          }
        }
        return callback();
      }
    };

    return {
      editStatus: true,
      sytemPrice: '3.8',
      price: {
        editPrice: '',

        form_rules: {
          editPrice: [{
            required: true,
            validator: dataValidate,

            trigger: "blur"
          }]
        }
      }
    };
  },
  created: function created() {
    var that = this;
    that.getConfig();
  },

  methods: {
    getConfig: function getConfig() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      confirm.getPrice({}).then(function (res) {
        that.sytemPrice = res.data.data.price;
        loading.close();
      });
    },
    edit: function edit(val) {
      var that = this;
      that.price.editPrice = val;
      that.editStatus = false;
    },
    editB: function editB(val) {
      var that = this;

      that.editStatus = true;

      var numReg = /^\d+(\.\d+)?$/;;

      if (!numReg.test(val)) {
        that.$message.warning("请输入数字");
        return;
      } else {
        if (val < 0) {
          that.$message.warning("请输入大于等于0的值");
          return;
        }
      }
      var loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.search.validate(function (valid) {
        validd = valid;

        return true;
      });
      var data = {
        price: val
      };
      if (validd) {

        confirm.updatePrice(data).then(function (res) {
          if (res.data.code == 0) {

            that.$message.success('提交成功 !');
            that.getConfig();
          } else {
            that.$message.error('提交错误 !');
          }
        });
        loading.close();
      } else {
        that.$message.error('表单输入错误 !');
        loading.close();
        return false;
      }
    }
  }
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _priceGoods = __webpack_require__(204);

var priceGoods = _interopRequireWildcard(_priceGoods);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (value === "") {
        var text = void 0;
        if (rule.field == "goodName") {
          text = "类型名称";
        } else if (rule.field == "price") {
          text = "价格系数";
        } else if (rule.field == "firstWeight") {
          text = "计算首重";
        } else if (rule.field == "goodType") {
          text = "货物类型";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "price") {
          var numReg = /^\d+(\.\d+)?$/;

          if (!numReg.test(value)) {
            callback(new Error("请输入数字"));
            return;
          } else {
            if (value < 0) {
              callback(new Error("请输入大于等于0的值"));

              return;
            }
          }
          return callback();
        }
      }
    };

    return {
      galObj: {},
      showOnsub: true,
      adminId: "",

      indexB: "",
      statusA: "",
      searchData: {
        keyWord: "",
        keyWord2: ""
      },
      indexA: "",
      rowDmind: "",
      dadBool: false,
      options: [],
      tableData: [],
      dialog: (0, _defineProperty3.default)({
        width: "300px",
        show: false,
        showC: false,
        title: "新增货物类型",
        formLabelWidth: "120px",
        showB: false
      }, "showC", false),
      priceGoods: {
        width: "300px",
        show: false,
        title: "",
        formLabelWidth: "120px",
        appendOrUpdate: 1,
        goodTypeSelect: [{
          goodType: 1,
          goodName: "海运"
        }, {
          goodType: 2,
          goodName: "海运大件"
        }, {
          goodType: 3,
          goodName: "空运"
        }],
        netBarForm: {
          goodName: "",
          price: "",
          firstWeight: 2,
          remark: "",
          goodType: 1
        },

        form_rules: {
          goodType: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          goodName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          price: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],

          firstWeight: [{
            required: true,
            validator: dataValidate,
            trigger: "change"
          }]
        }
      },
      search_data: {
        realName: "",
        mobile: ""
      },
      updateOrAdd: 0,
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 15, 20],
        layout: "total, sizes, prev, pager, next, jumper" }
    };
  },
  created: function created() {
    var that = this;
    this.getPriceGoodsList();
  },

  methods: {
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    deleteGoods: function deleteGoods(val) {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var data = {};
      data = {
        goodId: val.goodId || "",
        goodName: val.goodName || "",
        price: val.price || "",
        firstWeight: Number(val.firstWeight),
        reamrk: val.remark || ""
      };
      priceGoods.del(data).then(function (res) {
        if (res.data.code != 0) {
          var msg = void 0;
          msg = "删除失败!";
          that.$message.error(msg);
          loading.close();
          return;
        } else {
          var _msg = void 0;
          _msg = "删除成功 !";
          that.$message({
            message: _msg,
            type: "success"
          });
          that.dialog.showB = false;

          that.getPriceGoodsList();
          loading.close();
        }
      });
    },
    onDel: function onDel(val) {
      this.galObj = val;
      this.dialog.showB = true;
    },
    onEdit: function onEdit(val) {
      var that = this;
      that.priceGoods.netBarForm.goodId = val.goodId;
      that.priceGoods.netBarForm.goodType = val.goodType;
      that.priceGoods.netBarForm.goodName = val.goodName;
      that.priceGoods.netBarForm.price = val.price;
      that.priceGoods.netBarForm.firstWeight = val.firstWeight + 1;
      that.priceGoods.netBarForm.remark = val.remark || "";
      this.dialog.show = true;
    },
    onsumbit: function onsumbit() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var data = {};

      var validd = void 0;
      if (that.priceGoods.netBarForm.goodName && that.priceGoods.netBarForm.price && that.priceGoods.netBarForm.firstWeight) {
        validd = true;
      } else {
        validd = false;
      }

      this.$refs.netBar.validate(function (valid) {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          goodId: that.priceGoods.netBarForm.goodId || "",
          goodName: that.priceGoods.netBarForm.goodName || "",
          price: that.priceGoods.netBarForm.price || "",
          firstWeight: Number(that.priceGoods.netBarForm.firstWeight) - 1,
          reamrk: that.priceGoods.netBarForm.remark || "",
          goodType: that.priceGoods.netBarForm.goodType
        };
        priceGoods.add(data).then(function (res) {
          if (res.data.code != 0) {
            var msg = void 0;
            if (that.priceGoods.netBarForm.goodId) {
              msg = res.data.msg;
            } else {
              msg = "保存失败!";
            }
            that.$message.error(msg);
            loading.close();
            return;
          } else {
            var _msg2 = void 0;
            _msg2 = "保存成功 !";
            that.$message({
              message: _msg2,
              type: "success"
            });
            that.dialog.show = false;
            that.getPriceGoodsList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    openAdd: function openAdd() {
      var that = this;
      that.priceGoods.netBarForm.goodId = "";
      that.priceGoods.netBarForm.goodName = "";
      that.priceGoods.netBarForm.price = "";
      that.priceGoods.netBarForm.firstWeight = 2;
      that.priceGoods.netBarForm.remark = "";
      this.dialog.show = true;
    },
    getPriceGoodsList: function getPriceGoodsList(dataA) {
      var that = this;

      var data = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size
      };

      var loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      priceGoods.goodList(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          res.data.data.list.forEach(function (val, i) {
            val.operatorTime = mUtils.formatDate(new Date(val.operatorTime)).substring(0, 16);
          });
          that.tableData = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        }
      });
      loading.close();
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getPriceGoodsList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getPriceGoodsList();
    }
  }
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(207);

var _extends3 = _interopRequireDefault(_extends2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _login2 = __webpack_require__(301);

var _login = _interopRequireWildcard(_login2);

var _vuex = __webpack_require__(461);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			loginForm: {
				userName: '',
				password: '',
				checkedPwd: false
			},

			RoleID: '',

			rules: {
				userName: [{
					required: true,
					message: '请输入用户名',
					trigger: 'blur'
				}],
				password: [{
					required: true,
					message: '请输入密码',
					trigger: 'blur'
				}]
			},
			companyId: 0
		};
	},

	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['menuitems', 'isLoadRoutes'])),
	created: function created() {},

	methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['addMenu', 'loadRoutes']), {
		saveUserInfo: function saveUserInfo(data) {
			mUtils.setStore('userinfo', data);
			mUtils.setStore('roleID', data.roleId);
			this.RoleID = data.roleId;
		},
		generateMenuPushIndex: function generateMenuPushIndex(data) {
			var that = this;
			that.companyId = data.companyId;
			var menuData = [];
			mUtils.setStore('menuData', menuData);
			this.addMenu(menuData);
			if (!this.isLoadRoutes) {
				var routes = mUtils.generateRoutesFromMenu(menuData);
				var asyncRouterMap = [{
					path: '/404',
					name: '404',
					hidden: true,
					component: __webpack_require__(283)
				}, {
					path: '/index',
					name: '',
					hidden: true,
					component: __webpack_require__(52),
					redirect: '/index',
					children: routes
				}];
				this.$router.addRoutes(asyncRouterMap);
				this.loadRoutes();
			}

			if (that.RoleID == 1) {

				that.$router.push('/orderList');
			} else if (that.RoleID == 2) {

				that.$router.push('/distribution/order');
			} else if (that.RoleID == 3) {

				that.$router.push('/delivery/order');
			}
		},
		login: function login(loginForm) {
			var _this = this;

			var that = this;
			this.$refs.loginForm.validate(function (valid) {
				if (valid) {
					var loading = _this.$loading({
						lock: true,
						text: '登录中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					var data = {
						userName: that.loginForm.userName,

						password: that.$md5(that.loginForm.password)
					};
					_login.webLogin(data).then(function (res) {

						loading.close();
						if (res.data.code == 0) {
							var str = 'adminId:' + (res.data.data.adminId || '') + ',realName:' + res.data.data.roleName + ',userName:' + res.data.data.userName;

							that.$cookieStore.setCookie('zbt_', str);

							that.saveUserInfo(res.data.data);
							that.$store.dispatch('initLeftMenu');
							that.generateMenuPushIndex(res.data.data);
						}
						if (res.data.code != 0) {

							that.$message({
								message: '请输入正确的用户名密码',
								type: 'warning'
							});
							return false;
						}
					});
				} else {
					return false;
				}
			});
		}
	})
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _confirm = __webpack_require__(130);

var confirm = _interopRequireWildcard(_confirm);

var _customer = __webpack_require__(202);

var customer = _interopRequireWildcard(_customer);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (value === "") {
        var text = void 0;
        if (rule.field == "vipCode") {
          text = "名称";
        } else if (rule.field == "expressCompany") {
          text = "快递公司";
        } else if (rule.field == "expressNo") {
          text = "快递号";
        } else if (rule.field == "predictTotal") {
          text = "商品整单价值";
        } else if (rule.field == "checkedGoodsType") {
          text = "货运类型";
        }
        callback(new Error(text + "不能为空"));
      } else {
        if (rule.field == "predictTotal") {
          var reg = /^\d+$|^\d*\.\d+$/g;
          if (!reg.test(value)) {
            callback(new Error("只能输入数字和小数点"));
          }
        }
        return callback();
      }
    };
    return {
      searchData: {
        keyWord: "",
        keyWordB: "",
        keyWordC: ""
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      customerList: [],
      deliveyList: [],

      goodsType: [{
        value: "海运",
        id: 1
      }, {
        value: "海运大件",
        id: 2
      }, {
        value: "空运",
        id: 3
      }],
      value: "",
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false
      },

      order: {
        width: "400px",
        show: false,
        title: "",
        formLabelWidth: "80px",
        appendOrUpdate: 1,
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        checkedGoodsType: "",
        remark: "",
        detailList: [{
          detailId: 0,
          productName: "",
          productNum: ""
        }],

        form_rules: {
          predictTotal: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          expressNo: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          vipCode: [{
            required: true,
            validator: dataValidate,
            trigger: "change"
          }],
          expressCompany: [{
            required: true,
            validator: dataValidate,
            trigger: "change"
          }],
          checkedGoodsType: [{
            required: true,
            validator: dataValidate,
            trigger: "change"
          }]
        }
      }
    };
  },
  created: function created() {
    var that = this;
    that.getExpressList();
    that.getCustomer();
  },

  methods: {
    seleVipCode: function seleVipCode(vipCode) {
      this.order.vipCode = vipCode;
      this.adminDeleteDialog.showB = false;
    },
    showDialog: function showDialog() {
      this.adminDeleteDialog.showB = true;
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getCustomer: function getCustomer() {
      var that = this;
      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        nickname: that.searchData.keyWord ? that.searchData.keyWord : null,
        realName: that.searchData.keyWordB ? that.searchData.keyWordB : null,
        mobile: that.searchData.keyWordC ? that.searchData.keyWordC : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null
      };
      customer.getCustomerList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.customerList = res.data.data.list;
          that.customerList.forEach(function (val, i) {
            val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
          });
          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getExpressList: function getExpressList() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      confirm.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.deliveyList = res.data.data;
      });
    },
    deleteDialog: function deleteDialog(index) {
      this.indexA = index;
      this.adminDeleteDialog.show = true;
    },
    addProduct: function addProduct() {
      this.order.detailList.push({
        detailId: 0,
        productName: "",
        productNum: ""
      });
    },
    deleteItem: function deleteItem(index) {
      this.adminDeleteDialog.show = false;
      this.order.detailList.splice(index, 1);
    },
    back: function back() {
      this.$router.go(-1);
    },
    onSubmit: function onSubmit() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;
        return true;
      });

      if (validd) {
        data = {
          operatorId: mUtils.getStore("userinfo").adminId,
          orderNo: that.order.orderNo,
          vipCode: that.order.vipCode,
          expressCompany: that.order.expressCompany,
          expressNo: that.order.expressNo,
          predictTotal: that.order.predictTotal,
          goodType: that.order.checkedGoodsType,
          remark: that.order.remark,
          detailList: that.order.detailList
        };

        order.createOrder(data).then(function (res) {
          if (res.data.code != 0) {
            if (res.data.code == 1405) {
              var msg = res.data.msg;
              that.$message({
                message: msg,
                type: "warning"
              });
              loading.close();
            }
          } else {
            var _msg = "添加成功";
            that.$message({
              message: _msg,
              type: "success"
            });
            that.$router.push({
              path: "orderList"
            });
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;

      that.getCustomer();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getCustomer();
    },
    closeDialog: function closeDialog(form) {
      if (this.$refs[form] !== undefined) {
        this.$refs[form].resetFields();
      }
    }
  }
};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(303);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _utils = __webpack_require__(15);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _unit = __webpack_require__(206);

var unit = _interopRequireWildcard(_unit);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _face = __webpack_require__(284);

var _face2 = _interopRequireDefault(_face);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Face: _face2.default
  },
  data: function data() {
    return {
      multipleSelection: [],
      httpImg: "",
      activeName: "6",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      search: {
        boxNumber: "",
        deliveryTitle: "",
        vipCode: "",
        goodType: null,
        batchNum: null
      },
      dataList: [],
      viewDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: null,
        list: []
      },
      value1: "",
      startTime: "",
      endTime: "",
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      detailDialog: {
        show: false,
        title: "查看详情",
        boxId: null,
        boxInfo: {},
        list: []
      },
      outDialog: {
        show: false,
        boxId: null,
        content: "您是否将订单出库吗？该操作不可逆"
      },
      mianDialog: {
        show: false,
        title: "面单",
        width: "300",
        height: "260",
        boxId: null,
        boxInfo: {},
        list: []
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],

      addressSelect: [],
      columns: [{ title: "名称", key: "arrProduct" }, { title: "货物类型", key: "goodNames" }, { title: "客户", key: "realName" }, { title: "vip号", key: "vipCode" }, { title: "物流公司", key: "expressCompany" }, { title: "运单号", key: "expressNo" }, { title: "商品价值", key: "predictTotal" }, { title: "状态", key: "dealStatus" }, { title: "运费", key: "total" }, { title: "下单时间", key: "addDate" }, { title: "派送点", key: "deliveryTitle" }],
      orderMoneyB: [],
      deliverArr: [],

      howManyTotal: 0,
      listArr: [],

      OrderArr: [],
      columnsOrder: [{ title: "箱编号", key: "boxNumber" }, { title: "货物类型", key: "goodType" }, { title: "订单数量", key: "orderCount" }, { title: "用户VIP号", key: "vipCodes" }, { title: "派送点", key: "address" }, { title: "状态", key: "hxstatus" }, { title: "合箱时间", key: "createTime" }],

      batchList: [],

      timeout: null,
      loading: false,

      faceOrderList: [],
      faceKey: "",

      isHasClick: false
    };
  },
  created: function created() {
    var that = this;
    that.httpImg = "https://cn2ca-1370214517.cos.ap-nanjing.myqcloud.com/";

    that.getBoxList();
    that.getDeliverById();
    this.getBatchList();
  },

  methods: {
    init: function init() {
      this.paginations.page_index = 1;
      this.getBoxList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.multipleSelection = val;
    },
    handleClick: function handleClick(tab, event) {
      var that = this;
      if (tab.name != "6") {
        that.$router.push("/orderList?activeName=" + tab.name);
        return;
      }
    },
    getBoxList: function getBoxList() {
      var that = this;
      var param = {};
      param.pageIndex = that.paginations.page_index;
      param.pageSize = that.paginations.page_size;
      param.status = 0;
      param.goodType = that.search.goodType;
      param.boxNumber = that.search.boxNumber;
      param.vipCode = that.search.vipCode;
      param.startTime = that.startTime;
      param.endTime = that.endTime;
      param.batchNumber = that.search.batchNum ? that.search.batchNum.trim() : "";
      param.deliveryTitle = that.search.deliveryTitle;
      boxApi.boxList(param).then(function (res) {
        if (res.data.code != 0) {
          that.howManyTotal = 0;
          that.getAllData();
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.dataList = res.data.data.list || [];
        that.paginations.total = res.data.data.pageCount;
        that.howManyTotal = res.data.data.pageCount;
        that.getAllData();
      });
    },
    viewHandler: function viewHandler(row) {
      this.detailDialog.boxId = row.boxId;
      this.getDoxDetails();
      this.detailDialog.show = true;
    },
    getDoxDetails: function getDoxDetails() {
      var that = this;
      var param = {};
      param.boxId = that.detailDialog.boxId;
      boxApi.boxDetails(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.detailDialog.boxInfo = res.data.data;
        that.detailDialog.list = res.data.data.orderPojoList || [];
      });
    },
    outHanlder: function outHanlder(row) {
      if (row != null) {
        this.outDialog.show = true;
        this.outDialog.boxId = row.boxId;
        this.outDialog.content = "您是否将订单出库吗？该操作不可逆";
      } else {
        if (this.multipleSelection == null || this.multipleSelection.length == 0) {
          this.$message.error("请选择");
          return;
        }
        this.outDialog.show = true;
        this.outDialog.boxId = null;
        this.outDialog.content = "您是否批量出库吗？该操作不可逆";
      }
    },
    outSubmit: function outSubmit() {
      var that = this;
      var param = {};
      param.boxId = that.outDialog.boxId;
      param.status = 3;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.boxDelivery(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "出库成功!",
          type: "success"
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    multiPrint: function multiPrint() {
      this.isHasClick = true;
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        this.$message.warning("请选择");
        return;
      }


      var boxIdArr = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.multipleSelection), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var boxObj = _step.value;

          boxIdArr.push(boxObj.boxId);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.getFaceSheet(boxIdArr);
    },
    getFaceSheet: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(boxIdArr) {
        var _this = this;

        var that, loading, faceOrderList, i, param;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                loading = this.$loading({
                  lock: true,
                  text: '获取面单中',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                faceOrderList = [];
                i = 0;

              case 4:
                if (!(i < boxIdArr.length)) {
                  _context.next = 11;
                  break;
                }

                param = {
                  boxId: boxIdArr[i]
                };
                _context.next = 8;
                return boxApi.faceSheet(param).then(function (res) {
                  if (res.data.code !== 0) {
                    return that.$message.error(res.data.msg || "获取面单信息异常");
                  }
                  if (res.data.data) {
                    faceOrderList.push(res.data.data);
                    faceOrderList.map(function (itemObj) {
                      itemObj.faceImg = _this.httpImg + itemObj.img;
                      return itemObj;
                    });
                  }
                });

              case 8:
                i++;
                _context.next = 4;
                break;

              case 11:
                this.faceOrderList = faceOrderList;
                loading.close();
                this.mianDialog.show = true;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFaceSheet(_x) {
        return _ref.apply(this, arguments);
      }

      return getFaceSheet;
    }(),
    cancelBox: function cancelBox(row) {
      var _this2 = this;

      var param = {};
      param.boxId = row.boxId;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.cancelBox(param).then(function (res) {
        if (res.data.code != 0) {
          return _this2.$message.error(res.data.msg || "操作异常");
        }
        _this2.$message({
          message: "撤销成功!",
          type: "success"
        });
        _this2.getBoxList();
      });
      loading.close();
    },
    batchOutSubmit: function batchOutSubmit() {
      var that = this;
      if (that.multipleSelection == null || that.multipleSelection.length == 0) {
        this.$message.error("请选择");
        return;
      }
      var param = {};
      param.status = 3;
      var boxPojos = [];
      that.multipleSelection.forEach(function (item) {
        var obj = {};
        obj.boxId = item.boxId;
        obj.status = 3;
        boxPojos.push(obj);
      });
      param.boxPojos = boxPojos;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.volumeDelivery(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success"
        });
        that.getBoxList();
        that.outDialog.show = false;
      });
    },
    getDate: function getDate(value1) {
      if (!value1) {
        this.startTime = "";
        this.endTime = "";
        this.init();
        return;
      }
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.init();
    },
    mianHandler: function mianHandler(row) {
      this.mianDialog.show = true;
      this.mianDialog.boxId = row.boxId;
    },
    closeFaceDialog: function closeFaceDialog(val) {
      this.mianDialog.show = false;
      this.mianDialog.boxId = null;
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodType: function goodType(_goodType) {
      return StringUtils.goodType(_goodType);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.$refs.table.clearSelection();
      that.getBoxList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      this.multipleSelection = [];
      this.faceOrderList = [];
      this.$refs.table.clearSelection();
      that.getBoxList();
    },
    exportOrderToExcel: function exportOrderToExcel() {
      var that = this;
      this.getHowMangTotal();
    },
    getHowMangTotal: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var that, param, howManyPage, OrderArr, i, orderName;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = this;
                param = {
                  pageIndex: 1,
                  pageSize: 400
                };


                param.status = 0;
                param.goodType = that.search.goodType;
                param.boxNumber = that.search.boxNumber;
                param.vipCode = that.search.vipCode;
                param.startTime = that.startTime;
                param.endTime = that.endTime;
                param.batchNumber = that.search.batchNum ? that.search.batchNum.trim() : "";
                param.deliveryTitle = that.search.deliveryTitle;

                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                OrderArr = [];
                i = 1;

              case 13:
                if (!(i <= howManyPage)) {
                  _context2.next = 20;
                  break;
                }

                param.pageIndex = i;
                _context2.next = 17;
                return boxApi.boxList(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list && res.data.data.list.length > 0) {
                      res.data.data.list.forEach(function (detailPojo) {
                        if (detailPojo.orderPojoList && detailPojo.orderPojoList.length > 0) {
                          detailPojo.orderPojoList.map(function (everyPojo) {
                            everyPojo.deliveryTitle = detailPojo.deliveryTitle;
                            everyPojo.vipCode = detailPojo.vipCodes;
                            everyPojo.boxNumber = detailPojo.boxNumber;
                            everyPojo.sendRemark = detailPojo.sendRemark;
                            everyPojo.goodNames = that.goodTypeName(everyPojo.goodType) + "-" + everyPojo.goodName;
                            everyPojo.dealStatus = "已合箱";
                            everyPojo.addDate = mUtils.formatDate(new Date(everyPojo.addTime)).substring(0, 10);
                            OrderArr.push(everyPojo);
                          });
                        }
                      });
                    }
                  }
                });

              case 17:
                i++;
                _context2.next = 13;
                break;

              case 20:

                that.OrderArr = OrderArr;
                orderName = "已合箱导出订单列表Excel";

                mUtils.export2Excel(that.columns, that.OrderArr, orderName);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHowMangTotal() {
        return _ref2.apply(this, arguments);
      }

      return getHowMangTotal;
    }(),
    getOrderListB: function getOrderListB(page, callback) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        pageIndex: 1,
        pageSize: page,
        status: 6
      };
      data.goodType = that.search.goodType;
      data.boxNumber = that.search.boxNumber;
      data.userName = that.search.vipCode;
      data.startTime = that.startTime;
      data.endTime = that.endTime;
      data.deliveryTitle = that.search.deliv;
      order.getOrderList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.dealStatus = "已合箱";
              val.goodName = that.goodTypeName(val.goodType) + "-" + val.goodName;
              if (val.remark) {
                val.remark = val.remark;
              }
              if (val.userRemark) {
                val.userRemark = val.userRemark;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            callback(res.data.data.list, res.data.data.pageCount);
          } else {
            that.orderMoneyB = that.orderMoneyB;
            callback([], res.data.data.pageCount);
          }
        } else {
          callback();
          that.$message.error("导出订单列表失败");
        }
        loading.close();
      });
    },
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    getDeliverById: function getDeliverById() {
      var that = this;
      var type = 2;
      var param = {
        type: type
      };
      deliveryApi.deliveryList(param).then(function (res) {
        if (res.data.code !== 0) return;
        that.deliverArr = res.data.data.list;
      });
    },
    selectAddress: function selectAddress(value) {
      var that = this;
      that.search.deliveryTitle = value;
    },
    exportToExcelBox: function exportToExcelBox() {
      var that = this;
      var orderName = "合箱Excel";
      mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },
    getAllData: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var that, param, howManyPage, listArr, i;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = this;
                param = {};

                param.pageIndex = 1;
                param.pageSize = 400;
                param.status = 0;
                param.goodType = that.search.goodType;
                param.boxNumber = that.search.boxNumber;
                param.vipCode = that.search.vipCode;
                param.startTime = that.startTime;
                param.endTime = that.endTime;
                param.batchNumber = that.search.batchNum ? that.search.batchNum.trim() : "";
                param.deliveryTitle = that.search.deliveryTitle;
                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                listArr = [];
                i = 1;

              case 15:
                if (!(i <= howManyPage)) {
                  _context3.next = 22;
                  break;
                }

                param.pageIndex = i;
                _context3.next = 19;
                return boxApi.boxList(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        every.createTime = mUtils.formatDate(new Date(every.createTime)).substring(0, 19);

                        if (every.isHybrid) {
                          every.boxNumber += " 混";
                        }
                        every.hxstatus = "已合箱";

                        if (every.goodType == 1) {
                          every.goodType = "海运";
                        } else if (every.goodType == 2) {
                          every.goodType = "海运大件";
                        } else if (every.goodType == 3) {
                          every.goodType = "空运";
                        } else {
                          every.goodType = "";
                        }

                        listArr.push(every);
                      });
                    }
                  }
                });

              case 19:
                i++;
                _context3.next = 15;
                break;

              case 22:
                that.listArr = listArr;

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllData() {
        return _ref3.apply(this, arguments);
      }

      return getAllData;
    }(),
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.init();
    },
    batchChange: function batchChange() {
      this.init();
    },
    remoteMethod: function remoteMethod(value) {
      var _this3 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this3.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _confirm = __webpack_require__(130);

var confirmApi = _interopRequireWildcard(_confirm);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "vipCode") text = "请输入VIP号";else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      expressNo: "",
      orderInfo: null,
      disable: false,
      isSearch: false,
      msg: "",
      dialog: {
        show: false
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: ""
        },
        form_rules: {
          vipCode: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          expressCompany: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      }
    };
  },
  created: function created() {
    var that = this;
    that.getOrderList();
    that.getExpressList();
  },

  methods: {
    init: function init() {
      this.isSearch = false;
      this.dialog.show = false;

      this.orderInfo = null;
      this.msg = "";
      this.getOrderList();
    },
    openOrderDailog: function openOrderDailog() {
      this.orderDialog.show = true;
    },
    confirm: function confirm() {
      console.log("start...");
      this.msg = "";
      if (!this.expressNo) return;
      if (this.orderInfo && this.expressNo.toUpperCase() == this.orderInfo.expressNo.toUpperCase() && this.orderInfo.expressStatus == 1) {
        this.init();
        return;
      } else if (this.orderInfo && this.expressNo.toUpperCase() == this.orderInfo.expressNo.toUpperCase() && this.orderInfo.expressStatus == 0) {
        this.updateExpress();
        return;
      } else {
        this.orderInfo = null;
        this.dialog.show = true;
        this.getOrderInfo();
      }
    },
    cancel: function cancel() {
      this.init();
    },
    submitOrder: function submitOrder() {
      var _this = this;

      var that = this;
      var data = {
        expressNo: that.expressNo,
        vipCode: that.orderDialog.data.vipCode,
        expressCompany: that.orderDialog.data.expressCompany
      };
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          var loading = _this.$loading({
            lock: true,
            text: "提交中...",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          order.orderSupplement(data).then(function (res) {
            loading.close();
            if (res.data.code != 0) {
              return that.$message.error(res.data.msg || "操作异常");
            }
            that.$message({ message: "提交成功", type: "success" });
            that.getOrderList();
            that.orderDialog.show = false;
            that.cancel();
          });
        }
      });
    },
    inputOrder: function inputOrder(event) {
      var that = this;
      if (!this.expressNo) return;
      that.dialog.show = true;
      this.getOrderInfo();
    },
    getOrderInfo: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var that, data, loading;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                data = {};

                data.expressNo = that.expressNo.replace(/\s/g, "");

                if (that.expressNo) {
                  _context.next = 6;
                  break;
                }

                that.orderInfo = null;
                return _context.abrupt("return");

              case 6:
                loading = this.$loading({
                  lock: true,
                  text: "loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0,0,0,0.7)"
                });
                _context.next = 9;
                return order.searchOrderByExpress(data).then(function (res) {
                  loading.close();
                  that.isSearch = false;
                  if (res.data.code != 0) {
                    that.msg = res.data.msg || "NO DATA";


                    if (res.data.code == 1101) {
                      that.$message.error(res.data.msg);
                      that.dialog.show = false;
                      return;
                    }
                    return;
                  }
                  that.orderInfo = res.data.data && res.data.data.orderNo ? res.data.data : null;
                  if (res.data.code != 1101) {
                    if (!that.orderInfo) {
                      that.msg = "签收出错，系统无匹配运单";
                    } else if (that.orderInfo.expressStatus == 1) {
                      that.msg = "本运单已签收";
                    }
                  }
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrderInfo() {
        return _ref.apply(this, arguments);
      }

      return getOrderInfo;
    }(),
    updateExpress: function updateExpress() {
      var that = this;
      var data = {};
      data.orderNo = that.orderInfo.orderNo;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      order.updateOrderExpress(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.msg = res.data.msg || "操作失败";

          return;
        }
        that.$message.success("签收成功");
        that.init();
      });
    },
    getOrderList: function getOrderList() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var data = {
        pageIndex: 1,
        pageSize: 10,
        expressStatus: 1
      };

      order.getOrderList(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils.formatDate(new Date(val.deliveryTime)).substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils.formatDate(new Date(val.statementTime)).substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            that.tableData = res.data.data.list;
          } else {
            that.tableData = [];
          }
        }
      });
    },
    getExpressList: function getExpressList() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      confirmApi.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.expressList = res.data.data;
      });
    },
    messageAlert: function messageAlert(title) {
      this.$alert(title, {
        confirmButtonText: "确定",
        callback: function callback(action) {}
      });
    },
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      document.getElementById('inputBox').addEventListener("keyup", function (e) {
        if (e.keyCode == 27) {
          _this2.cancel();
        } else if (e.keyCode == 13) {
          if (!_this2.orderInfo && _this2.msg) {
            _this2.cancel();
          } else {
            _this2.confirm();
          }
        }
      });
    });
  }
};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(81);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      vipCode: "",
      newDate: "",

      orderG: "",
      volumeTotal: 0,
      weightTotal: 0,
      toEcelce: false,
      orderTitle: "",
      remark: "",
      batchNum: "",

      deliverAddress: null,
      deliverAddressArr: [],
      value1: "",
      activeName: "first",
      columns: [{ title: "商品名称", key: "orderNo" }, { title: "数量", key: "productNum" }, { title: "库位", key: "shelves" }, { title: "入库时间", key: "storeTime" }, { title: "关联运单号", key: "expressNo" }, { title: "关联订单编号", key: "orderNo" }, { title: "客户", key: "userName" }, { title: "客户VIP号", key: "vipCode" }],

      NowDate: "",
      dialog: {
        show: false
      },

      orderNOA: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      orderList: [],
      orderListExport: [],
      tableData: [{
        remark: "sdad",
        predictTotal: "100",
        rate: 10,
        productWeight: 12
      }],

      howManyTotal: 0,
      listArr: [],
      columnsOrder: [{ title: "发货编号", key: "sendNo" }, { title: "发货时间", key: "sendTime" }, { title: "发货VIP号", key: "vipCode" }, { title: "用户名", key: "realName" }, { title: "订单数量", key: "orderCount" }, { title: "实收费用CAD", key: "amount" }, { title: "余额", key: "userBalance" }, { title: "批次", key: "remark" }, { title: "操作时间", key: "operatorTime" }],

      isUpdateFeeShow: false,
      feeInput: "",
      textarea: "",

      paramSendId: "",
      lookWhichRow: null,
      chukuTime: null,
      startDate: null,
      endDate: null,
      totalFee: "",
      lookingStatus: null,
      sendNo: null,

      batchList: [],

      timeout: null,

      checkedRecStatus: null,

      receOptions: [{ value: "0", label: "未签收" }, { value: "1", label: "已签收" }],
      loading: false,

      detailBalance: 0,

      isCouldUpdated: true,

      roleId: null
    };
  },
  created: function created() {
    var that = this;
    that.getStoreList();
    this.getBatchList();
    this.getAdressId();
  },
  mounted: function mounted() {
    var userinfo = mUtils.getStore('userinfo');

    if (userinfo.roleId == 3) {
      this.roleId = 3;
      this.deliverAddress = userinfo.adminId;
    }
  },

  methods: {
    getPreviewOrders: function getPreviewOrders(val) {
      var _this2 = this;

      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        sendId: val.sendId,
        userId: val.userId
      };
      var standard = 0,
          countTotal = 0,
          orderName = "";

      order.getSendOrderInfo(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            that.volumeTotal = 0;
            that.weightTotal = 0;
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              that.volumeTotal = value.productSize - 0 + that.volumeTotal;
              that.weightTotal = value.productWeight - 0 + that.weightTotal;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              }
            });
          }

          if (res.data.data && res.data.data.sendPojo && res.data.data.sendPojo.extraType == 1) {
            _this2.isCouldUpdated = false;
          } else {
            _this2.isCouldUpdated = true;
          }
          var obj = {};
          var arr = [];

          obj.index = "VIP号：";
          if (res.data.data && res.data.data.vipCode) {
            obj.productName = res.data.data.vipCode;
          } else {
            obj.productName = "";
          }
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.boxNumber = "箱号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.userBalance = "余额";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = "总";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = that.volumeTotal;
          obj.productWeight = that.weightTotal;
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = res.data.data.demandMoney || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = true;
          obj.predictTotal = "额外费用";
          obj.remark = res.data.data.sendPojo.extraPrice || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用备注";
          obj.remark = res.data.data.sendPojo.extraPriceRemark || "";
          that.feeInput = res.data.data.sendPojo.extraPrice || 0;
          that.textarea = res.data.data.sendPojo.extraPriceRemark || "";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          var newAmount = res.data.data.sendPojo.amount;
          obj.remark = newAmount ? newAmount.toFixed(2) : 0;
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = "混箱数";
          obj.productName = res.data.data.mixingTankCount;


          var MixTank = res.data.data.mixingTank;

          obj.productVolume = " 123";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          that.paramSendId = res.data.data.sendPojo.sendId;

          obj = {};
          obj.index = "箱数";
          obj.productName = res.data.data.unMixingTanksCount;

          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
          that.tableData.map(function (everyObj, eIndex) {
            if (eIndex == 2) {
              everyObj.userBalance = _this2.detailBalance;
              return everyObj;
            }
          });

          if (that.toEcelce) {
            var columns = [{ title: "#", key: "index" }, { title: "订单名", key: "productName" }, { title: "运单号", key: "expressNo" }, { title: "箱号", key: "boxNumber" }, { title: "体积 CBM", key: "productSize" }, { title: "重量 KG ", key: "productWeight" }, { title: "折扣率 %", key: "rate" }, { title: "费用 CAD", key: "predictTotal" }, { title: "余额", key: "userBalance" }, { title: "订单备注", key: "remark" }];

            mUtils.export2ExcelTitle(columns, that.tableData, that.orderTitle);
            that.toEcelce = false;
          }
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    onLook: function onLook(val) {
      var that = this;
      that.lookWhichRow = val;
      console.log(697, that.lookWhichRow);
      that.lookingStatus = that.lookWhichRow.status || null;
      if (val.userBalance !== undefined) {
        this.detailBalance = val.userBalance;
      } else {
        this.detailBalance = "";
      }
      that.dialog.show = true;
      that.getPreviewOrders(val);
    },
    onTOEcexlce: function onTOEcexlce(val) {
      var that = this;
      that.toEcelce = true;
      that.orderTitle = val.vipCode + "-" + val.sendTime;
      if (val.userBalance !== undefined) {
        this.detailBalance = val.userBalance;
      } else {
        this.detailBalance = "";
      }
      that.getPreviewOrders(val);
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getStoreList: function getStoreList(dataA) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        vipCode: that.vipCode ? that.vipCode : "",
        startDate: that.startDate ? that.startDate : "",
        endDate: that.endDate ? that.endDate : "",
        remark: that.remark ? that.remark : null,
        sendNo: that.sendNo ? that.sendNo : null,
        batchNumber: that.batchNum ? that.batchNum.trim() : null,
        isReceipt: that.checkedRecStatus || null,

        deliveryId: null
      };

      if (that.deliverAddress) {
        that.deliverAddressArr.forEach(function (dItem, index) {
          if (dItem.adminId == that.deliverAddress) {
            data.deliveryId = dItem.addressId;
          }
        });
      }

      dataA == "1" ? data.pageIndex = 1 : "";
      dataA == "1" ? that.paginations.page_index = 1 : "";

      order.sendOrderList(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, i) {
              if (val.user && val.user.vipCode) {
                val.vipCode = val.user.vipCode || "";
              } else {
                val.vipCode = "";
              }

              if (val.user && val.user.realName) {
                val.realName = val.user.realName || "";
              } else {
                val.realName = "";
              }
              val.createTime = mUtils.formatDate(new Date(val.createTime)).substring(0, 16);
              val.sendTime = mUtils.formatDate(new Date(val.sendTime)).substring(0, 10);
              val.operatorTime = mUtils.formatDate(new Date(val.operatorTime)).substring(0, 16);
            });
            that.orderList = res.data.data.list;
            that.orderList.map(function (newObj) {
              if (newObj.user && newObj.user.balance !== undefined) {
                newObj.userBalance = newObj.user.balance || "0";
              } else {
                newObj.userBalance = "";
              }
            });
            that.paginations.total = res.data.data.pageCount;
            that.totalFee = res.data.data.total;
            that.howManyTotal = res.data.data.pageCount;
          } else {
            that.orderList = [];
            that.paginations.total = 0;
            that.totalFee = 0;
            that.howManyTotal = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });
    },
    outDepot: function outDepot() {
      this.getStoreList("1");
    },
    getDate: function getDate(chukuTime) {
      if (!chukuTime) {
        this.startDate = "";
        this.endDate = "";
        this.getStoreList("1");
        return;
      }
      this.startDate = new Date(mUtils.formatDate(chukuTime[0])).getTime();
      var tempEndDate = new Date(mUtils.formatDate(chukuTime[1])).getTime();
      tempEndDate *= 1;
      tempEndDate += 86399000;
      this.endDate = tempEndDate;
      this.getStoreList("1");
    },
    sendNoBlur: function sendNoBlur() {
      this.getStoreList("1");
    },
    vipCodeBlur: function vipCodeBlur() {
      this.getStoreList("1");
    },
    remarkBlur: function remarkBlur() {
      this.getStoreList("1");
    },
    exportToExcel: function exportToExcel() {
      var that = this;

      that.getAllData();
    },
    getAllData: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var that, data, howManyPage, listArr, i, orderName;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                data = {
                  pageIndex: 1,
                  pageSize: 400,
                  vipCode: that.vipCode ? that.vipCode : "",
                  startDate: that.startDate ? that.startDate : "",
                  endDate: that.endDate ? that.endDate : "",
                  remark: that.remark ? that.remark : null,
                  sendNo: that.sendNo ? that.sendNo : null,
                  batchNumber: that.batchNum ? that.batchNum.trim() : null,
                  isReceipt: that.checkedRecStatus || null,

                  deliveryId: null
                };

                if (that.deliverAddress) {
                  that.deliverAddressArr.forEach(function (dItem, index) {
                    if (dItem.adminId == that.deliverAddress) {
                      data.deliveryId = dItem.addressId;
                    }
                  });
                }

                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                listArr = [];
                i = 1;

              case 6:
                if (!(i <= howManyPage)) {
                  _context.next = 13;
                  break;
                }

                data.pageIndex = i;
                _context.next = 10;
                return order.sendOrderList(data).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        every.sendTime = mUtils.formatDate(new Date(every.sendTime)).substring(0, 10);
                        every.operatorTime = mUtils.formatDate(new Date(every.operatorTime)).substring(0, 16);
                        if (every.user && every.user.vipCode) {
                          every.vipCode = every.user.vipCode;
                        }
                        if (every.user && every.user.realName) {
                          every.realName = every.user.realName;
                        }

                        listArr.push(every);
                      });
                    }
                  }
                });

              case 10:
                i++;
                _context.next = 6;
                break;

              case 13:
                that.listArr = listArr;
                that.listArr.map(function (newObj) {
                  if (newObj.user && newObj.user.balance !== undefined) {
                    newObj.userBalance = newObj.user.balance || "0";
                  } else {
                    newObj.userBalance = "";
                  }
                });
                orderName = "发货单Excel";

                mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllData() {
        return _ref.apply(this, arguments);
      }

      return getAllData;
    }(),
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;

      that.paginations.page_size = page_size;

      that.getStoreList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getStoreList();
    },
    updateExtraFee: function updateExtraFee() {
      var that = this;
      that.isUpdateFeeShow = true;
    },
    closeUpdateDialog: function closeUpdateDialog() {
      var that = this;
      that.isUpdateFeeShow = false;
    },
    certainUpdateDialog: function certainUpdateDialog() {
      var _this3 = this;

      var that = this;

      if (that.feeInput == "") {
        that.$message.warning("额外费用不能为空");
        return;
      }

      console.log(1073, (0, _typeof3.default)(that.feeInput));
      if (that.feeInput) {
        that.feeInput += "";
      }
      var param = {
        sendId: that.paramSendId,
        extraPrice: that.feeInput ? that.feeInput.trim() : "0",
        extraPriceRemark: that.textarea
      };
      order.updateExtraInfo(param).then(function (res) {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
          that.getPreviewOrders(_this3.lookWhichRow);
          that.getStoreList();
        } else {
          that.$message.error("修改失败");
        }
        that.isUpdateFeeShow = false;
        that.feeInput = "";
        that.textarea = "";
      });
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.getStoreList("1");
    },
    batchChange: function batchChange() {
      this.getStoreList("1");
    },
    remoteMethod: function remoteMethod(value) {
      var _this4 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.getBatchList(value);
      }, 500);
    },
    banlanceShow: function banlanceShow(row) {
      if (row.user && row.user.balance !== undefined) {
        return row.user.balance;
      }
    },
    getAdressId: function getAdressId() {
      var _this5 = this;

      var uselist = mUtils.getStore("userinfo");
      var realName = uselist.realName;
      var roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this5.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this5.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this5.deliverAddressArr = res.data.data.list;
        }
      });
    }
  }
};

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _date = __webpack_require__(64);

var date = _interopRequireWildcard(_date);

var _img = __webpack_require__(131);

var img = _interopRequireWildcard(_img);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _confirm = __webpack_require__(130);

var confirm = _interopRequireWildcard(_confirm);

var _priceGoods = __webpack_require__(204);

var priceGoods = _interopRequireWildcard(_priceGoods);

var _address = __webpack_require__(199);

var addressApi = _interopRequireWildcard(_address);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _box = __webpack_require__(73);

var boxApi = _interopRequireWildcard(_box);

var _face = __webpack_require__(284);

var _face2 = _interopRequireDefault(_face);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default,
    Face: _face2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "productWeight") {
          text = "包裹重量";
        } else if (rule.field == "productLong") {
          text = "包裹长度";
        } else if (rule.field == "productWidth") {
          text = "包裹宽度";
        } else if (rule.field == "productHeight") {
          text = "包裹高度";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      multipleSelection: [],
      reserveSelection: true,
      boxDialog: {
        show: false,
        title: "已选订单"
      },
      excelBoxDialog: {
        show: false,
        uploading: false,
        fileList: [],
        uploadProgress: {
          show: false,
          percentage: 0,
          status: '',
          text: ''
        }
      },
      sendDialog: {
        remark: ""
      },
      mianDialog: {
        show: false,
        isPrint: false,
        boxId: null
      },
      deliveryAddressList: [],
      orderAddDialog: {
        show: false,
        activeName: "1",
        title: "商品补录",
        data: {
          orderId: null,
          expressNo: "",
          expressCompany: "",
          predictTotal: null,
          remark: "",
          productList: [{
            productName: "",
            productNum: null
          }]
        },
        form_rules: {}
      },
      search: {
        goodType: null,
        isOrderSend: null,
        addressId: null,
        boxNumber: null,
        batchNum: null
      },
      tableData: [],
      userIdCode: "",

      newDate: "2021-11-10",

      discountTotal: "",
      priceGoodsIdCopy: {
        firstWeight: "",
        price: "",
        goodId: ""
      },
      bool: false,
      sendList: [{
        id: 1,
        name: "未生成发货单"
      }, {
        id: 2,
        name: "已生成发货单"
      }],
      storeList: [],
      priceGoodsId: "",
      priceGoodsList: [],
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false,
        showC: false,
        showCC: false,
        showD: false,
        showF: false
      },
      delOrderNo: "",

      deliveyList: [],
      options: [{
        value: "不合箱",
        id: 0
      }, {
        value: "合箱",
        id: 1
      }],
      order: {
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        isBox: 0,
        remark: "",
        detailList: [{
          detailId: 0,
          productName: "",
          productNum: ""
        }]
      },
      pagTotal: false,
      pageIndexB: 0,
      pageIndex: 0,
      orderMoneyB: [],
      orderG: "",
      isBoxG: "",
      orderNOC: "",
      weiBol: false,
      volBol: false,
      galIndex: "",
      galIndexB: "",
      total: 0,
      weiTotal: 0,
      volTotal: 0,

      headers: {},
      orderInfoC: "",
      orderInfo: {
        orderNo: ""
      },
      goodTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: false,
          onlyShowBarOnScroll: false,
          background: "#C1C1C1",
          keepShow: true,
          size: "12px",
          opacity: 1 }
      },
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      activeName: "first",
      columns: [{ title: "订单编号", key: "orderNo" }, { title: "名称", key: "productName" }, { title: "货物类型", key: "goodName" }, { title: "派送点", key: "deliveryTitle" }, { title: "客户", key: "userName" }, { title: "vip号", key: "vipCode" }, { title: "物流公司", key: "expressCompany" }, { title: "运单号", key: "expressNo" }, { title: "状态", key: "dealStatus" }, { title: "签收人", key: "expressName" }, { title: "尺寸", key: "measure" }, { title: "联系方式", key: "userTel" }, { title: "商品价值", key: "predictTotal" }, { title: "体积", key: "productVolume" }, { title: "重量", key: "productWeight" }, { title: "运费", key: "total" }, { title: "下单时间", key: "addDate" }, { title: "用户备注", key: "userRemark" }, { title: "订单备注", key: "remark" }, { title: "批次", key: "batchNumber" }, { title: "箱号", key: "boxNumber" }],
      columns2: [{ title: "订单编号", key: "orderNo" }, { title: "名称", key: "productName" }, { title: "货物类型", key: "goodName" }, { title: "派送点", key: "deliveryTitle" }, { title: "客户", key: "userName" }, { title: "vip号", key: "vipCode" }, { title: "物流公司", key: "expressCompany" }, { title: "运单号", key: "expressNo" }, { title: "状态", key: "dealStatus" }, { title: "签收人", key: "expressName" }, { title: "尺寸", key: "measure" }, { title: "联系方式", key: "userTel" }, { title: "商品价值", key: "predictTotal" }, { title: "体积", key: "productVolume" }, { title: "重量", key: "productWeight" }, { title: "运费", key: "total" }, { title: "下单时间", key: "addDate" }, { title: "用户备注", key: "userRemark" }, { title: "订单备注", key: "remark" }, { title: "批次", key: "batchNumber" }, { title: "箱号", key: "boxNumber" }],

      orderNOG: "",

      NowDate: "",

      startTime: "",
      endTime: "",
      deliveryStartDate: "",
      deliveryEndDate: "",
      statementStartDate: "",
      statementEndDate: "",
      storeStartDate: "",
      storeEndDate: "",
      sytemPrice: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showE: false,
        showF: false,
        showG: false,
        showH: false
      },
      beforeExpressNo: "",
      DataInformation: "",
      orderNOA: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      orderMoney: [],
      orderMoney2: [],
      optionsType: [{
        id: 1,
        label: "全部"
      }, {
        id: 2,
        label: "待支付"
      }, {
        id: 3,
        label: "待结算"
      }, {
        id: 4,
        label: "交易关闭"
      }, {
        id: 5,
        label: "交易成功"
      }],
      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankCard: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankUser: [{ required: true, trigger: "blur", validator: dataValidate }]
        }
      },
      productCauserTelist: [],
      confirmDialogVisible: false,
      postCount: 0,
      excelList: [],
      excelList2: [],

      checkedTransType: "",
      transTypeSelect: [{
        goodType: 1,
        goodName: "海运"
      }, {
        goodType: 2,
        goodName: "海运大件"
      }, {
        goodType: 3,
        goodName: "空运"
      }],
      checkedgoodsType: "",
      transGoodSelectArr: [],
      goodsKindsArr: [],
      rukuRow: {},
      paramGoodType: "",

      batchList: [],

      timeout: null,
      loading: false
    };
  },
  created: function created() {
    var that = this;

    that.activeName = that.$route.query.activeName ? that.$route.query.activeName : that.activeName;
    if (that.activeName == "four") {
      this.search.goodType = 1;
    }
    that.getPriceGoodsList();
    that.getOrderList();
    that.getExpressList();
    that.getStoreList();
    that.getDeliveryList();
    this.getBatchList();
  },

  methods: {
    init: function init() {
      this.paginations.page_index = 1;
      this.getOrderList();
    },
    mianHandler: function mianHandler(type) {
      this.mianDialog.show = false;
      if (type == 1) {
        this.mianDialog.isPrint = true;
      } else {
        this.$router.push("/order/box");
      }
    },
    closeMianDialog: function closeMianDialog() {
      this.multipleSelection = [];
    },
    closeFaceDialog: function closeFaceDialog(val) {
      this.mianDialog.isPrint = false;
    },
    selectable: function selectable(row, index) {
      if (this.activeName != "third") {
        return false;
      } else {
        return true;
      }
    },
    openBoxHanlder: function openBoxHanlder() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.error("请选择订单");
      }
      this.boxDialog.show = true;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectChange: function selectChange(selection, row) {
      if (selection.length > 0) {
        var data = row;
        var data2 = selection[0];
        if (data && data2 && data.goodType && data2.goodType && data.goodType != data2.goodType || data && data2 && data.deliveryTitl && data2.deliveryTitle && data.deliveryTitle != data2.deliveryTitle) {
          var del_row = selection.pop();
          this.$refs.table.toggleRowSelection(del_row, false);
          return this.$message.error("合箱订单运输方式和派送点一致");
        }
      }
    },
    handleRowClick: function handleRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
      this.selectChange(this.multipleSelection);
    },
    submitBox: function submitBox() {
      var that = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.error("请选择订单");
      }
      var param = {};
      var orderList = [];
      this.multipleSelection.forEach(function (item) {
        var obj = {};
        obj.orderId = item.orderId;
        orderList.push(obj);
      });
      that.multipleSelection = [];
      param.orderList = orderList;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      boxApi.combinedBox(param).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "提交失败");
        }
        that.$message({
          message: "合箱成功!",
          type: "success"
        });

        that.boxDialog.show = false;
        that.getOrderList();
        that.handleSelectionChange();
        that.multipleSelection = [];
        that.$refs.table.clearSelection();

        that.mianDialog.boxId = res.data.data.boxId;
      });
    },
    openExcelBoxDialog: function openExcelBoxDialog() {
      this.excelBoxDialog.show = true;
      this.excelBoxDialog.fileList = [];
      this.excelBoxDialog.uploading = false;
      this.excelBoxDialog.uploadProgress.show = false;
    },
    handleExcelDialogClosed: function handleExcelDialogClosed() {
      this.excelBoxDialog.fileList = [];
      this.excelBoxDialog.uploading = false;
      this.excelBoxDialog.uploadProgress.show = false;
      if (this.$refs.excelUpload) {
        this.$refs.excelUpload.clearFiles();
      }
    },
    beforeUpload: function beforeUpload(file) {
      return false;
    },
    handleFileChange: function handleFileChange(file, fileList) {
      if (fileList.length > 1) {
        fileList = [fileList[fileList.length - 1]];
      }

      if (fileList.length === 0) {
        this.excelBoxDialog.fileList = [];
        return;
      }

      var currentFile = fileList[0];

      var isExcel = currentFile.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || currentFile.raw.type === 'application/vnd.ms-excel' || currentFile.name.endsWith('.xlsx') || currentFile.name.endsWith('.xls');

      if (!isExcel) {
        this.$message.error('只能上传Excel文件(.xlsx/.xls)!');
        this.excelBoxDialog.fileList = [];
        this.$refs.excelUpload.clearFiles();
        return;
      }

      var isLt10M = currentFile.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        this.excelBoxDialog.fileList = [];
        this.$refs.excelUpload.clearFiles();
        return;
      }

      this.excelBoxDialog.fileList = [currentFile.raw];
      console.log('文件选择成功:', currentFile.name, '文件列表长度:', this.excelBoxDialog.fileList.length);
    },
    submitExcelBoxing: function submitExcelBoxing() {
      var _this2 = this;

      if (this.excelBoxDialog.fileList.length === 0) {
        this.$message.error('请选择要上传的Excel文件');
        return;
      }

      var file = this.excelBoxDialog.fileList[0];
      this.excelBoxDialog.uploading = true;
      this.excelBoxDialog.uploadProgress.show = true;
      this.excelBoxDialog.uploadProgress.percentage = 0;
      this.excelBoxDialog.uploadProgress.status = '';
      this.excelBoxDialog.uploadProgress.text = '正在上传文件...';

      var progressTimer = setInterval(function () {
        if (_this2.excelBoxDialog.uploadProgress.percentage < 90) {
          _this2.excelBoxDialog.uploadProgress.percentage += 10;
        }
      }, 200);

      boxApi.excelBatchBoxing(file).then(function (res) {
        clearInterval(progressTimer);
        _this2.excelBoxDialog.uploading = false;
        _this2.excelBoxDialog.uploadProgress.percentage = 100;

        if (res.data.code !== 0) {
          _this2.excelBoxDialog.uploadProgress.status = 'exception';
          _this2.excelBoxDialog.uploadProgress.text = res.data.msg || '合箱失败';
          _this2.$message.error(res.data.msg || '合箱失败');
          return;
        }

        _this2.excelBoxDialog.uploadProgress.status = 'success';
        _this2.excelBoxDialog.uploadProgress.text = '合箱成功！';
        _this2.$message.success(res.data.msg || 'Excel批量合箱成功!');

        setTimeout(function () {
          _this2.excelBoxDialog.show = false;
          _this2.getOrderList();
        }, 1500);
      }).catch(function (error) {
        clearInterval(progressTimer);
        _this2.excelBoxDialog.uploading = false;
        _this2.excelBoxDialog.uploadProgress.status = 'exception';

        if (error.response && error.response.status === 404) {
          _this2.excelBoxDialog.uploadProgress.text = '接口暂未实现';
          _this2.$message.warning('Excel批量合箱接口暂未实现，请联系后端开发人员');
        } else if (error.response && error.response.status === 500) {
          _this2.excelBoxDialog.uploadProgress.text = '服务器错误';
          _this2.$message.error('服务器内部错误，请稍后再试');
        } else {
          _this2.excelBoxDialog.uploadProgress.text = '上传失败';
          _this2.$message.error('网络错误，上传失败');
        }

        console.error('Excel批量合箱失败:', error);
      });
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {},
    handleUploadError: function handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败');
      console.error('上传错误:', err);
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code != 0) {
          return;
        }
        if (res.data.code == 0) {
          that.deliveryAddressList = res.data.data.list;
        }
      });
    },
    addOrderProductDialog: function addOrderProductDialog(row) {
      this.orderAddDialog.show = true;
      this.orderAddDialog.data = {
        orderId: row.orderId,
        expressNo: row.expressNo,
        expressCompany: row.expressCompany,
        remark: row.remark,
        predictTotal: row.predictTotal ? row.predictTotal : null,
        productList: [{
          productName: "",
          productNum: null
        }]
      };
    },
    addOrderProduct: function addOrderProduct() {
      var obj = {
        productName: "",
        productNum: null
      };
      this.orderAddDialog.data.productList.push(obj);
    },
    deleteOrderProduct: function deleteOrderProduct(index) {
      this.orderAddDialog.data.productList.splice(index, 1);
    },
    supplementOrder: function supplementOrder() {
      var that = this;
      var param = {};
      var store = that.storeList && that.storeList.filter(function (item) {
        return item.goodType == that.orderAddDialog.activeName;
      });
      param.orderId = that.orderAddDialog.data.orderId;
      param.expressCompany = that.orderAddDialog.data.expressCompany;
      param.predictTotal = that.orderAddDialog.data.predictTotal;
      param.remark = that.orderAddDialog.data.remark;
      param.contacts = store ? store[0].contacts : "";
      param.tel = store ? store[0].tel : "";
      param.address = store ? store[0].address : "";
      param.goodType = that.orderAddDialog.activeName;
      that.orderAddDialog.data.productList.forEach(function (item, index) {
        if (!item.productName) {
          return that.$message.error("商品名称不能为空！");
        } else if (!item.productNum) {
          return that.$message.error("商品数量不能为空！");
        }
      });
      param.detailList = that.orderAddDialog.data.productList;

      order.supplementOrder(param).then(function (res) {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({ message: "提交成功", type: "success" });
        that.orderAddDialog.show = false;
        that.getOrderList();
      });
    },
    toDate: function toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    goodTypeName: function goodTypeName(goodType) {
      var str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    exportToOrderLook: function exportToOrderLook(val) {
      this.adminDeleteDialog.showD = false;
      this.adminDeleteDialog.showF = true;
      this.getPreviewOrders(val);
    },
    getStoreList: function getStoreList() {
      var that = this;
      var data = {};
      addressApi.getStoreList(data).then(function (res) {
        if (res.data.code == 0) {
          var dataList = res.data.data.list || null;
          if (dataList && dataList.length > 0) {
            var store1 = dataList.filter(function (item) {
              return item.goodType == 1;
            });
            var store2 = dataList.filter(function (item) {
              return item.goodType == 2;
            });
            var store3 = dataList.filter(function (item) {
              return item.goodType == 3;
            });
            var storeList = [];
            var obj = {};
            obj.goodType = "1";
            obj.goodName = "海运";
            obj.contacts = store1 ? store1[0].contacts : "";
            obj.tel = store1 ? store1[0].tel : "";
            obj.address = store1 ? store1[0].address : "";
            storeList.push(obj);

            obj = {};
            obj.goodType = "2";
            obj.goodName = "海运大件";
            obj.contacts = store1 ? store2[0].contacts : "";
            obj.tel = store1 ? store2[0].tel : "";
            obj.address = store1 ? store2[0].address : "";
            storeList.push(obj);

            obj = {};
            obj.goodType = "3";
            obj.goodName = "空运";
            obj.contacts = store1 ? store3[0].contacts : "";
            obj.tel = store1 ? store3[0].tel : "";
            obj.address = store1 ? store3[0].address : "";
            storeList.push(obj);

            that.storeList = storeList;
          }
        }
      });
    },
    getPreviewOrders: function getPreviewOrders(val) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        vipCode: val
      };
      var standard = 0,
          countTotal = 0;
      order.sendPreviewOrders(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName = value.detailList[0].productName + "...等" + value.detailList.length + "款";
                } else {
                  value.productName = value.detailList[0].productName.substring(0, 5) + "...等" + value.detailList.length + "款";
                }
              }
            });
          }
          var obj = {};
          var arr = [];
          obj.index = "VIP号：";
          obj.productName = res.data.data.vipCode;
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = countTotal ? countTotal.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用";
          obj.remark = 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          var subTotal = mUtils.accAdd(countTotal, standard);
          obj.remark = subTotal ? subTotal.toFixed(2) : 0;
          arr.push(obj);
          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },
    exportToSendOrder: function exportToSendOrder() {
      this.adminDeleteDialog.showCC = true;
      this.getNowData();
    },
    exportToSendOrderLook: function exportToSendOrderLook() {
      this.adminDeleteDialog.showD = true;
    },
    exportToOrder: function exportToOrder(val) {
      var that = this;

      var data = {
        sendTime: new Date(val).getTime(),
        userId: Number(mUtils.getStore("userinfo").adminId),
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate: that.deliveryStartDate && that.activeName == "four" ? that.deliveryStartDate : null,
        deliveryEndDate: that.deliveryEndDate && that.activeName == "four" ? that.deliveryEndDate : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        remark: that.sendDialog.remark,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null
      };

      var loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      order.sendOrder(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("批量生成失败");
          return;
        } else {
          that.$message.success("批量生成成功");
          that.adminDeleteDialog.showCC = false;
          that.activeName = that.$route.query.activeName ? that.$route.query.activeName : that.activeName;

          that.init();
          that.getOrderList();
          that.getStoreList();
          that.getDeliveryList();
        }
      });
      loading.close();
    },
    changeDiscount: function changeDiscount(val) {
      this.orderInfo.discount = val;
      this.$forceUpdate();
    },
    seleType: function seleType(val) {
      var that = this;
      that.priceGoodsIdCopy.goodId = val.split(",")[0];
      that.priceGoodsIdCopy.price = val.split(",")[1];
      that.priceGoodsIdCopy.firstWeight = val.split(",")[2];
      that.sytemPrice = val.split(",")[1];
      that.getComputer();
    },
    seleTransType: function seleTransType(goodType) {
      var that = this;

      that.checkedgoodsType = "";

      var newArr = that.goodsKindsArr.filter(function (value, index, array) {
        return value.goodType == goodType;
      });
      that.transGoodSelectArr = newArr;
      that.paramGoodType = goodType;
    },
    seleTransGoods: function seleTransGoods(val) {
      var that = this;
      that.priceGoodsIdCopy.goodId = val.split(",")[0];
      that.priceGoodsIdCopy.price = val.split(",")[1];
      that.priceGoodsIdCopy.firstWeight = val.split(",")[2];
      that.sytemPrice = val.split(",")[1];

      that.checkedgoodsType = val;
      that.getComputer();
    },
    getPriceGoodsList: function getPriceGoodsList() {
      var that = this;

      var data = {
        pageIndex: 1,
        pageSize: 50
      };

      var loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      priceGoods.goodList(data).then(function (res) {
        loading.close();

        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          that.priceGoodsId = res.data.data.list[0].goodId + "," + res.data.data.list[0].price + "," + res.data.data.list[0].firstWeight;
          that.priceGoodsIdCopy.price = res.data.data.list[0].price;
          that.priceGoodsIdCopy.firstWeight = res.data.data.list[0].firstWeight;
          that.priceGoodsIdCopy.goodId = res.data.data.list[0].goodId;
          that.sytemPrice = res.data.data.list[0].price;
          that.priceGoodsList = res.data.data.list;

          that.goodsKindsArr = res.data.data.list;
        }
      });
      loading.close();
    },
    checkOrder: function checkOrder(val) {
      var that = this;
      var reg = /^\d+$|^\d*\.\d+$/g;
      if (!reg.test(val)) {
        that.$message.warning("只能输入数字和小数点");
      }
    },
    deleteItem: function deleteItem(index) {
      this.adminDeleteDialog.show = false;
      this.order.detailList.splice(index, 1);
    },
    deleteDialog: function deleteDialog(index) {
      this.indexA = index;
      this.adminDeleteDialog.show = true;
    },
    deleteDialogB: function deleteDialogB(index) {
      this.indexA = index;
      this.adminDeleteDialog.showC = true;
    },
    deleteItemB: function deleteItemB(index) {
      this.adminDeleteDialog.showC = false;
      this.orderInfo.productList.splice(index, 1);
    },
    addProduct: function addProduct() {
      this.order.detailList.push({
        detailId: 0,
        productName: "",
        productNum: ""
      });
    },
    addProductB: function addProductB() {
      this.orderInfo.productList.push({
        detailId: 0,
        productName: "",
        productNameB: "",
        productNumB: "",
        productRemark: "",
        productNum: "",
        shelves: "",
        productImgList: [{
          productImg: ""
        }]
      });
      this.$forceUpdate();
    },
    onSubmitOrder: function onSubmitOrder() {
      var that = this;
      var data = {};
      if (!that.order.detailList.length) {
        that.$message.warning("请添加商品");
        return;
      }
      if (!that.order.expressNo) {
        that.$message.warning("请添加快递单号");
        return;
      }
      if (!that.order.predictTotal) {
        that.$message.warning("请填写商品价值");
        return;
      }
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;
        return true;
      });

      if (validd) {
        data = {
          operatorId: mUtils.getStore("userinfo").adminId,
          orderNo: that.order.orderNo,
          vipCode: that.order.vipCode,
          expressCompany: that.order.expressCompany,
          expressNo: that.order.expressNo,
          predictTotal: that.order.predictTotal,
          isBox: that.order.isBox,
          remark: that.order.remark || "",
          detailList: that.order.detailList
        };

        order.createOrder(data).then(function (res) {
          if (res.data.code != 0) {} else {
            that.getOrderList();
            that.dialog.showH = false;
            that.dialog.show = false;
            var msg = "添加成功";
            that.$message({
              message: msg,
              type: "success"
            });

            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    editOrder: function editOrder(val) {
      var that = this;
      that.order = val;
      var obj = {};
      var arr = [];
      val.detailList.forEach(function (value, i) {
        obj = {};
        obj.detailId = value.detailId;
        obj.productName = value.productName;
        obj.productNum = value.productNum;
        arr.push(obj);
      });
      that.order.detailList = arr;

      that.dialog.showH = true;
    },
    delOrderDiolag: function delOrderDiolag(val) {
      this.delOrderNo = val.orderNo;
      this.adminDeleteDialog.showB = true;
    },
    delOrder: function delOrder(val) {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      data = {
        orderNo: val
      };
      order.cancelOrder(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("取消订单失败");
          return;
        }
        that.adminDeleteDialog.showB = false;
        that.dialog.show = false;
        that.getOrderList();
      });
    },
    getExpressList: function getExpressList() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      confirm.expressList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          that.$message.error("获取快递公司列表失败");
          return;
        }
        that.deliveyList = res.data.data;
      });
    },
    affirmC: function affirmC() {
      var that = this;
      var isbox = "";
      if (that.isBoxG == 0) {
        isbox = 1;
      } else {
        isbox = 0;
      }
      var obj = {};
      obj.orderNo = that.orderG;
      obj.operatorId = mUtils.getStore("userinfo").adminId;
      obj.isBox = isbox;
      order.updateBox(obj).then(function (res) {
        if (res.data.code == 0) {
          that.$message.success("改变成功！");

          that.dialog.showG = false;
          that.getorderNo(that.orderG);
          that.getOrderList();
        } else {
          that.$message.error("改变失败！");
        }
      });
    },
    getorderNoB: function getorderNoB(val, isbox) {
      this.orderG = val;
      this.isBoxG = isbox;
      this.dialog.showG = true;
    },
    getorderNoC: function getorderNoC(val) {
      this.orderG = val;
      this.dialog.showE = true;
    },
    realDate: function realDate(val) {
      var that = this;
      that.paginations.page_index = 1;
      if (val.length >= 2) {
        that.getOrderList("1");
      } else if (val.length == 0) {
        that.getOrderList("1");
      }
    },
    inputOrder: function inputOrder(val) {
      var that = this;
      that.paginations.page_index = 1;
      if (val.length >= 4) {
        that.getOrderList("1");
      } else if (val.length == 0) {
        that.getOrderList("1");
      }
    },
    opBa: function opBa(val) {
      window.open(val, "_blank");
    },
    shelver: function shelver(i, val, value) {
      this.$forceUpdate();
    },
    onsubUpdate: function onsubUpdate(type) {
      var that = this;

      var status = 0;
      var mse = "";
      if (type == 2) {
        status = 2;
        mse = "入库";
      } else {
        mse = "出库";
        status = 3;
      }
      var arr = [];
      var obj = {};
      that.orderInfo.productList.forEach(function (val, i) {
        obj = {};
        obj.productName = val.productName;

        obj.detailId = val.detailId;
        obj.productNum = val.productNum;
        obj.weight = val.weight || 0;
        obj.productLong = val.productLong || 0;
        obj.width = val.width || 0;
        obj.height = val.height || 0;
        if (val.shelves) {
          obj.shelves = val.shelves;
        } else {
          obj.shelves = "";
        }
        if (val.productImgList.length) {
          val.productImgList.forEach(function (value, index) {
            if (index == 0) {
              obj.pic = value.productImgB;
            } else {
              obj.pic = obj.pic + "," + value.productImgB;
            }
          });
        } else {
          obj.pic = "";
        }
        arr.push(obj);
      });
      if (status == 2) {
        if (!that.orderInfo.productWeight) {
          return that.$message.error("包裹重量不能为空");
        }
        if (!that.orderInfo.productLong) {
          return that.$message.error("长度不能为空");
        }
        if (!that.orderInfo.productWidth) {
          return that.$message.error("宽度不能为空");
        }
        if (!that.orderInfo.productHeight) {
          return that.$message.error("高度不能为空");
        }
        if (!that.checkedgoodsType) {
          return that.$message.error("物品类型不能为空");
        }
      }
      var data = {
        orderNo: that.orderInfo.orderNo,
        status: status,
        subTotal: that.total,
        total: that.discountTotal,
        weightTotal: that.weiTotal,
        volumeTotal: that.volTotal,
        operatorId: mUtils.getStore("userinfo").adminId,
        rate: that.orderInfo.discount,
        productWeight: that.orderInfo.productWeight,
        productHeight: that.orderInfo.productHeight,
        productLong: that.orderInfo.productLong,
        productWidth: that.orderInfo.productWidth,
        remark: that.orderInfo.remark ? that.orderInfo.remark : null,
        goodId: that.priceGoodsIdCopy.goodId,
        priceFactor: that.sytemPrice,
        detailList: arr,
        goodType: that.paramGoodType
      };

      order.uploadOrderInfo(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.$message.success(mse + "保存成功");
          that.dialog.showD = false;
          that.dialog.show = false;
          that.dialog.showC = false;
          that.dialog.showB = false;
          that.getOrderList();
        } else {
          that.$message.error(mse + "保存失败");
        }
      });
    },
    getorderNo: function getorderNo(val, ind, row) {
      var that = this;
      if (row) {
        that.rukuRow = row;
        that.checkedTransType = row.goodType;
        that.paramGoodType = row.goodType;
        that.checkedgoodsType = "";
        var newArr = that.goodsKindsArr.filter(function (value, index, array) {
          return value.goodType == row.goodType;
        });
        that.transGoodSelectArr = newArr;
      }

      that.volTotal = 0;
      that.weiTotal = 0;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        orderNo: val
      };

      order.getOrderInfo(data).then(function (res) {
        if (res.data.code == 0) {
          that.orderInfo = res.data.data;
          that.priceGoodsList.forEach(function (val, i) {
            if (val.goodId == res.data.data.goodId) {
              that.priceGoodsId = val.goodId + "," + val.price + "," + val.firstWeight;
              that.priceGoodsIdCopy.price = val.price;
              that.priceGoodsIdCopy.firstWeight = val.firstWeight;
              that.sytemPrice = val.price;
            }
          });
          that.orderInfo.addDate = mUtils.formatDate(new Date(that.orderInfo.addTime)).substring(0, 16);
          that.orderInfo.storeTime = mUtils.formatDate(new Date(that.orderInfo.storeTime)).substring(0, 16);
          that.orderInfo.deliveryTime = mUtils.formatDate(new Date(that.orderInfo.deliveryTime)).substring(0, 16);

          that.orderInfo.centerEnterTime ? that.orderInfo.centerEnterTime = mUtils.formatDate(new Date(that.orderInfo.centerEnterTime)).substring(0, 16) : "";

          that.orderInfo.centerOutTime ? that.orderInfo.centerOutTime = mUtils.formatDate(new Date(that.orderInfo.centerOutTime)).substring(0, 16) : "";

          that.orderInfo.deliveryEnterTime ? that.orderInfo.deliveryEnterTime = mUtils.formatDate(new Date(that.orderInfo.deliveryEnterTime)).substring(0, 16) : "";

          that.orderInfo.statementTime ? that.orderInfo.statementTime = mUtils.formatDate(new Date(that.orderInfo.statementTime)).substring(0, 16) : "";
          that.orderInfo.suppleTime ? that.orderInfo.suppleTime = mUtils.formatDate(new Date(that.orderInfo.suppleTime)).substring(0, 16) : "";

          that.orderInfo.productList = that.orderInfo.detailList;
          if (res.data.data.rate) {
            that.orderInfo.discount = res.data.data.rate;
          } else {
            that.orderInfo.discount = 100;
          }
          var arr = [];
          var arrB = [];
          var obj = {};
          that.orderInfo.productList.forEach(function (val, i) {

            arrB = [];
            val.productImgList = [];

            if (val.pic) {
              if (val.pic.indexOf(",") != -1) {
                arr = val.pic.split(",");
                val.productImg = that.orderInfo.httpUrl + val.pic.split(",")[0];
                val.productImgB = that.orderInfo.httpUrl + val.pic.split(",")[1];
                arr.forEach(function (value, index) {
                  obj = {};
                  obj.productImg = that.orderInfo.httpUrl + value;
                  obj.productImgB = value;
                  arrB.push(obj);
                });
              } else {
                val.productImg = that.orderInfo.httpUrl + val.pic;
                obj = {};
                obj.productImg = that.orderInfo.httpUrl + val.pic;
                obj.productImgB = val.pic;
                arrB.push(obj);
              }
            }
            val.productImgList = arrB;
          });

          if (ind == 2) {
            that.orderInfo.productList.forEach(function (val, i) {
              val.weiBol = false;
              val.volBol = false;
              val.shelves = val.shelves;
              val.productNumB = val.productNum;
              val.weightB = val.weight;
              val.productLongB = val.productLong;
              val.widthB = val.width;
              val.heightB = val.height;
            });

            that.dialog.showD = true;
          } else if (ind == 3) {
            that.dialog.showB = true;
          } else {
            that.dialog.show = true;
          }
          that.$forceUpdate();
          loading.close();
        }
      });
    },
    getDate: function getDate(value1) {
      if (!value1) {
        this.startTime = "";
        this.endTime = "";
        this.getOrderList("1");
        return;
      }
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.getOrderList("1");
    },
    getDate2: function getDate2(value1) {
      if (!value1) {
        this.deliveryStartDate = "";
        this.deliveryEndDate = "";
        this.getOrderList("1");
        return;
      }
      this.deliveryStartDate = new Date(mUtils.formatDate(value1[0])).getTime();
      this.deliveryEndDate = new Date(mUtils.formatDate(value1[1])).getTime() + 86399000;
      this.getOrderList("1");
    },
    getDate3: function getDate3(value1) {
      if (!value1) {
        this.statementStartDate = "";
        this.statementEndDate = "";
        return;
      }
      this.statementStartDate = new Date(mUtils.formatDate(value1[0])).getTime();
      this.statementEndDate = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    getDate4: function getDate4(value1) {
      if (!value1) {
        this.storeStartDate = "";
        this.storeEndDate = "";
        return;
      }
      this.storeStartDate = new Date(mUtils.formatDate(value1[0])).getTime();
      this.storeEndDate = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    cahnBlur: function cahnBlur(val) {
      var that = this;
      var numReg = /^\d+(\.\d+)?$/;

      if (!numReg.test(val)) {
        that.$message.warning("请输入数字");
      } else {
        if (val < 0) {
          that.$message.warning("请输入大于等于0的值");
        }
      }
    },
    copy: function copy() {
      var that = this;

      var clipboard = new this.Clipboard(".btn");
      clipboard.on("success", function (e) {
        that.$message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        that.$message.warning("该浏览器不支持自动复制");

        clipboard.destroy();
      });
    },
    getComputer: function getComputer() {
      var that = this;
      var total = 0;
      var weiCount = 0;
      var volCount = 0;

      var good = that.priceGoodsList.filter(function (res) {
        return res.goodId == that.priceGoodsIdCopy.goodId;
      });
      var productWeight = 0,
          productVolumn = 0;

      if (that.orderInfo.productWeight) {
        if (good[0].goodType == 1) {
          productWeight = that.orderInfo.productWeight <= 1 && good[0].firstWeight == 1 ? 1 : that.orderInfo.productWeight;
        } else if (good[0].goodType == 3) {
          productWeight = that.orderInfo.productWeight;
        }
      }

      if (that.orderInfo.productLong > 0 && that.orderInfo.productWidth > 0 && that.orderInfo.productHeight > 0) {
        if (good[0].goodType == 2) {
          var v1 = (that.orderInfo.productLong / 100 * (that.orderInfo.productWidth / 100) * (that.orderInfo.productHeight / 100)).toFixed(4);
          var _v = Math.ceil(v1 * 2);
          var _v2 = _v / 2;
          productVolumn = _v2 <= 1 && good[0].firstWeight == 1 ? 1 : _v2;
        } else if (good[0].goodType == 3) {
          var _v3 = (that.orderInfo.productLong * that.orderInfo.productWidth * that.orderInfo.productHeight / 5000).toFixed(4);
          productVolumn = _v3;
        } else {
          var _v4 = (that.orderInfo.productLong * that.orderInfo.productWidth * that.orderInfo.productHeight / 6000).toFixed(4);
          productVolumn = _v4 <= 1 && good[0].firstWeight == 1 ? 1 : _v4;
        }
      }

      var v = good[0].goodType == 3 ? productVolumn * 2.2 : productVolumn;
      var v2 = good[0].goodType == 3 ? productWeight * 2.2 : productWeight;
      var productVolumn2 = v <= 1 && good[0].firstWeight == 1 ? 1 : v;
      var productWeight2 = v2 <= 1 && good[0].firstWeight == 1 ? 1 : v2;

      if (parseFloat(productWeight) > parseFloat(productVolumn)) {
        total = productWeight2;
      } else {
        total = productVolumn2;
      }

      if (good[0].goodType == 3) {
        volCount = parseFloat((productVolumn2 * good[0].price).toFixed(2));
        weiCount = parseFloat((productWeight2 * good[0].price).toFixed(2));
        total = parseFloat((total * good[0].price).toFixed(2));
      } else {
        weiCount = productWeight2 * good[0].price;
        volCount = productVolumn2 * good[0].price;
        total = total * good[0].price;
      }

      that.weiTotal = weiCount ? weiCount.toFixed(2) : 0;
      that.volTotal = volCount ? volCount.toFixed(2) : 0;
      that.total = total ? total.toFixed(2) : 0;
      that.discountTotal = total ? (mUtils.accMul(total, that.orderInfo.discount) / 100).toFixed(2) : 0;
      return;
    },
    affirmB: function affirmB() {
      var that = this;
      var val = that.galIndex;
      var i = that.galIndexB;
      that.orderInfo.productList[val].productImgList.splice(i, 1);
      that.$forceUpdate();
      that.dialog.showF = false;
    },
    del: function del(val, index) {
      var that = this;
      that.galIndex = val;
      that.galIndexB = index;
      that.dialog.showF = true;
    },
    onsubmitB: function onsubmitB() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.search.validate(function (valid) {
        validd = valid;
        return true;
      });

      if (validd) {
        that.onsubUpdate("2");
        loading.close();
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    instorage: function instorage(value) {
      var that = this;
      that.getExpressList();
      that.orderInfo = value;
      that.orderInfo.productList.forEach(function (val, i) {
        val.productNumB = val.productNum;
        val.weightB = val.weight;
        val.productLongB = val.productLong;
        val.widthB = val.width;
        val.heightB = val.height;
      });
      that.getComputer();
      that.dialog.showD = true;
    },
    affirmD: function affirmD() {
      var that = this;
      var data = {
        orderNo: that.orderG,
        status: 4,
        operatorId: mUtils.getStore("userinfo").adminId,
        remark: null,
        detailList: null
      };
      order.uploadOrderInfo(data).then(function (res) {
        if (res.data.code == 0) {
          that.$message.success("结单成功");
          that.dialog.showE = false;

          that.getOrderList();
        } else {
          that.$message.error("结单失败");
        }
      });
    },
    affirm: function affirm(val) {
      var that = this;

      var numReg = /^\d+(\.\d+)?$/;

      if (!numReg.test(val)) {
        that.$message.warning("请输入数字");
        return;
      } else {
        if (val < 0) {
          that.$message.warning("请输入大于等于0的值");
          return;
        } else {
          var loading = this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          setTimeout(function () {
            loading.close();
          }, 5000);
          var data = {
            orderNo: that.orderNOG,
            operatorId: mUtils.getStore("userinfo").adminId,
            total: val
          };
          order.updateOrderTotal(data).then(function (res) {
            if (res.data.code == 0) {
              that.dialog.showC = false;
              that.getorderNo(that.orderNOG);
              loading.close();
            } else {
              that.$message.error("修改错误");
            }
          });
        }
      }
    },
    edit: function edit(orderInfo) {
      var that = this;
      that.orderInfoC = orderInfo.total;
      that.orderNOG = orderInfo.orderNo;
      that.dialog.showC = true;
    },
    outbound: function outbound(orderInfo) {
      var that = this;

      that.orderInfo = orderInfo;
      that.dialog.showB = true;
    },
    handleClick: function handleClick(tab, event) {
      var that = this;
      that.search.batchNum = "";
      this.$refs.table.clearSelection();
      if (tab.name == "6") {
        that.$router.push("/order/box");
        return;
      }
      if (tab.name == "four") {
        this.search.goodType = 1;
      }
      this.value1 = "";
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";
      this.activeName = tab.name;
      that.orderMoneyB = [];
      that.paginations.page_index = 1;
      that.getOrderList();
    },
    unploadB: function unploadB(i) {
      var that = this;
      that.galIndex = i;
    },
    unpload: function unpload(i, index) {
      var that = this;
      that.galIndex = i;
      that.galIndexB = index;
    },

    handleLicenseImgFileB: function handleLicenseImgFileB(file) {
      var that = this;

      var i = that.galIndex;
      var index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");

          var obj = {};
          obj.productImg = res.data.data.data.path;
          obj.productImgB = res.data.data.data.url;
          that.orderInfo.productList[i].productImgList.push(obj);
          that.$forceUpdate();

          loading.close();
        }
      });
    },
    beforeAvatarUploadB: function beforeAvatarUploadB(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },

    handleLicenseImgFile: function handleLicenseImgFile(file) {
      var that = this;

      var i = that.galIndex;
      var index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          var obj = {};

          that.orderInfo.productList[i].productImgList[index].productImg = res.data.data.data.path;
          that.orderInfo.productList[i].productImgList[index].productImgB = res.data.data.data.url;

          that.$forceUpdate();
          loading.close();
        }
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    linkOrderNO: function linkOrderNO(val, status) {
      var that = this;
      that.$router.push({
        path: "/creatOrder",
        query: {
          orderId: val,
          shopId: status
        }
      });
    },
    getOrderList: function getOrderList(dataA) {
      var that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      var status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "four") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "seven") {
        status = 5;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA.replace(/\s/g, "") : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate: that.deliveryStartDate && status == 3 ? that.deliveryStartDate : null,
        deliveryEndDate: that.deliveryEndDate && status == 3 ? that.deliveryEndDate : null,
        statementStartDate: that.statementStartDate && status == 4 ? that.statementStartDate : null,
        statementEndDate: that.statementEndDate && status == 4 ? that.statementEndDate : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        addressId: that.search.addressId,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null
      };
      if (status == 2) {
        data.storeStartDate = that.storeStartDate, data.storeEndDate = that.storeEndDate;
      }
      order.getOrderList(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.deliveryDate = "";
              val.statementDate = "";
              val.storeDate = "";
              if (val.status == 1) {
                val.dealStatus = "待入库";
              } else if (val.status == 2) {
                val.dealStatus = "已入库";
                val.storeDate = mUtils.formatDate(new Date(val.storeTime)).substring(0, 10);
              } else if (val.status == 3) {
                val.dealStatus = "已出库";
                val.deliveryDate = mUtils.formatDate(new Date(val.deliveryTime)).substring(0, 10);
              } else if (val.status == 4) {
                val.dealStatus = "已结单";
                val.statementDate = mUtils.formatDate(new Date(val.statementTime)).substring(0, 10);
              } else if (val.status == -1) {
                val.dealStatus = "已取消";
              }
              if (val.userRemark) {
                val.userRemark = val.userRemar;
              }
              if (val.productWeight) {
                val.productWeight = val.productWeight;
              } else {
                val.productWeight = "";
              }
              if (val.productSize) {
                val.productVolume = val.productSize;
              } else {
                val.productVolume = "";
              }
              if (val.productLong) {
                val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
              } else {
                val.measure = "";
              }
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                } else if (val.detailList && val.detailList.length > 0) {
                  val.productName = val.detailList[0].productName;
                }
              }
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    getOrderListB: function getOrderListB(pageIndex, callback, pageCount) {
      var _this3 = this;

      var that = this;

      var status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 1;
      } else if (that.activeName == "third") {
        status = 2;
      } else if (that.activeName == "four") {
        status = 3;
      } else if (that.activeName == "five") {
        status = 4;
      } else if (that.activeName == "six") {
        status = -1;
      } else if (that.activeName == "6") {
        status = 6;
      } else if (that.activeName == "7") {
        status = 7;
      } else if (that.activeName == "8") {
        status = 8;
      } else if (that.activeName == "9") {
        status = 9;
      }

      var data = {
        pageIndex: pageIndex,
        pageSize: pageCount,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        userName: that.orderNOC ? that.orderNOC : null,
        deliveryStartDate: that.deliveryStartDate && status == 3 ? that.deliveryStartDate : null,
        deliveryEndDate: that.deliveryEndDate && status == 3 ? that.deliveryEndDate : null,
        statementStartDate: that.statementStartDate && status == 4 ? that.statementStartDate : null,
        statementEndDate: that.statementEndDate && status == 4 ? that.statementEndDate : null,
        goodType: that.search.goodType ? that.search.goodType : null,
        isOrderSend: that.search.isOrderSend ? that.search.isOrderSend : null,
        addressId: that.search.addressId,
        boxNumber: that.search.boxNumber ? that.search.boxNumber : null,
        batchNumber: that.search.batchNum ? that.search.batchNum.trim() : null
      };
      if (status == 2) {
        data.storeStartDate = that.storeStartDate, data.storeEndDate = that.storeEndDate;
      }

      order.exportOutCountryOrder(data).then(function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(res) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(res.data.code == 0)) {
                    _context.next = 13;
                    break;
                  }

                  if (!res.data.data.list) {
                    _context.next = 8;
                    break;
                  }

                  res.data.data.list.forEach(function (val, index) {
                    if (val.status == 1) {
                      val.dealStatus = "待入库";
                    } else if (val.status == 2) {
                      val.dealStatus = "已入库";
                    } else if (val.status == 3) {
                      val.dealStatus = "已出库";
                    } else if (val.status == 4) {
                      val.dealStatus = "已结单";
                    } else if (val.status == -1) {
                      val.dealStatus = "已取消";
                    }
                    val.goodName = that.goodTypeName(val.goodType) + "-" + val.goodName;
                    if (val.remark) {
                      val.remark = val.remark;
                    }
                    if (val.userRemark) {
                      val.userRemark = val.userRemark;
                    }
                    if (val.productWeight) {
                      val.productWeight = val.productWeight;
                    } else {
                      val.productWeight = "";
                    }
                    if (val.productSize) {
                      val.productVolume = val.productSize;
                    } else {
                      val.productVolume = "";
                    }
                    if (val.productLong) {
                      val.measure = val.productLong + "*" + val.productWidth + "*" + val.productHeight;
                    } else {
                      val.measure = "";
                    }
                    val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
                    if (val.detailList && val.detailList.length > 0 && val.detailList[0].productName.length > 20) {
                      if (val.detailList.length >= 2) {
                        val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList.length + "款";
                      } else if (val.detailList && val.detailList.length > 0) {
                        val.productName = val.detailList[0].productName.substring(0, 20);
                      }
                    } else {
                      if (val.detailList && val.detailList.length > 0 && val.detailList.length >= 2) {
                        val.productName = val.detailList[0].productName + "...等" + val.detailList.length + "款";
                      } else if (val.detailList && val.detailList.length > 0) {
                        val.productName = val.detailList[0].productName;
                      }
                    }
                  });
                  that.postCount++;
                  _context.next = 6;
                  return callback(res.data.data.list, res.data.data.pageCount, pageIndex);

                case 6:
                  _context.next = 11;
                  break;

                case 8:
                  that.orderMoneyB = that.orderMoneyB;
                  _context.next = 11;
                  return callback([], res.data.data.pageCount);

                case 11:
                  _context.next = 15;
                  break;

                case 13:
                  callback();
                  that.$message.error("导出订单列表失败");

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    changeDate: function changeDate(val) {},
    getNowData: function getNowData() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      console.log(4422, this.search.goodType);
      var param = { type: this.search.goodType || 1 };
      setTimeout(function () {
        loading.close();
      }, 5000);
      order.getNowDate(param).then(function (res) {
        if (res.data.code != 0) {
          var msg = void 0;
          msg = "获取现在的时间失败 !";
          that.$message.error(msg);
          return;
        } else {
          if (res.data && res.data.data && res.data.data.time) {
            that.newDate = res.data.data.time;
          }
          if (res.data && res.data.data && res.data.data.batchNumber) {
            that.sendDialog.remark = res.data.data.batchNumber;
          }

          loading.close();
        }
      });
    },
    backA: function backA() {
      this.dialog.show = false;
      this.DataInformation = "";
    },
    back: function back() {
      this.$router.go(-1);
    },
    filedSel: function filedSel() {
      var that = this;
      that.startDate = "";
      that.endDate = "";
      that.orderNOA = "";
      that.valueType = 1;
      that.getOrderList();
    },
    exportToExcel: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var _this4 = this;

        var that, orderName, pageCountt, columns, nowTime;
        return _regenerator2.default.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = this;
                orderName = "";

                that.orderMoneyB = [];
                that.pagTotal = false;
                that.postCount = 0;
                pageCountt = 400;
                columns = null;

                that.excelList = [];
                that.excelList2 = [];
                nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);

                if (that.activeName == "first") {
                  columns = this.columns;
                } else if (that.activeName == "second") {
                  columns = this.columns;

                  orderName = "国内待入库" + nowTime;
                } else if (that.activeName == "third") {
                  orderName = "国内入库" + nowTime;

                  columns = this.columns;
                } else if (that.activeName == "four") {
                  orderName = "国内出库" + nowTime;
                  columns = this.columns2;
                } else if (that.activeName == "7") {
                  orderName = "（中心仓）已入库" + nowTime;
                  columns = this.columns2;
                } else if (that.activeName == "8") {
                  orderName = "（中心仓）已出库" + nowTime;
                  columns = this.columns2;
                } else if (that.activeName == "9") {
                  orderName = "分舵入库" + nowTime;
                  columns = this.columns2;
                } else if (that.activeName == "five") {
                  orderName = "已结单" + nowTime;
                  columns = this.columns;
                } else if (that.activeName == "six") {
                  orderName = "已取消" + nowTime;
                  columns = this.columns2;
                }

                if (!that.paginations.total) {
                  _context4.next = 13;
                  break;
                }

                return _context4.delegateYield(_regenerator2.default.mark(function _callee2() {
                  var loading, _loop, i;

                  return _regenerator2.default.wrap(function _callee2$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          that.pageIndex = Math.ceil(that.paginations.total / pageCountt);
                          loading = _this4.$loading({
                            lock: true,
                            text: "loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)"
                          });

                          that.bool = false;
                          _loop = _regenerator2.default.mark(function _loop(i) {
                            return _regenerator2.default.wrap(function _loop$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    that.pageIndexB = i;
                                    _context2.next = 3;
                                    return that.getOrderListB(that.pageIndexB, function (val, pageCount, index) {
                                      that.orderMoneyB = that.orderMoneyB.concat(val);
                                      that.excelList[index - 1] = val;
                                      if (i == that.pageIndex && that.bool == false && that.postCount == that.pageIndex) {
                                        for (var _i = 0; _i < that.excelList.length; _i++) {
                                          that.excelList2 = that.excelList2.concat(that.excelList[_i]);
                                        }
                                        mUtils.export2Excel(columns, that.excelList2, orderName);

                                        loading.close();
                                        that.bool = true;
                                      } else if (pageCount <= that.orderMoneyB.length && that.bool == false) {
                                        loading.close();
                                        for (var _i2 = 0; _i2 < that.excelList.length; _i2++) {
                                          that.excelList2 = that.excelList2.concat(that.excelList[_i2]);
                                        }

                                        mUtils.export2Excel(columns, that.excelList2, orderName);
                                        that.bool = true;
                                      }
                                    }, pageCountt);

                                  case 3:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _loop, _this4);
                          });
                          i = 1;

                        case 5:
                          if (!(i <= that.pageIndex)) {
                            _context3.next = 10;
                            break;
                          }

                          return _context3.delegateYield(_loop(i), "t0", 7);

                        case 7:
                          i++;
                          _context3.next = 5;
                          break;

                        case 10:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee2, _this4);
                })(), "t0", 13);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function exportToExcel() {
        return _ref2.apply(this, arguments);
      }

      return exportToExcel;
    }(),
    getTimes: function getTimes(row, type) {
      if (type == 1) return mUtils.formatDate(new Date(row.expressTime), 4);else if (type == 2) return mUtils.formatDate(new Date(row.operatorTime), 4);else if (type == 3) return mUtils.formatDate(new Date(row.storeTime), 4);
    },
    withDeposit: function withDeposit() {},
    runTab: function runTab() {},
    orderIn: function orderIn() {},
    tabInformation: function tabInformation() {
      var that = this;
    },
    onsubmit: function onsubmit() {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;

      that.onsubUpdate("3");
      loading.close();
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getOrderList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getOrderList();
    },
    changeToTime: function changeToTime(datetimes) {
      var date = new Date(datetimes);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      var h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
      var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
      var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      var str = Y + M + D + " " + h + m + s;
      return str;
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
      this.init();
    },
    batchChange: function batchChange() {
      this.init();
    },
    remoteMethod: function remoteMethod(value) {
      var _this5 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this5.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _img = __webpack_require__(131);

var img = _interopRequireWildcard(_img);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      ruleForm: {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: ""
      },
      title: "新建通知",
      rules: {
        content: [{ required: true, message: "请输入通知内容", trigger: "blur" }]
      },
      headers: {},
      fileList: [],
      operatorArr: [{ id: "1", label: "张三" }, { id: "2", label: "李四" }, { id: "3", label: "王五" }],
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  created: function created() {
    console.log(this.$route.query);
    if (this.$route.query.hasOwnProperty("name")) {
      this.title = "查看通知";
    }
  },

  methods: {
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },

    handleLicenseImgFileB: function handleLicenseImgFileB(file) {
      var that = this;
      var formData = new FormData();
      formData.append("file", file.file);
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          that.fileList.push({ url: res.data.data.data.path });

          loading.close();
        }
      });
    },

    handleRemove: function handleRemove(file, fileList) {},
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _admin = __webpack_require__(200);

var admin = _interopRequireWildcard(_admin);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      if (value === "") {
        var text = void 0;
        if (rule.field == "userName") {
          text = "账户名称";
        } else if (rule.field == "realName") {
          text = "真实姓名";
        } else if (rule.field == "mobile") {
          text = "联系电话";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    var validatePass = function validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (_this.employee.netBarForm.passwordA !== "") {
          _this.$refs.netBarForm.validateField("passwordA");
        }
        callback();
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== _this.employee.netBarForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      showOnsub: true,
      adminId: "",

      indexB: "",
      statusA: "",
      searchData: {
        keyWord: "",
        keyWord2: ""
      },
      indexA: "",
      rowDmind: "",
      dadBool: false,
      options: [],
      tableData: [],
      dialog: (0, _defineProperty3.default)({
        width: "300px",
        show: false,
        showC: false,
        title: "创建员工",
        formLabelWidth: "120px",
        showB: false
      }, "showC", false),
      employee: {
        width: "300px",
        show: false,
        title: "",
        formLabelWidth: "120px",
        appendOrUpdate: 1,
        netBarForm: {
          roleType: "",
          userName: "",
          realName: "",
          password: "",
          passwordA: "",
          tel: "",
          fax: "",

          value: "",
          mobile: "",
          message: "",
          roleId: null
        },

        form_rules: {
          userName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          realName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          password: [{ required: true, validator: validatePass, trigger: "change" }, {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }],
          passwordA: [{ required: true, validator: validatePass2, trigger: "change" }, {
            required: true,
            message: "密码不能为空",
            trigger: "blur"
          }],


          mobile: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          roleId: [{
            required: true,
            message: "请选择角色类型",
            trigger: "change"
          }]
        }
      },
      search_data: {
        realName: "",
        mobile: ""
      },
      updateOrAdd: 0,
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 15, 20],
        layout: "total, sizes, prev, pager, next, jumper" }
    };
  },
  created: function created() {
    var that = this;
    this.getAdminList();
  },

  methods: {
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    startEnd: function startEnd(adminId, status) {
      this.indexB = adminId;
      this.statusA = status;
      this.dialog.showC = true;
    },
    deleteItem: function deleteItem(admind) {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        adminId: admind,
        operatorId: mUtils.getStore("userinfo").adminId
      };
      admin.adminDelete(data).then(function (res) {
        if (res.data.code != 0) {
          var msg = void 0;
          msg = "删除个人信息失败!";
          that.$message.error(msg);

          loading.close();
          return;
        } else {
          that.$message.success("删除个人信息成功！");
          that.dialog.showB = false;
          that.getAdminList();
          loading.close();
        }
      });
    },
    onDelAdmin: function onDelAdmin(val) {
      var that = this;
      that.dialog.showB = true;
      that.indexA = val;
    },
    onsumbitB: function onsumbitB() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var data = {};

      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          adminId: that.adminId,
          password: that.$md5(that.employee.netBarForm.password),
          operatorId: mUtils.getStore("userinfo").adminId
        };
        admin.updatePwd(data).then(function (res) {
          if (res.data.code != 0) {
            if (res.data.code == 1101) {
              var msg = void 0;
              msg = res.data.msg;
              that.$message.error(msg);
            } else if (res.data.code == 120) {
              var _msg = void 0;
              _msg = res.data.msg;
              that.$message.error(_msg);
            } else {
              var _msg2 = void 0;
              _msg2 = "保存失败!";
              that.$message.error(_msg2);
            }
            loading.close();
            return;
          } else {
            var _msg3 = void 0;
            _msg3 = "保存成功 !";
            that.$message({
              message: _msg3,
              type: "success"
            });
            that.dialog.showC = false;
            that.getAdminList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    onsumbit: function onsumbit() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var data = {};

      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          adminId: that.adminId ? that.adminId : null,
          userName: that.employee.netBarForm.userName,
          password: that.$md5(that.employee.netBarForm.password),
          realName: that.employee.netBarForm.realName ? that.employee.netBarForm.realName : null,
          roleId: that.employee.netBarForm.roleId,
          mobile: that.employee.netBarForm.mobile
        };
        admin.adminAdd(data).then(function (res) {
          console.log(res);
          if (res.data.code != 0) {
            if (res.data.code == 1101) {
              var msg = void 0;
              msg = res.data.msg;
              that.$message.error(msg);
            } else if (res.data.code == 120) {
              var _msg4 = void 0;
              _msg4 = res.data.msg;
              that.$message.error(_msg4);
            } else {
              var _msg5 = void 0;
              _msg5 = "保存失败!";
              that.$message.error(_msg5 + res.data.msg);
            }
            loading.close();
            return;
          } else {
            var _msg6 = void 0;
            _msg6 = "保存成功 !";
            that.$message({
              message: _msg6,
              type: "success"
            });
            that.dialog.show = false;
            that.getAdminList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    onSearch: function onSearch(search_data) {
      this.getAdminList();
    },
    resetForm: function resetForm() {
      var that = this;
      that.search_data.realName = "";
      that.search_data.mobile = " ";
      that.getAdminList();
    },
    getAdminList: function getAdminList(dataA) {
      var that = this;

      var data = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        userName: that.searchData.keyWord ? that.searchData.keyWord : null
      };

      var loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      admin.getAdminList(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push('/login');
          return;
        }
        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          that.tableData = res.data.data.list;
          that.paginations.total = res.data.data.pageCount;
        }
      });
      loading.close();
    },
    onAddAdmin: function onAddAdmin() {
      var that = this;
      var formdata = this.form;
      for (var key in formdata) {
        formdata[key] = "";
      }
      that.employee.netBarForm.userName = "", that.employee.netBarForm.password = "";
      that.employee.netBarForm.passwordA = "";
      that.employee.netBarForm.realName = "";
      that.employee.netBarForm.mobile = "";
      that.employee.netBarForm.roleId = null;

      this.dialog.title = "创建员工";
      this.dialog.show = true;
      this.updateOrAdd = 1;
    },
    onEditAdmin: function onEditAdmin(res, i) {
      var that = this;
      that.adminId = res.adminId;
      if (i == 3) {
        that.employee.netBarForm.password = "";
        that.employee.netBarForm.passwordA = "";
        that.dialog.showC = true;
      } else {
        that.employee.netBarForm.userName = res.userName;
        that.employee.netBarForm.password = res.password;
        that.employee.netBarForm.passwordA = res.password;
        that.employee.netBarForm.roleId = res.roleId;
        if (i == 2) {
          that.showOnsub = false;
          that.dialog.title = "查看员工信息";
        } else {
          that.showOnsub = true;
          that.dialog.title = "修改员工信息";
        }

        that.employee.netBarForm.realName = res.realName;
        that.employee.netBarForm.mobile = res.mobile;

        this.updateOrAdd = 0;

        this.dialog.show = true;
      }
    },
    onSubmit: function onSubmit(form) {
      var _this2 = this;

      var that = this;
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var parameter = {
            realName: that.form.realName,
            mobile: that.form.mobile,
            position: that.form.position,
            remark: that.form.remark
          };
          var loading = _this2.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          if (that.updateOrAdd == 1) {
            parameter.adminId = mUtils.getUserId();
            that.$sub.post("/v1/market/admin/addAdmin", parameter).then(function (res) {
              loading.close();
              if (res.data.code == 1202) {
                that.$router.push('/login');
                return;
              }
              if (res.data.code != 0) {
                that.$message.error(res.data.msg || "操作失败");
                return;
              }
              that.$message({
                message: "新增成功",
                type: "success"
              });
              loading.close();
              that.getAdminList();
              that.dialog.show = false;
            });
          } else if (that.updateOrAdd == 0) {
            parameter.adminId = that.form.adminId;
            that.$sub.post("/v1/market/admin/updateAdminInfo", parameter).then(function (res) {
              if (res.data.code != 0) {
                that.$message.error(res.data.msg || "操作失败");
                return;
              }
              that.$message({
                message: "更改成功",
                type: "success"
              });
              that.getAdminList();
              that.dialog.show = false;
            });
            loading.close();
          }
        }
      });
    },
    deleteAdmin: function deleteAdmin(row) {
      this.form.adminId = row.adminId;
      this.deleteOrNot = true;
    },
    onDeleteAdmin: function onDeleteAdmin() {
      var that = this;
      var data = {
        adminId: that.form.adminId,
        status: -1,
        token: mUtils.getToken()
      };
      that.$sub.post("/v1/market/admin/updateAdminStatus", data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "删除成功",
          type: "success"
        });
        that.getAdminList();
        setTimeout(function () {
          location.href = document.URL;
        }, 1000);
      });
      that.deleteOrNot = false;
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getAdminList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getAdminList();
    }
  }
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formInline: {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: ""
      },

      peopleArr: [],

      startTime: "",
      endTime: "",

      tableData: [{
        informContent: "开会",
        img: "pic1.jpg",
        sendTime: 1648518756000,
        operator: "mike",
        operatorTime: 1648518796000,
        dealStatus: "1"
      }, {
        informContent: "开会",
        img: "pic2.jpg",
        sendTime: 1648518756000,
        operator: "吴亦凡",
        operatorTime: 1648518796000,
        dealStatus: "4"
      }, {
        informContent: "元旦放假，各部门注意交接。元旦放假，各部门注意交接。元旦放假，各部门注意交接。",
        img: "pic3.jpg",
        sendTime: 1248518756000,
        operator: "John",
        operatorTime: 164345796000,
        dealStatus: "3"
      }],

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      deliveryList: [],

      loading: false,

      rowSelection: [],
      howManyTotal: 0,
      listArr: [],
      dealStatusArr: [{ value: 0, label: "全部" }, { value: 1, label: "待处理" }, { value: 2, label: "处理中" }, { value: 3, label: "处理完成" }, { value: 4, label: "已取消" }]
    };
  },
  created: function created() {},

  methods: (0, _defineProperty3.default)({
    search: function search() {},
    reset: function reset() {
      this.formInline = {
        content: "",
        operator: "",
        dealStatus: "",
        checkedTime: "",
        finishTime: ""
      };
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getDate: function getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    getBalanceList: function getBalanceList() {
      var _this = this;

      var param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size
      };
      statisticalApi.getUserBalance(param).then(function (res) {
        _this.paginations.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
        if (res.status !== 200) return _this.$message.error(res.msg);else if (res.data.code !== 0) return _this.$message.error(res.data.msg);
        _this.tableData = res.data.data.list;
      });
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    }
  }, "getIndex", function getIndex($index) {
    return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
  })
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _customer = __webpack_require__(202);

var customer = _interopRequireWildcard(_customer);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "realName") text = "用户名";else if (rule.field == "mobile") text = "手机号";else if (rule.field == "demandCount") text = "工单配额";else if (rule.field == "deliveryId") text = "派送点";
        return callback(new Error(text + "不能为空~"));
      } else {
        if (rule.field == "demandCount") {
          var reg = /^\d+$|^\d*\.\d+$/g;
          if (!reg.test(value)) {
            callback(new Error("只能输入数字和小数点"));
          }
        }
        return callback();
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改用户",
        data: {
          userId: null,
          realName: "",
          mobile: "",
          remark: "",
          demandCount: "",
          deliveryId: null
        },
        form_rules: {
          realName: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          mobile: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          demandCount: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          deliveryId: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },
      deleteDialog: {
        show: false,
        title: "删除用户"
      },
      deliveryList: [],
      galVal: "",
      radio: "",
      searchData: {
        keyWord: "",
        keyWordB: "",
        keyWordC: ""
      },
      dialog: {
        show: false,
        showB: false
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      customerList: [],
      sortWay: "1" };
  },
  created: function created() {
    var that = this;
    that.userId = that.$route.query.userId || "";
    that.getCustomer();
    that.getDeliveryList();
  },


  methods: {
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getCustomer();
    },
    editUser: function editUser(row) {
      this.editDialog.show = true;
      this.editDialog.data = {
        userId: row.userId,
        realName: row.realName,
        mobile: row.mobile,
        demandCount: row.demandCount,
        remark: row.remark,
        deliveryId: row.deliveryId || null
      };
    },
    delAppendUser: function delAppendUser(row) {
      this.deleteDialog.show = true;
      this.editDialog.data = {
        userId: row.userId
      };
    },
    routerTo: function routerTo() {
      this.$router.push("/recharge/charge");
    },
    submitUser: function submitUser() {
      var that = this;
      var data = {};
      data.userId = that.editDialog.data.userId;
      data.realName = that.editDialog.data.realName;
      data.mobile = that.editDialog.data.mobile;
      data.demandCount = that.editDialog.data.demandCount;
      data.remark = that.editDialog.data.remark;
      data.deliveryId = that.editDialog.data.deliveryId;
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          customer.updateUserInfo(data).then(function (res) {
            if (res.data.code == 1202) {
              that.$router.push("/login");
              return;
            }
            if (res.data.code != 0) {
              that.$message.error(res.data.msg || "操作失败");
              return;
            }
            that.$message({
              message: "操作成功",
              type: "success"
            });

            that.getCustomer();
            that.editDialog.show = false;
          });
        }
      });
    },
    deleteUser: function deleteUser() {
      var that = this;
      var data = {};
      data.userId = that.editDialog.data.userId;

      customer.del(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success"
        });

        that.getCustomer();
        that.deleteDialog.show = false;
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    getCustomer: function getCustomer(page) {
      var that = this;
      if (page) {
        that.paginations.page_index = 1;
      }
      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        nickname: that.searchData.keyWord ? that.searchData.keyWord : null,
        realName: that.searchData.keyWordB ? that.searchData.keyWordB : null,
        mobile: that.searchData.keyWordC ? that.searchData.keyWordC : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null,
        sort: that.sortWay
      };
      customer.getCustomerList(data).then(function (res) {
        console.log(res);
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.customerList = res.data.data.list;
          that.customerList && that.customerList.length > 0 && that.customerList.forEach(function (val, i) {
            val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
          });
          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getDate: function getDate(value1) {
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;

      that.getCustomer();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getCustomer();
    },
    sortBalance: function sortBalance(column) {
      if (this.sortWay == "1") {
        this.sortWay = "2";
        this.getCustomer(1);
      } else if (this.sortWay == "2") {
        this.sortWay = "1";
        this.getCustomer(1);
      } else {
        return;
      }
    }
  }
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

var _charge = __webpack_require__(129);

var charge = _interopRequireWildcard(_charge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      title: true,
      accountList: [],
      ruleForm: {
        accountId: '',
        accountName: '',
        contacts: '',
        tel: ''
      },
      rules: {
        accountName: [{ required: true, message: '请输入收款账号名称', trigger: 'blur' }, { min: 1, message: '请输入收款账号名称', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入账号负责人', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入负责人电话', trigger: 'blur' }]
      },
      dialog: false
    };
  },
  created: function created() {
    this.getAccountList();
  },

  methods: {
    getAccountList: function getAccountList() {
      var _this = this;

      var param = {};
      charge.getAccountList(param).then(function (res) {
        if (res.data.code !== 0) return _this.$message.error('获取账户列表失败');else {
          _this.accountList = res.data.data.list;
        }
      });
    },
    editBt: function editBt(row) {
      var arr = JSON.parse((0, _stringify2.default)(row));
      this.$set(this.ruleForm, 'accountId', arr.accountId);
      this.$set(this.ruleForm, 'accountName', arr.accountName);
      this.$set(this.ruleForm, 'contacts', arr.contacts);
      this.$set(this.ruleForm, 'tel', arr.tel);
      this.title = true;
      this.dialog = true;
    },
    addBt: function addBt() {
      this.$set(this.ruleForm, 'accountName', '');
      this.$set(this.ruleForm, 'contacts', '');
      this.$set(this.ruleForm, 'tel', '');
      this.title = false;
      this.dialog = true;
    },
    closeD: function closeD() {
      this.$refs.RuleForm.resetFields();
    },
    comfirmBt: function comfirmBt() {
      var _this2 = this;

      var bool;
      var param = {
        accountId: this.ruleForm.accountId,
        accountName: this.ruleForm.accountName,
        contacts: this.ruleForm.contacts,
        tel: this.ruleForm.tel
      };
      this.$refs.RuleForm.validate(function (vali) {
        bool = vali;
      });
      if (bool) {
        if (this.title) {
          charge.upDateAccountList(param).then(function (res) {
            if (res.data.code !== 0) {
              _this2.dialog = false;
              return _this2.$message.error('编辑数据失败');
            }
            _this2.getAccountList();
            _this2.dialog = false;
            return _this2.$message.success('编辑数据成功');
          });
        } else {
          delete param.accountId;
          charge.addAccountList(param).then(function (res) {
            if (res.data.code !== 0) {
              _this2.dialog = false;
              return _this2.$message.error('添加数据失败');
            }
            _this2.getAccountList();
            _this2.dialog = false;
            return _this2.$message.success('添加数据成功');
          });
        }
      } else {
        this.$message.error('正确输入内容才能点击确定');
      }
    }
  }
};

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _charge = __webpack_require__(129);

var charge = _interopRequireWildcard(_charge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      moneyAdjust: '',
      ruleForm: {
        vipCode: '',
        amount: ''
      },
      changedB: 0,
      rules: {
        vipCode: [{ required: true, message: '请输入充值人VIP号', trigger: 'blur' }, { min: 6, message: '长度为6个字符', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入调账金额', trigger: 'blur' }]
      },
      CAD: 'CAD',
      search: {
        adjustType: null
      },
      userDate: {},
      realName: '',
      paidCount: [],
      textarea2: '',
      adjustTypeSelect: [{
        adjustType: 0,
        adjustName: "上调账户余额"
      }, {
        adjustType: 1,
        adjustName: "下调账户余额"
      }]
    };
  },

  computed: {},
  created: function created() {
    this.getlist();
  },

  methods: {
    init: function init() {},
    balanceChange: function balanceChange() {
      if (this.search.adjustType == 0) {
        this.changedB = this.userDate.balance - 0 + (this.ruleForm.amount - 0);
      } else if (this.search.adjustType == 1) {
        this.changedB = this.userDate.balance - 0 - (this.ruleForm.amount - 0);
      }
    },
    getlist: function getlist() {
      this.userDate = mUtils.getStore('userinfo');
      this.realName = this.userDate.realName;
    },
    getVipCode: function getVipCode() {
      var _this = this;

      this.userDate = {};
      var param = {
        vipCode: this.ruleForm.vipCode
      };
      if (param.vipCode.length > 5) {
        charge.getVipCode(param).then(function (res) {
          console.log(res);
          _this.userDate = res.data.data;
        });
      }
    },
    getLength: function getLength() {
      return this.ruleForm.vipCode.length;
    },
    submitBt: function submitBt() {
      var _this2 = this;

      var param = {
        vipCode: this.userDate.vipCode,
        type: this.search.adjustType,
        amount: this.ruleForm.amount - 0,
        remark: this.textarea2
      };
      var b = null;
      this.$refs.RuleForm.validate(function (vali) {
        b = vali;
      });
      if (b) {
        if (this.ruleForm.amount - 0 < 0) {
          this.$message.error('输入金额不能为负，请重新输入');
        } else {
          charge.adjustBalance(param).then(function (res) {
            console.log(res);
            if (res.status !== 200) return _this2.$message.error('提交调账信息失败');
            if (res.data.code !== 0) return _this2.$message.error(res.data.msg);else {
              _this2.ruleForm.vipCode = '';
              _this2.ruleForm.amount = '';
              _this2.textarea2 = '';
              _this2.changedB = '';
              _this2.userDate.balance = '';
              _this2.userDate.vipCode = undefined;
              _this2.$message.success('提交调账信息成功');
            }
          });
        }
      }
    }
  }
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _charge = __webpack_require__(129);

var charge = _interopRequireWildcard(_charge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      ruleForm: {
        vipCode: "",
        accountName: "",
        actualAmount: "",
        amount: ""
      },
      rules: {
        vipCode: [{ required: true, message: "请输入充值人VIP号", trigger: "blur" }, { min: 6, message: "长度为6个字符", trigger: "blur" }],
        actualAmount: [{ required: true, message: "请输入实际收费", trigger: "blur" }],
        amount: [{ required: true, message: "请输入充值金额", trigger: "blur" }]
      },
      rateList: [],
      CAD: "CAD",
      currency: {
        currencyType: 1
      },
      paidCount: [],
      paidSearch: {
        accountId: null
      },
      userDate: {},
      realName: "",
      textarea2: "",
      currencyTypeSelect: [{
        currencyType: 1,
        currency: "￥"
      }, {
        currencyType: 2,
        currency: "$"
      }, {
        currencyType: 3,
        currency: "C$"
      }],
      disCount: "",

      userBalancesPojos: null

    };
  },
  created: function created() {
    this.getlist();
    this.getAccountList();
    this.getRateList();
    this.getDiscount();
  },

  methods: {
    init: function init() {},
    getlist: function getlist() {
      this.userDate = mUtils.getStore("userinfo");
      this.realName = this.userDate.realName;
    },
    getDiscount: function getDiscount() {
      var _this = this;

      var param = {};
      charge.getDiscount(param).then(function (res) {
        if (res.status !== 200) return _this.$message.error("获取优惠列表失败：" + res.msg);
        if (res.data.code !== 0) return _this.$message.error("获取优惠列表失败：" + res.data.msg);
        _this.disCount = res.data.data.title;
      });
    },
    getRateList: function getRateList() {
      var _this2 = this;

      var param = {};
      charge.getRateList(param).then(function (res) {
        if (res.status !== 200) return _this2.$message.error("获取汇率列表失败");
        if (res.data.code !== 0) return _this2.$message.error("参数错误");
        _this2.rateList = res.data.data.list;
      });
    },
    getAccountList: function getAccountList() {
      var _this3 = this;

      var param = {};
      charge.getAccountList(param).then(function (res) {
        if (res.status !== 200) return _this3.$message.error("获取账户列表失败");
        if (res.data.code !== 0) return _this3.$message.error(res.data.msg);else {
          _this3.paidCount = res.data.data.list;
        }
      });
    },
    getVipCode: function getVipCode() {
      var _this4 = this;

      this.userDate = {};
      this.userBalancesPojos = null;
      var param = {
        vipCode: this.ruleForm.vipCode
      };
      if (param.vipCode.length > 5) {
        charge.getVipCode(param).then(function (res) {
          if (res.data.data) {
            _this4.userDate = res.data.data;
            if (res.data.data.userBalancesPojos) {
              _this4.userBalancesPojos = res.data.data.userBalancesPojos;
            }
          }
        });
      }
    },
    getLength: function getLength() {
      return this.ruleForm.vipCode.length;
    },
    rateChange: function rateChange() {
      console.log(this.currency.currencyType);
      if (this.currency.currencyType == 1) {
        this.ruleForm.amount = (this.rateList[0].rate * (this.ruleForm.actualAmount - 0)).toFixed(2);
      } else if (this.currency.currencyType == 2) {
        this.ruleForm.amount = (this.rateList[1].rate * (this.ruleForm.actualAmount - 0)).toFixed(2);
      } else if (this.currency.currencyType == 3) {
        this.ruleForm.amount = (this.ruleForm.actualAmount - 0).toFixed(2);
      }
    },
    sendBt: function sendBt() {
      var _this5 = this;

      var curr = null;
      if (this.currency.currencyType == 1) curr = "CNY";else if (this.currency.currencyType == 2) curr = "USD";else if (this.currency.currencyType == 3) curr = "CAD";
      var param = {
        vipCode: this.ruleForm.vipCode,
        accountId: this.paidSearch.accountId,
        currency: curr,
        actualAmount: this.ruleForm.actualAmount - 0,
        amount: this.ruleForm.amount - 0,
        remark: this.textarea2
      };
      console.log(param);
      var b = null;
      this.$refs.RuleForm.validate(function (vali) {
        b = vali;
      });
      if (this.ruleForm.actualAmount - 0 < 0) return this.$message.error("充值金额不能为负，请重新输入");
      if (b) {
        charge.deposit(param).then(function (res) {
          console.log(res);
          if (res.status !== 200) return _this5.$message.error("提交充值信息失败");
          if (res.data.code !== 0) return _this5.$message.error(res.data.msg);else {
            _this5.$message.success("提交充值信息成功");
            _this5.ruleForm.vipCode = "";
            _this5.ruleForm.actualAmount = "";
            _this5.ruleForm.amount = "";
            _this5.textarea2 = "";
            _this5.paidSearch.accountId = null;
            _this5.userDate.vipCode = undefined;
          }
        });
      }
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    }
  }
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _charge = __webpack_require__(129);

var charge = _interopRequireWildcard(_charge);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      activeName: "0",
      balanceNo: "",
      vipCode: "",
      remark: "",
      balanceType: 0,
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      tableData: [],

      formInline: {
        transactionType: "1",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: ""
      },

      startTime: "",
      endTime: "",
      batchArr: [],
      loading: false
    };
  },
  created: function created() {
    this.getBatchList();
    this.getBalanceList();
  },

  methods: {
    init: function init(activeName) {
      this.balanceType = activeName - 0;
      this.getBalanceList();
    },
    getBalanceList: function getBalanceList() {
      var _this = this;

      this.tableData = [];
      var param = {
        balanceType: this.balanceType == 0 ? "" : this.balanceType,
        balanceNo: this.balanceNo ? this.balanceNo : "",
        vipCode: this.vipCode ? this.vipCode : "",
        remark: this.remark ? this.remark : "",
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : ""
      };
      charge.getUesrBalance(param).then(function (res) {
        console.log(res);
        _this.paginations.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
        if (res.status !== 200) return _this.$message.error(res.msg);else if (res.data.code !== 0) return _this.$message.error(res.data.msg);
        _this.tableData = res.data.data.list;
      });
    },
    routerPush: function routerPush() {
      this.$router.push("/recharge/charge");
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
    getDate: function getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.getBalanceList();
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
    },
    batchChange: function batchChange() {},
    remoteMethod: function remoteMethod(value) {
      var _this2 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.getBatchList(value);
      }, 500);
    }
  }
};

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _charge = __webpack_require__(129);

var charge = _interopRequireWildcard(_charge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      index: ['CNY', 'USD'],
      dialogVisible: false,
      title: true,
      textarea2: '',
      rateId: '',
      rate: '',
      rateList: [],
      tableData: [{
        name: 'CNY',
        cost: 0,
        id: 0
      }, {
        name: 'USD',
        cost: 0,
        id: 0
      }]
    };
  },
  created: function created() {
    this.getRateList();
    this.getDiscount();
  },

  methods: {
    showDia: function showDia(row) {
      console.log(112, row);
      this.title = row.name == 'CNY' ? true : false;
      this.rateId = row.id;
      this.rate = row.cost;
      this.dialogVisible = true;
    },
    getRateList: function getRateList() {
      var _this = this;

      var param = {};
      charge.getRateList(param).then(function (res) {
        console.log(res);
        if (res.status !== 200) return _this.$message.error('获取汇率列表失败');
        if (res.data.code !== 0) return _this.$message.error('参数错误');
        _this.rateList = res.data.data.list;
        _this.putRateToList();
      });
    },
    putRateToList: function putRateToList() {
      for (var i = 0; i < this.rateList.length; i++) {
        if (this.tableData && this.tableData[i]) {
          this.tableData[i].name = this.rateList[i].exchangeCurrenty;
          this.tableData[i].cost = this.rateList[i].rate;
          this.tableData[i].id = this.rateList[i].rateId;
        }
      }
    },
    updateRate: function updateRate() {
      var _this2 = this;

      var param = {
        rateId: this.rateId,
        rate: this.rate
      };
      charge.updateRate(param).then(function (res) {
        if (res.status !== 200) return _this2.$message.error('编辑汇率失败');
        if (res.data.code !== 0) return _this2.$message.error(res.data.msg);
        _this2.getRateList();
        _this2.$message.success('编辑汇率成功');
        _this2.dialogVisible = false;
      });
    },
    updateDisCount: function updateDisCount() {
      var _this3 = this;

      var param = {
        discountId: 1,
        title: this.textarea2
      };
      charge.updateDis(param).then(function (res) {
        if (res.status !== 200) return _this3.$message.error('编辑汇率失败' + res.msg);
        if (res.data.code !== 0) return _this3.$message.error(res.data.msg);
        _this3.$message.success('编辑优惠信息成功');
      }).catch('error');
    },
    getDiscount: function getDiscount() {
      var _this4 = this;

      var param = {};
      charge.getDiscount(param).then(function (res) {
        if (res.status !== 200) return _this4.$message.error('获取优惠列表失败：' + res.msg);
        if (res.data.code !== 0) return _this4.$message.error('获取优惠列表失败：' + res.data.msg);
        _this4.textarea2 = res.data.data.title;
      });
    }
  }
};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      orderG: "",
      isBoxG: "",
      startTime: "",
      endTime: "",
      total: 0,

      headers: {},
      orderInfoC: "",
      orderInfo: {
        orderNo: ""
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: false,
          onlyShowBarOnScroll: false,
          background: "#C1C1C1",
          keepShow: true,
          size: "12px",
          opacity: 1 }
      },
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      value1: "",
      activeName: "first",
      columns: [{ title: "订单编号", key: "orderNo" }, { title: "下单时间", key: "addDate" }, { title: "名称", key: "productName" }, { title: "客户", key: "contacts" }, { title: "联系方式", key: "tel" }, { title: "物流公司", key: "expressCompany" }, { title: "运单号", key: "expressNo" }, { title: "状态", key: "status" }],

      NowDate: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showG: false
      },
      DataInformation: "",
      orderNOA: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      orderMoney: [],
      optionsType: [{
        id: 1,
        label: "全部"
      }, {
        id: 2,
        label: "待支付"
      }, {
        id: 3,
        label: "待结算"
      }, {
        id: 4,
        label: "交易关闭"
      }, {
        id: 5,
        label: "交易成功"
      }],
      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankCard: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankUser: [{ required: true, trigger: "blur", validator: dataValidate }]
        }
      },
      productCateList: [],
      confirmDialogVisible: false
    };
  },
  created: function created() {
    var that = this;
    that.getStoreList();
  },

  methods: {
    affirmC: function affirmC() {
      console.log("s");
      var that = this;
      var isbox = "";
      if (that.isBoxG == 0) {
        isbox = 1;
      } else {
        isbox = 0;
      }
      var obj = {};
      obj.orderNo = that.orderG;
      obj.operatorId = mUtils.getStore("userinfo").adminId;
      obj.isBox = isbox;
      order.updateBox(obj).then(function (res) {
        if (res.data.code == 0) {
          that.$message.success("改变成功！");

          that.dialog.showG = false;
          that.getorderNo(that.orderG);
        } else {
          that.$message.error("改变失败！");
        }
      });
    },
    opBa: function opBa(val) {
      window.open(val, "_blank");
    },
    getStoreList: function getStoreList(dataA) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var status = 0;
      if (that.activeName == "first") {
        status = 0;
      } else if (that.activeName == "second") {
        status = 2;
      } else if (that.activeName == "third") {
        status = 3;
      }

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status ? status : null,
        orderNo: that.orderNOA ? that.orderNOA : null,
        startTime: that.startTime ? that.startTime : null,
        endTime: that.endTime ? that.endTime : null
      };

      order.getStoreList(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.length > 0 && res.data.data.list.forEach(function (val, index) {
              val.operatorDate = mUtils.formatDate(new Date(val.operatorTime));
              val.addDate = mUtils.formatDate(new Date(val.addTime)).substring(0, 10);
              if (val.detailList && val.detailList.length > 0 && val.detailList[0] && val.detailList[0].productName.length > 20) {
                if (val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName.substring(0, 20) + "...等" + val.detailList && val.detailList.length + "类";
                } else {
                  val.productName = val.detailList && val.detailList[0] && val.detailList[0].productName && val.detailList[0].productName.substring(0, 20);
                }
              } else {
                if (val.detailList && val.detailList.length >= 2) {
                  val.productName = val.detailList[0].productName + "...等" + val.detailList && val.detailList.length + "类";
                } else {
                  val.productName = val.detailList && val.detailList[0].productName;
                }
              }

              val.detailList && val.detailList.forEach(function (value, i) {});
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });
    },
    getDate: function getDate(value1) {
      this.startTime = new Date(mUtils.formatDate(value1[0])).getTime();
      this.endTime = new Date(mUtils.formatDate(value1[1])).getTime();
    },
    getorderNo: function getorderNo(val) {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        orderNo: val
      };

      order.getOrderInfo(data).then(function (res) {
        if (res.data.code == 0) {
          that.orderInfo = res.data.data;
          that.orderInfo.addDate = mUtils.formatDate(new Date(that.orderInfo.addTime)).substring(0, 16);
          that.orderInfo.storeTime = mUtils.formatDate(new Date(that.orderInfo.storeTime)).substring(0, 16);
          that.orderInfo.deliveryTime = mUtils.formatDate(new Date(that.orderInfo.deliveryTime)).substring(0, 16);

          that.orderInfo.productList = that.orderInfo.detailList;
          var arr = [];
          var arrB = [];
          var obj = {};
          that.orderInfo.productList.forEach(function (val, i) {

            arrB = [];
            val.productImgList = [];

            if (val.pic) {
              if (val.pic.indexOf(",") != -1) {
                arr = val.pic.split(",");
                val.productImg = that.orderInfo.httpUrl + val.pic.split(",")[0];
                val.productImgB = that.orderInfo.httpUrl + val.pic.split(",")[1];
                arr.forEach(function (value, index) {
                  obj = {};
                  obj.productImg = value;
                  arrB.push(obj);
                });
              } else {
                val.productImg = that.orderInfo.httpUrl + val.pic;
                obj = {};
                obj.productImg = that.orderInfo.httpUrl + val.pic;
                arrB.push(obj);
              }
            }
            val.productImgList = arrB;
          });

          that.dialog.show = true;

          that.$forceUpdate();
          loading.close();
        }
      });
    },
    copy: function copy() {
      var that = this;

      var clipboard = new this.Clipboard(".btn");
      clipboard.on("success", function (e) {
        that.$message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        that.$message.warning("该浏览器不支持自动复制");

        clipboard.destroy();
      });
    },
    onsubmitB: function onsubmitB() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;
        return true;
      });

      if (validd) {} else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    getComputer: function getComputer() {
      var that = this;
    },
    instorage: function instorage(value) {
      var that = this;
      that.orderInfo = value;
      that.orderInfo.productList.forEach(function (val, i) {
        val.productNumB = val.productNum;
        val.weightB = val.weight;
        val.productLongB = val.productLong;
        val.widthB = val.width;
        val.heightB = val.height;
      });
      that.dialog.showD = true;
    },
    affirm: function affirm() {
      var that = this;
      that.dialog.showC = false;
      that.orderInfo.orderNo = that.orderInfoC;
    },
    edit: function edit(orderInfo) {
      var that = this;
      that.orderInfoC = orderInfo;
      that.dialog.showC = true;
    },
    outbound: function outbound(orderInfo) {
      var that = this;
      that.orderInfoB = orderInfo;
      that.dialog.showB = true;
    },
    handleClick: function handleClick(tab, event) {
      var that = this;

      this.activeName = tab.name;
      that.paginations.page_index = 1;
      that.getStoreList();
    },
    changeDate: function changeDate(val) {},
    getNowData: function getNowData() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      other.GetNowTime().then(function (res) {
        if (res.data.code != 1) {
          var msg = void 0;
          msg = "获取现在的时间失败 !";
          that.$message.error(msg);
          return;
        } else {
          that.NowData = res.data.data;

          loading.close();
        }
      });
    },
    backA: function backA() {
      this.dialog.show = false;
      this.DataInformation = "";
    },
    getorderNoB: function getorderNoB(val, isbox) {
      this.orderG = val;
      this.isBoxG = isbox;
      this.dialog.showG = true;
    },
    chai: function chai(val) {
      this.orderInfo = val;
      this.dialog.show = true;
    },
    back: function back() {
      this.$router.go(-1);
    },
    filedSel: function filedSel() {
      var that = this;
      that.startDate = "";
      that.endDate = "";
      that.orderNOA = "";
      that.valueType = 1;
      that.getStoreList();
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      var orderName = "";
      var nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);
      if (that.activeName == "first") {} else if (that.activeName == "second") {
        orderName = "入库记录" + nowTime;
      } else if (that.activeName == "third") {
        orderName = "出库记录" + nowTime;
      } else if (that.activeName == "four") {}
      var fix = document.querySelector("#printTable").querySelector(".el-table__fixed-right");
      var xlsxParam = { raw: true };
      var wb = void 0;
      if (fix) {
        wb = _xlsx2.default.utils.table_to_book(document.querySelector("#printTable").removeChild(fix), xlsxParam);
        document.querySelector("#printTable").appendChild(fix);
      } else {
        wb = _xlsx2.default.utils.table_to_book(document.querySelector("#printTable"), xlsxParam);
      }
      var wbout = _xlsx2.default.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        _fileSaver2.default.saveAs(new Blob([wbout], { type: "application/octet-stream;charset=utf-8" }), orderName + ".xlsx");
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;

      that.paginations.page_size = page_size;

      that.getStoreList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getStoreList();
    }
  }
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "bankCard") {
          text = "银行卡号";
        } else if (rule.field == "bankUser") {
          text = "账户名";
        } else if (rule.field == "bankName") {
          text = "开户行";
        } else if (rule.field == "salePrice") {
          text = "商品现价";
        } else if (rule.field == "stock") {
          text = "商品库存";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      orderG: "",
      isBoxG: "",
      pagTotal: false,
      pageIndexB: "",
      pageIndex: "",
      orderMoneyB: [],
      total: 0,

      headers: {},
      orderInfoC: "",
      orderInfo: {
        orderNo: ""
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: false,
          onlyShowBarOnScroll: false,
          background: "#C1C1C1",
          keepShow: true,
          size: "12px",
          opacity: 1 }
      },
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      value1: "",
      activeName: "first",
      columns: [{ title: "商品名称", key: "orderNo" }, { title: "数量", key: "productNum" }, { title: "库位", key: "shelves" }, { title: "入库时间", key: "storeTime" }, { title: "关联运单号", key: "expressNo" }, { title: "关联订单编号", key: "orderNo" }, { title: "客户", key: "userName" }, { title: "客户VIP号", key: "vipCode" }],

      NowDate: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showG: false
      },
      DataInformation: "",
      orderNOA: "",
      orderNOB: "",
      orderNOC: "",
      orderNOD: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      orderMoney: [],
      optionsType: [{
        id: 1,
        label: "全部"
      }, {
        id: 2,
        label: "待支付"
      }, {
        id: 3,
        label: "待结算"
      }, {
        id: 4,
        label: "交易关闭"
      }, {
        id: 5,
        label: "交易成功"
      }],
      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankCard: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankUser: [{ required: true, trigger: "blur", validator: dataValidate }]
        }
      },
      productCateList: [],
      confirmDialogVisible: false
    };
  },
  created: function created() {
    var that = this;
    that.getStoreList();
  },

  methods: {
    realDateA: function realDateA(val) {
      var that = this;
      that.paginations.page_index = 1;
      if (val.length >= 2) {
        that.getStoreList();
      } else if (val.length == 0) {
        that.getStoreList();
      }
    },
    realDateB: function realDateB(val) {
      var that = this;
      that.paginations.page_index = 1;
      if (val.length >= 2) {
        that.getStoreList();
      } else if (val.length == 0) {
        that.getStoreList();
      }
    },
    affirmC: function affirmC() {
      console.log("s");
      var that = this;
      var isbox = "";
      if (that.isBoxG == 0) {
        isbox = 1;
      } else {
        isbox = 0;
      }
      var obj = {};
      obj.orderNo = that.orderG;
      obj.operatorId = mUtils.getStore("userinfo").adminId;
      obj.isBox = isbox;
      order.updateBox(obj).then(function (res) {
        if (res.data.code == 0) {
          that.$message.success("改变成功！");

          that.dialog.showG = false;
          that.getorderNo(that.orderG);
        } else {
          that.$message.error("改变失败！");
        }
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginations.page_index - 1) * this.paginations.page_size + $index + 1;
    },
    opBa: function opBa(val) {
      window.open(val, "_blank");
    },
    getStoreList: function getStoreList(dataA) {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,

        userName: that.orderNOC ? that.orderNOC : null,
        expressNo: that.orderNOD ? that.orderNOD : null,
        orderNo: that.orderNOB ? that.orderNOB : null,
        keyword: that.orderNOA ? that.orderNOA : null
      };

      order.getStoreListProduct(data).then(function (res) {
        loading.close();
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              val.storeTime = mUtils.formatDate(new Date(val.storeTime));
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询列表失败");
          } else {
            that.$message.error("获取列表失败");
          }
        }
        loading.close();
      });
    },
    getStoreListB: function getStoreListB(callback) {

      var that = this;

      var loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        pageIndex: that.pageIndexB,
        pageSize: that.paginations.page_size,

        userName: that.orderNOC ? that.orderNOC : null,
        xpressNo: that.orderNOD ? that.orderNOD : null,
        orderNo: that.orderNOB ? that.orderNOB : null,
        keyword: that.orderNOA ? that.orderNOA : null
      };

      order.getStoreListProduct(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {

              val.storeTime = mUtils.formatDate(new Date(val.storeTime));
            });

            callback(res.data.data.list, res.data.data.pageCount);
          } else {
            that.orderMoneyB = that.orderMoneyB;
            callback([], res.data.data.pageCount);
          }
        } else {
          callback();

          that.$message.error('导出订单列表失败');
        }
        loading.close();
      });
    },
    getorderNo: function getorderNo(val, ind) {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        orderNo: val
      };

      order.getOrderInfo(data).then(function (res) {
        if (res.data.code == 0) {
          that.orderInfo = res.data.data;
          that.orderInfo.addDate = mUtils.formatDate(new Date(that.orderInfo.addTime)).substring(0, 16);
          that.orderInfo.storeTime = mUtils.formatDate(new Date(that.orderInfo.storeTime)).substring(0, 16);
          that.orderInfo.deliveryTime = mUtils.formatDate(new Date(that.orderInfo.deliveryTime)).substring(0, 16);

          that.orderInfo.productList = that.orderInfo.detailList;
          var arr = [];
          var arrB = [];
          var obj = {};
          that.orderInfo.productList.forEach(function (val, i) {

            arrB = [];
            val.productImgList = [];

            if (val.pic) {
              if (val.pic.indexOf(",") != -1) {
                arr = val.pic.split(",");
                val.productImg = that.orderInfo.httpUrl + val.pic.split(",")[0];
                val.productImgB = that.orderInfo.httpUrl + val.pic.split(",")[1];
                arr.forEach(function (value, index) {
                  obj = {};
                  obj.productImg = value;
                  arrB.push(obj);
                });
              } else {
                val.productImg = that.orderInfo.httpUrl + val.pic;
                obj = {};
                obj.productImg = that.orderInfo.httpUrl + val.pic;
                arrB.push(obj);
              }
            }
            val.productImgList = arrB;
          });

          if (ind == 2) {
            that.orderInfo.productList.forEach(function (val, i) {
              val.weiBol = false;
              val.volBol = false;
              val.shelves = "";
              val.productNumB = val.productNum;
              val.weightB = val.weight;
              val.productLongB = val.productLong;
              val.widthB = val.width;
              val.heightB = val.height;
            });
            that.getComputer();
            that.dialog.showD = true;
          } else {
            that.dialog.show = true;
          }
          that.$forceUpdate();
          loading.close();
        }
      });
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      var orderName = "";
      that.orderMoneyB = [];
      that.pagTotal = false;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      var nowTime = mUtils.formatDate(new Date(), 2).substring(0, 10);

      orderName = "库存列表" + nowTime;
      var pageTotal = 0;
      that.pageIndex = 0;
      var pageI = that.paginations.page_size;
      if (that.paginations.total) {
        pageTotal = that.paginations.total;

        if (pageTotal % pageI) {
          that.pageIndex = that.pageIndex + (pageTotal - pageTotal % pageI) / pageI + 1;
        } else {
          that.pageIndex = that.pageIndex + Math.floor(pageTotal / pageI);
        }

        for (var i = 0; i < that.pageIndex; i++) {
          that.pageIndexB = i + 1;
          that.getStoreListB(function (val, pageCount) {
            that.orderMoneyB = that.orderMoneyB.concat(val);
            if (val < that.paginations.page_size) {

              mUtils.export2Excel(that.columns, that.orderMoneyB, orderName);
              loading.close();
              res = '';
              loading.close();
            } else if (pageCount == that.orderMoneyB.length) {

              mUtils.export2Excel(that.columns, that.orderMoneyB, orderName);
              loading.close();
            }
          });
        }
      }

      setTimeout(function () {
        if (that.pagTotal) {
          mUtils.export2Excel(that.columns, that.orderMoneyB, orderName);
        }
      }, 200);
    },
    copy: function copy() {
      var that = this;

      var clipboard = new this.Clipboard(".btn");
      clipboard.on("success", function (e) {
        that.$message.success("复制成功");
        clipboard.destroy();
      });
      clipboard.on("error", function (e) {
        that.$message.warning("该浏览器不支持自动复制");

        clipboard.destroy();
      });
    },
    getorderNoB: function getorderNoB(val, isbox) {
      this.orderG = val;
      this.isBoxG = isbox;
      this.dialog.showG = true;
    },
    getOrder: function getOrder(val) {
      var that = this;
      that.orderInfo = val;
      that.dialog.show = true;
    },
    onsubmitB: function onsubmitB() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.netBarForm.validate(function (valid) {
        validd = valid;
        return true;
      });

      if (validd) {} else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    getComputer: function getComputer() {
      var that = this;
    },
    instorage: function instorage(value) {
      var that = this;
      that.orderInfo = value;
      that.orderInfo.productList.forEach(function (val, i) {
        val.productNumB = val.productNum;
        val.weightB = val.weight;
        val.productLongB = val.productLong;
        val.widthB = val.width;
        val.heightB = val.height;
      });
      that.dialog.showD = true;
    },
    affirm: function affirm() {
      var that = this;
      that.dialog.showC = false;
      that.orderInfo.orderNo = that.orderInfoC;
    },
    edit: function edit(orderInfo) {
      var that = this;
      that.orderInfoC = orderInfo;
      that.dialog.showC = true;
    },
    outbound: function outbound(orderInfo) {
      var that = this;
      that.orderInfoB = orderInfo;
      that.dialog.showB = true;
    },


    handleLicenseImgFile: function handleLicenseImgFile(file) {
      var that = this;

      var formData = new FormData();
      formData.append("ProductPicture", file.file);

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      product.upImage(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          that.imageUrl = res.data.data.realPath;
          that.imageUrlA = res.data.data.path;
          loading.close();
        }
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    linkOrderNO: function linkOrderNO(val, status) {
      var that = this;
      that.$router.push({
        path: "/creatOrder",
        query: {
          orderId: val,
          shopId: status
        }
      });
    },
    changeDate: function changeDate(val) {},
    getNowData: function getNowData() {
      var that = this;
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      other.GetNowTime().then(function (res) {
        if (res.data.code != 1) {
          var msg = void 0;
          msg = "获取现在的时间失败 !";
          that.$message.error(msg);
          return;
        } else {
          that.NowData = res.data.data;

          loading.close();
        }
      });
    },
    backA: function backA() {
      this.dialog.show = false;
      this.DataInformation = "";
    },
    chai: function chai(val) {
      this.orderInfo = val;
      this.dialog.show = true;
    },
    back: function back() {
      this.$router.go(-1);
    },
    filedSel: function filedSel() {
      var that = this;
      that.startDate = "";
      that.endDate = "";
      that.orderNOA = "";
      that.valueType = 1;
      that.getStoreList();
    },
    withDeposit: function withDeposit() {},
    runTab: function runTab() {},
    orderIn: function orderIn() {},
    tabInformation: function tabInformation() {
      var that = this;
    },
    onsubmit: function onsubmit() {
      var that = this;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var validd = void 0;
      that.$refs.search.validate(function (valid) {
        validd = valid;

        return true;
      });

      if (validd) {
        loading.close();
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;

      that.paginations.page_size = page_size;

      that.getStoreList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getStoreList();
    }
  }
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _statistical = __webpack_require__(205);

var statisticalApi = _interopRequireWildcard(_statistical);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formInline: {
        transactionType: "1",
        transportType: null,
        statusType: null,
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: "",
        checkedRole: "",
        deliverAddress: null
      },

      peopleArr: [],

      deliverAddressArr: [],

      startTime: "",
      endTime: "",

      batchArr: [],
      loading: false,

      statusArr: [{
        name: "中心仓已出库",
        key: "8",
        value: "8"
      }, {
        name: "派送已入库",
        key: "9",
        value: "9"
      }, {
        name: "可预约",
        key: "10",
        value: "10"
      }, {
        name: "已预约",
        key: "11",
        value: "11"
      }, {
        name: "已结单",
        key: "4",
        value: "4"
      }],
      orderStatusArr2: [{
        name: "待入库",
        key: "1",
        value: "1"
      }, {
        name: "已入库",
        key: "2",
        value: "2"
      }, {
        name: "已出库",
        key: "3",
        value: "3"
      }, {
        name: "中心仓已入库",
        key: "7",
        value: "7"
      }, {
        name: "中心仓已出库",
        key: "8",
        value: "8"
      }, {
        name: "派送已入库",
        key: "9",
        value: "9"
      }, {
        name: "可预约",
        key: "10",
        value: "10"
      }, {
        name: "已预约",
        key: "11",
        value: "11"
      }, {
        name: "已结单",
        key: "4",
        value: "4"
      }],
      tableData: [],
      sendOrderList: [],
      customerList: [],
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      paginationsPerson: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      deliveryList: [],
      showWhichTable: 1,
      isShowUserDialog: false,

      roleInput: "",

      roleData: [],

      rolePaginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      rowSelection: [],

      howManyTotal: 0,

      listArr: [],

      billColumn: [{ title: "订单编号", key: "orderNo" }, { title: "下单时间", key: "addTime" }, { title: "名称", key: "arrProduct" }, { title: "货物类型", key: "goodType" }, { title: "派送点", key: "deliveryTitle" }, { title: "客户", key: "realName" }, { title: "vip号", key: "vipCode" }, { title: "联系方式", key: "mobile" }, { title: "批次", key: "sendRemark" }, { title: "物流公司", key: "expressCompany" }, { title: "摘要", key: "orderNo" }, { title: "运单号", key: "expressNo" }, { title: "状态", key: "status" }, { title: "运费", key: "total" }, { title: "工单费（CAD）", key: "demandMoney" }, { title: "派送费(CAD)", key: "deliveryPrice" }, { title: "额外费用（CAD）", key: "extraPrice" }, { title: "签收状态", key: "isReceipt" }],

      sendOrderColumn: [{ title: "发货编号", key: "sendNo" }, { title: "发货单生成时间", key: "sendTime" }, { title: "VIP号", key: "vipCode" }, { title: "用户名", key: "realName" }, { title: "订单数量", key: "orderCount" }, { title: "实收费用CAD", key: "amount" }, { title: "余额", key: "userBalance" }, { title: "额外费用", key: "extraPrice" }, { title: "派送费", key: "deliveryPrice" }, { title: "批次", key: "remark" }, { title: "签收状态", key: "isReceipt" }],

      freight: 0,

      demandMoney: 0,

      extraPrice: 0,

      deliveryPrice: 0,

      sign: 1,

      roleId: null,

      peopleAddressId: null,

      exportAddressId: null
    };
  },
  created: function created() {
    this.getBatchList();
    this.getAdressId();
    this.getDeliveryList();
    this.getSendOrderList();
  },
  mounted: function mounted() {
    var userinfo = mUtils.getStore("userinfo");

    if (userinfo.roleId == 3) {
      this.roleId = 3;
      this.formInline.deliverAddress = userinfo.adminId;
    } else {
      this.statusArr = this.orderStatusArr2;
    }
  },

  methods: {
    search: function search() {
      var type = this.showWhichTable;
      if (type == 1) {
        this.getWayBillList(null, null, 1);
      } else {
        this.getSendOrderList(null, null, 3);
      }
    },
    getDate: function getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    getWayBillList: function getWayBillList(page, size, numType) {
      var _this = this;

      var that = this;

      this.tableData = [];
      var param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        type: 1,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",
        status: this.formInline.statusType,

        addressId: null,
        vipCode: this.formInline.checkedPerson,
        sign: this.sign ? this.sign : null
      };

      if (this.formInline.deliverAddress) {
        that.deliveryList.forEach(function (dItem, index) {
          if (dItem.adminId == _this.formInline.deliverAddress) {
            _this.exportAddressId = param.addressId = dItem.addressId;
          }
        });
      }

      statisticalApi.getWayBillList(param).then(function (res) {
        if (res.status !== 200) {
          return _this.$message.error(res.msg);
        }
        if (res.data.code !== 0) {
          _this.demandMoney = 0;
          _this.freight = 0;
          _this.extraPrice = 0, _this.deliveryPrice = 0;

          return _this.$message.error(res.data.msg);
        }
        if (res.data.data && res.data.data.demandMoney) {
          _this.demandMoney = res.data.data.demandMoney;
        } else {
          _this.demandMoney = 0;
        }

        if (res.data.data && res.data.data.freight) {
          _this.freight = res.data.data.freight;
        } else {
          _this.freight = 0;
        }

        if (res.data.data && res.data.data.list) {
          _this.tableData = res.data.data.list;
          _this.paginations.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
          _this.howManyTotal = _this.paginations.total;
        }
      });
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getWayBillList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getWayBillList();
    },
    handleSizeChangePerson: function handleSizeChangePerson(page_size) {
      var that = this;
      that.paginationsPerson.page_size = page_size;
      that.getSendOrderList();
    },
    handleCurrentChangePerson: function handleCurrentChangePerson(page) {
      var that = this;
      that.paginationsPerson.page_index = page;
      that.getSendOrderList();
    },
    getSendOrderList: function getSendOrderList(page, size, num) {
      var _this2 = this;

      var that = this;
      var data = {
        pageIndex: that.paginationsPerson.page_index,
        pageSize: that.paginationsPerson.page_size,
        type: 3,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",

        addressId: null,
        vipCode: this.formInline.checkedPerson,
        sign: this.sign ? this.sign : null
      };

      if (this.formInline.deliverAddress) {
        that.deliveryList.forEach(function (dItem, index) {
          if (dItem.adminId == _this2.formInline.deliverAddress) {
            _this2.exportAddressId = data.addressId = dItem.addressId;
          }
        });
      }

      var val = JSON.parse(localStorage.getItem("userinfo"));
      if (val.roleId !== 1) {
        data.adminId = val.adminId;
      }
      statisticalApi.getWayBillList(data).then(function (res) {
        if (res.data.code == 0) {
          that.sendOrderList = res.data.data.list;
          if (res.data.data && res.data.data.demandMoney) {
            _this2.demandMoney = res.data.data.demandMoney;
          } else {
            _this2.demandMoney = 0;
            _this2.freight = 0;
            _this2.extraPrice = 0, _this2.deliveryPrice = 0;
          }

          if (res.data.data && res.data.data.freight) {
            _this2.freight = res.data.data.freight;
          } else {
            _this2.freight = 0;
          }

          if (res.data.data && res.data.data.deliveryPrice) {
            _this2.deliveryPrice = res.data.data.deliveryPrice;
          } else {
            _this2.deliveryPrice = 0;
          }

          if (res.data.data && res.data.data.extraPrice) {
            _this2.extraPrice = res.data.data.extraPrice;
          } else {
            _this2.extraPrice = 0;
          }

          that.paginationsPerson.total = res.data.data.pageCount;
          _this2.howManyTotal = that.paginationsPerson.total;
        } else {
          that.$message.error("获取发货单列表失败");
        }
      });
    },
    getDeliveryList: function getDeliveryList() {
      var _this3 = this;

      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
          _this3.getCustomer();
          _this3.getRoleList();
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginationsPerson.page_index - 1) * this.paginationsPerson.page_size + $index + 1;
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
    },
    batchChange: function batchChange(value) {
      if (value.length == 0 && this.formInline.statusType == 1 || this.formInline.statusType == 2) {
        this.formInline.statusType = "";
      }
    },
    remoteMethod: function remoteMethod(value) {
      var _this4 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.getBatchList(value);
      }, 500);
    },
    getAdressId: function getAdressId() {
      var _this5 = this;

      var uselist = mUtils.getStore("userinfo");
      var realName = uselist.realName;
      var roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this5.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this5.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this5.deliverAddressArr = res.data.data.list;
        }
      });
    },
    goodType: function goodType(_goodType) {
      var str = "";
      switch (_goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    showUserVipCode: function showUserVipCode(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.vipCode) {
          return user.vipCode;
        } else {
          return "";
        }
      }
    },
    showRealName: function showRealName(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.realName) {
          return user.realName;
        } else {
          return "";
        }
      }
    },
    showBalance: function showBalance(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.balance) {
          return user.balance;
        } else {
          return "0";
        }
      }
    },
    getCustomer: function getCustomer() {
      var that = this;
      var data = {};
      if (mUtils.getStore("roleID") && mUtils.getStore("roleID") == 3) {
        if (mUtils.getStore("userinfo") && mUtils.getStore("userinfo").adminId) {
          var one = that.deliveryList.filter(function (item) {
            return item.adminId == mUtils.getStore("userinfo").adminId;
          });
          if (one && one.length > 0) {
            this.peopleAddressId = one[0].addressId;
          }
          data.deliveryId = this.peopleAddressId;
        }
      }
      statisticalApi.getCustomerList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data && res.data.data && res.data.data.list) {
            that.peopleArr = res.data.data.list;
          }
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    changeTransactionType: function changeTransactionType(value) {
      this.freight = 0;
      this.demandMoney = 0;
      this.deliveryPrice = 0;
      this.extraPrice = 0;
      if (value == 1) {
        this.showWhichTable = "1";
        this.sign = 1;

        this.tableData = [];
        if (this.roleId == 3) {} else {
          this.statusArr = this.orderStatusArr2;
        }
      } else if (value == 2) {
        this.formInline.statusType = "";
        this.showWhichTable = "2";
        this.sign = 2;
        this.formInline.transportType = "1";

        this.sendOrderList = [];
      } else if (value == 3) {
        this.showWhichTable = "1";
        this.sign = 3;

        this.tableData = [];
      } else {
        this.showWhichTable = "2";
        this.sign = 4;

        this.sendOrderList = [];

        this.formInline.transportType = "1";
      }
    },
    cancelRole: function cancelRole() {
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    searchRole: function searchRole() {
      this.rolePaginations.page_index = 1;
      this.getRoleList();
    },
    setRole: function setRole() {
      this.roleInput = "";
      this.getRoleList();
    },
    showUserDialog: function showUserDialog() {
      this.isShowUserDialog = true;
      this.roleInput = "";
    },
    certainRole: function certainRole() {
      if (this.rowSelection && this.rowSelection[0] && this.rowSelection[0].vipCode) {
        this.formInline.checkedPerson = this.rowSelection[0].vipCode;
      }
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    selectOptionChange: function selectOptionChange(val) {
      this.rowSelection = val;
    },
    selectRoleOnce: function selectRoleOnce(selection, row) {
      if (selection.length > 1) {
        var del_row = selection.shift();
        this.$refs.multipleTableRole.toggleRowSelection(del_row, false);
      }
    },
    getRoleList: function getRoleList() {
      var _this6 = this;

      var param = {
        realName: this.roleInput ? this.roleInput.trim() : "",
        pageIndex: this.rolePaginations.page_index,
        pageSize: this.rolePaginations.page_size
      };
      if (mUtils.getStore("roleID") && mUtils.getStore("roleID") == 3) {
        if (mUtils.getStore("userinfo") && mUtils.getStore("userinfo").adminId) {
          param.deliveryId = this.peopleAddressId;
        }
      }
      statisticalApi.getCustomerList(param).then(function (res) {
        if (res.data.code !== 0) return _this6.$message.error("获取人员数据失败: " + res.data.msg);
        if (res.data && res.data.data && res.data.data && res.data.data.list) {
          _this6.roleData = res.data.data.list;
          _this6.rolePaginations.total = res.data.data.pageCount;
        }
      });
    },
    rHandleSizeChange: function rHandleSizeChange(page_size) {
      this.rolePaginations.page_size = page_size;
      this.getRoleList();
    },
    rHandleCurrentChange: function rHandleCurrentChange(page) {
      this.rolePaginations.page_index = page;
      this.getRoleList();
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      var param = {
        pageIndex: 1,
        pageSize: 400,
        sign: this.sign ? this.sign : null
      };

      var howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
      var orderName = "";
      var columns = [];
      if (this.formInline.transactionType == "1" || this.formInline.transactionType == "3") {
        param["type"] = "1";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "";
        param["status"] = this.formInline.statusType;
        if (this.formInline.transactionType == "3") {
          param["addressId"] = this.exportAddressId;
        }
        param["vipCode"] = this.formInline.checkedPerson;
        param["addressId"] = this.exportAddressId;
        orderName = "统计费用-运单列表";
        columns = this.billColumn;
      } else {
        param["type"] = "3";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "";

        if (this.formInline.transactionType == "2") {
          param["addressId"] = this.exportAddressId;
        }
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计费用-发货单列表";
        columns = this.sendOrderColumn;
      }

      this.getExportData(param, howManyPage, orderName, columns);
    },
    getOrderStatus: function getOrderStatus(status) {
      if (status == 1) {
        return "待入库";
      } else if (status == 2) {
        return "已入库";
      } else if (status == 3) {
        return "已出库";
      } else if (status == 4) {
        return "已结单";
      } else if (status == -1) {
        return "已取消";
      } else if (status == 6) {
        return "已合箱";
      } else if (status == 7) {
        return "（中心仓）已入库";
      } else if (status == 8) {
        return "（中心仓）已出库";
      } else if (status == 9) {
        return "（派送）已入库";
      } else if (status == 10) {
        return "可预约";
      } else if (status == 11) {
        return "已预约";
      } else {
        return "";
      }
    },
    getExportData: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(param, howManyPage, orderName, columns) {
        var _this7 = this;

        var that, listArr, i;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                listArr = [];
                i = 1;

              case 3:
                if (!(i <= howManyPage)) {
                  _context.next = 10;
                  break;
                }

                param.pageIndex = i;
                _context.next = 7;
                return statisticalApi.getWayBillList(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        if (param.type == 1) {
                          every.addTime = mUtils.formatDate(new Date(every.addTime)).substring(0, 19);
                          if (every.goodType == 1) {
                            every.goodType = "海运";
                          } else if (every.goodType == 2) {
                            every.goodType = "海运大件";
                          } else if (every.goodType == 3) {
                            every.goodType = "空运";
                          } else {
                            every.goodType = "";
                          }
                          every.status = _this7.getOrderStatus(every.status);
                          every.isReceipt = every.isReceipt == 1 ? "已签收" : every.isReceipt == 0 ? "未签收" : "";
                        } else {
                          every.sendTime = mUtils.formatDate(new Date(every.sendTime)).substring(0, 19);
                          if (every.user && every.user.vipCode) {
                            every.vipCode = every.user.vipCode;
                          }
                          if (every.user && every.user.realName) {
                            every.realName = every.user.realName;
                          }
                          if (every.user && every.user.balance) {
                            every.userBalance = every.user.balance;
                          } else {
                            every.userBalance = "0";
                          }
                          every.operatorTime = mUtils.formatDate(new Date(every.operatorTime)).substring(0, 19);
                        }
                        every.isReceipt = every.isReceipt ? "已签收" : "未签收";

                        listArr.push(every);
                      });
                    }
                  }
                });

              case 7:
                i++;
                _context.next = 3;
                break;

              case 10:
                that.listArr = listArr;
                mUtils.export2Excel(columns, listArr, orderName);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getExportData(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getExportData;
    }()
  }
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _statistical = __webpack_require__(205);

var statisticalApi = _interopRequireWildcard(_statistical);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formInline: {
        transactionType: "1",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: ""
      },

      peopleArr: [],

      startTime: "",
      endTime: "",

      batchArr: [],

      tableData: [],
      customerList: [],
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      paginationsPerson: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      deliveryList: [],
      showWhichTable: 1,
      loading: false,

      isShowUserDialog: false,

      roleInput: "",

      roleData: [],

      rolePaginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      rowSelection: [],
      howManyTotal: 0,
      listArr: [],
      rechargeColumns: [{ title: "充值账单流水号", key: "balanceNo" }, { title: "充值人vip号", key: "vipCode" }, { title: "摘要", key: "orderNo" }, { title: "充值金额 CAD", key: "amount" }, { title: "收款类型", key: "accountName" }, { title: "备注", key: "remark" }, { title: "操作人", key: "realName" }, { title: "时间", key: "operatorTime" }, { title: "每笔交易之后账号剩余金额（CAD）", key: "afterBalance" }],
      expendColumns: [{ title: "支出账单流水号", key: "balanceNo" }, { title: "客户vip号", key: "vipCode" }, { title: "摘要", key: "orderNo" }, { title: "收取金额（CAD）", key: "amount" }, { title: "备注", key: "remark" }, { title: "操作人", key: "realName" }, { title: "取货时间", key: "operatorTime" }, { title: "每笔交易之后账号剩余金额（CAD）", key: "afterBalance" }]
    };
  },
  created: function created() {
    this.getBatchList();

    this.getDeliveryList();
    this.getCustomer();
    this.getRoleList();
  },

  methods: {
    search: function search() {
      this.getBalanceList();
    },
    getDate: function getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    getBalanceList: function getBalanceList() {
      var _this = this;

      var param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        type: this.formInline.transactionType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",
        vipCode: this.formInline.checkedPerson
      };
      statisticalApi.getUserBalance(param).then(function (res) {
        console.log(res);
        _this.paginations.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
        _this.howManyTotal = res.data.data.pageCount;
        if (res.status !== 200) return _this.$message.error(res.msg);else if (res.data.code !== 0) return _this.$message.error(res.data.msg);
        _this.tableData = res.data.data.list;
      });
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getBalanceList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getBalanceList();
    },
    getDeliveryList: function getDeliveryList() {
      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginationsPerson.page_index - 1) * this.paginationsPerson.page_size + $index + 1;
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
    },
    batchChange: function batchChange() {},
    remoteMethod: function remoteMethod(value) {
      var _this2 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.getBatchList(value);
      }, 500);
    },
    getCustomer: function getCustomer() {
      var that = this;
      var data = {};
      statisticalApi.getCustomerList(data).then(function (res) {
        console.log("993.res", res);

        if (res.data.code == 0) {
          if (res.data.data && res.data.data) {
            that.peopleArr = res.data.data;
            console.log("996", that.peopleArr);
          }
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    cancelRole: function cancelRole() {
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    searchRole: function searchRole() {
      this.getRoleList();
    },
    setRole: function setRole() {
      this.roleInput = "";
      this.getRoleList();
    },
    showUserDialog: function showUserDialog() {
      this.isShowUserDialog = true;
      this.roleInput = "";
    },
    certainRole: function certainRole() {
      console.log(1103, this.rowSelection);
      if (this.rowSelection && this.rowSelection[0] && this.rowSelection[0].vipCode) {
        this.formInline.checkedPerson = this.rowSelection[0].vipCode;
      }
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    selectOptionChange: function selectOptionChange(val) {
      this.rowSelection = val;
    },
    selectRoleOnce: function selectRoleOnce(selection, row) {
      if (selection.length > 1) {
        var del_row = selection.shift();
        this.$refs.multipleTableRole.toggleRowSelection(del_row, false);
      }
    },
    getRoleList: function getRoleList() {
      var _this3 = this;

      var param = {
        realName: this.roleInput ? this.roleInput.trim() : "",
        pageIndex: this.rolePaginations.page_index,
        pageSize: this.rolePaginations.page_size
      };
      statisticalApi.getCustomerList(param).then(function (res) {
        if (res.data.code !== 0) return _this3.$message.error("获取人员数据失败: " + res.data.msg);
        if (res.data && res.data.data && res.data.data) {
          _this3.roleData = res.data.data;
          _this3.rolePaginations.total = res.data.data.length;
        }
      });
    },
    rHandleSizeChange: function rHandleSizeChange(page_size) {
      this.rolePaginations.page_size = page_size;
      this.getRoleList();
    },
    rHandleCurrentChange: function rHandleCurrentChange(page) {
      this.rolePaginations.page_index = page;
      this.getRoleList();
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      this.getHowMangTotal();
    },
    getHowMangTotal: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var that, param, howManyPage, listArr, i, orderName;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                param = {
                  pageIndex: 1,
                  pageSize: 400,
                  type: this.formInline.transactionType,
                  start: this.startTime,
                  end: this.endTime,
                  batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",
                  vipCode: this.formInline.checkedPerson
                };
                howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
                listArr = [];
                i = 1;

              case 5:
                if (!(i <= howManyPage)) {
                  _context.next = 12;
                  break;
                }

                param.pageIndex = i;
                _context.next = 9;
                return statisticalApi.getUserBalance(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        every.operatorTime = mUtils.formatDate(new Date(every.operatorTime)).substring(0, 19);
                        listArr.push(every);
                      });
                    }
                  }
                });

              case 9:
                i++;
                _context.next = 5;
                break;

              case 12:

                that.listArr = listArr;
                orderName = "统计-流水列表Excel";

                if (param.type == 1) {
                  that.columnsOrder = that.rechargeColumns;
                } else {
                  that.columnsOrder = that.expendColumns;
                }
                mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getHowMangTotal() {
        return _ref.apply(this, arguments);
      }

      return getHowMangTotal;
    }()
  }
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(38);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _delivery = __webpack_require__(44);

var deliveryApi = _interopRequireWildcard(_delivery);

var _order = __webpack_require__(25);

var order = _interopRequireWildcard(_order);

var _book = __webpack_require__(63);

var book = _interopRequireWildcard(_book);

var _statistical = __webpack_require__(205);

var statisticalApi = _interopRequireWildcard(_statistical);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formInline: {
        transactionType: "1",
        transportType: null,
        statusType: "",
        checkedPerson: null,
        checkedTime: "",
        checkedBatch: "",
        checkedRole: "",
        deliverAddress: null
      },

      peopleArr: [],

      deliverAddressArr: [],

      startTime: "",
      endTime: "",

      batchArr: [],
      loading: false,

      statusArr: [],

      orderStatusArr: [{
        name: "中心仓已出库",
        key: "8",
        value: "8"
      }, {
        name: "派送已入库",
        key: "9",
        value: "9"
      }, {
        name: "可预约",
        key: "10",
        value: "10"
      }, {
        name: "已预约",
        key: "11",
        value: "11"
      }, {
        name: "已结单",
        key: "4",
        value: "4"
      }],
      orderStatusArr2: [{
        name: "待入库",
        key: "1",
        value: "1"
      }, {
        name: "已入库",
        key: "2",
        value: "2"
      }, {
        name: "已出库",
        key: "3",
        value: "3"
      }, {
        name: "中心仓已入库",
        key: "7",
        value: "7"
      }, {
        name: "中心仓已出库",
        key: "8",
        value: "8"
      }, {
        name: "派送已入库",
        key: "9",
        value: "9"
      }, {
        name: "可预约",
        key: "10",
        value: "10"
      }, {
        name: "已预约",
        key: "11",
        value: "11"
      }, {
        name: "已结单",
        key: "4",
        value: "4"
      }],

      boxStatusArr: [{
        name: "已合箱",
        key: "0",
        value: "0"
      }, {
        name: "已出库",
        key: "3",
        value: "3"
      }, {
        name: "分拨已入库",
        key: "7",
        value: "7"
      }, {
        name: "分拨已出库",
        key: "8",
        value: "8"
      }, {
        name: "派送已入库",
        key: "9",
        value: "9"
      }],

      tableData: [],
      sendOrderList: [],
      boxList: [],
      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      paginationsPerson: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      paginationsBox: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      deliveryList: [],
      showWhichTable: 1,
      customerList: [],
      isShowUserDialog: false,

      roleInput: "",

      roleData: [],

      rolePaginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      rowSelection: [],

      howManyTotal: 0,

      listArr: [],

      billColumn: [{ title: "订单编号", key: "orderNo" }, { title: "下单时间", key: "addTime" }, { title: "名称", key: "arrProduct" }, { title: "货物类型", key: "goodType" }, { title: "派送点", key: "deliveryTitle" }, { title: "客户", key: "realName" }, { title: "vip号", key: "vipCode" }, { title: "联系方式", key: "mobile" }, { title: "批次", key: "sendRemark" }, { title: "物流公司", key: "expressCompany" }, { title: "摘要", key: "orderNo" }, { title: "运单号", key: "expressNo" }, { title: "状态", key: "status" }, { title: "运费", key: "total" }, { title: "工单费（CAD）", key: "demandMoney" }, { title: "派送费(CAD)", key: "deliveryPrice" }, { title: "额外费用（CAD）", key: "extraPrice" }, { title: "签收状态", key: "isReceipt" }],

      boxColumn: [{ title: "合箱编码", key: "boxNumber" }, { title: "货物类型", key: "goodType" }, { title: "订单数量", key: "orderCount" }, { title: "用户VIP号", key: "vipCodes" }, { title: "批次", key: "batchNumber" }, { title: "箱号", key: "boxNumber" }, { title: "状态", key: "boxStatus" }],

      sendOrderColumn: [{ title: "发货编号", key: "sendNo" }, { title: "发货单生成时间", key: "sendTime" }, { title: "VIP号", key: "vipCode" }, { title: "用户名", key: "realName" }, { title: "订单数量", key: "orderCount" }, { title: "实收费用CAD", key: "amount" }, { title: "余额", key: "userBalance" }, { title: "额外费用", key: "extraPrice" }, { title: "批次", key: "remark" }, { title: "签收状态", key: "isReceipt" }],

      roleId: null,

      peopleAddressId: null,

      exportAddressId: null
    };
  },
  created: function created() {
    this.getBatchList();
    this.getAdressId();
    this.getDeliveryList();
    this.getSendOrderList();
  },
  mounted: function mounted() {
    var userinfo = mUtils.getStore('userinfo');

    if (userinfo.roleId == 3) {
      this.roleId = 3;
      this.formInline.deliverAddress = userinfo.adminId;
      this.statusArr = this.orderStatusArr;
    } else {
      this.statusArr = this.orderStatusArr2;
    }
  },

  watch: {},
  methods: {
    changeTransactionType: function changeTransactionType(value) {
      if (value == 1) {
        if (this.roleId == 3) {
          this.statusArr = this.orderStatusArr;
        } else {
          this.statusArr = this.orderStatusArr2;
        }

        this.showWhichTable = "1";

        this.tableData = [];
      } else if (value == 2) {
        this.statusArr = this.boxStatusArr;

        this.showWhichTable = "2";

        this.boxList = [];
      } else {
        this.statusArr = [];

        this.showWhichTable = "3";

        this.sendOrderList = [];
      }
    },
    search: function search() {
      var type = this.formInline.transactionType;
      if (type == 1) {
        this.getWayBillList(null, null, 1);
      } else if (type == 2) {
        this.getBoxList(null, null, 2);
      } else {
        this.getSendOrderList(null, null, 3);
      }
    },
    getDate: function getDate(time) {
      if (time) {
        this.startTime = new Date(mUtils.formatDate(time[0])).getTime();
        this.endTime = new Date(mUtils.formatDate(time[1])).getTime();
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
    getWayBillList: function getWayBillList(page, size, numType) {
      var _this = this;

      var that = this;
      var param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",
        status: this.formInline.statusType,

        addressId: null,

        vipCode: this.formInline.checkedPerson
      };

      if (this.formInline.deliverAddress) {
        that.deliveryList.forEach(function (dItem, index) {
          if (dItem.adminId == _this.formInline.deliverAddress) {
            _this.exportAddressId = param.addressId = dItem.addressId;
          }
        });
      } else {
        console.log(1106, this.formInline.deliverAddress);
      }

      statisticalApi.getWayBillList(param).then(function (res) {
        if (res.status !== 200) {
          return _this.$message.error(res.msg);
        }
        if (res.data.code !== 0) {
          return _this.$message.error(res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this.tableData = res.data.data.list;
          _this.paginations.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
          _this.howManyTotal = _this.paginations.total;
        }
      });
    },
    getBoxList: function getBoxList(page, size, numType) {
      var _this2 = this;

      var that = this;
      this.tableData = [];
      var param = {
        pageIndex: this.paginationsBox.page_index,
        pageSize: this.paginationsBox.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",
        status: this.formInline.statusType,

        addressId: null,
        vipCode: this.formInline.checkedPerson
      };

      if (this.formInline.deliverAddress) {
        that.deliveryList.forEach(function (dItem, index) {
          if (dItem.adminId == _this2.formInline.deliverAddress) {
            _this2.exportAddressId = param.addressId = dItem.addressId;
          }
        });
      }

      statisticalApi.getWayBillList(param).then(function (res) {
        if (res.status !== 200) {
          return _this2.$message.error(res.msg);
        }
        if (res.data.code !== 0) {
          return _this2.$message.error(res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this2.boxList = res.data.data.list;
          _this2.paginationsBox.total = res.data.data.pageCount ? res.data.data.pageCount : 0;
          _this2.howManyTotal = _this2.paginationsBox.total;
        }
      });
    },
    changeDate: function changeDate(row) {
      return mUtils.formatDate(new Date(row), 4);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getWayBillList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getWayBillList();
    },
    handleSizeChangePerson: function handleSizeChangePerson(page_size) {
      var that = this;
      that.paginationsPerson.page_size = page_size;
      that.getSendOrderList();
    },
    handleCurrentChangePerson: function handleCurrentChangePerson(page) {
      var that = this;
      that.paginationsPerson.page_index = page;
      that.getSendOrderList();
    },
    handleSizeChangeBox: function handleSizeChangeBox(page_size) {
      var that = this;
      that.paginationsBox.page_size = page_size;
      this.getBoxList(null, null, 2);
    },
    handleCurrentChangeBox: function handleCurrentChangeBox(page) {
      var that = this;
      that.paginationsBox.page_index = page;
      this.getBoxList(null, null, 2);
    },
    getSendOrderList: function getSendOrderList(page, size, num) {
      var _this3 = this;

      var that = this;
      var data = {
        pageIndex: that.paginationsPerson.page_index,
        pageSize: that.paginationsPerson.page_size,
        type: this.formInline.transactionType,
        goodType: this.formInline.transportType,
        start: this.startTime,
        end: this.endTime,
        batchNumber: this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "",

        addressId: null,
        vipCode: this.formInline.checkedPerson
      };

      if (this.formInline.deliverAddress) {
        that.deliveryList.forEach(function (dItem, index) {
          if (dItem.adminId == _this3.formInline.deliverAddress) {
            _this3.exportAddressId = data.addressId = dItem.addressId;
          }
        });
      }

      var val = JSON.parse(localStorage.getItem("userinfo"));
      if (val.roleId !== 1) {
        data.adminId = val.adminId;
      }
      statisticalApi.getWayBillList(data).then(function (res) {
        if (res.data.code == 0) {

          that.sendOrderList = res.data.data.list;

          that.paginationsPerson.total = res.data.data.pageCount;
          _this3.howManyTotal = that.paginationsPerson.total;
        } else {
          that.$message.error("获取发货单列表失败");
        }
      });
    },
    getDeliveryList: function getDeliveryList() {
      var _this4 = this;

      var that = this;
      var data = {};
      data.type = 2;
      deliveryApi.deliveryList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list || [];
          _this4.getCustomer();
          _this4.getRoleList();
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    getIndex: function getIndex($index) {
      return (this.paginationsPerson.page_index - 1) * this.paginationsPerson.page_size + $index + 1;
    },
    getBatchList: function getBatchList(value) {
      var that = this;

      var data = {};

      value ? data.batchNumber = value : "";

      order.getSelectBatchList(data).then(function (res) {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchArr = res.data.data;
          } else {
            that.batchArr = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },
    clearChecked: function clearChecked() {
      this.getBatchList();
    },
    batchChange: function batchChange() {},
    remoteMethod: function remoteMethod(value) {
      var _this5 = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this5.getBatchList(value);
      }, 500);
    },
    getAdressId: function getAdressId() {
      var _this6 = this;

      var uselist = mUtils.getStore("userinfo");
      var realName = uselist.realName;
      var roleId = uselist.roleId;
      book.deliveryList({ type: 2 }).then(function (res) {
        if (res.status !== 200) {
          return _this6.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return _this6.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data && res.data.data.list) {
          _this6.deliverAddressArr = res.data.data.list;
        }
      });
    },
    goodType: function goodType(_goodType) {
      var str = "";
      switch (_goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    showUserVipCode: function showUserVipCode(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.vipCode) {
          return user.vipCode;
        } else {
          return "";
        }
      }
    },
    showRealName: function showRealName(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.realName) {
          return user.realName;
        } else {
          return "";
        }
      }
    },
    showBalance: function showBalance(user) {
      if (!((0, _stringify2.default)(user) == "{}")) {
        if (user.balance) {
          return user.balance;
        } else {
          return "0";
        }
      }
    },
    getCustomer: function getCustomer() {
      var that = this;
      var data = {};
      if (mUtils.getStore('roleID') && mUtils.getStore('roleID') == 3) {

        if (mUtils.getStore('userinfo') && mUtils.getStore('userinfo').adminId) {

          var one = that.deliveryList.filter(function (item) {
            return item.adminId == mUtils.getStore('userinfo').adminId;
          });
          if (one && one.length > 0) {
            this.peopleAddressId = one[0].addressId;
          }

          data.deliveryId = this.peopleAddressId;
        }
      }
      statisticalApi.getCustomerList(data).then(function (res) {

        if (res.data.code == 0) {
          if (res.data.data && res.data.data && res.data.data.list) {
            that.peopleArr = res.data.data.list;
          }
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    cancelRole: function cancelRole() {
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    searchRole: function searchRole() {
      this.rolePaginations.page_index = 1;
      this.getRoleList();
    },
    setRole: function setRole() {
      this.roleInput = "";
      this.getRoleList();
    },
    showUserDialog: function showUserDialog() {
      this.isShowUserDialog = true;
      this.roleInput = "";
    },
    certainRole: function certainRole() {
      if (this.rowSelection && this.rowSelection[0] && this.rowSelection[0].vipCode) {
        this.formInline.checkedPerson = this.rowSelection[0].vipCode;
      }
      this.isShowUserDialog = false;
      this.rowSelection = [];
      this.getRoleList();
    },
    selectOptionChange: function selectOptionChange(val) {
      this.rowSelection = val;
    },
    selectRoleOnce: function selectRoleOnce(selection, row) {
      if (selection.length > 1) {
        var del_row = selection.shift();
        this.$refs.multipleTableRole.toggleRowSelection(del_row, false);
      }
    },
    getRoleList: function getRoleList(num, size) {
      var _this7 = this;

      var param = {
        realName: this.roleInput ? this.roleInput.trim() : "",
        pageIndex: this.rolePaginations.page_index,
        pageSize: this.rolePaginations.page_size
      };
      if (mUtils.getStore('roleID') && mUtils.getStore('roleID') == 3) {

        if (mUtils.getStore('userinfo') && mUtils.getStore('userinfo').adminId) {

          param.deliveryId = this.peopleAddressId;
        }
      }
      statisticalApi.getCustomerList(param).then(function (res) {
        if (res.data.code !== 0) return _this7.$message.error("获取人员数据失败: " + res.data.msg);
        if (res.data && res.data.data && res.data.data && res.data.data.list) {
          _this7.roleData = res.data.data.list;
          _this7.rolePaginations.total = res.data.data.pageCount;
        }
      });
    },
    rHandleSizeChange: function rHandleSizeChange(page_size) {
      this.rolePaginations.page_size = page_size;
      this.getRoleList(null, page_size);
    },
    rHandleCurrentChange: function rHandleCurrentChange(page) {
      this.rolePaginations.page_index = page;
      this.getRoleList(page, null);
    },
    exportToExcel: function exportToExcel() {
      var that = this;
      var param = {
        pageIndex: 1,
        pageSize: 400
      };

      var howManyPage = Math.ceil(that.howManyTotal * 1 / 400);
      var orderName = "";
      var columns = [];
      if (this.formInline.transactionType == "1") {
        param["type"] = "1";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "";
        param["status"] = this.formInline.statusType;

        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计-运单列表";
        columns = this.billColumn;
      } else if (this.formInline.transactionType == "2") {
        param["type"] = "2";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "";
        param["status"] = this.formInline.statusType;

        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计-箱号列表";
        columns = this.boxColumn;
      } else {
        param["type"] = "3";
        param["goodType"] = this.formInline.transportType;
        param["start"] = this.startTime;
        param["end"] = this.endTime;
        param["batchNumber"] = this.formInline.checkedBatch ? this.formInline.checkedBatch.trim() : "";

        param["addressId"] = this.exportAddressId;
        param["vipCode"] = this.formInline.checkedPerson;
        orderName = "统计—发货单列表";
        columns = this.sendOrderColumn;
      }

      this.getExportData(param, howManyPage, orderName, columns);
    },
    getOrderStatus: function getOrderStatus(status) {
      if (status == 1) {
        return "待入库";
      } else if (status == 2) {
        return "已入库";
      } else if (status == 3) {
        return "已出库";
      } else if (status == 4) {
        return "已结单";
      } else if (status == -1) {
        return "已取消";
      } else if (status == 6) {
        return "已合箱";
      } else if (status == 7) {
        return "（中心仓）已入库";
      } else if (status == 8) {
        return "（中心仓）已出库";
      } else if (status == 9) {
        return "（派送）已入库";
      } else if (status == 10) {
        return "可预约";
      } else if (status == 11) {
        return "已预约";
      } else {
        return "";
      }
    },
    getExportData: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(param, howManyPage, orderName, columns) {
        var _this8 = this;

        var that, listArr, i;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = this;
                listArr = [];
                i = 1;

              case 3:
                if (!(i <= howManyPage)) {
                  _context.next = 10;
                  break;
                }

                param.pageIndex = i;
                _context.next = 7;
                return statisticalApi.getWayBillList(param).then(function (res) {
                  if (res.data.code == 0) {
                    if (res.data.data.list) {
                      res.data.data.list.map(function (every, index) {
                        if (param.type == 1) {
                          every.addTime = mUtils.formatDate(new Date(every.addTime)).substring(0, 19);
                          if (every.goodType == 1) {
                            every.goodType = "海运";
                          } else if (every.goodType == 2) {
                            every.goodType = "海运大件";
                          } else if (every.goodType == 3) {
                            every.goodType = "空运";
                          } else {
                            every.goodType = "";
                          };
                          every.status = _this8.getOrderStatus(every.status);
                          every.isReceipt = every.isReceipt == 1 ? "已签收" : every.isReceipt == 0 ? "未签收" : "";
                        } else if (param.type == 2) {
                          if (every.goodType == 1) {
                            every.goodType = "海运";
                          } else if (every.goodType == 2) {
                            every.goodType = "海运大件";
                          } else if (every.goodType == 3) {
                            every.goodType = "空运";
                          } else {
                            every.goodType = "";
                          }
                          every.boxStatus = "已合箱";
                        } else {
                          every.sendTime = mUtils.formatDate(new Date(every.sendTime)).substring(0, 19);
                          if (every.user && every.user.vipCode) {
                            every.vipCode = every.user.vipCode;
                          }
                          if (every.user && every.user.realName) {
                            every.realName = every.user.realName;
                          }
                          if (every.user && every.user.balance) {
                            every.userBalance = every.user.balance;
                          } else {
                            every.userBalance = "0";
                          }
                          every.operatorTime = mUtils.formatDate(new Date(every.operatorTime)).substring(0, 19);
                        }
                        every.isReceipt = every.isReceipt ? "已签收" : "未签收";

                        listArr.push(every);
                      });
                    }
                  }
                });

              case 7:
                i++;
                _context.next = 3;
                break;

              case 10:
                that.listArr = listArr;
                mUtils.export2Excel(columns, listArr, orderName);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getExportData(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getExportData;
    }()
  }
};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _agree = __webpack_require__(201);

var agreeApi = _interopRequireWildcard(_agree);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      content: "",
      agreeId: null
    };
  },
  created: function created() {
    var that = this;
    that.getAgreeInfo();
  },

  methods: {
    getAgreeInfo: function getAgreeInfo() {
      var that = this;
      var data = {};
      data.type = 0;
      agreeApi.agreementInfo(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.agreeId = res.data.data.agreeId;
        that.content = res.data.data.content;
      });
    },
    add: function add() {
      var that = this;
      var data = {};
      data.agreeId = that.agreeId;
      data.content = that.content;
      data.type = 0;
      if (!that.content) {
        that.$message.error("请输入条款协议");
        return;
      }

      agreeApi.add(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success"
        });
      });
    }
  }
};

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _agree = __webpack_require__(201);

var agreeApi = _interopRequireWildcard(_agree);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      content: "",
      agreeId: null
    };
  },
  created: function created() {
    var that = this;
    that.getAgreeInfo();
  },

  methods: {
    getAgreeInfo: function getAgreeInfo() {
      var that = this;
      var data = {};
      data.type = 1;
      agreeApi.agreementInfo(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.agreeId = res.data.data.agreeId;
        that.content = res.data.data.content;
      });
    },
    add: function add() {
      var that = this;
      var data = {};
      data.agreeId = that.agreeId;
      data.content = that.content;
      data.type = 1;


      agreeApi.add(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success"
        });
      });
    }
  }
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _StringUtils = __webpack_require__(117);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _address = __webpack_require__(199);

var addressApi = _interopRequireWildcard(_address);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    var dataValidate = function dataValidate(rule, value, callback) {
      if (!value) {
        var text = void 0;
        if (rule.field == "contacts") text = "请输入负责人姓名";else if (rule.field == "tel") text = "请输入负责人电话";else if (rule.field == "goodType") text = "请选择货物类型";else if (rule.field == "address") text = "请输入国内仓地址";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改",
        data: {
          storeId: null,
          address: "",
          contacts: "",
          tel: "",
          goodType: null
        },
        goodTypeList: [{
          goodType: 1,
          goodName: "海运"
        }, {
          goodType: 2,
          goodName: "海运大件"
        }, {
          goodType: 3,
          goodName: "空运"
        }],
        form_rules: {
          goodType: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          tel: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          contacts: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }],
          address: [{
            required: true,
            validator: dataValidate,
            trigger: "blur"
          }]
        }
      },

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 20,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },
      addressList: [] };
  },
  created: function created() {
    var that = this;
    that.getStoreList();
  },


  methods: {
    goodType: function goodType(type) {
      return StringUtils.goodType(type);
    },
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getStoreList();
    },
    add: function add() {
      this.editDialog.show = true;
      this.editDialog.data = {
        storeId: null,
        address: "",
        contacts: "",
        tel: "",
        goodType: null
      };
    },
    edit: function edit(row) {
      this.editDialog.show = true;
      this.editDialog.data = {
        storeId: row.storeId,
        address: row.address,
        contacts: row.contacts,
        tel: row.tel,
        goodType: row.goodType
      };
    },
    submit: function submit() {
      var _this = this;

      var that = this;

      var data = {
        storeId: that.editDialog.data.storeId,
        contacts: that.editDialog.data.contacts,
        tel: that.editDialog.data.tel,
        goodType: that.editDialog.data.goodType,
        address: that.editDialog.data.address
      };
      that.$refs.editForm.validate(function (valid) {
        if (valid) {
          var loading = _this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          if (data.storeId) {
            addressApi.storeUpdate(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getStoreList();
              that.editDialog.show = false;
            });
          } else {
            addressApi.storeAdd(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({ message: "提交成功", type: "success" });
              that.getStoreList();
              that.editDialog.show = false;
            });
          }
        }
      });
    },
    getStoreList: function getStoreList() {
      var that = this;
      var data = {};
      addressApi.getStoreList(data).then(function (res) {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.addressList = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;
      that.paginations.page_size = page_size;
      that.getStoreList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;
      that.getStoreList();
    }
  }
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _img = __webpack_require__(131);

var img = _interopRequireWildcard(_img);

var _workOrder = __webpack_require__(302);

var workOrder = _interopRequireWildcard(_workOrder);

var _confirm = __webpack_require__(130);

var confirm = _interopRequireWildcard(_confirm);

var _priceGoods = __webpack_require__(204);

var priceGoods = _interopRequireWildcard(_priceGoods);

var _vuedraggable = __webpack_require__(93);

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _sortablejs = __webpack_require__(92);

var _sortablejs2 = _interopRequireDefault(_sortablejs);

var _fileSaver = __webpack_require__(91);

var _fileSaver2 = _interopRequireDefault(_fileSaver);

var _xlsx = __webpack_require__(94);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _utils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  components: {
    Draggable: _vuedraggable2.default
  },
  data: function data() {
    var _this = this;

    var demandValidate = function demandValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "content") {
          text = "客户回复";
        }

        return callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    var dataValidate = function dataValidate(rule, value, callback) {
      var that = _this;
      if (value === "") {
        var text = void 0;
        if (rule.field == "productWeight") {
          text = "包裹重量";
        } else if (rule.field == "productLong") {
          text = "长度";
        } else if (rule.field == "productWidth") {
          text = "宽度";
        } else if (rule.field == "productHeight") {
          text = "高度";
        }

        callback(new Error(text + "不能为空~"));
      } else {
        return callback();
      }
    };

    return {
      circleUrl: "https://cn2ca-1259002481.cos.na-toronto.myqcloud.com/other/avatar-gray.png",
      feedback: {
        data: {
          content: ""
        },
        list: [],
        rules: {
          content: [{ required: true, trigger: "blur", validator: demandValidate }]
        }
      },
      productImgB: "",
      productImgA: "",
      productImgACopy: "",
      productImgBCopy: "",
      tableData: [],
      userIdCode: "",

      newDate: "",

      discountTotal: "",
      priceGoodsIdCopy: {
        firstWeight: "",
        price: "",
        goodId: ""
      },
      priceGoodsId: "",
      priceGoodsList: [],
      indexA: "",
      adminDeleteDialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showF: false
      },
      delOrderNo: "",

      deliveyList: [{
        value: "待处理",
        id: 1
      }, {
        value: "处理中",
        id: 2
      }, {
        value: "已处理",
        id: 3
      }, {
        value: "已取消",
        id: 0
      }],
      options: [{
        value: "不合箱",
        id: 0
      }, {
        value: "合箱",
        id: 1
      }],
      order: {
        vipCode: "",
        expressCompany: "",
        expressNo: "",
        predictTotal: "",
        isBox: 0,
        remark: "",
        detailList: [{
          detailId: 0,
          productName: "",
          productNum: ""
        }]
      },
      pagTotal: false,
      pageIndexB: 0,
      pageIndex: 0,
      orderMoneyB: [],
      orderG: "",
      isBoxG: "",
      orderNOC: "",
      weiBol: false,
      volBol: false,
      galIndex: "",
      galIndexB: "",
      total: 0,
      weiTotal: 0,
      volTotal: 0,

      headers: {},
      orderInfoC: "",
      orderInfo: {
        demandNo: "",

        demandMoney: "",
        demandId: "",
        content: "",
        expressCompany: "",

        expressNo: "",
        realName: "",
        mobile: "",
        vipCode: "",
        status: "",
        workOrderStatus: "",
        reply: ""
      },
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
          keepShow: true
        },
        bar: {
          hoverStyle: false,
          onlyShowBarOnScroll: false,
          background: "#C1C1C1",
          keepShow: true,
          size: "12px",
          opacity: 1 }
      },
      value1: "",
      activeName: "first",

      orderNOG: "",

      NowDate: "",

      startTime: "",
      endTime: "",
      sytemPrice: "",
      dialog: {
        show: false,
        showB: false,
        showC: false,
        showD: false,
        showE: false,
        showF: false,
        showG: false,
        showH: false
      },
      DataInformation: "",
      orderNOA: "",

      paginations: {
        page_index: 1,
        total: 0,
        page_size: 10,
        page_sizes: [5, 10, 20, 100],
        layout: "total, sizes, prev, pager, next, jumper" },

      orderMoney: [],

      valueType: 1,
      startDate: "",
      endDate: "",
      form: {
        bankUser: "",

        bankCard: "",
        bankName: "",

        rules: {
          bankName: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankCard: [{ required: true, trigger: "blur", validator: dataValidate }],
          bankUser: [{ required: true, trigger: "blur", validator: dataValidate }]
        }
      },
      productCauserTelist: [],
      confirmDialogVisible: false
    };
  },
  created: function created() {
    var that = this;

    this.newDate = mUtils.formatDate(new Date()).substring(0, 10);
    that.getOrderList();
  },

  methods: {
    initData: function initData() {
      this.paginations.page_index = 1;
      this.getOrderList();
    },
    addFeedback: function addFeedback() {
      var _this2 = this;

      var that = this;
      var data = {};

      data.demandNo = that.orderInfo.demandNo;
      data.content = that.feedback.data.content;
      that.$refs.feedbackForm.validate(function (valid) {
        if (valid) {
          var loading = _this2.$loading({
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)"
          });
          workOrder.demandFeedback(data).then(function (res) {
            loading.close();
            if (res.data.code != 0) {
              that.$message({
                message: res.data.msg || "提交失败",
                type: "error"
              });
              return;
            }
            that.$message({
              message: "发送成功",
              type: "succuss"
            });
            that.feedback.data.content = "";
            that.getFeedbackList();
          });
        }
      });
    },
    getFeedbackList: function getFeedbackList() {
      var that = this;
      var data = {};
      var loading = this.$loading({
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      data.demandNo = that.orderInfo.demandNo;

      workOrder.demandFeedbackList(data).then(function (res) {
        loading.close();
        if (res.data.code != 0) {
          return;
        }
        that.feedback.list = res.data.data || [];
      });
    },
    onSubmitOrder: function onSubmitOrder() {
      var that = this;
      var data = {};

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      var img = "";

      if (that.productImgA) {
        img = that.productImgA;
      }
      if (that.productImgB) {
        img = img + "," + that.productImgB;
      }

      data = {
        demandId: that.orderInfo.demandId,
        demandMoney: that.orderInfo.demandMoney,
        status: that.orderInfo.workOrderStatus - 1,
        reply: that.orderInfo.reply,
        replayImg: img
      };

      workOrder.update(data).then(function (res) {
        if (res.data.code != 0) {
          var msg = "编辑失败";
          that.$message({
            message: msg,
            type: "error"
          });
        } else {
          that.getOrderList();

          that.dialog.show = false;
          var _msg = "编辑成功";
          that.$message({
            message: _msg,
            type: "success"
          });
          that.getOrderList();
          loading.close();
        }
      });
    },
    affirmB: function affirmB() {
      var that = this;

      var i = that.galIndexB;
      if (i == 1) {
        that.productImgA = "";
        that.productImgACopy = "";
      } else {
        that.productImgB = "";
        that.productImgBCopy = "";
      }
      that.$forceUpdate();
      that.dialog.showF = false;
    },
    del: function del() {
      var that = this;

      that.galIndexB = "1";
      that.dialog.showF = true;
    },
    delB: function delB() {
      var that = this;

      that.galIndexB = "2";
      that.dialog.showF = true;
    },
    unploadB: function unploadB(i) {
      var that = this;
      that.galIndex = i;
    },
    unpload: function unpload(i, index) {
      var that = this;
      that.galIndex = i;
      that.galIndexB = index;
    },

    handleLicenseImgFileB: function handleLicenseImgFileB(file) {
      var that = this;

      var i = that.galIndex;
      var index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");

          var obj = {};
          that.productImgBCopy = res.data.data.data.path;
          that.productImgB = res.data.data.data.url;

          that.$forceUpdate();

          loading.close();
        }
      });
    },
    beforeAvatarUploadB: function beforeAvatarUploadB(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },

    handleLicenseImgFile: function handleLicenseImgFile(file) {
      var that = this;

      var i = that.galIndex;
      var index = that.galIndexB;

      var formData = new FormData();
      formData.append("file", file.file);

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      that.headers = {
        "Content-Type": "multipart/form-data"
      };
      img.upload(formData).then(function (res) {
        if (res.data.code != 0) {
          if (res.data.code == 1101) {
            var msg = res.data.msg;
            that.$message.error(msg);
          } else {
            that.$message.error("上传失败 !");
          }
          loading.close();
          return;
        } else {
          that.$message.success("上传成功 !");
          var obj = {};

          that.productImgACopy = res.data.data.data.path;
          that.productImgA = res.data.data.data.url;

          that.$forceUpdate();
          loading.close();
        }
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      var isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    getorderNo: function getorderNo(val) {
      var that = this;
      that.productImgB = "";
      that.productImgA = "";
      that.productImgACopy = "";
      that.productImgBCopy = "";

      that.volTotal = 0;
      that.weiTotal = 0;

      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      var data = {
        demandId: val.demandId
      };

      workOrder.check(data).then(function (res) {
        if (res.data.code == 0) {
          that.orderInfo.createTime = mUtils.formatDate(new Date(res.data.data.list[0].createTime)).substring(0, 10);
          that.orderInfo.demandNo = res.data.data.list[0].demandNo;

          that.orderInfo.demandMoney = res.data.data.list[0].demandMoney || "";
          that.orderInfo.demandId = res.data.data.list[0].demandId;
          that.orderInfo.content = res.data.data.list[0].content || "";
          that.orderInfo.expressCompany = res.data.data.list[0].orderPojo.expressCompany;

          that.orderInfo.expressNo = res.data.data.list[0].orderPojo.expressNo;
          that.orderInfo.realName = res.data.data.list[0].usersPojo.realName;
          that.orderInfo.mobile = res.data.data.list[0].usersPojo.mobile;
          that.orderInfo.vipCode = res.data.data.list[0].usersPojo.vipCode;
          that.orderInfo.status = res.data.data.list[0].orderPojo.status;
          that.orderInfo.workOrderStatus = res.data.data.list[0].status + 1;
          that.orderInfo.reply = res.data.data.list[0].reply || "";
          that.orderInfo.orderPojo = res.data.data.list[0].orderPojo;
          if (res.data.data.list[0].replayImg) {
            if (res.data.data.list[0].replayImg.split(",").length > 1) {
              that.productImgA = res.data.data.list[0].replayImg.split(",")[0];
              that.productImgACopy = res.data.data.filePath + res.data.data.list[0].replayImg.split(",")[0];
              that.productImgB = res.data.data.list[0].replayImg.split(",")[1];
              that.productImgBCopy = res.data.data.filePath + res.data.data.list[0].replayImg.split(",")[1];
            } else {
              that.productImgA = res.data.data.list[0].replayImg.split(",")[0];
              that.productImgACopy = res.data.data.filePath + res.data.data.list[0].replayImg.split(",")[0];
            }
          }
          that.getFeedbackList();
          that.$forceUpdate();
          that.dialog.show = true;

          loading.close();
        }
      });
    },
    handleClick: function handleClick(tab, event) {
      var that = this;

      this.activeName = tab.name;
      that.orderMoneyB = [];
      that.paginations.page_index = 1;
      that.getOrderList();
    },
    getOrderList: function getOrderList(dataA) {
      var that = this;
      if (dataA) {
        that.paginations.page_index = 1;
      }
      var loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      setTimeout(function () {
        loading.close();
      }, 5000);
      var status = 0;
      if (that.activeName == "first") {
        status = "";
      } else if (that.activeName == "second") {
        status = 0;
      } else if (that.activeName == "third") {
        status = 1;
      } else if (that.activeName == "four") {
        status = 2;
      } else if (that.activeName == "five") {
        status = -1;
      }

      var data = {
        pageIndex: that.paginations.page_index,
        pageSize: that.paginations.page_size,
        status: status,
        demandNo: that.orderNOA ? that.orderNOA : null,
        realName: that.orderNOC ? that.orderNOC : null
      };

      workOrder.demandList(data).then(function (res) {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list) {
            res.data.data.list.forEach(function (val, index) {
              if (val.orderPojo.expressNo) {
                val.expressNo = val.orderPojo.expressNo;
                val.expressCompany = val.orderPojo.expressCompany;
              }
              val.mobile = val.usersPojo.mobile;
              val.realName = val.usersPojo.realName;
              val.vipCode = val.usersPojo.vipCode;
              val.createDate = mUtils.formatDate(new Date(val.createTime)).substring(0, 10);
            });
            that.orderMoney = res.data.data.list;
            that.paginations.total = res.data.data.pageCount;
          } else {
            that.orderMoney = [];
            that.paginations.total = 0;
          }
        } else {
          if (dataA == 1) {
            that.$message.error("查询订单列表失败");
          } else {
            that.$message.error("获取订单列表失败");
          }
        }
        loading.close();
      });
    },
    toDate: function toDate(time) {
      return mUtils.formatDate(new Date(time), 4);
    },
    handleSizeChange: function handleSizeChange(page_size) {
      var that = this;

      that.paginations.page_size = page_size;

      that.getOrderList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var that = this;
      that.paginations.page_index = page;

      that.getOrderList();
    }
  }
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _agree = __webpack_require__(201);

var agreeApi = _interopRequireWildcard(_agree);

var _workOrder = __webpack_require__(302);

var workOrder = _interopRequireWildcard(_workOrder);

var _utils = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      content: "",
      agreeId: null
    };
  },
  created: function created() {
    var that = this;
    that.getAgreeInfo();
  },

  methods: {
    getAgreeInfo: function getAgreeInfo() {
      var that = this;
      var data = {};
      data.type = 2;
      workOrder.agreementInfo(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.agreeId = res.data.data.agreeId;
        that.content = res.data.data.content;
      });
    },
    add: function add() {
      var that = this;
      var data = {};
      data.agreeId = that.agreeId;
      data.content = that.content;
      data.type = 2;
      if (!that.content) {
        that.$message.error("请输入工单须知");
        return;
      }

      workOrder.add(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success"
        });
      });
    }
  }
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cbs = exports.gbs = undefined;

var _settings = __webpack_require__(587);

exports.gbs = _settings.gbs;
exports.cbs = _settings.cbs;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var gbs = {
	host: ''
};

var cbs = {
	statusError: function statusError(err) {
		var _this = this;

		if (err.status !== 404) {
			this.$message({
				showClose: true,
				message: '返回错误：' + err.msg,
				type: 'error'
			});
		} else {
			this.$store.dispatch('remove_userinfo').then(function () {
				_this.$alert(err.status + ',' + err.msg + '！', '登录错误', {
					confirmButtonText: '确定',
					callback: function callback(action) {
						_this.$router.push({ path: '/login' });
					}
				});
			});
		}
	},
	requestError: function requestError(err) {
		console.log(err);
		this.$message({
			showClose: true,
			message: '请求错误：Internal Server Error',
			type: 'error'
		});
	}
};

exports.gbs = gbs;
exports.cbs = cbs;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(96);

var _stringify2 = _interopRequireDefault(_stringify);

__webpack_require__(484);

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _elementUi = __webpack_require__(293);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(487);

var _App = __webpack_require__(491);

var _App2 = _interopRequireDefault(_App);

var _axios = __webpack_require__(197);

var _axios2 = _interopRequireDefault(_axios);

var _router = __webpack_require__(292);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(483);

var _store2 = _interopRequireDefault(_store);

var _jsMd = __webpack_require__(490);

var _jsMd2 = _interopRequireDefault(_jsMd);

var _jsBase = __webpack_require__(489);

var _jsBase2 = _interopRequireDefault(_jsBase);

var _echarts = __webpack_require__(486);

var _echarts2 = _interopRequireDefault(_echarts);

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

var _vuescroll = __webpack_require__(493);

var _vuescroll2 = _interopRequireDefault(_vuescroll);

__webpack_require__(488);

var _vuePrintNb = __webpack_require__(492);

var _vuePrintNb2 = _interopRequireDefault(_vuePrintNb);

var _clipboard = __webpack_require__(485);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _cookie = __webpack_require__(291);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuescroll2.default);
_vue2.default.use(_vuePrintNb2.default);

_vue2.default.prototype.Clipboard = _clipboard2.default;

_vue2.default.use(_elementUi2.default);


_vue2.default.prototype.$echarts = _echarts2.default;
_vue2.default.prototype.$Base64 = _jsBase2.default.Base64;
_vue2.default.prototype.$md5 = _jsMd2.default;
_vue2.default.prototype.$cookieStore = {
	setCookie: _cookie.setCookie,
	getCookie: _cookie.getCookie,
	delCookie: _cookie.delCookie
};
_vue2.default.prototype.$sub = _axios2.default.create({
	baseURL: "https://admin.shhfxd.com/api/",
	headers: {
		'Content-Type': 'application/json; charset=UTF-8',
		'token': mUtils.getStore("token")
	},
	transformRequest: [function (data) {
		return (0, _stringify2.default)(data);
	}],
	transformResponse: [function (data) {
		if (data) {
			var ret = JSON.parse(data);

			if (ret.code == 1203) {
				localStorage.removeItem('userinfo');
				localStorage.removeItem('menuData');
				_router2.default.push('/');
			} else if (ret.code == 100) {
				_router2.default.push('/');
			} else {
				return ret;
			}
		} else {
			return;
		}
	}]
});
_vue2.default.filter('priceFilt', function (value) {

	if (!value) return '0.00';

	var intPart = Number(value) - Number(value) % 1;

	var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

	var floatPart = '.00';
	value = value.toString();
	var value2Array = value.split('.');
	if (value2Array.length === 2) {
		floatPart = value2Array[1].toString();
		if (floatPart.length === 1) {

			return intPartFormat + '.' + floatPart + '0';
		} else {

			return intPartFormat + '.' + floatPart;
		}
	} else {

		return intPartFormat + floatPart;
	}
});

_vue2.default.filter('priceFiltB', function (value) {

	if (!value) return '0.00';

	var intPart = Number(value) - Number(value) % 1;

	var floatPart = '.00';
	value = value.toString();
	var value2Array = value.split('.');
	if (value2Array.length === 2) {
		floatPart = value2Array[1].toString();
		if (floatPart.length === 1) {

			return intPart + '.' + floatPart + '0';
		} else {

			return intPart + '.' + floatPart;
		}
	} else {

		return intPart + floatPart;
	}
});

_vue2.default.config.productionTip = false;

_router2.default.beforeEach(function (to, from, next) {

	next();
});

new _vue2.default({
	el: '#app',
	router: _router2.default,
	store: _store2.default,
	template: '<App/>',
	components: {
		App: _App2.default
	}
});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _menu = __webpack_require__(590);

var _menu2 = _interopRequireDefault(_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _menu2.default;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    ADD_MENU: 'ADD_MENU',
    LOAD_ROUTES: 'LOAD_ROUTES',
    HANDLE_LEFT_MENU: 'HANDLE_LEFT_MENU',
    INIT_LEFT_MENU: 'INIT_LEFT_MENU',
    SET_LEFT_COLLAPSE: "SET_LEFT_COLLAPSE",
    DROP_NAME: 'DROP_NAME',
    THREE_NAME: 'THREE_NAME'
};

var state = {
    items: [],
    isLoadRoutes: false,
    sidebar: {
        opened: true,
        width: '180px'
    },
    isCollapse: false,
    isDropname: false };

var getters = {
    menuitems: function menuitems(state) {
        return state.items;
    },
    isLoadRoutes: function isLoadRoutes(state) {
        return state.isLoadRoutes;
    }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_MENU, function (state, menuItems) {
    if (menuItems.length === 0) {
        state.items = [];
    } else {
        state.items = menuItems;
    }
}), (0, _defineProperty3.default)(_mutations, types.LOAD_ROUTES, function (state) {
    state.isLoadRoutes = !state.isLoadRoutes;
}), (0, _defineProperty3.default)(_mutations, types.HANDLE_LEFT_MENU, function (state) {
    if (state.sidebar.opened) {
        state.sidebar.width = '35px';
    } else {
        state.sidebar.width = '180px';
    }
    state.sidebar.opened = !state.sidebar.opened;
}), (0, _defineProperty3.default)(_mutations, types.INIT_LEFT_MENU, function (state) {
    state.sidebar = {
        opened: true,
        width: '180px'
    };
}), (0, _defineProperty3.default)(_mutations, types.SET_LEFT_COLLAPSE, function (state) {
    state.isCollapse = !state.isCollapse;
}), (0, _defineProperty3.default)(_mutations, types.DROP_NAME, function (state) {
    state.isDropname = !state.isDropname;
}), _mutations);

var actions = {
    addMenu: function addMenu(_ref, menuItems) {
        var commit = _ref.commit;

        if (menuItems.length > 0) {
            commit(types.ADD_MENU, menuItems);
        }
    },
    loadRoutes: function loadRoutes(_ref2) {
        var commit = _ref2.commit;

        commit(types.LOAD_ROUTES);
    },
    handleLeftMenu: function handleLeftMenu(_ref3) {
        var commit = _ref3.commit;

        commit(types.HANDLE_LEFT_MENU);
    },
    initLeftMenu: function initLeftMenu(_ref4) {
        var commit = _ref4.commit;

        commit(types.INIT_LEFT_MENU);
    },
    setLeftCollapse: function setLeftCollapse(_ref5) {
        var commit = _ref5.commit;

        commit(types.SET_LEFT_COLLAPSE);
    },
    dropName: function dropName(_ref6) {
        var commit = _ref6.commit;

        commit(types.DROP_NAME);
    }

};

exports.default = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _page = __webpack_require__(592);

var _page2 = _interopRequireDefault(_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _page2.default;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(97);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    SET_WIN_CONTENT: 'SET_WIN_CONTENT' };

var state = {
    win_content: {
        width: '',
        height: ''
    }
};

var getters = {
    width: function width(state) {
        return state.win_content.width;
    },
    height: function height(state) {
        return state.win_content.height;
    }
};

var mutations = (0, _defineProperty3.default)({}, types.SET_WIN_CONTENT, function (state, contentobjs) {
    state.win_content.width = contentobjs.width;
    state.win_content.height = contentobjs.height;
});

var actions = {
    set_win_content: function set_win_content(_ref, contentobjs) {
        var commit = _ref.commit;

        commit(types.SET_WIN_CONTENT, contentobjs);
    }
};

exports.default = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user = __webpack_require__(594);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _user2.default;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mUtils = __webpack_require__(5);

var mUtils = _interopRequireWildcard(_mUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var types = {
    ADD_MENU: 'ADD_MENU',
    LOAD_ROUTES: 'LOAD_ROUTES' };

var state = {
    userinfo: mUtils.getStore('userinfo') || {}
};

var getters = {};

var mutations = {};

var actions = {};

exports.default = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof2 = __webpack_require__(81);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = function () {
	var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    type = _ref.type,
	    path = _ref.path,
	    data = _ref.data,
	    fn = _ref.fn,
	    errFn = _ref.errFn,
	    headers = _ref.headers,
	    opts = _ref.opts;

	var options = {
		method: type,
		url: path,
		headers: headers && (typeof headers === 'undefined' ? 'undefined' : (0, _typeof3.default)(headers)) === 'object' ? headers : {}
	};
	options[type === 'get' ? 'params' : 'data'] = data;

	if (opts && (typeof opts === 'undefined' ? 'undefined' : (0, _typeof3.default)(opts)) === 'object') {
		for (var f in opts) {
			options[f] = opts[f];
		}
	}

	_vue2.default.axios(options).then(function (res) {
		fn(res.data);
	}).catch(function (error) {
		errFn(error);
	});
};

var _vue = __webpack_require__(30);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(197);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(1211);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _config = __webpack_require__(586);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueAxios2.default, _axios2.default);

_vue2.default.axios.defaults.baseURL = _config.gbs.host;

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1211 */,
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1150)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1237),
  /* scopeId */
  "data-v-4780a294",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1230),
  /* scopeId */
  "data-v-2be245b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1185)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1261),
  /* scopeId */
  "data-v-be06e6b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1145)
__webpack_require__(1144)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1233),
  /* scopeId */
  "data-v-3bafa3bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1141)

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1229),
  /* scopeId */
  "data-v-27a51348",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productDustribut"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 客户列表")]), _vm._v(" "), _c('div', {
    staticClass: "minWidth"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称/vip号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称/vip号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordB),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordB", $$v)
      },
      expression: "searchData.keyWordB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordC),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordC", $$v)
      },
      expression: "searchData.keyWordC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.initData()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerList,
      "border": "",
      "default-sort": {
        prop: 'balance',
        order: 'descending'
      },
      "stripe": ""
    },
    on: {
      "sort-change": _vm.sortBalance
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "头像",
      "header-align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', [_c('el-image', {
          staticClass: "imgRaduis",
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.photo,
            "fit": "contain"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n              " + _vm._s(scope.row.nickname) + "\n            ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.realName) ? _c('div', [_vm._v(_vm._s(scope.row.realName))]) : _c('div', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "注册时间",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.addDate) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.mobile) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单配额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.demandCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "align": "center",
      "prop": "balance",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "消费金额",
      "align": "center",
      "prop": "amount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('p', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.deliveryAddress))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.remark) + "\n        ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "400px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "realName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.realName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "realName", $$v)
      },
      expression: "editDialog.data.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile",
      "label": "手机号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "demandCount",
      "label": "工单预期："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "工单预期",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.demandCount),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "demandCount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.demandCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "客户备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "客户备注",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryId",
      "label": "派送点："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editDialog.data.deliveryId),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryId", $$v)
      },
      expression: "editDialog.data.deliveryId"
    }
  }, _vm._l((_vm.deliveryList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitUser()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "visible": _vm.deleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.deleteDialog, "show", $event)
      }
    }
  }, [_c('span', [_vm._v("您确定删除吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('head-nav'), _vm._v(" "), _c('div', {
    staticClass: "left-fixed-right-auto"
  }, [_c('left-menu'), _vm._v(" "), _c('div', {
    staticClass: "content_page",
    style: ({
      'margin-left': _vm.$store.state.menu.sidebar.width,
      'width': _vm.$store.state.page.win_content.width + 'px',
      'height': _vm.$store.state.page.win_content.height + 'px'
    })
  }, [_c('div', {
    staticClass: "content"
  }, [_c('bread', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.roleId == 1),
      expression: "roleId==1"
    }]
  }), _vm._v(" "), _c('router-view')], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知内容:"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入关键字筛选并选择"
    },
    model: {
      value: (_vm.formInline.content),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "content", $$v)
      },
      expression: "formInline.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理人："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.formInline.operator),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "operator", $$v)
      },
      expression: "formInline.operator"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "张三",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "李四",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发送时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理完成时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.finishTime)
      }
    },
    model: {
      value: (_vm.formInline.finishTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "finishTime", $$v)
      },
      expression: "formInline.finishTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.formInline.dealStatus),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dealStatus", $$v)
      },
      expression: "formInline.dealStatus"
    }
  }, _vm._l((_vm.dealStatusArr), function(statusObj) {
    return _c('el-option', {
      key: statusObj.value,
      attrs: {
        "label": statusObj.label,
        "value": statusObj.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/announcement/newOrEdit"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("新建通知")])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "informContent",
      "label": "通知内容",
      "align": "center",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.informContent) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "img",
      "label": "图片描述",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.img) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendTime",
      "align": "center",
      "label": "发送时间",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.sendTime ?
          _vm.changeDate(scope.row.sendTime) :
          "时间未知") + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "处理人",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operatorTime",
      "align": "center",
      "label": "处理完成时间",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dealStatus",
      "label": "处理状态",
      "align": "center",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.dealStatus),
            callback: function($$v) {
              _vm.$set(scope.row, "dealStatus", $$v)
            },
            expression: "scope.row.dealStatus"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "待处理",
            "value": "1"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "处理中",
            "value": "2"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "处理完成",
            "value": "3"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "已取消",
            "value": "4"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "操作",
      "align": "center",
      "min-width": "200px"
    }
  }, [
    [_c('router-link', {
      attrs: {
        "to": {
          path: '/announcement/newOrEdit',
          query: {
            name: 4
          }
        }
      }
    }, [_c('el-link', {
      attrs: {
        "underline": false
      }
    }, [_vm._v("查看详情")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n      | 仓库地址\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.stores,
      "rules": _vm.stores.form_rules,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "felx"
  }, [_c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_vm._v("\n          国内集货仓地址：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "address"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "地址：江苏太仓沙溪沙南西路1658号"
    },
    model: {
      value: (_vm.stores.address),
      callback: function($$v) {
        _vm.$set(_vm.stores, "address", $$v)
      },
      expression: "stores.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contacts"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "收货人：李庆中"
    },
    model: {
      value: (_vm.stores.contacts),
      callback: function($$v) {
        _vm.$set(_vm.stores, "contacts", $$v)
      },
      expression: "stores.contacts"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tel"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "电话：13901620438"
    },
    model: {
      value: (_vm.stores.tel),
      callback: function($$v) {
        _vm.$set(_vm.stores, "tel", $$v)
      },
      expression: "stores.tel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('div', {
    staticClass: "space"
  }, [_vm._v("\n          国外集货仓地址：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "addressO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "地址：江苏太仓沙溪沙南西路1658号"
    },
    model: {
      value: (_vm.stores.addressO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "addressO", $$v)
      },
      expression: "stores.addressO"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contactsO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "联系人：Justin Biber"
    },
    model: {
      value: (_vm.stores.contactsO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "contactsO", $$v)
      },
      expression: "stores.contactsO"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spaceTop"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "telO"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30vw"
    },
    attrs: {
      "placeholder": "电话：+14082029128"
    },
    model: {
      value: (_vm.stores.telO),
      callback: function($$v) {
        _vm.$set(_vm.stores, "telO", $$v)
      },
      expression: "stores.telO"
    }
  })], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "fotet"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "margin-left": "-8vw"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onsub
    }
  }, [_vm._v("确认修改")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "ratelist",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "ratelist_text"
  }, [_vm._v("\n        | 汇率列表\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ratelist_box"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": " ",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cost",
      "label": "1 CAD",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showDia(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "discountsBox"
  }, [_c('div', {
    staticClass: "discountsBox_text"
  }, [_vm._v("\n        | 优惠信息\n      ")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticClass: "discountsBox_input",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4
      },
      "placeholder": "可输入优惠内容"
    },
    model: {
      value: (_vm.textarea2),
      callback: function($$v) {
        _vm.textarea2 = $$v
      },
      expression: "textarea2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateDisCount
    }
  }, [_vm._v("\n        提 交\n      ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑汇率",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.updateRate
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "dia"
  }, [_c('span', [_vm._v("1 ")]), _vm._v(" "), (_vm.title) ? _c('span', [_vm._v("CNY ")]) : (!_vm.title) ? _c('span', [_vm._v("USD ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("= ")]), _vm._v(" "), _c('el-input', {
    staticClass: "dia_input",
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" CAD")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("条款协议")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, [_c('el-input', {
    staticClass: "wj_txt",
    attrs: {
      "type": "textarea",
      "rows": 15,
      "placeholder": "请输入条款协议"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wj_btns"
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待入库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已出库",
      "name": "4"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "合箱编码",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户VIP号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "vipCode", $$v)
      },
      expression: "search.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "订单号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderNumber", $$v)
      },
      expression: "search.orderNumber"
    }
  })], 1), _vm._v(" "), (_vm.accountObj.roleId == 1) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "派送点"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "deliveryTitle", $$v)
      },
      expression: "search.deliveryTitle"
    }
  }, _vm._l((_vm.deliveryAddressList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.deliveryTitle
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "row-key": "boxId",
      "max-height": "550px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_vm._v("\n      stripe>\n      "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.strStatus(scope.row.status)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 8) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHanlder(scope.row)
            }
          }
        }, [_vm._v("签收入库")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.activeName == 8 && _vm.accountObj.roleId == 1) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulIntoStore()
      }
    }
  }, [_vm._v("批量入库")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ?
    _vm.toDate(_vm.viewDialog.boxInfo.createTime, "yyyy-MM-dd hh:mm:ss") :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("待入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.orderCount : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("预估费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.totalFreight : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.vipCodes : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "align": "center",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "header-align": "center",
      "min-width": "160px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    },
    slot: "reference"
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.orderCount : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("货物类型：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ?
    _vm.stringGoodType(_vm.detailDialog.boxInfo.goodType) :
    ""))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.vipCodes : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "align": "center",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.stringGoodType(scope.row.goodType)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "width": "80px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "70px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', {
          staticClass: "status1"
        }, [_vm._v("待入库")]) : (scope.row.status == 2) ? _c('span', {
          staticClass: "status2"
        }, [_vm._v("已入库")]) : (scope.row.status == 3) ? _c('span', {
          staticClass: "status3"
        }, [_vm._v("已出库")]) : (scope.row.status == 4) ? _c('span', {
          staticClass: "status4"
        }, [_vm._v("已结单")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "status-1"
        }, [_vm._v("已取消")]) : (scope.row.status == 7) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("(分拨)已入库")]) : (scope.row.status == 8) ? _c('span', {
          staticClass: "status8"
        }, [_vm._v("(分拨)已出库")]) : (scope.row.status == 9) ? _c('span', {
          staticClass: "status9"
        }, [_vm._v("(派送)已入库")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(CAD)",
      "prop": "total",
      "width": "95px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "addTime",
      "width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss")) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "100px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.outDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.outDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确定出库吗？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.outSubmit()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.outDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "order_main2 order_face",
    style: ({
      width: _vm.width + 'px',
      height: _vm.height + 'px'
    }),
    attrs: {
      "id": "printContent"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "print",
      rawName: "v-print",
      value: (_vm.printObj),
      expression: "printObj"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("打 印")]), _vm._v(" "), _c('el-button', [_vm._v("关 闭")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_header"
  }, [_c('img', {
    staticClass: "code_img",
    attrs: {
      "src": "https://cn2ca-1259002481.cos.na-toronto.myqcloud.com/img/c076e719965343bcb1e09d8adcd8d9f4.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_box"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("分拨中心：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("蒙特利尔")]), _vm._v(" "), _c('span', {
    staticClass: "l_label l_label2"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("Toronto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "order_count"
  }, [_vm._v("订单数量：2")]), _vm._v(" "), _c('div', {
    staticClass: "product_list",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试测试测试测试测试测试测试测试测试")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00010")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_item_val l_name",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("测试商品042211")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("A00011")]), _vm._v(" "), _c('span', {
    staticClass: "l_item_val",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("sf0425001")])]), _vm._v(" "), _c('div', {
    staticClass: "box_footer2",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "box_time",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_label",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("2021-04-25 07:50:54")])]), _vm._v(" "), _c('span', {
    staticClass: "box_type",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_c('span', {
    staticClass: "l_label",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("运输方式：")]), _c('span', {
    staticClass: "l_value",
    attrs: {
      "data-v-075294c4": ""
    }
  }, [_vm._v("海运")])])])])])
}]}

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("首页公告")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, [_c('el-input', {
    staticClass: "wj_txt",
    attrs: {
      "type": "textarea",
      "rows": 15,
      "placeholder": "请输入公告内容"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wj_btns"
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('header', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("| 筛选条件")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "输出类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.changeTransactionType
    },
    model: {
      value: (_vm.formInline.transactionType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transactionType", $$v)
      },
      expression: "formInline.transactionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "运单号",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "箱号",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "发货单号",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运输类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.transportType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transportType", $$v)
      },
      expression: "formInline.transportType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "空运",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运大件",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "160px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "",
      "disabled": _vm.formInline.transactionType == 3,
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.statusType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "statusType", $$v)
      },
      expression: "formInline.statusType"
    }
  }, _vm._l((_vm.statusArr), function(statusObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": statusObj.name,
        "value": statusObj.value,
        "disabled": statusObj &&
          (statusObj.value == 1 || statusObj.value == 2) &&
          !!_vm.formInline.checkedBatch
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "people",
    attrs: {
      "label": "人员："
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.checkedPerson),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedPerson", $$v)
      },
      expression: "formInline.checkedPerson"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleArr), function(peopleObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": peopleObj.vipCode,
        "value": peopleObj.vipCode
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search-icon",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showUserDialog
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "56px"
    },
    attrs: {
      "label": "派送点："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.formInline.deliverAddress),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "deliverAddress", $$v)
      },
      expression: "formInline.deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("筛选数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "margin-top": "100px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(_vm.showWhichTable == 1) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 运单页")]) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 箱号页")]) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 3) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单页")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号",
      "width": "160",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.orderNo) + "\n                ")]
      }
    }], null, false, 3318077970)
  }), _vm._v(" "), _c('el-table-column', {
    key: 12,
    attrs: {
      "min-width": "180",
      "align": "center",
      "prop": "expressNo",
      "label": "运单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n                  ")]) : _vm._e(), _vm._v("\n\n                  " + _vm._s(scope.row.expressNo ? scope.row.expressNo : "") + "\n                ")]
      }
    }], null, false, 2997915901)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addTime",
      "label": "下单时间",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.addTime ? _vm.changeDate(scope.row.addTime, 1) : "") + "\n                ")]
      }
    }], null, false, 4135224054)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "arrProduct",
      "label": "名称",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.arrProduct) + "\n                ")]
      }
    }], null, false, 7906967)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.goodName) + "\n                  ")])]
      }
    }], null, false, 3339316019)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.deliveryTitle) + "\n                ")]
      }
    }], null, false, 610745121)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.vipCode) + "\n                ")]
      }
    }], null, false, 3926535327)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "width": "120",
      "label": "联系方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.sendRemark) + "\n                ")]
      }
    }], null, false, 3366488835)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expressCompany",
      "width": "100",
      "label": "物流公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "width": "160",
      "label": "摘要"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n                    待入库\n                  ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已入库\n                  ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已出库\n                  ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已结单\n                  ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n                    已取消\n                  ")]) : (scope.row.status == 6) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已合箱\n                  ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （中心仓）已入库\n                  ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    （中心仓）已出库\n                  ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （派送）已入库\n                  ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#ffa500"
          }
        }, [_vm._v("\n                    可预约\n                  ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#008000"
          }
        }, [_vm._v("\n                    已预约\n                  ")]) : _vm._e()]
      }
    }], null, false, 3709828376)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n                ")]
      }
    }], null, false, 3897659740)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单费（CAD）",
      "min-width": "140px",
      "align": "center",
      "prop": "demandMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送费(CAD)",
      "min-width": "140px",
      "align": "center",
      "prop": "deliveryPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用（CAD）",
      "min-width": "160px",
      "align": "center",
      "prop": "extraPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 3) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sendOrderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sendNo ? scope.row.sendNo : ""))])]
      }
    }], null, false, 710498544)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "width": "160px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.sendTime ? _vm.changeDate(scope.row.sendTime) : ""))])]
      }
    }], null, false, 2563937936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showUserVipCode(scope.row.user) : ""))])]
      }
    }], null, false, 182391634)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showRealName(scope.row.user) : ""))])]
      }
    }], null, false, 3898529692)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.orderCount ? scope.row.orderCount : ""))])]
      }
    }], null, false, 4182808579)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showBalance(scope.row.user) : ""))])]
      }
    }], null, false, 2388616455)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用",
      "prop": "extraPrice",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.remark))])]
      }
    }], null, false, 186672324)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-table', {
    attrs: {
      "data": _vm.boxList,
      "stripe": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.vipCodes || '').split(',').length > 1) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s((scope.row.vipCodes || "").split(",").length > 1 ?
          "混" :
          "") + "\n                  ")]) : _vm._e(), _vm._v("\n                  " + _vm._s(scope.row.boxNumber) + "\n                ")]
      }
    }], null, false, 1482358165)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.goodName) + "\n                  ")])]
      }
    }], null, false, 3339316019)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.orderCount) + "\n                ")]
      }
    }], null, false, 3197602192)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.vipCodes) + "\n                ")]
      }
    }], null, false, 4057442380)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.sendRemark) + "\n                ")]
      }
    }], null, false, 3366488835)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "80px"
    }
  }, [_vm._v("\n                已合箱\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "padding-right": "40px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsBox.page_sizes,
      "page-size": _vm.paginationsBox.page_size,
      "layout": _vm.paginationsBox.layout,
      "total": _vm.paginationsBox.total,
      "current-page": _vm.paginationsBox.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangeBox,
      "size-change": _vm.handleSizeChangeBox
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 3) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsPerson.page_sizes,
      "page-size": _vm.paginationsPerson.page_size,
      "layout": _vm.paginationsPerson.layout,
      "total": _vm.paginationsPerson.total,
      "current-page": _vm.paginationsPerson.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangePerson,
      "size-change": _vm.handleSizeChangePerson
    }
  }) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "append-to-body": true,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "roleData dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v("人员选择")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("客户/vipCode：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.roleInput),
      callback: function($$v) {
        _vm.roleInput = $$v
      },
      expression: "roleInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchRole
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setRole
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTableRole",
    staticClass: "table",
    attrs: {
      "data": _vm.roleData,
      "border": "",
      "max-height": 580
    },
    on: {
      "select": _vm.selectRoleOnce,
      "selection-change": _vm.selectOptionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vipCode",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "background": "",
      "current-page": _vm.rolePaginations.page_index,
      "page-sizes": _vm.rolePaginations.page_sizes,
      "page-size": _vm.rolePaginations.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.rolePaginations.total
    },
    on: {
      "size-change": _vm.rHandleSizeChange,
      "current-change": _vm.rHandleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelRole()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.certainRole()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("快递单号：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入快递单号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.expressNo),
      callback: function($$v) {
        _vm.expressNo = $$v
      },
      expression: "expressNo"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近签收订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "stripe": "",
      "id": "printTable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "8"
          }
        }, [_c('div', [_vm._v(_vm._s(scope.row.productName))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n         ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "70px",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "sign"
  }, [_vm._v("已签收")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "min-width": "80px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收时间",
      "min-width": "80px",
      "align": "center",
      "prop": "expressTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "sign"
        }, [_vm._v(_vm._s(_vm.toDate(scope.row.expressTime, "yyyy-MM-dd")))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递签收（" + _vm._s(_vm.expressNo.replace(/\s/g, "")) + "）")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.vipCode) + " " + _vm._s(_vm.orderInfo && _vm.orderInfo.userName) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderNo) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.detailList.length > 0 && _vm.orderInfo.detailList[0].productName) + "...等" + _vm._s(_vm.orderInfo && _vm.orderInfo.detailList.length) + "款\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价值："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.predictTotal) + "元\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.expressStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.toDate(_vm.orderInfo && _vm.orderInfo.addTime, "yyyy-MM-dd hh:mm")) + " 录入")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.toDate(_vm.orderInfo && _vm.orderInfo.expressTime, "yyyy-MM-dd hh:mm")) + " 签收")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键确认签收，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 0) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("确认签收")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("确认")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "margin-top": "50px",
      "text-align": "center"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.openOrderDailog()
      }
    }
  }, [_vm._v("补录订单")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.orderDialog.show,
      "title": _vm.orderDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.orderDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.orderDialog.data,
      "rules": _vm.orderDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入运单号",
      "disabled": ""
    },
    model: {
      value: (_vm.expressNo),
      callback: function($$v) {
        _vm.expressNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "expressNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "VIP号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入VIP号",
      "maxlength": "32"
    },
    model: {
      value: (_vm.orderDialog.data.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.orderDialog.data, "vipCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderDialog.data.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "goodType",
      "label": "物流公司："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "物流公司"
    },
    model: {
      value: (_vm.orderDialog.data.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderDialog.data, "expressCompany", $$v)
      },
      expression: "orderDialog.data.expressCompany"
    }
  }, _vm._l((_vm.expressList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.orderDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitOrder()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Box",
    staticStyle: {
      "margin": "30px 50px 0 70px"
    }
  }, [_c('div', {
    staticClass: "Box_left"
  }, [_c('el-form', {
    ref: "RuleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "hide-required-asterisk": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "充值人VIP号 ",
      "prop": "vipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户的VIP号"
    },
    on: {
      "input": _vm.getVipCode
    },
    model: {
      value: (_vm.ruleForm.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "vipCode", $$v)
      },
      expression: "ruleForm.vipCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Box_accountMsg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDate.vipCode !== undefined),
      expression: "userDate.vipCode !== undefined"
    }],
    staticClass: "exit msg"
  }, [_c('div', {
    staticClass: "exit_left"
  }, [_c('div', {
    staticClass: "tag tag1"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag2"
  }, [_vm._v("真实姓名")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag3"
  }, [_vm._v("VIP号")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag4"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag5"
  }, [_vm._v("余额")])]), _vm._v(" "), _c('div', {
    staticClass: "exit_right"
  }, [_c('div', {
    staticClass: "exit_right_text",
    staticStyle: {
      "color": "#ffd700"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.userDate.nickname) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text",
    staticStyle: {
      "color": "#dc143c"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.userDate.realName) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text code"
  }, [_vm._v("\n                " + _vm._s(_vm.userDate.vipCode) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text"
  }, [_vm._v("\n                " + _vm._s(_vm.userDate.mobile) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.userDate.balance) + "\n              ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDate.vipCode == undefined && _vm.getLength() > 0),
      expression: "userDate.vipCode == undefined && getLength() > 0"
    }],
    staticClass: "nexit msg"
  }, [_vm._v("\n            暂无数据\n          ")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款账户",
      "prop": "accountName"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "37%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "收款方式"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.paidSearch.accountId),
      callback: function($$v) {
        _vm.$set(_vm.paidSearch, "accountId", $$v)
      },
      expression: "paidSearch.accountId"
    }
  }, _vm._l((_vm.paidCount), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.accountName,
        "value": item.accountId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实际收费",
      "prop": "actualAmount"
    }
  }, [_c('el-input', {
    staticClass: "money_input",
    attrs: {
      "type": "number",
      "clearable": ""
    },
    on: {
      "input": _vm.rateChange
    },
    model: {
      value: (_vm.ruleForm.actualAmount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "actualAmount", $$v)
      },
      expression: "ruleForm.actualAmount"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "货币类型"
    },
    on: {
      "change": function($event) {
        return _vm.rateChange()
      }
    },
    model: {
      value: (_vm.currency.currencyType),
      callback: function($$v) {
        _vm.$set(_vm.currency, "currencyType", $$v)
      },
      expression: "currency.currencyType"
    }
  }, _vm._l((_vm.currencyTypeSelect), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.currency,
        "value": item.currencyType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "充值金额",
      "prop": "amount"
    }
  }, [_c('el-input', {
    staticClass: "money_input",
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.ruleForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "amount", $$v)
      },
      expression: "ruleForm.amount"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "money_input_out",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.CAD),
      callback: function($$v) {
        _vm.CAD = $$v
      },
      expression: "CAD"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.realName),
      callback: function($$v) {
        _vm.realName = $$v
      },
      expression: "realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4
      },
      "placeholder": "可输入备注内容"
    },
    model: {
      value: (_vm.textarea2),
      callback: function($$v) {
        _vm.textarea2 = $$v
      },
      expression: "textarea2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendBt
    }
  }, [_vm._v(" 提 交 ")])], 1), _vm._v(" "), (_vm.ruleForm.vipCode && _vm.userBalancesPojos) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel_title"
  }, [_vm._v("| 最近五次交易流水(CAD)")]), _vm._v(" "), _c('div', {
    staticClass: "panel_msg"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.userBalancesPojos,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "balanceNo",
      "label": "流水号",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.balanceNo) + "\n            ")])]
      }
    }], null, false, 4031953040)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "60",
      "align": "center",
      "prop": "amount",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.balanceType == 2) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n              -" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n              +" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 3) ? _c('span', [(scope.row.orderNo.indexOf('上') !== -1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n                +" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.orderNo.indexOf('下') !== -1) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n                -" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 4148299291)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "时间",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n            ")])]
      }
    }], null, false, 2161084652)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterBalance",
      "min-width": "80",
      "align": "center",
      "label": "剩余金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.afterBalance) + "\n            ")])]
      }
    }], null, false, 3190025749)
  })], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('header', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("| 筛选条件")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "输出类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.formInline.transactionType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transactionType", $$v)
      },
      expression: "formInline.transactionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "充值",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "支出",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "people",
    attrs: {
      "label": "人员："
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.checkedPerson),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedPerson", $$v)
      },
      expression: "formInline.checkedPerson"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleArr), function(peopleObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": peopleObj.vipCode,
        "value": peopleObj.vipCode
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search-icon",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showUserDialog
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "56px"
    },
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("筛选数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "margin-top": "100px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(_vm.showWhichTable == 1) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n          | 流水页-充值/支出\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [(_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 1,
    attrs: {
      "prop": "balanceNo",
      "label": "充值账单流水号",
      "width": "170",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 2,
    attrs: {
      "prop": "balanceNo",
      "label": "支出账单流水号",
      "width": "170",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 3,
    attrs: {
      "prop": "vipCode",
      "width": "100",
      "label": "客户vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 4,
    attrs: {
      "prop": "vipCode",
      "width": "100",
      "label": "充值人vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "min-width": "140",
      "label": "摘要"
    }
  }), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 5,
    attrs: {
      "prop": "amount",
      "width": "140",
      "align": "center",
      "label": "收取金额（CAD）"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 6,
    attrs: {
      "prop": "amount",
      "align": "center",
      "width": "140",
      "label": "充值金额 CAD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 7,
    attrs: {
      "prop": "accountName",
      "align": "center",
      "width": "200",
      "label": "收款类型"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "width": "100",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "width": "130",
      "align": "center",
      "label": "操作人"
    }
  }), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('el-table-column', {
    key: 8,
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "取货时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n                ")]
      }
    }], null, false, 2559449318)
  }) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('el-table-column', {
    key: 9,
    attrs: {
      "align": "center",
      "label": "时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n                ")]
      }
    }], null, false, 2559449318)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterBalance",
      "width": "200",
      "align": "center",
      "label": "每笔交易之后账号剩余金额（CAD）"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "padding-right": "40px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsPerson.page_sizes,
      "page-size": _vm.paginationsPerson.page_size,
      "layout": _vm.paginationsPerson.layout,
      "total": _vm.paginationsPerson.total,
      "current-page": _vm.paginationsPerson.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangePerson,
      "size-change": _vm.handleSizeChangePerson
    }
  }) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "append-to-body": true,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "roleData dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v("人员选择")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("客户/vipCode：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.roleInput),
      callback: function($$v) {
        _vm.roleInput = $$v
      },
      expression: "roleInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchRole
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setRole
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTableRole",
    staticClass: "table",
    attrs: {
      "data": _vm.roleData,
      "border": "",
      "max-height": 580
    },
    on: {
      "select": _vm.selectRoleOnce,
      "selection-change": _vm.selectOptionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vipCode",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "background": "",
      "current-page": _vm.rolePaginations.page_index,
      "page-sizes": _vm.rolePaginations.page_sizes,
      "page-size": _vm.rolePaginations.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.rolePaginations.total
    },
    on: {
      "size-change": _vm.rHandleSizeChange,
      "current-change": _vm.rHandleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelRole()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.certainRole()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "botmBtnContainer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.print();
      }
    }
  }, [_vm._v("打印本页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.exportWord
    }
  }, [_vm._v("导出word")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "pagecontent"
    }
  }, [_c('table', {
    staticClass: "toptable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', [_c('h1', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.companyInfo.companyName)), _c('br'), _vm._v(" "), _c('samp', [_vm._v("\n\t\t\t\t\t\t\t电话：" + _vm._s(_vm.companyInfo.tel) + "\n\t\t\t\t\t\t\t传真：" + _vm._s(_vm.companyInfo.fax)), _c('br'), _vm._v(" "), (_vm.companyInfo.adress) ? _c('span', [_vm._v("地址：" + _vm._s(_vm.companyInfo.adress))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "midtable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.detailData.productName))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("产品编号")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.productId))]), _vm._v(" "), _c('th', [_vm._v("出发地")]), _vm._v(" "), _c('td', {
    staticClass: "cityName"
  }, [_vm._v(_vm._s(_vm.detailData.startCity))]), _vm._v(" "), _c('th', [_vm._v("旅游天数")]), _vm._v(" "), _c('td', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detailData.travelDay))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("出团日期")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.orderInfo && _vm.orderInfo.startDate || ""))]), _vm._v(" "), _c('th', [_vm._v("出发交通")]), _vm._v(" "), _c('td', {
    staticClass: "cityName",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.goTraffic))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("返程日期")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.orderInfo && _vm.orderInfo.backDay || ""))]), _vm._v(" "), _c('th', [_vm._v("返程交通")]), _vm._v(" "), _c('td', {
    staticClass: "cityName",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.backTraffic))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("集合时间")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.collectionTime ? _vm.detailData.collectionTime : ""))]), _vm._v(" "), _c('th', [_vm._v("集合地点")]), _vm._v(" "), _c('td', {
    staticClass: "cityName"
  }, [_vm._v(_vm._s(_vm.detailData.collectionPlace ? _vm.detailData.collectionPlace : ""))]), _vm._v(" "), _c('th', [_vm._v("单房差价")]), _vm._v(" "), _c('td', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detailData.housePrice ? _vm.detailData.housePrice : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("送团电话")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.giveTel ? _vm.detailData.giveTel : ""))]), _vm._v(" "), _c('th', [_vm._v("送团标志/人")]), _vm._v(" "), _c('td', {
    staticClass: "num",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.giveId ? _vm.detailData.giveId : ""))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("产品亮点")]), _vm._v(" "), _c('td', {
    staticClass: "list",
    attrs: {
      "colspan": "5"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.summary || ''))
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "faq"
  }, [_c('th', [_vm._v("报名须知")]), _vm._v(" "), _c('td', {
    staticClass: "list",
    attrs: {
      "colspan": "5"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.signUp || ''))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("成人价格：")]), _vm._v(" "), _c('b', [_vm._v("¥" + _vm._s(_vm.detailData.adminPrice))]), _vm._v(" "), _c('span', [_vm._v("/人 ")]), _vm._v(" "), _c('span', [_vm._v("小孩价格：")]), _vm._v(" "), _c('b', [_vm._v("¥" + _vm._s(_vm.detailData.childPrice))]), _vm._v(" "), _c('span', [_vm._v("/人 ")])])])])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "routeinfo",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.templateList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v("第" + _vm._s(item.day) + "天")]), _vm._v(" "), _c('td', {
      staticClass: "descript"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.repalce(item.remark || ''))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "food"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.isBreakfast === 0 ? '' : '早餐') + "\n\t\t\t\t\t" + _vm._s(item.isLunch === 0 ? '' : '中餐') + "\n\t\t\t\t\t" + _vm._s(item.isDinner === 0 ? '' : '晚餐') + "\n\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "hotel"
    }, [_vm._v(_vm._s(item.hotelName))])])
  })], 2), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "include",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems) ? _c('th', [_vm._v("\n\t\t\t\t\t包含项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems) ? _c('th', [_vm._v("\n\t\t\t\t\t不包含项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t儿童安排\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t购物安排\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t可选项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan) ? _c('th', [_vm._v("\n\t\t\t\t\t赠送项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.attentions) ? _c('th', [_vm._v("\n\t\t\t\t\t注意事项\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.attentions) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.attentions || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t其他事项\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan || ''))
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "reminder",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.reminder) ? _c('th', [_vm._v("温馨提醒")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.reminder) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.reminder || ''))
    }
  }) : _vm._e()])]), _vm._v("\n\t\t \n\t\t"), _c('table', {
    staticClass: "foot",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("操作人：" + _vm._s(_vm.operatorName) + "   打印日期：" + _vm._s(_vm.detailData.currentDate))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-checkbox', [_vm._v("\n\t\t\t\t\t\t我已阅读行程细则并认可")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t签字：\n\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t日期：\n\t\t\t\t")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("描述")]), _vm._v(" "), _c('th', {
    staticClass: "food"
  }, [_vm._v("三餐")]), _vm._v(" "), _c('th', {
    staticClass: "hotel"
  }, [_vm._v("住宿")])])
}]}

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nofundcontain"
  }, [_c('div', {
    staticClass: "nofund_container"
  }, [_c('h1', [_vm._v("对不起，您访问的页面不存在！")])])])
}]}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "50px"
    }
  }, [_c('el-input', {
    staticClass: "area",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "输入快递单号",
      "clearable": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('div', [_vm._v("单号：" + _vm._s(_vm.keyword))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://wuji-airport.oss-cn-hangzhou.aliyuncs.com/100k0y000000lzekl0155_C_500_280.jpg"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 预约配置")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "calendar"
  }, [_c('div', [_c('el-calendar', {
    staticClass: "calendar_left",
    scopedSlots: _vm._u([{
      key: "dateCell",
      fn: function(ref) {
        var data = ref.data;

        return [_c('div', {
          staticClass: "stag",
          on: {
            "click": function($event) {
              return _vm.showAddDateDia(data.day)
            }
          }
        }, [_c('span', [_vm._v("\n                " + _vm._s(data.day.slice(8)) + "\n              ")]), _vm._v(" "), _vm._l((_vm.appointmentTimeList), function(item, index) {
          return _c('div', {
            key: index,
            class: item.search(data.day) !== -1 ? 'bcolor' : ''
          }, [_c('div', {
            staticClass: "timeText"
          }, [_vm._v("\n                  " + _vm._s((_vm.a =
            item.search(data.day) !== -1 && _vm.getToday(data.day) ?
            "已选" :
            "")) + "\n                  "), _c('div', {
            staticClass: "canChoose",
            staticStyle: {
              "color": "green"
            }
          }, [_vm._v("\n                    " + _vm._s((_vm.a =
            item.search(data.day) == -1 && _vm.getToday(data.day) ?
            "可选" :
            "")) + "\n                  ")])])])
        })], 2)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('el-calendar', {
    staticClass: "calendar_right",
    scopedSlots: _vm._u([{
      key: "dateCell",
      fn: function(ref) {
        var data = ref.data;

        return [_c('div', [_vm._v("\n              " + _vm._s(data.day.slice(8)) + "\n            ")]), _vm._v(" "), _c('div', _vm._l((_vm.orderList), function(item) {
          return _c('div', {
            key: item.appointmentTimeId
          }, [_c('div', {
            staticClass: "timeText2"
          }, [_vm._v("\n                  " + _vm._s(data.day == _vm.changeDate(item) &&
            item.status == 2 &&
            !_vm.getToday(data.day) ?
            "已选" :
            "") + "\n                ")])])
        }), 0)]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [(_vm.roleId == 1) ? _c('div', {
    staticClass: "selecT"
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px",
      "margin": "0px auto 0px auto"
    },
    attrs: {
      "placeholder": "派送地址"
    },
    on: {
      "change": function($event) {
        return _vm.addressChange()
      }
    },
    model: {
      value: (_vm.deliveryDate.addressId),
      callback: function($$v) {
        _vm.$set(_vm.deliveryDate, "addressId", $$v)
      },
      expression: "deliveryDate.addressId"
    }
  }, _vm._l((_vm.addressList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-alert', {
    staticStyle: {
      "width": "26%",
      "margin": "10px 0 0px auto"
    },
    attrs: {
      "title": "添加或修改数据后，需点击“修改保存”按钮，否则数据将不会展示到前台",
      "type": "warning",
      "closable": false,
      "effect": "dark",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table_El"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "appointmentTime",
      "align": "center",
      "width": "150px",
      "label": "已选日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.changeDate(scope.row)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "500px",
      "label": "预约时间段配置",
      "align": "periodPojoList"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('el-button', {
          staticClass: "btTime",
          attrs: {
            "icon": "el-icon-circle-plus"
          },
          on: {
            "click": function($event) {
              return _vm.showSelTimeDia(scope.row)
            }
          }
        }, [_vm._v("\n                  添加时间\n                ")]), _vm._v(" "), _vm._l((scope.row.periodPojoList), function(item, index) {
          return _c('el-tag', {
            key: item.id,
            attrs: {
              "closable": item.appointmentCount == 0,
              "type": "success"
            },
            on: {
              "close": function($event) {
                return _vm.showDeleteTimeDia(scope.row, index)
              }
            }
          }, [_vm._v("\n                  " + _vm._s(item.period) + "\n                ")])
        })], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "maxCount",
      "align": "center",
      "label": "预约总人数配置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          attrs: {
            "id": "bookNum"
          }
        }, [_vm._v(_vm._s(scope.row.maxCount) + "人")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "useCount",
      "align": "center",
      "label": "已预约人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "5",
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.sendData(scope.row)
            }
          }
        }, [_vm._v("\n                修改保存\n              ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "disabled": scope.row.useCount !== 0
          },
          on: {
            "click": function($event) {
              return _vm.cancelData(scope.row)
            }
          }
        }, [_vm._v("\n                取消日期\n              ")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.addDateDialog,
      "width": "20%",
      "center": "",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDateDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.addDateDialog = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.addTime()
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.chooseTime),
      callback: function($$v) {
        _vm.chooseTime = $$v
      },
      expression: "chooseTime"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("添加 ' " + _vm._s(_vm.chooseTime) + "' 新日期？")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.addTimeDialog,
      "width": "26%",
      "center": "",
      "modal-append-to-body": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.addTimeDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.addTimeDialog = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "disabled": _vm.selTime.endTime == '' || _vm.bookPerNum == ''
          },
          on: {
            "click": function($event) {
              return _vm.addTimeQuantum()
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.selTime),
      callback: function($$v) {
        _vm.selTime = $$v
      },
      expression: "selTime"
    }
  }, [_c('div', [_c('el-time-picker', {
    attrs: {
      "is-range": "",
      "format": "HH:mm",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    on: {
      "change": _vm.newTimeChange
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "80%",
      "margin-top": "20px"
    },
    attrs: {
      "placeholder": "可预约人数",
      "autofocus": ""
    },
    model: {
      value: (_vm.bookPerNum),
      callback: function($$v) {
        _vm.bookPerNum = $$v
      },
      expression: "bookPerNum"
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提 示",
      "visible": _vm.deleteTimeDialog,
      "width": "30%",
      "close": _vm.closeDeleteTimeDia,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.deleteTimeDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.deleteTimeDialog = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.deleteTimeDiaComfirm
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('span', {
    staticClass: "diatext"
  }, [_vm._v("您确定删除该时间段吗？此操作将影响前台展示")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "t_left"
  }, [_vm._v("请配置可预约的时间：")]), _vm._v(" "), _c('span', {
    staticClass: "t_right"
  }, [_vm._v("历史预约时间：")])])
}]}

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fillcontain"
  }, [_c('div', {
    staticClass: "navCalss",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("| 货物价格")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-flexRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openAdd()
      }
    }
  }, [_vm._v("新增货物类型")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": "",
      "size": "medium"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodName",
      "label": "货物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格系数",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.price) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "是否计算首重",
      "min-width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.firstWeight) ? _c('span', [_vm._v(" 是 ")]) : _c('span', [_vm._v(" 否 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operatorTime",
      "label": "操作时间",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onDel(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("移除")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialog.title,
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBar",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.priceGoods.netBarForm,
      "rules": _vm.priceGoods.form_rules,
      "label-width": _vm.priceGoods.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "货物类型:",
      "prop": "goodType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请选择货物类型",
      "filterable": ""
    },
    model: {
      value: (_vm.priceGoods.netBarForm.goodType),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "goodType", $$v)
      },
      expression: "priceGoods.netBarForm.goodType"
    }
  }, _vm._l((_vm.priceGoods.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "goodName",
      "label": "类型名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入类型名称"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.goodName),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "goodName", $$v)
      },
      expression: "priceGoods.netBarForm.goodName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格系数:",
      "prop": "price"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入价格系数"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.price),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "price", $$v)
      },
      expression: "priceGoods.netBarForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "计算首重:",
      "prop": "firstWeight"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.priceGoods.netBarForm.firstWeight),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "firstWeight", $$v)
      },
      expression: "priceGoods.netBarForm.firstWeight"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入备注(选填)"
    },
    model: {
      value: (_vm.priceGoods.netBarForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.priceGoods.netBarForm, "remark", $$v)
      },
      expression: "priceGoods.netBarForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [(_vm.showOnsub) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbit()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: _vm.showOnsub ? '' : 'margiLeft',
    on: {
      "click": function($event) {
        _vm.dialog.show = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定删除该货物类型信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteGoods(_vm.galObj)
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('el-container', [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知内容：",
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "type": "textarea",
      "maxlength": "96",
      "rows": "5",
      "cols": "20",
      "autoFocus": "",
      "placeholder": "不超过96个字....."
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片描述："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "list-type": "picture-card",
      "http-request": _vm.handleLicenseImgFileB,
      "show-file-list": true,
      "file-list": _vm.fileList,
      "limit": 3,
      "auto-upload": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-remove": _vm.handleRemove,
      "on-preview": _vm.handlePictureCardPreview
    }
  }, [_c('i', {
    staticClass: "el-icon-plus",
    attrs: {
      "slot": "default"
    },
    slot: "default"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理人："
    }
  }, [_c('el-select', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.operator),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "operator", $$v)
      },
      expression: "ruleForm.operator"
    }
  }, _vm._l((_vm.operatorArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('el-button', {
    staticClass: "cancel"
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提交")])], 1), _c('br')], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Box",
    staticStyle: {
      "margin": "30px 50px 0 70px"
    }
  }, [_c('div', {
    staticClass: "Box_left"
  }, [_c('el-form', {
    ref: "RuleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "hide-required-asterisk": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "充值人VIP号 ",
      "prop": "vipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户的VIP号"
    },
    on: {
      "input": _vm.getVipCode
    },
    model: {
      value: (_vm.ruleForm.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "vipCode", $$v)
      },
      expression: "ruleForm.vipCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Box_accountMsg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDate.vipCode !== undefined),
      expression: "userDate.vipCode!==undefined"
    }],
    staticClass: "exit msg"
  }, [_c('div', {
    staticClass: "exit_left"
  }, [_c('div', {
    staticClass: "tag tag1"
  }, [_vm._v("\n              用户名\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag3"
  }, [_vm._v("\n              VIP号\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tag tag4"
  }, [_vm._v("\n              手机号\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "exit_right"
  }, [_c('div', {
    staticClass: "exit_right_text",
    staticStyle: {
      "color": "#FFD700"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.userDate.nickname) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text code"
  }, [_vm._v("\n              " + _vm._s(_vm.userDate.vipCode) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "exit_right_text"
  }, [_vm._v("\n              " + _vm._s(_vm.userDate.mobile) + "\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDate.vipCode == undefined && _vm.getLength() > 0),
      expression: "userDate.vipCode==undefined&&getLength()>0"
    }],
    staticClass: "nexit msg"
  }, [_vm._v("\n        暂无数据\n        ")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "现有余额"
    }
  }, [_c('el-input', {
    staticClass: "money_input",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.userDate.balance),
      callback: function($$v) {
        _vm.$set(_vm.userDate, "balance", $$v)
      },
      expression: "userDate.balance"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "money_input_out",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.CAD),
      callback: function($$v) {
        _vm.CAD = $$v
      },
      expression: "CAD"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调账",
      "prop": "amount"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "选择调账类型"
    },
    on: {
      "change": function($event) {
        return _vm.balanceChange()
      }
    },
    model: {
      value: (_vm.search.adjustType),
      callback: function($$v) {
        _vm.$set(_vm.search, "adjustType", $$v)
      },
      expression: "search.adjustType"
    }
  }, _vm._l((_vm.adjustTypeSelect), function(item) {
    return _c('el-option', {
      key: item.adjustType,
      attrs: {
        "label": item.adjustName,
        "value": item.adjustType
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticClass: "money_Adjust",
    attrs: {
      "disabled": _vm.search.adjustType == null,
      "type": "number",
      "clearable": "",
      "placeholder": "请输入要调账的金额"
    },
    on: {
      "input": _vm.balanceChange
    },
    model: {
      value: (_vm.ruleForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "amount", $$v)
      },
      expression: "ruleForm.amount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_vm._v("\n            调账后账户余额将变为:\n            "), _c('el-input', {
    staticClass: "money_change",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.changedB),
      callback: function($$v) {
        _vm.changedB = $$v
      },
      expression: "changedB"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "money_input_out",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.CAD),
      callback: function($$v) {
        _vm.CAD = $$v
      },
      expression: "CAD"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.realName),
      callback: function($$v) {
        _vm.realName = $$v
      },
      expression: "realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4
      },
      "placeholder": "可输入备注内容"
    },
    model: {
      value: (_vm.textarea2),
      callback: function($$v) {
        _vm.textarea2 = $$v
      },
      expression: "textarea2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitBt
    }
  }, [_vm._v("\n        提 交\n      ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    staticStyle: {
      "background": "red",
      "height": "100%",
      "position": "fixed",
      "z-index": "2000"
    }
  }, [_c('el-row', {
    staticClass: "tac menu_page"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "default-active": "1-1",
      "unique-opened": true,
      "background-color": "#324057",
      "collapse": _vm.isCollapse
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, _vm._l((_vm.menuList), function(item, index) {
    return _c('el-submenu', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.Roleid == item.msg || _vm.Roleid == item.msg2),
        expression: "Roleid==item.msg||Roleid==item.msg2"
      }],
      key: index,
      attrs: {
        "index": (index + 1).toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: 'fa fa-margin ' + item.actionPic,
      staticStyle: {
        "display": "inline-block"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item.permissionName))])]), _vm._v(" "), _c('el-menu-item-group', _vm._l((item.child), function(citem, cindex) {
      return _c('router-link', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (citem.cmsg == _vm.Roleid || citem.cmsg2 == _vm.Roleid),
          expression: "citem.cmsg==Roleid||citem.cmsg2==Roleid"
        }],
        key: cindex,
        attrs: {
          "to": citem.pmUrl
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": (index + 2).toString() + '-' + (cindex + 1).toString()
        }
      }, [_c('span', {
        staticClass: "font",
        staticStyle: {
          "color": "#fff"
        }
      }, [_vm._v(_vm._s(citem.permissionName) + "\n                ")])])], 1)
    }), 1)], 2)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.addressList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "goodType",
      "label": "货运类型",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.goodType(scope.row.goodType)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "国内仓地址",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.contacts) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.tel) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "goodType",
      "label": "货物类型："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    model: {
      value: (_vm.editDialog.data.goodType),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "goodType", $$v)
      },
      expression: "editDialog.data.goodType"
    }
  }, _vm._l((_vm.editDialog.goodTypeList), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "contacts",
      "label": "负责人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人姓名",
      "minlength": "64"
    },
    model: {
      value: (_vm.editDialog.data.contacts),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "contacts", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "负责人电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人电话",
      "minlength": "128"
    },
    model: {
      value: (_vm.editDialog.data.tel),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "国内仓地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入国内仓地址：",
      "minlength": "300"
    },
    model: {
      value: (_vm.editDialog.data.address),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.address"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.RouterState) ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内待入库",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内入库",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已合箱",
      "name": "6"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内出库",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心出库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分舵入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "客户签收",
      "name": "five"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "six"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待补录",
      "name": "seven"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "monewt"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "运单号"
    },
    on: {
      "input": function($event) {
        return _vm.inputOrder(_vm.orderNOA)
      }
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户名/vip号"
    },
    on: {
      "input": function($event) {
        return _vm.realDate(_vm.orderNOC)
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [(_vm.activeName !== 'second') ? _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "派送点"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.addressId),
      callback: function($$v) {
        _vm.$set(_vm.search, "addressId", $$v)
      },
      expression: "search.addressId"
    }
  }, _vm._l((_vm.deliveryAddressList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "箱号"
    },
    on: {
      "input": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "是否发货单"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.isOrderSend),
      callback: function($$v) {
        _vm.$set(_vm.search, "isOrderSend", $$v)
      },
      expression: "search.isOrderSend"
    }
  }, _vm._l((_vm.sendList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "search_lbl"
  }, [_vm._v("下单时间：")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.value1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), (_vm.activeName == 'four') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("出库时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-date-picker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate2(_vm.value2)
      }
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("国内入库时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate4(_vm.value4)
      }
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("结算时间：")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate3(_vm.value3)
      }
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getOrderList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.activeName != 'first') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportToSendOrderLook();
        _vm.getNowData();
      }
    }
  }, [_vm._v("预览客户发货单")]) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "16px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToSendOrder()
      }
    }
  }, [_vm._v("批量生成发货单")]) : _vm._e()], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "height": "380",
      "stripe": "",
      "row-key": "orderId"
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select": _vm.selectChange,
      "row-click": _vm.handleRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "selectable": _vm.selectable,
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderSend) ? _c('span', {
          staticClass: "tag tag2"
        }, [_vm._v("已生成")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.productName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.deliveryTitle) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n          "), (scope.row.status == 1 || scope.row.status == 2) ? _c('div', {
          staticClass: "sign"
        }, [(scope.row.expressTime) ? _c('div', [_vm._v("\n              国内已签收(" + _vm._s(_vm.toDate(scope.row.expressTime, "yyyy-MM-dd")) + ")\n            ")]) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "115px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1 && scope.row.expressStatus == 0) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待签收\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1 && scope.row.expressStatus == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待入库\n          ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            已入库\n          ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已出库\n          ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已结单\n          ")]) : (scope.row.status == 5) ? _c('div', {
          staticStyle: {
            "color": "#eea381"
          }
        }, [_vm._v("\n            待补录\n          ")]) : (scope.row.status == 6) ? _c('div', {
          staticStyle: {
            "color": "#c0e781"
          }
        }, [_vm._v("\n            已合箱\n          ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n            已取消\n          ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （中心仓）已入库\n          ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            （中心仓）已出库\n          ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （派送）已入库\n          ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#008b8b"
          }
        }, [_vm._v("\n            可预约\n          ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#800080"
          }
        }, [_vm._v("\n            已预约\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收人",
      "width": "100px",
      "align": "center",
      "prop": "expressName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "尺寸",
      "prop": "measure",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积",
      "prop": "productVolume",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量",
      "prop": "productWeight",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "100px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "补录时间",
      "min-width": "170px",
      "align": "center",
      "prop": "suppleTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.suppleTime ? _vm.changeToTime(scope.row.suppleTime) : "") + "\n        ")]
      }
    }])
  }), _vm._v(" "), (_vm.activeName == 'third') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "入库时间",
      "min-width": "90px",
      "align": "center",
      "prop": "storeDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'four') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "出库时间",
      "min-width": "90px",
      "align": "center",
      "prop": "deliveryDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "结算时间",
      "min-width": "90px",
      "align": "center",
      "prop": "statementDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '7') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "中心仓入库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "statementDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 1)) + "\n        ")]
      }
    }], null, false, 3998975071)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '8') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "中心仓出库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "statementDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 2)) + "\n        ")]
      }
    }], null, false, 2433945084)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '9') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "派送入库时间",
      "min-width": "110px",
      "align": "center",
      "prop": "storeTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.getTimes(scope.row, 3)) + "\n        ")]
      }
    }], null, false, 4276116637)
  }) : _vm._e(), _vm._v(" "), (
    _vm.activeName == 'four' ||
    _vm.activeName == '7' ||
    _vm.activeName == '8' ||
    _vm.activeName == '9'
  ) ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "所在箱",
      "min-width": "90px",
      "align": "center",
      "prop": "boxNumber"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == 'five' || _vm.activeName == '9') ? _c('el-table-column', {
    key: Math.random(),
    attrs: {
      "label": "货柜号",
      "min-width": "90px",
      "align": "center",
      "prop": "containerName"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "batchNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "90px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo, '2', scope.row)
            }
          }
        }, [_vm._v("入库")]) : _vm._e(), _vm._v(" "), (scope.row.status == 5) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.addOrderProductDialog(scope.row)
            }
          }
        }, [_vm._v("补录")]) : _vm._e(), _vm._v(" "), (scope.row.status != 5) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo)
            }
          }
        }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), [(_vm.activeName == 'third') ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.delOrder(scope.row.orderNo)
            }
          }
        }, [_vm._v("取消")]) : _vm._e()]]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == 'third') ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openBoxHanlder()
      }
    }
  }, [_vm._v("合箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openExcelBoxDialog()
      }
    }
  }, [_vm._v("Excel批量合箱")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showE,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showE", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您是否确认结单？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmD()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showE = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showG,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showG", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认改变该合箱状态嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmC()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showG = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showF", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认删除该图片嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmB()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showF = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showD,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "800px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showD", $event)
      }
    }
  }, [_c('div', [_c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.orderInfo,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderNo) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.orderInfo.addDate) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.orderInfo.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "expressCompany", $$v)
      },
      expression: "orderInfo.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1) : _c('div', [_vm._v("\n                  " + _vm._s(_vm.orderInfo.expressCompany) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.orderInfo.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "expressNo", $$v)
      },
      expression: "orderInfo.expressNo"
    }
  })], 1) : _c('div', [_vm._v("\n                  " + _vm._s(_vm.orderInfo.expressNo) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                  待入库\n                ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                  已入库\n                ")]) : _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v(" 已出库 ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    model: {
      value: (_vm.orderInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "remark", $$v)
      },
      expression: "orderInfo.remark"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("包裹重量KG：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productWeight),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productWeight", $$v)
      },
      expression: "orderInfo.productWeight"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("长CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productLong),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productLong", $$v)
      },
      expression: "orderInfo.productLong"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("宽CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productWidth),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productWidth", $$v)
      },
      expression: "orderInfo.productWidth"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lbl_title lbl_margin"
  }, [_vm._v("高CM：")]), _c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    on: {
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.productHeight),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "productHeight", $$v)
      },
      expression: "orderInfo.productHeight"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1 lineHeight"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("货物类型：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "220px",
      "margin-left": "18px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "float": "left",
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择运输方式"
    },
    on: {
      "change": _vm.seleTransType
    },
    model: {
      value: (_vm.checkedTransType),
      callback: function($$v) {
        _vm.checkedTransType = $$v
      },
      expression: "checkedTransType"
    }
  }, _vm._l((_vm.transTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "120px",
      "margin": "-46px 0 0 130px"
    },
    attrs: {
      "placeholder": "物品类型"
    },
    on: {
      "change": _vm.seleTransGoods
    },
    model: {
      value: (_vm.checkedgoodsType),
      callback: function($$v) {
        _vm.checkedgoodsType = $$v
      },
      expression: "checkedgoodsType"
    }
  }, _vm._l((_vm.transGoodSelectArr), function(item) {
    return _c('el-option', {
      key: item.goodId,
      attrs: {
        "label": item.goodName,
        "value": item.goodId + ',' + item.price + ',' + item.firstWeight
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px",
      "margin-left": "48px"
    }
  }, [_vm._v("\n                价格系数：" + _vm._s(_vm.priceGoodsIdCopy.price) + "\n              ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("\n                首重计算："), (_vm.priceGoodsIdCopy.firstWeight == 1) ? _c('span', [_vm._v("是")]) : _c('span', [_vm._v("否")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-felxz"
  }, [_c('div', {
    staticClass: "wrl-left"
  }, [_c('div', {
    staticClass: "wrl-felxz1"
  }, [_c('div', {
    staticClass: "wrl-leftig",
    class: _vm.weiTotal &&
      _vm.weiTotal > 0 &&
      Number(_vm.weiTotal) >= Number(_vm.volTotal) ?
      'backRed' :
      ''
  }, [_vm._v("\n                重量费用：CAD " + _vm._s(_vm.weiTotal) + "\n              ")]), _vm._v(" "), _c('div', {
    class: _vm.volTotal &&
      _vm.volTotal > 0 &&
      Number(_vm.volTotal) > Number(_vm.weiTotal) ?
      'backRed' :
      '',
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                体积费用：CAD " + _vm._s(_vm.volTotal) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList",
    staticStyle: {
      "margin": "40px 30px"
    }
  }, [_c('div', {
    staticClass: "wlr-header"
  }, [_c('div', {
    staticClass: "wlr-start"
  }, [_c('div', [_vm._v("商品清单")])]), _vm._v(" "), _c('div', [_vm._v("商品入库数据(每件商品数据)")]), _vm._v(" "), _c('div', {
    staticClass: "addProdauc"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _c('div', _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n                  " + _vm._s(i + 1) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [(_vm.orderInfo.status == 2) ? _c('div', {
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-bottom": "18px"
      },
      attrs: {
        "prop": 'productList.' + i + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "340px",
        "height": "30px"
      },
      model: {
        value: (val.productName),
        callback: function($$v) {
          _vm.$set(val, "productName", $$v)
        },
        expression: "val.productName"
      }
    })], 1)], 1) : _c('div', {
      staticClass: "ellipsisB",
      staticStyle: {
        "-webkit-box-orient": "vertical",
        "width": "370px"
      }
    }, [_vm._v("\n                    " + _vm._s(val.productName) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [(_vm.orderInfo.status == 2) ? _c('div', [_c('el-form-item', [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      attrs: {
        "disabled": ""
      },
      model: {
        value: (val.productNumB),
        callback: function($$v) {
          _vm.$set(val, "productNumB", $$v)
        },
        expression: "val.productNumB"
      }
    })], 1)], 1) : _c('div', [_vm._v("\n                        " + _vm._s(val.productNumB) + "\n                        件\n                      ")])]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                      " + _vm._s(val.productRemark) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx44",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "wrl-felx5 inpout",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticClass: "space"
    }, [_c('div', [_vm._v("入库数量")]), _vm._v(" "), _c('div', {
      staticClass: "inpoutTop"
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'productList.' + i + '.productNum',
        "rules": [{
          required: true,
          message: '入库数量不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      model: {
        value: (val.productNum),
        callback: function($$v) {
          _vm.$set(val, "productNum", $$v)
        },
        expression: "val.productNum"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "space"
    }, [_c('div', [_vm._v("货架")]), _vm._v(" "), _c('div', {
      staticClass: "inpoutTop"
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'productList.' + i + '.shelves'
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "70px",
        "height": "30px"
      },
      on: {
        "input": function($event) {
          return _vm.shelver(i, val, val.shelves)
        }
      },
      model: {
        value: (val.shelves),
        callback: function($$v) {
          _vm.$set(val, "shelves", $$v)
        },
        expression: "val.shelves"
      }
    })], 1)], 1)])])]), _vm._v(" "), _vm._l((val.productImgList), function(value, index) {
      return _c('div', {
        key: index,
        staticClass: "wrl-felx6"
      }, [_c('el-upload', {
        staticClass: "upload-demo",
        attrs: {
          "action": "",
          "headers": _vm.headers,
          "http-request": _vm.handleLicenseImgFile,
          "show-file-list": false,
          "before-upload": _vm.beforeAvatarUpload
        }
      }, [(value.productImg) ? _c('div', {
        staticClass: "pta",
        on: {
          "click": function($event) {
            return _vm.unpload(i, index)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-delete childe",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.del(i, index)
          }
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "avatar",
        class: index > 0 ? 'spaceLeft' : '',
        attrs: {
          "src": value.productImg
        }
      })]) : _vm._e()])], 1)
    }), _vm._v(" "), (val.productImgList.length < 2) ? _c('div', {
      staticClass: "wrl-felx6",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "action": "",
        "headers": _vm.headers,
        "http-request": _vm.handleLicenseImgFileB,
        "show-file-list": false,
        "before-upload": _vm.beforeAvatarUploadB
      }
    }, [_c('div', {
      staticClass: "backgroundA",
      staticStyle: {
        "width": "48px",
        "height": "48px"
      },
      on: {
        "click": function($event) {
          return _vm.unploadB(i)
        }
      }
    }, [_vm._v("\n                      上传\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (val.productImgList.length == 0) ? _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "48px",
        "height": "48px"
      }
    })]) : _vm._e()], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrl-flex56"
  }, [_c('div', [_c('span', [_vm._v("折扣比率：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "input": function($event) {
        return _vm.changeDiscount(_vm.orderInfo.discount)
      },
      "blur": function($event) {
        return _vm.getComputer()
      }
    },
    model: {
      value: (_vm.orderInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "discount", $$v)
      },
      expression: "orderInfo.discount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("优惠前价格：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("\n              CAD " + _vm._s(_vm._f("priceFilt")(_vm.total)) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#ec808d",
      "margin-left": "20px"
    }
  }, [_vm._v("\n            优惠后价格： CAD " + _vm._s(_vm._f("priceFilt")(_vm.discountTotal)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-flex57"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsubmitB()
      }
    }
  }, [_vm._v("提交")])], 1)])])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": "",
      "title": "修改最后费用值"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 0 10px 0"
    }
  }, [_vm._v("您确认修改嘛？")]), _vm._v(" "), _c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.cahnBlur(_vm.orderInfoC)
      }
    },
    model: {
      value: (_vm.orderInfoC),
      callback: function($$v) {
        _vm.orderInfoC = $$v
      },
      expression: "orderInfoC"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirm(_vm.orderInfoC)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您是否将订单出库吗？该操作不可逆")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsubmit()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showB = false;
        _vm.dialog.show = false;
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }, [_c('el-row', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.instorage(_vm.orderInfo)
      }
    }
  }, [_vm._v("入库")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.delOrderDiolag(_vm.orderInfo)
      }
    }
  }, [_vm._v("取消订单")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editOrder(_vm.orderInfo)
      }
    }
  }, [_vm._v("编辑订单")])], 1) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.instorage(_vm.orderInfo)
      }
    }
  }, [_vm._v("重新入库")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editOrder(_vm.orderInfo)
      }
    }
  }, [_vm._v("编辑订单")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressNo))]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("商品价值：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.predictTotal))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n            待入库\n          ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已出库\n          ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已结单\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [(_vm.orderInfo.isBox == 1) ? _c('div', [_c('span', [_vm._v("合箱")])]) : _c('div', [_c('span', {
    staticClass: "red",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("不合箱")])])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [(_vm.orderInfo.status != 4) ? _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.getorderNoB(_vm.orderInfo.orderNo, _vm.orderInfo.isBox)
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.orderInfo.suppleTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("补录时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.suppleTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.storeTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 3) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.centerEnterTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("中心入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.centerEnterTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.centerOutTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("中心出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.centerOutTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.deliveryEnterTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("派送入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryEnterTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.statementTime) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("派送出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.statementTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际尺寸：")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.orderInfo.productSize) + " CBM\n          "), _c('span', [_vm._v("（" + _vm._s(_vm.orderInfo.productLong) + "CM*" + _vm._s(_vm.orderInfo.productWidth) + "CM*" + _vm._s(_vm.orderInfo.productHeight) + "CM）")])])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际重量：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productWeight) + " KG")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', [_vm._v("最后费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [(_vm.orderInfo.status == 2) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.orderInfo)
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单备注：")]), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.remark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.orderInfo.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.userRemark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status == 1) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "ellipsisBB",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(val.productName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(val.productNum) + "件")]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productRemark) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [(val.shelves) ? _c('div', {
      staticStyle: {
        "color": "#ec808d"
      }
    }, [_vm._v("\n                货架: " + _vm._s(val.shelves) + "\n              ")]) : _vm._e()]), _vm._v(" "), (val.productImg) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImg)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImg,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })]), _vm._v(" "), (val.productImgB) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImgB)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImgB,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })])])])
  })], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showH,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "title": "编辑订单",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showH", $event)
      }
    }
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "label-width": "55px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.order.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressCompany", $$v)
      },
      expression: "order.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.order.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressNo", $$v)
      },
      expression: "order.expressNo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("商品价值：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "整单商品价值,单位元"
    },
    on: {
      "blur": function($event) {
        return _vm.checkOrder(_vm.order.predictTotal)
      }
    },
    model: {
      value: (_vm.order.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.order, "predictTotal", $$v)
      },
      expression: "order.predictTotal"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n              待入库\n            ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n              已入库\n            ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n              已出库\n            ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n              已结单\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入合箱状态"
    },
    model: {
      value: (_vm.order.isBox),
      callback: function($$v) {
        _vm.$set(_vm.order, "isBox", $$v)
      },
      expression: "order.isBox"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.order.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.order.userRemark))]) : _c('div', [_vm._v("无")])]), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', {
    staticClass: "flex22"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_vm._v("\n                添加商品")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.order.detailList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n                " + _vm._s(i + 1) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + i + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (val.productName),
        callback: function($$v) {
          _vm.$set(val, "productName", $$v)
        },
        expression: "val.productName"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "-15px"
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + i + '.productNum',
        "rules": [{
            required: true,
            message: '商品数量不能为空',
            trigger: 'blur',
          },
          {
            type: 'number',
            message: '商品数量必须为数字值'
          } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "商品数量"
      },
      model: {
        value: (val.productNum),
        callback: function($$v) {
          _vm.$set(val, "productNum", _vm._n($$v))
        },
        expression: "val.productNum"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDialog(i)
        }
      }
    }, [_vm._v("删除")])], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitOrder()
      }
    }
  }, [_vm._v("提交")])], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItemB(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定取消该订单嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.delOrder(_vm.delOrderNo)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showCC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "540px",
      "title": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showCC", $event)
      }
    }
  }, [_c('div', {
    staticClass: "showFontSize"
  }, [_vm._v("批量生成发货单")]), _vm._v(" "), _c('div', {
    staticClass: "lineHeightTop"
  }), _vm._v(" "), _c('div', [_c('div', [_c('span', {
    staticStyle: {
      "width": "100px",
      "text-align": "right",
      "display": "inline-block"
    }
  }, [_vm._v("批量发货时间：")]), _vm._v(" "), _c('span', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择有效起始日期时间"
    },
    model: {
      value: (_vm.newDate),
      callback: function($$v) {
        _vm.newDate = $$v
      },
      expression: "newDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "100px",
      "text-align": "right",
      "display": "inline-block"
    }
  }, [_vm._v("发货单批次：")]), _vm._v(" "), _c('span', [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.sendDialog.remark),
      callback: function($$v) {
        _vm.$set(_vm.sendDialog, "remark", $$v)
      },
      expression: "sendDialog.remark"
    }
  })], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToOrder(_vm.newDate)
      }
    }
  }, [_vm._v("批量生成发货单")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showCC = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showD,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "540px",
      "title": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showD", $event)
      }
    }
  }, [_c('div', {
    staticClass: "showFontSize"
  }, [_vm._v("预览客户发货单")]), _vm._v(" "), _c('div', {
    staticClass: "lineHeightTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "showFlex"
  }, [_c('div', [_vm._v("客户VIP编号：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入客户VIP编号"
    },
    model: {
      value: (_vm.userIdCode),
      callback: function($$v) {
        _vm.userIdCode = $$v
      },
      expression: "userIdCode"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToOrderLook(_vm.userIdCode)
      }
    }
  }, [_vm._v("预览客户发货单")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.showD = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showF", $event)
      }
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "50px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "min-width": "100px",
      "align": "center"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.orderAddDialog.show,
      "title": _vm.orderAddDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.orderAddDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "tab_address"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.orderAddDialog.activeName),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog, "activeName", $$v)
      },
      expression: "orderAddDialog.activeName"
    }
  }, _vm._l((_vm.storeList), function(item) {
    return _c('el-tab-pane', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "name": item.goodType
      }
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.contacts) + "," + _vm._s(item.tel))])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order_base"
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.orderAddDialog.data,
      "rules": _vm.orderAddDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "快递单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "type": "text",
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.orderAddDialog.data.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "expressNo", $$v)
      },
      expression: "orderAddDialog.data.expressNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "expressCompany",
      "label": "快递公司："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.orderAddDialog.data.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "expressCompany", $$v)
      },
      expression: "orderAddDialog.data.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价值："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "预估价值"
    },
    model: {
      value: (_vm.orderAddDialog.data.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "predictTotal", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderAddDialog.data.predictTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.orderAddDialog.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.orderAddDialog.data, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderAddDialog.data.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("补录商品清单")]), _vm._v(" "), _c('el-button', {
    staticClass: "order_add",
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.addOrderProduct()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加商品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, _vm._l((_vm.orderAddDialog.data.productList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "p_item"
    }, [_c('span', {
      staticClass: "p_num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "p_name"
    }, [_c('el-input', {
      staticClass: "p_input",
      attrs: {
        "type": "text",
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (
          _vm.orderAddDialog.data.productList[index].productName
        ),
        callback: function($$v) {
          _vm.$set(_vm.orderAddDialog.data.productList[index], "productName", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "\n                  orderAddDialog.data.productList[index].productName\n                "
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "p_input",
      attrs: {
        "type": "text",
        "placeholder": "请输入商品数量"
      },
      model: {
        value: (
          _vm.orderAddDialog.data.productList[index].productNum
        ),
        callback: function($$v) {
          _vm.$set(_vm.orderAddDialog.data.productList[index], "productNum", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "\n                  orderAddDialog.data.productList[index].productNum\n                "
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('div', {
      staticClass: "p_del",
      on: {
        "click": function($event) {
          return _vm.deleteOrderProduct(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.supplementOrder()
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.orderAddDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.boxDialog.show,
      "title": _vm.boxDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.boxDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.multipleSelection,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.productName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n              " + _vm._s(scope.row.goodName) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.userName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.expressNo) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.deliveryTitle) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.submitBox
    },
    slot: "reference"
  }, [_vm._v("确认合箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.boxDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.mianDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "close": "closeMianDialog()",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.mianDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您已合箱完成，可选择：")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mianHandler(1)
      }
    }
  }, [_vm._v("打印面单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.mianHandler(2)
      }
    }
  }, [_vm._v("合箱列表")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.excelBoxDialog.show,
      "title": "Excel批量合箱",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.excelBoxDialog, "show", $event)
      },
      "closed": _vm.handleExcelDialogClosed
    }
  }, [_c('div', {
    staticClass: "excel-upload-container"
  }, [_c('div', {
    staticClass: "upload-area"
  }, [_c('el-upload', {
    ref: "excelUpload",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "before-upload": _vm.beforeUpload,
      "on-change": _vm.handleFileChange,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "file-list": _vm.excelBoxDialog.fileList,
      "auto-upload": false,
      "accept": ".xlsx,.xls"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将Excel文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_c('div', [_vm._v("只能上传Excel文件(.xlsx/.xls)，且不超过10MB")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#909399",
      "font-size": "12px"
    }
  }, [_vm._v("\n              Excel文件格式要求：第一列为运单号，系统将根据运单号自动分组合箱\n            ")])])])], 1), _vm._v(" "), (_vm.excelBoxDialog.uploadProgress.show) ? _c('div', {
    staticClass: "upload-progress"
  }, [_c('el-progress', {
    attrs: {
      "percentage": _vm.excelBoxDialog.uploadProgress.percentage,
      "status": _vm.excelBoxDialog.uploadProgress.status
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-text"
  }, [_vm._v(_vm._s(_vm.excelBoxDialog.uploadProgress.text))])], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.excelBoxDialog.show = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.excelBoxDialog.uploading,
      "disabled": _vm.excelBoxDialog.fileList.length === 0
    },
    on: {
      "click": _vm.submitExcelBoxing
    }
  }, [_vm._v("\n        " + _vm._s(_vm.excelBoxDialog.uploading ? '处理中...' : '开始合箱') + "\n      ")])], 1)]), _vm._v(" "), (_vm.mianDialog.isPrint) ? _c('Face', {
    attrs: {
      "boxId": _vm.mianDialog.boxId
    },
    on: {
      "closeFaceDialog": _vm.closeFaceDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fillcontain"
  }, [_c('div', {
    staticClass: "navCalss",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("| 员工列表")]), _vm._v(" "), _c('div', {
    staticClass: "search_container"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true,
      "model": _vm.search_data,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录名:"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入真实姓名"
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getAdminList('1')
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "btnRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "view"
    },
    on: {
      "click": function () {
        _vm.searchData = {
          keyWord: ''
        };
        _vm.getAdminList();
      }
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "btnRight"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onAddAdmin()
      }
    }
  }, [_vm._v("创建员工")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": "",
      "size": "medium"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.realName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号",
      "min-width": "200px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "min-width": "300px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row, '2')
            }
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row)
            }
          }
        }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onEditAdmin(scope.row, '3')
            }
          }
        }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onDelAdmin(scope.row.adminId)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("删除")])])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialog.showC,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showC", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.employee.netBarForm,
      "rules": _vm.employee.form_rules,
      "label-width": _vm.employee.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.password),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "password", $$v)
      },
      expression: "employee.netBarForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordA",
      "label": "确认密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请再输入一次密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.passwordA),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "passwordA", $$v)
      },
      expression: "employee.netBarForm.passwordA"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbitB()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showC = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialog.title,
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "margin": "20px",
      "width": "auto"
    },
    attrs: {
      "model": _vm.employee.netBarForm,
      "rules": _vm.employee.form_rules,
      "label-width": _vm.employee.formLabelWidth,
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "账户名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入账户名称"
    },
    model: {
      value: (_vm.employee.netBarForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "userName", $$v)
      },
      expression: "employee.netBarForm.userName"
    }
  })], 1), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.password),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "password", $$v)
      },
      expression: "employee.netBarForm.password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "passwordA",
      "label": "确认密码:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请再输入一次密码",
      "type": "password"
    },
    model: {
      value: (_vm.employee.netBarForm.passwordA),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "passwordA", $$v)
      },
      expression: "employee.netBarForm.passwordA"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "真实姓名:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    model: {
      value: (_vm.employee.netBarForm.realName),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "realName", $$v)
      },
      expression: "employee.netBarForm.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile",
      "label": "手机:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    on: {
      "keyup": function($event) {
        this.value = this.value.replace(/[^\d]/g, '')
      }
    },
    model: {
      value: (_vm.employee.netBarForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "mobile", $$v)
      },
      expression: "employee.netBarForm.mobile"
    }
  })], 1), _vm._v(" "), (_vm.showOnsub) ? _c('el-form-item', {
    attrs: {
      "prop": "roleId",
      "label": "角色类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "placeholder": "请选择角色类型"
    },
    model: {
      value: (_vm.employee.netBarForm.roleId),
      callback: function($$v) {
        _vm.$set(_vm.employee.netBarForm, "roleId", $$v)
      },
      expression: "employee.netBarForm.roleId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "系统管理员",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "快递点管理员",
      "value": 4
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 150px"
    }
  }, [(_vm.showOnsub) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onsumbit()
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: _vm.showOnsub ? '' : 'margiLeft',
    on: {
      "click": function($event) {
        _vm.dialog.show = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定删除该员工信息？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("移除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.showB = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("合箱编码：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入合箱编号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.inputC()
      }
    },
    model: {
      value: (_vm.boxNumber),
      callback: function($$v) {
        _vm.boxNumber = $$v
      },
      expression: "boxNumber"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近出库订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyList,
      "border": "",
      "stripe": "",
      "row-key": "boxId",
      "max-height": "550px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h4', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库时间",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.createTime ?
          _vm.toDate(scope.row.createTime, "yyyy-MM-dd hh:mm") :
          "时间未知") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#008b8b"
    }
  }, [_vm._v("已出库")])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "show-close": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递出库")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合箱编码："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.boxNumber) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.vipCodes) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单数量："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderCount) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货物类型："
    }
  }, [(_vm.orderInfo.goodType == 1) ? _c('span', {
    staticClass: "tag"
  }, [_vm._v(" 海运 ")]) : (_vm.orderInfo.goodType == 2) ? _c('span', {
    staticClass: "tag tag1"
  }, [_vm._v("\n                海运大件\n              ")]) : (_vm.orderInfo.goodType == 3) ? _c('span', {
    staticClass: "tag tag3"
  }, [_vm._v("\n                空运\n              ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.deliveryTitle) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('span', {
    staticClass: "tag tag4"
  }, [_vm._v(" 未入库 ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.createTime) ? _c('span', [_vm._v(_vm._s(_vm.toDate(
    _vm.orderInfo && _vm.orderInfo.createTime,
    "yyyy-MM-dd hh:mm"
  )) + "\n                "), _c('span', {
    staticClass: "tag tag2"
  }, [_vm._v(" 合箱 ")])]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货柜号：",
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站出库可不填）")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                      ")]
      }
    }], null, false, 1453014801)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.realName) + "\n                      ")]
      }
    }], null, false, 3257019584)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.vipCode) + "\n                      ")]
      }
    }], null, false, 1338675743)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键出库，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("出库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合箱出库",
      "visible": _vm.isExistMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "left",
      "destroy-on-close": _vm.trueMark
    },
    on: {
      "update:visible": function($event) {
        _vm.isExistMark = $event
      },
      "opened": _vm.openFail,
      "closed": _vm.closed
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n      出库失败，系统无匹配运单。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "audioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isRepeatMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.reHandleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.isRepeatMark = $event
      },
      "opened": _vm.openRepeat
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("\n      合箱出库  (" + _vm._s(_vm.orderNum) + ")\n    ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("重复出库，本箱已被出库")]), _vm._v(" "), _c('div', {
    staticClass: "repeAudioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isPassMark,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.succHandleClose,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isPassMark = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('audio', {
    attrs: {
      "src": "../../../static/audio/chukuSuccess.mp3",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentBlock"
  }, [_c('el-container', [_c('el-header', [_c('div', {
    staticClass: "search"
  }, [_c('header', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("| 筛选条件")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "输出类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.changeTransactionType
    },
    model: {
      value: (_vm.formInline.transactionType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transactionType", $$v)
      },
      expression: "formInline.transactionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "运费",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "额外费用",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "工单费",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "派送费",
      "value": "4"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "运输类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.transportType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "transportType", $$v)
      },
      expression: "formInline.transportType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "空运",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "海运大件",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "",
      "disabled": _vm.showWhichTable == 2,
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.statusType),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "statusType", $$v)
      },
      expression: "formInline.statusType"
    }
  }, _vm._l((_vm.statusArr), function(statusObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": statusObj.name,
        "value": statusObj.value,
        "disabled": statusObj.value == 1 ||
          (statusObj.value == 2 && !!_vm.formInline.checkedBatch)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.formInline.deliverAddress),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "deliverAddress", $$v)
      },
      expression: "formInline.deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "人员："
    }
  }, [_c('div', [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInline.checkedPerson),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedPerson", $$v)
      },
      expression: "formInline.checkedPerson"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.peopleArr), function(peopleObj, pIndex) {
    return _c('el-option', {
      key: pIndex,
      attrs: {
        "label": peopleObj.vipCode,
        "value": peopleObj.vipCode
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "search-icon",
    attrs: {
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.showUserDialog
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "56px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("筛选数据")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("导出")]), _vm._v(" "), (_vm.formInline.transactionType == 1) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总运费:"), _c('span', [_vm._v(_vm._s(_vm.freight))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 2) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总额外费用:"), _c('span', [_vm._v(_vm._s(_vm.extraPrice))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 3) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总工单费:"), _c('span', [_vm._v(_vm._s(_vm.demandMoney))])])]) : _vm._e(), _vm._v(" "), (_vm.formInline.transactionType == 4) ? _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总派送费:"), _c('span', [_vm._v(_vm._s(_vm.deliveryPrice))])])]) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "margin-top": "100px",
      "box-sizing": "border-box"
    }
  }, [_c('div', {
    staticClass: "bodyContent"
  }, [(_vm.showWhichTable == 1) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 运单页")]) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单页")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in",
    staticStyle: {
      "max-width": "1700px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    key: 1,
    attrs: {
      "prop": "orderNo",
      "label": "订单编号",
      "width": "160",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.orderNo) + "\n                ")]
      }
    }], null, false, 3318077970)
  }), _vm._v(" "), _c('el-table-column', {
    key: 12,
    attrs: {
      "min-width": "180",
      "align": "center",
      "prop": "expressNo",
      "label": "运单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n                  ")]) : _vm._e(), _vm._v("\n\n                  " + _vm._s(scope.row.expressNo ? scope.row.expressNo : "") + "\n                ")]
      }
    }], null, false, 2997915901)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addTime",
      "label": "下单时间",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.addTime ? _vm.changeDate(scope.row.addTime, 1) : "") + "\n                ")]
      }
    }], null, false, 4135224054)
  }), _vm._v(" "), _c('el-table-column', {
    key: 3,
    attrs: {
      "prop": "arrProduct",
      "label": "名称",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                    " + _vm._s(scope.row.goodName) + "\n                  ")])]
      }
    }], null, false, 3339316019)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.deliveryTitle) + "\n                ")]
      }
    }], null, false, 610745121)
  }), _vm._v(" "), _c('el-table-column', {
    key: 6,
    attrs: {
      "prop": "realName",
      "label": "客户",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.vipCode) + "\n                ")]
      }
    }], null, false, 3926535327)
  }), _vm._v(" "), _c('el-table-column', {
    key: 8,
    attrs: {
      "prop": "mobile",
      "width": "120",
      "label": "联系方式",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.sendRemark) + "\n                ")]
      }
    }], null, false, 3366488835)
  }), _vm._v(" "), _c('el-table-column', {
    key: 10,
    attrs: {
      "prop": "expressCompany",
      "width": "100",
      "label": "物流公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 11,
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "width": "160",
      "label": "摘要"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n                    待入库\n                  ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已入库\n                  ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已出库\n                  ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    已结单\n                  ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n                    已取消\n                  ")]) : (scope.row.status == 6) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    已合箱\n                  ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （中心仓）已入库\n                  ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n                    （中心仓）已出库\n                  ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n                    （派送）已入库\n                  ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#ffa500"
          }
        }, [_vm._v("\n                    可预约\n                  ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#008000"
          }
        }, [_vm._v("\n                    已预约\n                  ")]) : _vm._e()]
      }
    }], null, false, 3709828376)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n                ")]
      }
    }], null, false, 3897659740)
  }), _vm._v(" "), _c('el-table-column', {
    key: 13,
    attrs: {
      "label": "工单费（CAD）",
      "min-width": "140px",
      "align": "center",
      "prop": "demandMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 14,
    attrs: {
      "label": "派送费(CAD)",
      "min-width": "140px",
      "align": "center",
      "prop": "deliveryPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 15,
    attrs: {
      "label": "额外费用（CAD）",
      "min-width": "160px",
      "align": "center",
      "prop": "extraPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sendOrderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n                    " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.sendNo ? scope.row.sendNo : ""))])]
      }
    }], null, false, 662158576)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "width": "160px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.sendTime ? _vm.changeDate(scope.row.sendTime) : ""))])]
      }
    }], null, false, 2563937936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showUserVipCode(scope.row.user) : ""))])]
      }
    }], null, false, 182391634)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showRealName(scope.row.user) : ""))])]
      }
    }], null, false, 3898529692)
  }), _vm._v(" "), _c('el-table-column', {
    key: 25,
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 26,
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.user ? _vm.showBalance(scope.row.user) : ""))])]
      }
    }], null, false, 2388616455)
  }), _vm._v(" "), _c('el-table-column', {
    key: 28,
    attrs: {
      "label": "额外费用",
      "prop": "extraPrice",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 281,
    attrs: {
      "label": "派送费",
      "min-width": "100px",
      "align": "center",
      "prop": "deliveryPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: 29,
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n                ")]
      }
    }], null, false, 4265623366)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "padding-right": "40px"
    }
  }, [(_vm.showWhichTable == 1) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showWhichTable == 2) ? _c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginationsPerson.page_sizes,
      "page-size": _vm.paginationsPerson.page_size,
      "layout": _vm.paginationsPerson.layout,
      "total": _vm.paginationsPerson.total,
      "current-page": _vm.paginationsPerson.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChangePerson,
      "size-change": _vm.handleSizeChangePerson
    }
  }) : _vm._e()], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowUserDialog,
      "append-to-body": true,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowUserDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "roleData dialogTitle",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "title-text"
  }, [_vm._v("人员选择")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("客户/vipCode：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入内容",
      "size": "small",
      "clearable": ""
    },
    model: {
      value: (_vm.roleInput),
      callback: function($$v) {
        _vm.roleInput = $$v
      },
      expression: "roleInput"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchRole
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.setRole
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTableRole",
    staticClass: "table",
    attrs: {
      "data": _vm.roleData,
      "border": "",
      "max-height": 580
    },
    on: {
      "select": _vm.selectRoleOnce,
      "selection-change": _vm.selectOptionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vipCode",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "background": "",
      "current-page": _vm.rolePaginations.page_index,
      "page-sizes": _vm.rolePaginations.page_sizes,
      "page-size": _vm.rolePaginations.page_size,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.rolePaginations.total
    },
    on: {
      "size-change": _vm.rHandleSizeChange,
      "current-change": _vm.rHandleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelRole()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.certainRole()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有工单",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "处理中",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已处理",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "five"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "monewt"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单号 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入物流单号/工单号查询",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入客户名称或vip号查询",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getOrderList('1')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "stripe": "",
      "id": "printTable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "工单编号",
      "prop": "orderNo",
      "min-width": "150px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.demandNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提出时间",
      "min-width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "8"
          }
        }, [_c('div', [_vm._v(_vm._s(scope.row.createDate))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.realName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "min-width": "130px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.mobile) + "\n          ")]
      }
    }])
  }), _vm._v("\n\n        >\n\n        "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n              待处理\n            ")]) : (scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n              处理中\n            ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n              已处理\n            ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n              已取消\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "min-width": "100px",
      "align": "center",
      "prop": "addDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.adminPojo ? scope.row.adminPojo.realName : "") + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "130px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row)
            }
          }
        }, [_vm._v("查看")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "title": "编辑订单",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "label-width": "55px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wj_dialog_panel"
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.demandNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("提交时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.createTime))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.orderInfo.expressCompany) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.orderInfo.expressNo) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                待入库\n              ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                已入库\n              ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                已出库\n              ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                已结单\n              ")]) : (_vm.orderInfo.status == -1) ? _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("\n                已取消\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("运输类型：")]), _vm._v(" "), _c('div', [(_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 1)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                海运\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 1)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 2)) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                海运大件\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 2)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 3)) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                空运\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 3)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "linHeight"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.realName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("贵宾号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("联系方式：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户需求：")]), _vm._v(" "), (_vm.orderInfo.content) ? _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.content) + "\n            ")]) : _c('div', [_vm._v("无")])]), _vm._v(" "), _c('div', {
    staticClass: "linHeight"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单状态：")]), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.orderInfo.workOrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "workOrderStatus", $$v)
      },
      expression: "orderInfo.workOrderStatus"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单费用：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "本次工单收费"
    },
    model: {
      value: (_vm.orderInfo.demandMoney),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "demandMoney", $$v)
      },
      expression: "orderInfo.demandMoney"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', [_vm._v("附件照片：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wrl-felx6"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "headers": _vm.headers,
      "http-request": _vm.handleLicenseImgFile,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.productImgA) ? _c('div', {
    staticClass: "pta"
  }, [_c('i', {
    staticClass: "el-icon-delete childe",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.del()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    },
    attrs: {
      "src": _vm.productImgACopy
    }
  })]) : _c('div', [_c('div', {
    staticClass: "backgroundA",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    }
  }, [_vm._v("\n                      上传\n                    ")])])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wrl-felx6",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "headers": _vm.headers,
      "http-request": _vm.handleLicenseImgFileB,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUploadB
    }
  }, [(_vm.productImgB) ? _c('div', {
    staticClass: "pta"
  }, [_c('i', {
    staticClass: "el-icon-delete childe",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delB()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    },
    attrs: {
      "src": _vm.productImgBCopy
    }
  })]) : _c('div', [_c('div', {
    staticClass: "backgroundA",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    }
  }, [_vm._v("\n                      上传\n                    ")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitOrder()
      }
    }
  }, [_vm._v("提交")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wj_dialog_right"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("反馈记录")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, _vm._l((_vm.feedback.list), function(item, index) {
    return _c('div', {
      key: index,
      class: item.type == 1 ? 'wj_item clear' : 'wj_item_right clear'
    }, [_c('div', [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.toDate(item.operatorTime)))])]), _vm._v(" "), _c('el-avatar', {
      staticClass: "wj_avater",
      attrs: {
        "size": 32,
        "src": _vm.circleUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "wj_replay"
    }, [_vm._v(_vm._s(item.content))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "wj_bottom"
  }, [_c('el-form', {
    ref: "feedbackForm",
    attrs: {
      "model": _vm.feedback.data,
      "rules": _vm.feedback.rules,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "20px"
    },
    attrs: {
      "placeholder": "回复客户"
    },
    model: {
      value: (_vm.feedback.data.content),
      callback: function($$v) {
        _vm.$set(_vm.feedback.data, "content", $$v)
      },
      expression: "feedback.data.content"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addFeedback()
      }
    }
  }, [_vm._v("发送")])], 1)], 1)], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showF", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认删除该图片嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmB()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showF = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {
        return _vm.handleClick(_vm.activeName)
      }
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "处理中",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已处理",
      "name": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 派送列表")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', [_vm._v("发货单号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "输入运单号/订单编号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("用户名/ViP号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "输入用户名/vip号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("派送编号:\n        "), _c('el-input', {
    attrs: {
      "placeholder": "请输入派送编号",
      "clearable": ""
    },
    on: {
      "clear": _vm.getDeliveryList
    },
    model: {
      value: (_vm.deliveryNumber),
      callback: function($$v) {
        _vm.deliveryNumber = $$v
      },
      expression: "deliveryNumber"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("批次:\n        "), _c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.deliveryBatch),
      callback: function($$v) {
        _vm.deliveryBatch = $$v
      },
      expression: "deliveryBatch"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getDeliveryList()
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getDeliveryList('select')
      }
    }
  }, [_vm._v("查 询")])], 1), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainList,
      "border": "",
      "max-height": "550px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deliveryNumber",
      "label": "派送编号",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "运单",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + " 个运单\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vip号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendNo",
      "label": "发货单号",
      "align": "center",
      "width": "140px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendRemark",
      "label": "批次",
      "align": "center",
      "width": "140px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "status_text"
        }, [(scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#1e90ff"
          }
        }, [_vm._v("\n              已处理\n            ")]) : (scope.row.status == 0) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("待处理")])]) : (scope.row.status == 1) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ffd700"
          }
        }, [_vm._v("处理中")])]) : (scope.row.status == -1) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ff6347"
          }
        }, [_vm._v("已取消")])]) : (scope.row.status == 3) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#ff6347"
          }
        }, [_vm._v("已取消")])]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "派送费",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "width": "120px",
      "label": "发货单总费用",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "提出时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.changeDate(scope.row, 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "volume",
      "label": "体积CBM",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productWeight",
      "label": "重量KG",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unMixingTank",
      "label": "箱数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mixingTank",
      "label": "混箱数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "收货人电话",
      "width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "收货地址",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预计派送时间",
      "prop": "expectTime",
      "min-width": "160px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.expectTime) ? _c('span', [_vm._v(_vm._s(_vm.changeToTime(scope.row.expectTime)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showEditDia(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showAccountDia(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showOrder(scope.row)
            }
          }
        }, [_vm._v("订单详情")]), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onLook(scope.row)
            }
          }
        }, [_vm._v("发货单详情")]), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateAddress(scope.row)
            }
          }
        }, [_vm._v("地址修改")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == 4) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编 辑",
      "visible": _vm.editDialog,
      "width": "60%",
      "center": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, _vm._l((_vm.editLsit), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "diaBox"
    }, [_c('div', {
      staticClass: "dialog_left diaBoxIn"
    }, [_c('div', {
      staticClass: "dialog_left_top diaStyle"
    }, [_c('div', {
      staticClass: "dialog_left_top1",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              发货单号：" + _vm._s(item.sendNo) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("\n              提交时间：" + _vm._s(item.createTime ? _vm.changeDate(item, 1) : "时间未知") + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_center diaStyle",
      staticStyle: {
        "border-top": "2px solid black"
      }
    }, [_c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("客户名称：" + _vm._s(item.userName))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("贵宾号：" + _vm._s(item.vipCode))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("总运费：CAD " + _vm._s(item.amount))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("备注： 未含加拿大出库后的派送费用")]), _vm._v(" "), _c('p', [_vm._v("客户需求： "), _c('span', [_vm._v("派送")])])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_center diaStyle",
      staticStyle: {
        "border-top": "2px solid black"
      }
    }, [_c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("派送地址：" + _vm._s(item.address))]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_vm._v("派送电话：" + _vm._s(item.mobile))]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_c('span', [_vm._v("总体积：" + _vm._s(item.volume))]), _vm._v(" "), _c('span', {
      staticClass: "rightSpan"
    }, [_vm._v("总重量：" + _vm._s(item.productWeight))])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_left_top2"
    }, [_c('span', [_vm._v("特混箱数：" + _vm._s(item.mixingTank))]), _vm._v(" "), _c('span', {
      staticClass: "rightSpan"
    }, [_vm._v("箱数：" + _vm._s(item.unMixingTank))])])]), _vm._v(" "), _c('div', {
      staticClass: "diaStyle",
      staticStyle: {
        "border-top": "solid"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              订单状态：\n              "), _c('el-select', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "clearable": "",
        "placeholder": "订单状态",
        "size": "small",
        "disabled": _vm.isDisabledStatus == 2
      },
      on: {
        "change": function($event) {
          return _vm.init()
        }
      },
      model: {
        value: (_vm.status.statusType),
        callback: function($$v) {
          _vm.$set(_vm.status, "statusType", $$v)
        },
        expression: "status.statusType"
      }
    }, _vm._l((_vm.statusTypeSelect), function(item) {
      return _c('el-option', {
        key: item.statusType,
        attrs: {
          "label": item.statusName,
          "value": item.statusType
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "0 0 15px -26px"
      }
    }, [_c('el-form', {
      ref: "RuleForm",
      refInFor: true,
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.ruleForm,
        "rules": _vm.rules,
        "label-width": "100px",
        "label-position": "right"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "派送费用 :",
        "prop": "price"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "number",
        "clearable": "",
        "size": "small",
        "disabled": _vm.isDisabledStatus == 2
      },
      model: {
        value: (_vm.ruleForm.price),
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, "price", $$v)
        },
        expression: "ruleForm.price"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              预计派送时间："), _c('el-date-picker', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "type": "datetime",
        "size": "small",
        "picker-options": _vm.pickerOptions,
        "placeholder": "选择派送时间",
        "disabled": _vm.isDisabledStatus == 2
      },
      model: {
        value: (_vm.expectTime),
        callback: function($$v) {
          _vm.expectTime = $$v
        },
        expression: "expectTime"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              余额：CAD\n              "), _c('span', {
      staticStyle: {
        "color": "#ffa500"
      }
    }, [_vm._v("\n                " + _vm._s(item.balance) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n              备注：\n              "), _c('div', {
      staticStyle: {
        "margin-top": "6px"
      }
    }, [_vm._v("1. 加拿大出库后的派送上门费用")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "6px"
      }
    }, [_vm._v("\n                2. 派送状态为已处理时派送费用才有效\n              ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin": "36px 0 0 0"
      }
    }, [_c('el-button', {
      attrs: {
        "disabled": _vm.isDisabledStatus == 2,
        "type": "primary"
      },
      on: {
        "click": _vm.updateDelivery
      }
    }, [_vm._v("\n                提 交\n              ")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "dialog_right diaBoxIn"
    }, [_c('div', {
      staticClass: "dialog_right_text",
      staticStyle: {
        "text-align": "center",
        "border-bottom": "2px solid black"
      }
    }, [_vm._v("\n            反馈记录\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "dia_Text"
    }, [_c('div', {
      staticClass: "dia_Text_content"
    }, _vm._l((_vm.feedbackList), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "content_text"
      }, [(item.type == 1) ? _c('div', {}, [_c('div', [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.changeDate(item.operatorTime, 4)) + "\n                    ")])]), _vm._v(" "), _c('span', [_c('el-avatar', {
        attrs: {
          "size": "medium",
          "src": "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block",
          "margin": "-30px 0 0 43px"
        }
      }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")])]) : _vm._e(), _vm._v(" "), (item.type == 2) ? _c('div', {
        staticStyle: {
          "position": "relative",
          "text-align": "right"
        }
      }, [_c('div', [_c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.changeDate(item.operatorTime, 4)) + "\n                    ")])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "position": "absolute",
          "right": "40px",
          "top": "28px"
        }
      }, [_vm._v("\n                    " + _vm._s(item.content) + "\n                  ")]), _vm._v(" "), _c('span', [_c('el-avatar', {
        attrs: {
          "size": "medium",
          "src": "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
        }
      })], 1)]) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "dia_Text_input"
    }, [_c('el-button', {
      staticClass: "refresh el-icon-refresh-right",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.getFeedbackList(1)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      staticClass: "dinput",
      attrs: {
        "id": "diaBt",
        "clearable": ""
      },
      nativeOn: {
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
          return _vm.postDeliveryFeedback($event)
        }
      },
      model: {
        value: (_vm.content),
        callback: function($$v) {
          _vm.content = $$v
        },
        expression: "content"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "dbt",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.postDeliveryFeedback
      }
    }, [_c('span', {
      staticClass: "send"
    }, [_vm._v("发 送")])])], 1)])])])])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "出库结算",
      "visible": _vm.accountDia,
      "width": "60%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.accountDia = $event
      }
    }
  }, _vm._l((_vm.accountList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BigBox"
    }, [_c('div', {
      staticClass: "accountDia-content-header"
    }, [_c('div', {
      staticClass: "content-left content-left-text"
    }, [_c('div', [_vm._v("\n            发货单号:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.sendNo) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            预约状态:\n            "), _c('span', {
      staticStyle: {
        "color": "rgb(9, 157, 255)"
      }
    }, [_vm._v(" 已预约 ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-center content-left-text"
    }, [_c('div', [_vm._v("\n            VIP号:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.user.vipCode) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            入库时间:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.operatorTime ?
      _vm.changeDate(item.operatorTime, 4) :
      "无法显示") + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-left-text"
    }, [_c('div', [_vm._v("\n            客户:\n            "), _c('span', [_vm._v("\n              " + _vm._s(item.user.realName) + "\n            ")])]), _vm._v(" "), _c('div', [_vm._v("\n            订单数量: "), _c('span', [_vm._v(_vm._s(item.orderPojoList.length))])])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "36%",
        "float": "left",
        "margin-right": "20px"
      }
    }, [_vm._v("\n          所需总运费："), _c('span', [_vm._v(_vm._s(item.totalFreight))])]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "36%",
        "float": "left"
      }
    }, [_vm._v("\n          所需总派送费："), _c('span', [_vm._v(_vm._s(item.deliveryPrice))])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_vm._v("\n        所需总工单费用："), _c('span', [_vm._v(_vm._s(item.totalWorkOrderFee))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer1",
      staticStyle: {
        "width": "100%",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "32%",
        "float": "left",
        "margin-right": "6px"
      }
    }, [_vm._v("\n          额外费用："), _c('span', [_vm._v(_vm._s(item.extraPrice))]), _vm._v(" CAD\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "32%",
        "float": "left",
        "margin-right": "6px"
      }
    }, [_vm._v("\n          最后总费用："), _c('span', [_vm._v(_vm._s(item.totalCost))]), _vm._v(" CAD\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "32%",
        "float": "left"
      }
    }, [_vm._v("\n          账户余额：\n          "), _c('span', {
      staticStyle: {
        "color": "#d2691e"
      }
    }, [_vm._v(_vm._s(item.user.balance))]), _vm._v(" CAD\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer2",
      staticStyle: {
        "width": "100%",
        "margin-top": "30px",
        "text-align": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "46%",
        "font-size": "17px",
        "font-weight": "bolder"
      }
    }, [_vm._v("\n          订单列表\n        ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "margin": "25px 0 -20px 0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "table"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listRow
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "label": "#",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productName",
        "align": "center",
        "label": "物品"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "orderNo",
        "label": "运单号",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productNum",
        "align": "center",
        "label": "数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "label": "货运类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n            ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goodType",
        "align": "center",
        "label": "用户"
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(_vm.accountList[0].user.realName) + "\n            ")])]), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "total",
        "align": "center",
        "label": "运费（CAD）"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "demandMoney",
        "align": "center",
        "label": "工费（CAD）"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "accountDia-footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.settlementBt()
        }
      }
    }, [_vm._v("确认结算")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          _vm.accountDia = false
        }
      }
    }, [_vm._v("取 消")])], 1)])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.listDia,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.listDia = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.listDia = false
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "diaText"
  }, [_c('div', {
    staticClass: "e_text"
  }, [_vm._v("发货单号：" + _vm._s(_vm.orderMsg.sendNo))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("订单数量：" + _vm._s(_vm.orderMsg.orderCount))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("相关用户VIP：" + _vm._s(_vm.user.vipCode))])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "max-height": "300px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "名称",
      "align": "center",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货物类型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.realName) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.vipCode) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价格",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(9, 157, 255)"
    }
  }, [_vm._v(" 已预约 ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "width": "180"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.user.deliveryTitle) + "\n        ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "运费(CAD)",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "align": "center",
      "width": "240px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.changeDate(scope.row.storeTime, 4)) + "\n          ")]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "160px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rate !== true) ? _c('span', [_vm._v(_vm._s(scope.row.rate))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "width": "220px",
      "align": "center"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isUpdateFeeShow,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isUpdateFeeShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("额外费用 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入修改后的费用",
      "autofocus": ""
    },
    model: {
      value: (_vm.feeInput),
      callback: function($$v) {
        _vm.feeInput = $$v
      },
      expression: "feeInput"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        备注 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入额外费用备注",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdateDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdateDialog
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.dialog.updaAddDia,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "updaAddDia", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("收货人电话 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入收货人电话",
      "autofocus": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        收货人地址 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入收货人地址",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdaAddDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdaAddDialog
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("工单须知")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, [_c('el-input', {
    staticClass: "wj_txt",
    attrs: {
      "type": "textarea",
      "rows": 15,
      "placeholder": "增值服务须知：拍照、合箱、打包1.5 CAD/h，每提一次工单会占用一次工单配额"
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wj_btns"
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 出入记录")]), _vm._v(" "), _c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有记录",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "入库记录",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "出库记录",
      "name": "third"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "monewt"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单号 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入物流单号/订单编号查询"
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单时间:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.value1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "stripe": "",
      "id": "printTable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作时间",
      "min-width": "180px",
      "align": "center",
      "prop": "operatorDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "p": "",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("入库")]) : _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("出库")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单编号",
      "prop": "orderNo",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ss",
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo)
            }
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.orderNo) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "min-width": "100px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "8"
          }
        }, [_c('div', [_vm._v(_vm._s(scope.row.productName))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "prop": "operatorName",
      "min-width": "100px",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showG,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showG", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认改变该合箱状态嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmC()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showG = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressNo))]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n            待入库\n          ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已出库\n          ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已结单\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [(_vm.orderInfo.isBox == 1) ? _c('div', [_c('span', [_vm._v("合箱")])]) : _c('div', [_c('span', {
    staticClass: "red",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("不合箱")])])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.getorderNoB(_vm.orderInfo.orderNo, _vm.orderInfo.isBox)
      }
    }
  }, [_vm._v("修改")])], 1)]), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.storeTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 3) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际尺寸：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productSize) + " CBM")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际重量：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productWeight) + " KG")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', [_vm._v("最后费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单备注：")]), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.remark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.orderInfo.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.userRemark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status == 1) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "ellipsisB",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(val.productName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(val.productNum) + "件")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1",
        "min-width": "50px"
      }
    }, [_vm._v(_vm._s(val.weight) + "kg")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "2",
        "min-width": "100px"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productLong) + "x" + _vm._s(val.width) + "x" + _vm._s(val.height) + "cm\n                ")]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productRemark) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx6",
      staticStyle: {
        "margin-left": "0px",
        "min-width": "80px"
      }
    }, [(val.shelves) ? _c('div', {
      staticStyle: {
        "color": "#ec808d"
      }
    }, [_vm._v("\n                货架: " + _vm._s(val.shelves) + "\n              ")]) : _vm._e()]), _vm._v(" "), (val.productImg) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImg)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImg,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })]), _vm._v(" "), (val.productImgB) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImgB)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImgB,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })])])])
  })], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单管理")]), _vm._v(" "), _c('div', {
    staticClass: "monewt",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "wj_flex"
  }, [_c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "138px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入客户VIP号查询"
    },
    on: {
      "input": _vm.vipCodeBlur
    },
    model: {
      value: (_vm.vipCode),
      callback: function($$v) {
        _vm.vipCode = $$v
      },
      expression: "vipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "发货编号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入发货编号查询"
    },
    on: {
      "input": _vm.sendNoBlur
    },
    model: {
      value: (_vm.sendNo),
      callback: function($$v) {
        _vm.sendNo = $$v
      },
      expression: "sendNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "出库时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "220px",
      "padding-right": "6px"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "clearable": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.chukuTime)
      }
    },
    model: {
      value: (_vm.chukuTime),
      callback: function($$v) {
        _vm.chukuTime = $$v
      },
      expression: "chukuTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getStoreList('1')
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("批次：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.batchNum),
      callback: function($$v) {
        _vm.batchNum = $$v
      },
      expression: "batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1), _vm._v(" "), _c('span', [_vm._v("派送点：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.deliverAddress),
      callback: function($$v) {
        _vm.deliverAddress = $$v
      },
      expression: "deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("\n        批量导出Excel\n      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.sendNo) + "\n         \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库时间",
      "prop": "createTime",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onLook(scope.row)
            }
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onTOEcexlce(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("导出")])])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "840px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rate !== true) ? _c('span', [_vm._v(_vm._s(scope.row.rate))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "prop": "userBalance",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "min-width": "220px",
      "align": "center"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isUpdateFeeShow,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isUpdateFeeShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("额外费用 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入修改后的费用",
      "autofocus": ""
    },
    model: {
      value: (_vm.feeInput),
      callback: function($$v) {
        _vm.feeInput = $$v
      },
      expression: "feeInput"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        备注 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdateDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdateDialog
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productDustribut"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 客户列表")]), _vm._v(" "), _c('div', {
    staticClass: "minWidth"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称/vip号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称/vip号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordB),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordB", $$v)
      },
      expression: "searchData.keyWordB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入昵称",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.searchData.keyWordC),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordC", $$v)
      },
      expression: "searchData.keyWordC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.initData()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.routerTo
    }
  }, [_vm._v("充 值")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerList,
      "border": "",
      "default-sort": {
        prop: 'balance',
        order: 'descending'
      },
      "stripe": ""
    },
    on: {
      "sort-change": _vm.sortBalance
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "头像",
      "header-align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', [_c('el-image', {
          staticClass: "imgRaduis",
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.photo,
            "fit": "contain"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n              " + _vm._s(scope.row.nickname) + "\n            ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.realName) ? _c('div', [_vm._v(_vm._s(scope.row.realName))]) : _c('div', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "注册时间",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.addDate) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.mobile) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单配额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.demandCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "align": "center",
      "prop": "balance",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "消费金额",
      "align": "center",
      "prop": "amount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('p', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.deliveryAddress))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.remark) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editUser(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.delAppendUser(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "400px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "realName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.realName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "realName", $$v)
      },
      expression: "editDialog.data.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "mobile",
      "label": "手机号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "demandCount",
      "label": "工单预期："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "工单预期",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.demandCount),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "demandCount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.demandCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "客户备注："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "客户备注",
      "minlength": "8"
    },
    model: {
      value: (_vm.editDialog.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryId",
      "label": "派送点："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editDialog.data.deliveryId),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryId", $$v)
      },
      expression: "editDialog.data.deliveryId"
    }
  }, _vm._l((_vm.deliveryList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.addressId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitUser()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "visible": _vm.deleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.deleteDialog, "show", $event)
      }
    }
  }, [_c('span', [_vm._v("您确定删除吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "head-nav",
    attrs: {
      "id": "header_container"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_c('el-col', {
    staticClass: "logo-container",
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("加阳华枫快运")])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('i', {
    staticClass: "fa fa-sign-out logout",
    on: {
      "click": _vm.logout
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryP),
      expression: "deliveryP"
    }],
    staticClass: "welcome"
  }, [_c('p', {
    staticClass: "deliveryP"
  }, [_vm._v("派送点：\n                    " + _vm._s(_vm.deliveryP))])])]), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": __webpack_require__(1210),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "welcome"
  }, [_c('p', {
    staticClass: "name comename"
  }), _vm._v(" "), _c('p', {
    staticClass: "name avatarname"
  }, [_vm._v(_vm._s(_vm.userName) + "  " + _vm._s(_vm.realeName))])])]), _vm._v(" "), _c('div', {
    staticClass: "notify-row"
  }, [_c('ul', {
    staticClass: "top-menu"
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bread_container",
    staticStyle: {
      "min-width": "200px"
    },
    attrs: {
      "id": "bread_container"
    }
  }, [_c('span', {
    staticClass: "bars",
    on: {
      "click": _vm.handleLeftMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    class: {
      isactive: _vm.changeBarDirection
    }
  })]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/orderList'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [(item.name != null) ? _c('span', [_vm._v(_vm._s(item.name))]) : _vm._e()])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": function($event) {
        return _vm.init(_vm.activeName)
      }
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "充值流水",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支出流水",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "调账流水",
      "name": "3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账单流水号:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入账单流水号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getBalanceList
    },
    model: {
      value: (_vm.balanceNo),
      callback: function($$v) {
        _vm.balanceNo = $$v
      },
      expression: "balanceNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ViP号: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入vip号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getBalanceList
    },
    model: {
      value: (_vm.vipCode),
      callback: function($$v) {
        _vm.vipCode = $$v
      },
      expression: "vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.formInline.checkedTime)
      }
    },
    model: {
      value: (_vm.formInline.checkedTime),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedTime", $$v)
      },
      expression: "formInline.checkedTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批次："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.formInline.checkedBatch),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "checkedBatch", $$v)
      },
      expression: "formInline.checkedBatch"
    }
  }, _vm._l((_vm.batchArr), function(batchObj) {
    return _c('el-option', {
      key: batchObj.sendId,
      attrs: {
        "label": batchObj.remark,
        "value": batchObj.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入备注查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.getBalanceList
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getBalanceList
    }
  }, [_vm._v("查 询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 财务流水")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '2'),
      expression: "activeName == '2'"
    }],
    staticClass: "chargeBt",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.routerPush
    }
  }, [_vm._v("充 值")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table_in"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "max-height": "600px"
    }
  }, [(_vm.activeName == '1') ? _c('el-table-column', {
    key: 1,
    attrs: {
      "prop": "balanceNo",
      "label": "充值账单流水号",
      "width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '0') ? _c('el-table-column', {
    key: 2,
    attrs: {
      "prop": "balanceNo",
      "label": "账单流水号",
      "width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '2') ? _c('el-table-column', {
    key: 3,
    attrs: {
      "prop": "balanceNo",
      "label": "支出账单流水号",
      "width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '3') ? _c('el-table-column', {
    key: 4,
    attrs: {
      "prop": "balanceNo",
      "label": "调账账单流水号",
      "width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '0' || _vm.activeName == '2' || _vm.activeName == '3') ? _c('el-table-column', {
    key: 5,
    attrs: {
      "prop": "vipCode",
      "width": "120",
      "label": "客户vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '1') ? _c('el-table-column', {
    key: 6,
    attrs: {
      "prop": "vipCode",
      "width": "200",
      "label": "充值人vip号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "align": "center",
      "min-width": "120",
      "label": "摘要"
    }
  }), _vm._v(" "), (_vm.activeName == '0') ? _c('el-table-column', {
    key: 7,
    attrs: {
      "width": "200",
      "align": "center",
      "prop": "amount",
      "label": "支出/充值/金额（CAD）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.balanceType == 2) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n              -" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n              +" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 3) ? _c('span', [(scope.row.orderNo.indexOf('上') !== -1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n                +" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.orderNo.indexOf('下') !== -1) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n                -" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 1828098395)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '2') ? _c('el-table-column', {
    key: 8,
    attrs: {
      "prop": "amount",
      "width": "200",
      "align": "center",
      "label": "收取金额（CAD）"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '1') ? _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "align": "center",
      "width": "200",
      "label": "充值金额 CAD"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '3') ? _c('el-table-column', {
    key: 9,
    attrs: {
      "align": "center",
      "width": "100",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.balanceType == 2) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n              -" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n              +" + _vm._s(scope.row.amount) + "\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.balanceType == 3) ? _c('span', [(scope.row.orderNo.indexOf('上') !== -1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("\n                +" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.orderNo.indexOf('下') !== -1) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n                -" + _vm._s(scope.row.amount) + "\n              ")]) : _vm._e()]) : _vm._e()]
      }
    }], null, false, 1828098395)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '1') ? _c('el-table-column', {
    key: 10,
    attrs: {
      "prop": "accountName",
      "align": "center",
      "width": "200",
      "label": "收款类型"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "width": "100",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "width": "150",
      "align": "center",
      "label": "操作人"
    }
  }), _vm._v(" "), (_vm.activeName == '2') ? _c('el-table-column', {
    key: 11,
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "取货时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n          ")]
      }
    }], null, false, 946390502)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '3') ? _c('el-table-column', {
    key: 12,
    attrs: {
      "align": "center",
      "label": "调账时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n          ")]
      }
    }], null, false, 946390502)
  }) : _vm._e(), _vm._v(" "), (_vm.activeName == '0' || _vm.activeName == '1') ? _c('el-table-column', {
    key: 13,
    attrs: {
      "align": "center",
      "min-width": "120",
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.operatorTime ?
          _vm.changeDate(scope.row.operatorTime) :
          "时间未知") + "\n          ")]
      }
    }], null, false, 946390502)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "afterBalance",
      "width": "200",
      "align": "center",
      "label": "每笔交易之后账号剩余金额（CAD）"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deliveryList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "派送点",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址",
      "align": "center",
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点编码",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.boxSign) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.contact) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.tel) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联账户名",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.updateStatus(scope.row.addressId, scope.row.status)
            }
          }
        }, [(scope.row.status == 1) ? _c('span', [_vm._v("启用")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', [_vm._v("禁用")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.step == 3) ? _c('div', {
    staticClass: "first"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contact",
      "label": "负责人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人姓名"
    },
    model: {
      value: (_vm.editDialog.data.contact),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "contact", $$v)
      },
      expression: "editDialog.data.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "负责人电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人电话",
      "maxlength": "20"
    },
    model: {
      value: (_vm.editDialog.data.tel),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "派送点："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入派送地址",
      "minlength": "128"
    },
    model: {
      value: (_vm.editDialog.data.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryTitle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.deliveryTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "boxSign",
      "label": "派送点编号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入派送点编号",
      "maxlength": "4"
    },
    model: {
      value: (_vm.editDialog.data.boxSign),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "boxSign", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.boxSign"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "详细地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入派送点详细地址",
      "minlength": "300"
    },
    model: {
      value: (_vm.editDialog.data.address),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "contactPhoto",
      "label": "负责人照片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "http-request": _vm.handleLicenseImgFile,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.editDialog.data.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.process.env.IMG_URL + _vm.editDialog.data.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 3) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.data.addressId) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 1 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 2
      }
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 1
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待入库",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已出库",
      "name": "8"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "合箱编码",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户VIP号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "vipCode", $$v)
      },
      expression: "search.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "派送点"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "deliveryTitle", $$v)
      },
      expression: "search.deliveryTitle"
    }
  }, _vm._l((_vm.deliveryAddressList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.deliveryTitle
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "stripe": "",
      "row-key": "boxId",
      "max-height": "550px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "selectable": _vm.selectable,
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h4', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.strStatus(scope.row.status)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHanlder(scope.row)
            }
          }
        }, [_vm._v("签收入库")]) : _vm._e(), _vm._v(" "), (scope.row.status == 7) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outBoxHanlder(scope.row)
            }
          }
        }, [_vm._v("出库")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == '7' && _vm.accountObj.roleId == 1) ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.outBoxHanlder(null)
      }
    }
  }, [_vm._v("批量出库")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeName == '3') ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.intoBoxHanlder(null)
      }
    }
  }, [_vm._v("批量入库")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ?
    _vm.toDate(_vm.viewDialog.boxInfo.createTime, "yyyy-MM-dd hh:mm:ss") :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("待入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.orderCount : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("预估费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.totalFreight : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.vipCodes : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    },
    slot: "reference"
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("货物类型：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ?
    _vm.stringGoodType(_vm.detailDialog.boxInfo.goodType) :
    ""))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.vipCodes : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "align": "center",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.stringGoodType(scope.row.goodType)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "width": "80px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "70px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', {
          staticClass: "status1"
        }, [_vm._v("待入库")]) : (scope.row.status == 2) ? _c('span', {
          staticClass: "status2"
        }, [_vm._v("（国内）已入库")]) : (scope.row.status == 3) ? _c('span', {
          staticClass: "status3"
        }, [_vm._v("（国内）已出库")]) : (scope.row.status == 4) ? _c('span', {
          staticClass: "status4"
        }, [_vm._v("已结单")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "status-1"
        }, [_vm._v("已取消")]) : (scope.row.status == 7) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("(中心仓)已入库")]) : (scope.row.status == 8) ? _c('span', {
          staticClass: "status8"
        }, [_vm._v("(中心仓)已出库")]) : (scope.row.status == 9) ? _c('span', {
          staticClass: "status9"
        }, [_vm._v("(派送)已入库")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(CAD)",
      "prop": "total",
      "width": "95px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "addTime",
      "width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss")) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "100px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.outDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.outDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.outDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.outSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), (!_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchOutSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.outDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.intoDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.intoDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.intoDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchIntoSubmit()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.intoDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 库存列表")]), _vm._v(" "), _c('div', {
    staticClass: "monewt",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "货物名称 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入货物名称查询"
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-70px"
    },
    attrs: {
      "label": "用户名:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入用户名/VIP号查询"
    },
    on: {
      "input": function($event) {
        return _vm.realDateA(_vm.orderNOC)
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-90px"
    },
    attrs: {
      "label": "运单号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "输入运单号查询"
    },
    on: {
      "input": function($event) {
        return _vm.realDateB(_vm.orderNOD)
      }
    },
    model: {
      value: (_vm.orderNOD),
      callback: function($$v) {
        _vm.orderNOD = $$v
      },
      expression: "orderNOD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入订单编号查询"
    },
    model: {
      value: (_vm.orderNOB),
      callback: function($$v) {
        _vm.orderNOB = $$v
      },
      expression: "orderNOB"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "70px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          attrs: {
            "align": "center"
          }
        }, [_vm._v(_vm._s(scope.row.productName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "productNum",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库位",
      "prop": "shelves",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库时间",
      "prop": "storeTime",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联运单号",
      "prop": "orderNo",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.expressNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联订单编号",
      "prop": "orderNo",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "ss",
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row.orderNo)
            }
          }
        }, [_vm._v("\n            " + _vm._s(scope.row.orderNo) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "100px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户VIP号",
      "prop": "vipCode",
      "min-width": "100px",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showG,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showG", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认改变该合箱状态嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmC()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showG = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wrl-hedaNa"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("下单时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户电话：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户vip：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.expressNo))]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text",
      "data-clipboard-text": _vm.orderInfo.expressNo
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n            待入库\n          ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已出库\n          ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n            已结单\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("合箱状态：")]), _vm._v(" "), _c('div', {
    staticClass: "bt"
  }, [(_vm.orderInfo.isBox == 1) ? _c('div', [_c('span', [_vm._v("合箱")])]) : _c('div', [_c('span', {
    staticClass: "red",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("不合箱")])])]), _vm._v(" "), _c('div', {
    staticClass: "bt",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.getorderNoB(_vm.orderInfo.orderNo, _vm.orderInfo.isBox)
      }
    }
  }, [_vm._v("修改")])], 1)]), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("入库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.storeTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 3) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("出库时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.deliveryTime))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际尺寸：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productSize) + " CBM")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("实际重量：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.productWeight) + " KG")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', [_vm._v("最后费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单备注：")]), _vm._v(" "), (_vm.orderInfo.remark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.remark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status >= 2) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("用户备注：")]), _vm._v(" "), (_vm.orderInfo.userRemark) ? _c('div', [_vm._v(_vm._s(_vm.orderInfo.userRemark))]) : _c('div', [_vm._v("无")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.status == 1) ? _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("预估费用：")]), _vm._v(" "), _c('div', [_vm._v("CAD " + _vm._s(_vm._f("priceFilt")(_vm.orderInfo.total)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrl-productList"
  }, [_c('div', [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "wrl-border"
  }), _vm._v(" "), _vm._l((_vm.orderInfo.productList), function(val, i) {
    return _c('div', {
      key: i,
      staticClass: "wrl-list"
    }, [_c('div', {
      staticClass: "wrl-flex2"
    }, [_c('div', {
      staticClass: "wrl-felx3"
    }, [_vm._v("\n              " + _vm._s(i + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx4",
      staticStyle: {
        "margin-left": "20px"
      }
    }, [_c('div', {
      staticClass: "ellipsisB",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v("\n                " + _vm._s(val.productName) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx5",
      staticStyle: {
        "display": "flex",
        "margin-top": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_vm._v(_vm._s(val.productNum) + "件")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "1",
        "min-width": "50px"
      }
    }, [_vm._v(_vm._s(val.weight) + "kg")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "2",
        "min-width": "100px"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productLong) + "x" + _vm._s(val.width) + "x" + _vm._s(val.height) + "cm\n                ")]), _vm._v(" "), (val.productRemark) ? _c('div', {
      staticStyle: {
        "flex": "2",
        "color": "#ec808d"
      }
    }, [_vm._v("\n                  " + _vm._s(val.productRemark) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "wrl-felx6 ",
      staticStyle: {
        "margin-left": "0px",
        "min-width": "80px"
      }
    }, [(val.shelves) ? _c('div', {
      staticStyle: {
        "color": "#ec808d"
      }
    }, [_vm._v("\n                货架:  " + _vm._s(val.shelves) + "\n                ")]) : _vm._e()]), _vm._v(" "), (val.productImg) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImg)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImg,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })]), _vm._v(" "), (val.productImgB) ? _c('div', {
      staticClass: "wrl-felx6 cursor",
      on: {
        "click": function($event) {
          return _vm.opBa(val.productImgB)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": val.productImgB,
        "fit": "contain"
      }
    })], 1) : _c('div', {
      staticClass: "wrl-felx6"
    }, [_c('div', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      }
    })])])])
  })], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("合箱编码：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入合箱编号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.inputC()
      }
    },
    model: {
      value: (_vm.boxNumber),
      callback: function($$v) {
        _vm.boxNumber = $$v
      },
      expression: "boxNumber"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近签收订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "stripe": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.detailList[0].productName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "150px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v("\n              海运\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n              海运大件\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n              空运\n            ")]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.deliveryTitle) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n            已入库\n          ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库时间",
      "width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n      " + _vm._s(scope.row.storeTime ? _vm.toDate(scope.row.storeTime, "yyyy-MM-dd hh:mm") : '时间未知') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱编号",
      "min-width": "90px",
      "align": "center",
      "prop": "boxNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货柜号",
      "min-width": "90px",
      "align": "center",
      "prop": "containerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "show-close": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "opened": _vm.openPass,
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递签收\n           ")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合箱编码："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo.boxNumber) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo.vipCodes) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单数量："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderCount) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货物类型："
    }
  }, [(_vm.orderInfo.goodType == 1) ? _c('span', {
    staticClass: "tag"
  }, [_vm._v("\n                    海运\n                  ")]) : (_vm.orderInfo.goodType == 2) ? _c('span', {
    staticClass: "tag tag1"
  }, [_vm._v("\n                    海运大件\n                  ")]) : (_vm.orderInfo.goodType == 3) ? _c('span', {
    staticClass: "tag tag3"
  }, [_vm._v("\n                    空运\n                  ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.deliveryTitle) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('span', {
    staticClass: "tag tag4"
  }, [_vm._v("\n                    未入库\n                  ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.createTime) ? _c('span', [_vm._v(_vm._s(_vm.toDate(_vm.orderInfo && _vm.orderInfo.createTime, "yyyy-MM-dd hh:mm")) + " \n                   "), _c('span', {
    staticClass: "tag tag2"
  }, [_vm._v("\n                     合箱\n                   ")])]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预估费用："
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.total ? _vm.total : '未知') + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货柜号：",
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "align": "center",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left",
      "header-align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }], null, false, 1711087377)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.realName) + "\n                  ")]
      }
    }], null, false, 1044165952)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.vipCode) + "\n                  ")]
      }
    }], null, false, 4086610335)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键签收入库，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("签收入库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合箱签收",
      "visible": _vm.isExistMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "left",
      "destroy-on-close": _vm.trueMark
    },
    on: {
      "update:visible": function($event) {
        _vm.isExistMark = $event
      },
      "opened": _vm.openFail,
      "closed": _vm.closed
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n      签收出错，系统无匹配运单。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "audioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isRepeatMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark
    },
    on: {
      "update:visible": function($event) {
        _vm.isRepeatMark = $event
      },
      "opened": _vm.openRepeat
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("\n      合箱签收  (" + _vm._s(_vm.orderNum) + ")\n    ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("签收出错，本箱已被签收")]), _vm._v(" "), _c('div', {
    staticClass: "repeAudioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isPassMark,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isPassMark = $event
      },
      "opened": _vm.openPass
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "passAudioPar"
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "src": "../../../static/audio/rukuSuccess.mp3",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待入库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已出库",
      "name": "4"
    }
  })], 1), _vm._v(" "), (_vm.activeName != 8) ? _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "运单号/订单号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderNo", $$v)
      },
      expression: "search.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户名/vip号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.userName),
      callback: function($$v) {
        _vm.$set(_vm.search, "userName", $$v)
      },
      expression: "search.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "placeholder": "订单号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.orderNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderNumber", $$v)
      },
      expression: "search.orderNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "签收状态"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }],
    attrs: {
      "label": "出库时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "clearable": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.chukuTime)
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.chukuTime),
      callback: function($$v) {
        _vm.chukuTime = $$v
      },
      expression: "chukuTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("导出Excel\n              ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bookTip = true
      }
    }
  }, [_vm._v("开放预约\n              ")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == '4'),
      expression: "activeName == '4'"
    }]
  }, [_c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  总运费:"), _c('span', [_vm._v(_vm._s(_vm.totalFee))])])]), _vm._v(" "), _c('button', {
    staticClass: "totalFeeBtn"
  }, [_c('div', {
    staticClass: "totalFee"
  }, [_vm._v("\n                  用户人数:"), _c('span', [_vm._v(_vm._s(_vm.totalNum))])])])])], 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "height": "380",
      "stripe": "",
      "id": "printTable",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderSend) ? _c('span', {
          staticClass: "tag tag2"
        }, [_vm._v("已生成")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.productName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodName",
      "width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.deliveryTitle) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.batchNumber) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积",
      "prop": "productVolume",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量",
      "prop": "productWeight",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "尺寸",
      "prop": "measure",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n            待入库\n          ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            已入库\n          ")]) : (scope.row.status == 3) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已出库\n          ")]) : (scope.row.status == 4) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            已结单\n          ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n            已取消\n          ")]) : (scope.row.status == 7) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （中心仓）已入库\n          ")]) : (scope.row.status == 8) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n            （中心仓）已出库\n          ")]) : (scope.row.status == 9) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n            （派送）已入库\n          ")]) : (scope.row.status == 10) ? _c('div', {
          staticStyle: {
            "color": "#ffa500"
          }
        }, [_vm._v("\n            可预约\n          ")]) : (scope.row.status == 11) ? _c('div', {
          staticStyle: {
            "color": "#008000"
          }
        }, [_vm._v("\n            已预约\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费",
      "min-width": "70px",
      "align": "center",
      "prop": "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("priceFilt")(scope.row.total)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单费（CAD）",
      "min-width": "140px",
      "align": "center",
      "prop": "demandMoney"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送费(CAD)",
      "min-width": "140px",
      "align": "center",
      "prop": "deliveryAmount"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用（CAD）",
      "min-width": "160px",
      "align": "center",
      "prop": "extraPrice"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "额外费用备注",
      "min-width": "140px",
      "align": "center",
      "prop": "extraPriceRemark"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入库时间",
      "width": "100px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.format(scope.row.deliveryTime)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "width": "100px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱编号",
      "min-width": "90px",
      "align": "center",
      "prop": "boxNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货柜号",
      "min-width": "90px",
      "align": "center",
      "prop": "containerName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "90px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 9 ||
          scope.row.status == 10 ||
          scope.row.status == 11
        ) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHandler(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), (_vm.activeName == 9 && _vm.accountObj.roleId == 1) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [(_vm.viewDialog.orderInfo.sendNo) ? _c('span', {
    staticClass: "l_label"
  }, [_vm._v("发货单号：")]) : (_vm.viewDialog.orderInfo.orderNo) ? _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单号：")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.sendNo ?
    _vm.viewDialog.orderInfo.sendNo :
    _vm.viewDialog.orderInfo.orderNo))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("VIP号：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.user.vipCode ? _vm.user.vipCode : _vm.viewDialog.orderInfo.vipCode))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.user.realName ? _vm.user.realName : _vm.viewDialog.orderInfo.realName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value",
    staticStyle: {
      "color": "#20b2aa"
    }
  }, [_vm._v("已入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("入库时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.deliveryEnterTime ?
    _vm.toDate(
      _vm.viewDialog.orderInfo.deliveryEnterTime,
      "yyyy-MM-dd hh:mm:ss"
    ) :
    _vm.toDate(
      _vm.viewDialog.orderInfo.operatorTime,
      "yyyy-MM-dd hh:mm:ss"
    )))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.orderInfo.orderCount ?
    _vm.viewDialog.orderInfo.orderCount :
    _vm.viewDialog.orderInfo.detailList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总运费：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.totalFreight : 0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总工单费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ?
    _vm.viewDialog.orderInfo.totalWorkOrderFee :
    0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.extraPrice : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("所需总费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.orderInfo ? _vm.viewDialog.orderInfo.totalCost : 0))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("账户余额：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            "), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v(_vm._s(_vm.user.balance ? _vm.user.balance : _vm.viewDialog.orderInfo.balance))])])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "align": "center",
      "label": "物品"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.expressNo ?
          scope.row.expressNo :
          _vm.viewDialog.orderInfo.expressNo) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productNum",
      "align": "center",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货运类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.goodType ?
          _vm.goodTypeName(scope.row.goodType) :
          _vm.goodTypeName(_vm.viewDialog.orderInfo.goodType)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "用户"
    }
  }, [_c('div', [_vm._v("\n                " + _vm._s(_vm.user.realName ?
    _vm.user.realName :
    _vm.viewDialog.orderInfo.realName) + "\n              ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "运费（CAD）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.total ?
          scope.row.total :
          _vm.viewDialog.orderInfo.total) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "demandMoney",
      "align": "center",
      "label": "工费（CAD）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.demandMoney ?
          scope.row.demandMoney :
          _vm.viewDialog.orderInfo.totalWorkOrderFee) + "\n              ")]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-popconfirm', {
    attrs: {
      "title": "您确定结算吗？"
    },
    on: {
      "confirm": _vm.submit,
      "onConfirm": _vm.submit
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    slot: "reference"
  }, [_vm._v("确定结算")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.bookTip,
      "width": "400px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.bookTip = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.setReservation
          }
        }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
          on: {
            "click": function($event) {
              _vm.bookTip = false
            }
          }
        }, [_vm._v("取 消")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("确定确认吗？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("\n      点击确定将会将已入库但未提醒的订单打开预约通道\n    ")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_contaner"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单号：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("下单时间：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.toDate(_vm.detailDialog.orderInfo.addTime, "yyyy-MM-dd hh:mm:ss")))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户名称：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户电话：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userTel))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("客户vip：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("快递公司：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.expressCompany))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("商品价值：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.predictTotal))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _vm._v(" "), _c('span', {
    class: 'l_value status' + _vm.detailDialog.orderInfo.status
  }, [_vm._v(_vm._s(_vm.orderStatus(_vm.detailDialog.orderInfo.status)))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("箱编号：")]), _vm._v(" "), _c('span', {
    staticClass: "'l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.boxNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('span', {
    staticClass: "'l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.containerName))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("入库时间：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.storeTime ?
    _vm.toDate(
      _vm.detailDialog.orderInfo.storeTime,
      "yyyy-MM-dd hh:mm:ss"
    ) :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("实际尺寸：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.productLong) + "CM*" + _vm._s(_vm.detailDialog.orderInfo.width) + "CM*" + _vm._s(_vm.detailDialog.orderInfo.height) + "CM")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("实际重量：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.productWeight) + " KG")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("运费：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.orderInfo.total))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("工单费（CAD）：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.demandMoney))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送费(CAD)：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.deliveryAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用(CAD)：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.extraPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("额外费用备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.feeInfo.extraPriceRemark))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("最后总费用：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD " + _vm._s(_vm.detailDialog.orderInfo.totalPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.remark))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户备注：")]), _vm._v(" "), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.orderInfo.userRemark))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "productNum",
      "width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productNum) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货架",
      "prop": "shelves",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.shelves) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "prop": "pic",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pic) ? _c('div', _vm._l((scope.row.pic.split(',')), function(item, index) {
          return _c('a', {
            key: index,
            attrs: {
              "href": _vm.detailDialog.orderInfo.httpUrl + item,
              "target": "_blank"
            }
          }, [_c('img', {
            staticClass: "d_pic",
            attrs: {
              "src": _vm.detailDialog.orderInfo.httpUrl + item
            }
          })])
        }), 0) : _vm._e()]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.mianDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": (_vm.mianDialog.width + 160) + 'px',
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.mianDialog, "show", $event)
      },
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "order_main3",
    style: ({
      width: _vm.mianDialog.width + 'px'
    }),
    attrs: {
      "id": "printContent"
    }
  }, _vm._l((_vm.boxId), function(pobj, pIndex) {
    return _c('div', {
      key: pIndex,
      staticClass: "every",
      staticStyle: {
        "height": "350px",
        "margin-bottom": "93px"
      }
    }, [_c('div', {
      staticClass: "order_header"
    }, [_c('img', {
      staticClass: "code_img",
      attrs: {
        "src": pobj.faceImg
      },
      on: {
        "click": _vm.flashPiture
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "grandpa"
    }, [_c('div', {
      staticClass: "parentLeft"
    }, [_c('div', {
      staticClass: "imgBlock"
    }, [_c('img', {
      staticClass: "newCodeImg",
      attrs: {
        "src": pobj.faceImg
      },
      on: {
        "click": _vm.flashPiture
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "parentRight"
    }, [_c('div', {
      staticClass: "deliverBox"
    }, [_c('div', {
      staticClass: "sentenOne"
    }, [_c('span', {
      staticClass: "fontOne"
    }), _c('span', {
      staticClass: "fontTwo"
    })]), _vm._v(" "), _c('div', {
      staticClass: "sentenOne"
    }, [_c('span', {
      staticClass: "fontOne"
    }), _c('span', {
      staticClass: "fontTwo"
    }, [_vm._v(_vm._s(pobj.deliveryTitle))])])]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "order_detail"
    }, [_c('div', {
      staticClass: "product_list"
    }, [(pobj && pobj.orderPojoList && pobj.orderPojoList[0]) ? _c('div', {
      staticClass: "l_item"
    }, [_c('span', {
      staticClass: "l_item_val vipCode"
    }, [_vm._v(_vm._s(pobj.orderPojoList[0].vipCode))]), _vm._v(" "), _c('div', {
      staticClass: "order_count",
      staticStyle: {
        "clear": "both",
        "width": "250px",
        "margin-top": "30px"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin-left": "-40px"
      }
    }, [_vm._v("订单名称：" + _vm._s(_vm.getOrderName(pobj.orderPojoList[0].productName)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "140px"
      }
    }, [_c('span', [_vm._v("　运单号：" + _vm._s(pobj.orderPojoList[0].expressNo))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "120px"
      }
    })]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "margin": "-140px -40px 0 0px"
      }
    }, [_c('h1', {
      staticStyle: {
        "display": "inline-block",
        "margin-top": "-60px",
        "font-size": "80px"
      }
    }, [_vm._v(_vm._s(pobj.isHybrid == 1 ? "混" : ""))]), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "box_footer2"
    }, [_c('div', {
      staticClass: "box_type"
    }), _c('br'), _vm._v(" "), _c('div'), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "order_count",
      staticStyle: {
        "clear": "both"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin-left": "-40px"
      }
    }, [_vm._v("订单数量：" + _vm._s(pobj.orderCount))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', [_vm._v("运输方式：" + _vm._s(_vm.goodType(pobj.goodType)))])])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "parentFooter"
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "print",
      rawName: "v-print",
      value: (_vm.printObj),
      expression: "printObj"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("打 印")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关 闭")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("合箱编码：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入合箱编号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.inputC()
      }
    },
    model: {
      value: (_vm.boxNumber),
      callback: function($$v) {
        _vm.boxNumber = $$v
      },
      expression: "boxNumber"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近签收订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyList,
      "border": "",
      "stripe": "",
      "row-key": "boxId",
      "max-height": "550px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h4', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收时间",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.createTime ?
          _vm.toDate(scope.row.createTime, "yyyy-MM-dd hh:mm") :
          "时间未知") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#008b8b"
    }
  }, [_vm._v("已入库")])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "show-close": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递签收")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合箱编码："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.boxNumber) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.vipCodes) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单数量："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderCount) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货物类型："
    }
  }, [(_vm.orderInfo.goodType == 1) ? _c('span', {
    staticClass: "tag"
  }, [_vm._v(" 海运 ")]) : (_vm.orderInfo.goodType == 2) ? _c('span', {
    staticClass: "tag tag1"
  }, [_vm._v("\n                海运大件\n              ")]) : (_vm.orderInfo.goodType == 3) ? _c('span', {
    staticClass: "tag tag3"
  }, [_vm._v("\n                空运\n              ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "派送点："
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo && _vm.orderInfo.deliveryTitle) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('span', {
    staticClass: "tag tag4"
  }, [_vm._v(" 未入库 ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.createTime) ? _c('span', [_vm._v(_vm._s(_vm.toDate(
    _vm.orderInfo && _vm.orderInfo.createTime,
    "yyyy-MM-dd hh:mm"
  )) + "\n                "), _c('span', {
    staticClass: "tag tag2"
  }, [_vm._v(" 合箱 ")])]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "货柜号：",
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.productName) + "\n                      ")]
      }
    }], null, false, 1453014801)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.realName) + "\n                      ")]
      }
    }], null, false, 3257019584)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.vipCode) + "\n                      ")]
      }
    }], null, false, 1338675743)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键签收入库，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("签收入库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "合箱签收",
      "visible": _vm.isExistMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "left",
      "destroy-on-close": _vm.trueMark
    },
    on: {
      "update:visible": function($event) {
        _vm.isExistMark = $event
      },
      "opened": _vm.openFail,
      "closed": _vm.closed
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n      签收出错，系统无匹配运单。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "audioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isExistMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isRepeatMark,
      "width": "30%",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.reHandleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.isRepeatMark = $event
      },
      "opened": _vm.openRepeat
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("\n      合箱签收  (" + _vm._s(_vm.orderNum) + ")\n    ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#a30014",
      "font-size": "24px"
    }
  }, [_vm._v("签收出错，本箱已被签收")]), _vm._v(" "), _c('div', {
    staticClass: "repeAudioPar"
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isRepeatMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isPassMark,
      "width": "0px",
      "height": "0px",
      "modal": _vm.falseMark,
      "modal-append-to-body": false,
      "align": "center",
      "destroy-on-close": _vm.trueMark,
      "before-close": _vm.succHandleClose,
      "show-close": false,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isPassMark = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('audio', {
    attrs: {
      "src": "../../../static/audio/rukuSuccess.mp3",
      "autoplay": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.isPassMark = false
      }
    }
  }, [_vm._v("确 定")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 预约订单")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', [_vm._v("发货单号:\n         "), _c('el-input', {
    attrs: {
      "placeholder": "输入发货单号",
      "clearable": ""
    },
    on: {
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("用户名/ViP号:\n         "), _c('el-input', {
    attrs: {
      "placeholder": "输入用户名/vip号查询",
      "clearable": ""
    },
    on: {
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("批次:\n\n         "), _c('el-select', {
    staticStyle: {
      "width": "255px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.batchNum),
      callback: function($$v) {
        _vm.batchNum = $$v
      },
      expression: "batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("货物类型:\n         "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": _vm.cancelSearch
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getAppointList('1')
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('span', [_vm._v("派送点：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.deliverAddress),
      callback: function($$v) {
        _vm.deliverAddress = $$v
      },
      expression: "deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2), _vm._v(" "), _c('span', [_c('el-button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getAppointList('select')
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "filterTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mainList,
      "border": "",
      "max-height": "700px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.row.orderCount) + " 个运单 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "客户",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipCode",
      "label": "vip号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodType",
      "label": "货物类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodTypeName(scope.row.goodType)))]) : _vm._e(), _vm._v("\n               " + _vm._s(scope.row.goodName) + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sendNo",
      "label": "发货单号",
      "width": "160px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sendStatus == 4) ? _c('div', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n               已结算\n             ")]) : (scope.row.sendStatus == 10) ? _c('div', {
          staticStyle: {
            "color": "#008b8b"
          }
        }, [_vm._v("\n               可预约\n             ")]) : (scope.row.sendStatus == 11) ? _c('div', {
          staticStyle: {
            "color": "#800080"
          }
        }, [_vm._v("\n               已预约\n             ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "总费用",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("\n               " + _vm._s((_vm.text =
          scope.row.sendNo == null ?
          scope.row.total :
          scope.row.amount)) + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "7",
      "label": "预约时间",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("\n               " + _vm._s(scope.row.appointmentTime ?
          _vm.changeDateCopy(scope.row.appointmentTime, 3) :
          "无时间数据") + "\n             ")]), _vm._v(" "), _c('el-tag', {
          staticStyle: {
            "min-width": "80px"
          },
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n               " + _vm._s(scope.row.start && scope.row.endTime ?
          _vm.itemChangedHM(scope.row.start, scope.row.endTime) :
          "无预约时间") + "\n             ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "prop": "address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n           ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.sendStatus == 10 || scope.row.sendStatus == 11) ? _c('el-button', {
          staticClass: "bt",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showAccountDia(scope.row)
            }
          }
        }, [_vm._v("出库结算")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "bt2",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.showOrder(scope.row)
            }
          }
        }, [_vm._v("订单详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.mulOutStoreToPay()
      }
    }
  }, [_vm._v("批量出库结算")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "出库结算",
      "visible": _vm.accountDia,
      "width": "60%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.accountDia = $event
      }
    }
  }, _vm._l((_vm.accountList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BigBox"
    }, [_c('div', {
      staticClass: "accountDia-content-header"
    }, [_c('div', {
      staticClass: "content-left content-left-text"
    }, [_c('div', [_vm._v("\n             发货单号:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.sendNo) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             预约状态:\n             "), _c('span', {
      staticStyle: {
        "color": "rgb(9, 157, 255)"
      }
    }, [_vm._v(" 已预约 ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-center content-left-text"
    }, [_c('div', [_vm._v("\n             VIP号:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.user.vipCode) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             入库时间:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.operatorTime ?
      _vm.changeDate(item.operatorTime, 4) :
      "无法显示") + "\n             ")])])]), _vm._v(" "), _c('div', {
      staticClass: "content-right content-left-text"
    }, [_c('div', [_vm._v("\n             客户:\n             "), _c('span', [_vm._v("\n               " + _vm._s(item.user.realName) + "\n             ")])]), _vm._v(" "), _c('div', [_vm._v("\n             订单数量: "), _c('span', [_vm._v(_vm._s(item.orderPojoList.length))])])])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         所需总运费："), _c('span', [_vm._v(_vm._s(item.totalFreight))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         所需总工单费用："), _c('span', [_vm._v(_vm._s(item.totalWorkOrderFee))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-center2",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n         额外费用："), _c('span', [_vm._v(_vm._s(item.extraPrice))])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer1",
      staticStyle: {
        "width": "100%",
        "overflow": "hidden"
      }
    }, [_c('div', {
      staticClass: "content-footer-left",
      staticStyle: {
        "width": "36%",
        "float": "left",
        "margin-right": "20px"
      }
    }, [_vm._v("\n           最后总费用："), _c('span', [_vm._v(_vm._s(item.totalCost))]), _vm._v(" CAD\n         ")]), _vm._v(" "), _c('div', {
      staticClass: "content-footer-right",
      staticStyle: {
        "width": "36%",
        "float": "left"
      }
    }, [_vm._v("\n           账户余额：\n           "), _c('span', {
      staticStyle: {
        "color": "#d2691e"
      }
    }, [_vm._v(_vm._s(item.user.balance))]), _vm._v(" CAD\n         ")])]), _vm._v(" "), _c('div', {
      staticClass: "accountDia-content-footer2",
      staticStyle: {
        "width": "100%",
        "margin-top": "30px",
        "text-align": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "width": "46%",
        "font-size": "17px",
        "font-weight": "bolder"
      }
    }, [_vm._v("\n           订单列表\n         ")])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "margin": "25px 0 -20px 0"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "table"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listRow
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "index",
        "label": "#",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productName",
        "align": "center",
        "label": "物品"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "orderNo",
        "label": "运单号",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "productNum",
        "align": "center",
        "label": "数量"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "align": "center",
        "label": "货运类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n               " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n             ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goodType",
        "align": "center",
        "label": "用户"
      }
    }, [_c('div', [_vm._v("\n               " + _vm._s(_vm.accountList[0].user.realName) + "\n             ")])]), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "total",
        "align": "center",
        "label": "运费（CAD）"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "demandMoney",
        "align": "center",
        "label": "工费（CAD）"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "accountDia-footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.settlementBt
      }
    }, [_vm._v("确认结算")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          _vm.accountDia = false
        }
      }
    }, [_vm._v("取 消")])], 1)])
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.listDia,
      "width": "70%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.listDia = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "warningDia-footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.listDia = false
            }
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "diaText"
  }, [_c('div', {
    staticClass: "e_text"
  }, [_vm._v("发货单号：" + _vm._s(_vm.orderMsg.sendNo))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("订单数量：" + _vm._s(_vm.orderMsg.orderCount))]), _vm._v(" "), _c('div', {
    staticClass: "e_text"
  }, [_vm._v("相关用户VIP：" + _vm._s(_vm.user.vipCode))])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "max-height": "300px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "名称",
      "align": "center",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "货物类型",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm.goodTypeName(scope.row.goodType)) + "\n           ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.realName) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "align": "center",
      "width": "120"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.vipCode) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号",
      "align": "center",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价格",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(9, 157, 255)"
    }
  }, [_vm._v(" 已预约 ")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "center",
      "width": "180"
    }
  }, [_vm._v("\n           " + _vm._s(_vm.user.deliveryTitle) + "\n         ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "运费(CAD)",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "下单时间",
      "align": "center",
      "width": "240px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n             " + _vm._s(_vm.changeDate(scope.row.storeTime, 4)) + "\n           ")]
      }
    }])
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1262 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_page"
  }, [_c('transition', {
    attrs: {
      "name": "form-fade",
      "mode": "in-out"
    }
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_c('section', {
    staticClass: "form_contianer loginForm"
  }, [_c('div', {
    staticClass: "manage_tip"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("加阳华枫快运")])]), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "60px"
    },
    attrs: {
      "prop": "userName"
    }
  }, [_c('span', {
    staticClass: "fa-tips"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "area",
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.loginForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "userName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "fa-tips"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "area",
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login('loginForm')
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tiparea"
  }), _vm._v(" "), _c('div', {
    staticClass: "icp-info"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t上海华枫新达供应链有限公司 沪ICP备2025137398号-1\n\t\t\t\t\t\t\t")])])], 1)], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 发货单管理")]), _vm._v(" "), _c('div', {
    staticClass: "monewt",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "wj_flex"
  }, [_c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "138px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入客户VIP号查询"
    },
    on: {
      "input": _vm.vipCodeBlur
    },
    model: {
      value: (_vm.vipCode),
      callback: function($$v) {
        _vm.vipCode = $$v
      },
      expression: "vipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "发货编号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "输入发货编号查询"
    },
    on: {
      "input": _vm.sendNoBlur
    },
    model: {
      value: (_vm.sendNo),
      callback: function($$v) {
        _vm.sendNo = $$v
      },
      expression: "sendNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "出库时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "220px",
      "padding-right": "6px"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "clearable": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.chukuTime)
      }
    },
    model: {
      value: (_vm.chukuTime),
      callback: function($$v) {
        _vm.chukuTime = $$v
      },
      expression: "chukuTime"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "wj_left"
  }, [_c('span', [_vm._v("签收状态：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getStoreList('1')
      }
    },
    model: {
      value: (_vm.checkedRecStatus),
      callback: function($$v) {
        _vm.checkedRecStatus = $$v
      },
      expression: "checkedRecStatus"
    }
  }, _vm._l((_vm.receOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("批次：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "请输入批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.batchNum),
      callback: function($$v) {
        _vm.batchNum = $$v
      },
      expression: "batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1), _vm._v(" "), _c('span', [_vm._v("派送点：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.roleId == 3
    },
    model: {
      value: (_vm.deliverAddress),
      callback: function($$v) {
        _vm.deliverAddress = $$v
      },
      expression: "deliverAddress"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.deliverAddressArr), function(addressObj, aIndex) {
    return _c('el-option', {
      key: aIndex,
      attrs: {
        "label": addressObj.deliveryTitle,
        "value": addressObj.adminId
      }
    })
  })], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getStoreList('1')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcel()
      }
    }
  }, [_vm._v("\n        批量导出Excel\n      ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "发货编号",
      "prop": "sendNo",
      "min-width": "220px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDelivery) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s(scope.row.isDelivery ? "派" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.sendNo) + "\n         \n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货单生成时间",
      "prop": "sendTime",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "prop": "orderCount",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实收费用 CAD",
      "prop": "amount",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "width": "120px",
      "align": "center",
      "prop": "userBalance"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "remark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出库时间",
      "prop": "createTime",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "prop": "isReceipt",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.isReceipt ? "已签收" : "未签收") + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operation",
      "align": "center",
      "label": "操作",
      "fixed": "right",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onLook(scope.row)
            }
          }
        }, [_vm._v("查看")])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "flex": "6"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.onTOEcexlce(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("导出")])])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "840px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "show-header": false,
      "data": _vm.tableData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单名",
      "prop": "productName",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积 CBM",
      "prop": "productSize",
      "min-width": "90px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量 KG",
      "prop": "productWeight",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣率 %",
      "prop": "rate",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.rate !== true) ? _c('span', [_vm._v(_vm._s(scope.row.rate))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用 CAD",
      "prop": "predictTotal",
      "min-width": "120px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "prop": "userBalance",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单备注",
      "prop": "remark",
      "min-width": "220px",
      "align": "center"
    }
  })], 1), _vm._v(" "), (_vm.lookingStatus !== 4 && _vm.lookingStatus < 11 && _vm.isCouldUpdated) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "33px",
      "top": "-46px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateExtraFee
    }
  }, [_vm._v("修改额外费用")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.isUpdateFeeShow,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isUpdateFeeShow = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "float": "left",
      "font-size": "18px"
    }
  }, [_vm._v("额外费用 :")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "200px",
      "margin": "-8px 0 20px 20px"
    },
    attrs: {
      "placeholder": "请输入修改后的费用",
      "autofocus": ""
    },
    model: {
      value: (_vm.feeInput),
      callback: function($$v) {
        _vm.feeInput = $$v
      },
      expression: "feeInput"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "clear": "both",
      "float": "left",
      "padding-bottom": "10px",
      "font-size": "18px"
    }
  }, [_vm._v("\n        备注 :\n      ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "maxlength": "300",
      "show-word-limit": "",
      "clearable": "",
      "resize": "none",
      "rows": "8"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeUpdateDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.certainUpdateDialog
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 财务账号")]), _vm._v(" "), _c('el-button', {
    staticClass: "addBt",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addBt
    }
  }, [_vm._v("添 加")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.accountList,
      "border": "",
      "max-height": "600px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "accountName",
      "label": "收款账号名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contacts",
      "label": "负责人名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tel",
      "align": "center",
      "label": "负责人电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editBt(scope.row)
            }
          }
        }, [_vm._v("\n          编辑\n         ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.title ? '编 辑' : '添 加',
      "visible": _vm.dialog,
      "width": "35%",
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      },
      "close": _vm.closeD
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('span', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialog = false
            }
          }
        }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.comfirmBt
          }
        }, [_vm._v("确 定")])], 1)]
      },
      proxy: true
    }])
  }, [_c('el-form', {
    ref: "RuleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收款账号名称",
      "prop": "accountName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.accountName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "accountName", $$v)
      },
      expression: "ruleForm.accountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号负责人",
      "prop": "contacts"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.contacts),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contacts", $$v)
      },
      expression: "ruleForm.contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人电话",
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "tel", $$v)
      },
      expression: "ruleForm.tel"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 添加 ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.deliveryList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "分拨点",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "详细地址",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "负责人",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.contact) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.tel) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联账户名",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), [_c('el-button', {
          staticStyle: {
            "color": "red"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteData(scope.row.addressId)
            }
          }
        }, [_vm._v("删除")])]]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.editDialog.show,
      "title": _vm.editDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editDialog.data,
      "rules": _vm.editDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.step == 3) ? _c('div', {
    staticClass: "first"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "contact",
      "label": "负责人姓名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人姓名"
    },
    model: {
      value: (_vm.editDialog.data.contact),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "contact", $$v)
      },
      expression: "editDialog.data.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "负责人电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入负责人电话",
      "maxlength": "20"
    },
    model: {
      value: (_vm.editDialog.data.tel),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "tel", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "deliveryTitle",
      "label": "分拨点："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入分拨地址",
      "minlength": "128"
    },
    model: {
      value: (_vm.editDialog.data.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "deliveryTitle", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.deliveryTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "address",
      "label": "详细地址："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入分拨点详细地址",
      "minlength": "300"
    },
    model: {
      value: (_vm.editDialog.data.address),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "contactPhoto",
      "label": "负责人照片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "http-request": _vm.handleLicenseImgFile,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.editDialog.data.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.process.env.IMG_URL + _vm.editDialog.data.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 3) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2) ? _c('div', {
    staticClass: "second"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "userName",
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.editDialog.data.userName),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "userName", $$v)
      },
      expression: "editDialog.data.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "label": "用户密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入用户密码",
      "maxlength": "32"
    },
    model: {
      value: (_vm.editDialog.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editDialog.data, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "editDialog.data.password"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.editDialog.step == 1 || _vm.editDialog.data.addressId) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog.show = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 1 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 2
      }
    }
  }, [_vm._v("下一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog.step = 1
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.step == 2 && !_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.editDialog.data.addressId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("\n       | 价格管理\n   ")]), _vm._v(" "), _c('el-form', {
    ref: "search",
    attrs: {
      "model": _vm.price,
      "rules": _vm.price.form_rules,
      "label-position": "left"
    }
  }, [(_vm.editStatus) ? _c('div', {
    staticClass: "wrl-hea"
  }, [_c('div', [_vm._v("\n      当前价格系数：\n      "), _c('span', {
    staticClass: "wrl-font"
  }, [_vm._v("\n          " + _vm._s(_vm.sytemPrice) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "ss"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.edit(_vm.sytemPrice)
      }
    }
  }, [_vm._v("修改")])], 1)]) : _c('div', {
    staticClass: "wrl-hea"
  }, [_c('div', [_vm._v("\n      当前价格系数：\n      \n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "editPrice"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入大于0的数字"
    },
    model: {
      value: (_vm.price.editPrice),
      callback: function($$v) {
        _vm.$set(_vm.price, "editPrice", $$v)
      },
      expression: "price.editPrice"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editB(_vm.price.editPrice)
      }
    }
  }, [_vm._v("确认修改 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editStatus == true
      }
    }
  }, [_vm._v("取消 ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    备注：价格计价公式如下\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n  单个商品：\n")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n    然后取体积和重量二者之间的较大值为单个商品的运费\n")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n   最后，一类物品的运费为单个商品运费 x 商品数量，订单运费为多类物品运费之和\n")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n       按体积算：（长*宽*高 / 6000） * 价格系数\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n        按重量算：千克重量* 价格系数\n  ")])])
}]}

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内待入库",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内入库",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已合箱",
      "name": "6"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "国内出库",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "中心出库",
      "name": "8"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分舵入库",
      "name": "9"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "客户签收",
      "name": "five"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "six"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待补录",
      "name": "seven"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.activeName != 8) ? _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "合箱编码",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "用户VIP号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "vipCode", $$v)
      },
      expression: "search.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "派送点",
      "clearable": ""
    },
    on: {
      "change": _vm.selectAddress,
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "deliveryTitle", $$v)
      },
      expression: "search.deliveryTitle"
    }
  }, _vm._l((_vm.deliverArr), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.deliveryTitle
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "货物类型",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "search_lbl",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("合箱时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.getDate(_vm.value1)
      }
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportToExcelBox()
      }
    }
  }, [_vm._v("导出箱")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportOrderToExcel()
      }
    }
  }, [_vm._v("导出订单")])], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "row-key": "boxId",
      "stripe": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.vipCodes || '').split(',').length > 1) ? _c('span', {
          staticClass: "boxTag"
        }, [_vm._v("\n            " + _vm._s((scope.row.vipCodes || "").split(",").length > 1 ? "混" : "") + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(scope.row.boxNumber) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n            " + _vm._s(scope.row.goodName) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "batchNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left",
      "min-width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', _vm._l((_vm.deliverArr), function(delivalue, indexs) {
          return _c('h5', {
            key: indexs
          }, [_c('h5', [_vm._v("\n                " + _vm._s(delivalue.addressId === scope.row.addressId ?
            delivalue.deliveryTitle :
            "") + "\n              ")])])
        }), 0), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "80px"
    }
  }, [_vm._v("\n        已合箱\n      ")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合箱时间",
      "align": "center",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.toDate(scope.row.createTime, "yyyy-MM-dd hh:mm:ss")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHanlder(scope.row)
            }
          }
        }, [_vm._v("出库")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.cancelBox(scope.row)
            }
          },
          slot: "reference"
        }, [_vm._v("撤销")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.outHanlder(null)
      }
    }
  }, [_vm._v("批量出库")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.multiPrint
    }
  }, [_vm._v("批量打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("X100000001")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("Toronto")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("2021-03-09 12:23:21")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("待入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("预估费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD 19.88")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户VIP号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("A100009")])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("商品入库数据 （每件商品数据）")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list,
      "show-header": false,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.outDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.outDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.outDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.outSubmit()
      }
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (!_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchOutSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.outDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("货物类型：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ?
    _vm.goodType(_vm.detailDialog.boxInfo.goodType) :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("用户VIP号：")]), _c('span', {
    staticClass: "l_value2"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.vipCodes : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v(" "), (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v(_vm._s(_vm.goodType(scope.row.goodType)))]) : _vm._e(), _vm._v("\n                  " + _vm._s(scope.row.goodName) + "\n                ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "width": "80px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "70px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', {
          staticClass: "status1"
        }, [_vm._v("待入库")]) : (scope.row.status == 2) ? _c('span', {
          staticClass: "status2"
        }, [_vm._v("已入库")]) : (scope.row.status == 3) ? _c('span', {
          staticClass: "status3"
        }, [_vm._v("已出库")]) : (scope.row.status == 4) ? _c('span', {
          staticClass: "status4"
        }, [_vm._v("已结单")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "status-1"
        }, [_vm._v("已取消")]) : (scope.row.status == 6) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("已合箱")]) : (scope.row.status == 7) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("(中心仓)已入库")]) : (scope.row.status == 8) ? _c('span', {
          staticClass: "status8"
        }, [_vm._v("(中心仓)已出库")]) : (scope.row.status == 9) ? _c('span', {
          staticClass: "status9"
        }, [_vm._v("(派送)已入库")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(CAD)",
      "prop": "total",
      "width": "95px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "addTime",
      "width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss")) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "100px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), (_vm.mianDialog.show) ? _c('Face', {
    attrs: {
      "boxId": _vm.faceOrderList
    },
    on: {
      "closeFaceDialog": _vm.closeFaceDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1268 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCalss"
  }, [_vm._v("| 创建订单")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "rules": _vm.order.form_rules,
      "label-width": "95px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "flex2"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lineBorder"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vipCode",
      "label": "客户VIP号 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入客户VIP号"
    },
    on: {
      "focus": function($event) {
        return _vm.showDialog()
      }
    },
    model: {
      value: (_vm.order.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.order, "vipCode", $$v)
      },
      expression: "order.vipCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "predictTotal",
      "label": "商品价值 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "整单商品价值,单位元"
    },
    model: {
      value: (_vm.order.predictTotal),
      callback: function($$v) {
        _vm.$set(_vm.order, "predictTotal", $$v)
      },
      expression: "order.predictTotal"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressCompany",
      "label": "快递公司 :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递公司",
      "filterable": ""
    },
    model: {
      value: (_vm.order.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressCompany", $$v)
      },
      expression: "order.expressCompany"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "checkedGoodsType",
      "label": "货运类型 :"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请选择货运类型"
    },
    model: {
      value: (_vm.order.checkedGoodsType),
      callback: function($$v) {
        _vm.$set(_vm.order, "checkedGoodsType", $$v)
      },
      expression: "order.checkedGoodsType"
    }
  }, _vm._l((_vm.goodsType), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "flexLeft"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "快递单号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "请输入快递单号"
    },
    model: {
      value: (_vm.order.expressNo),
      callback: function($$v) {
        _vm.$set(_vm.order, "expressNo", $$v)
      },
      expression: "order.expressNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flexRight"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": "订单备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.order.remark),
      callback: function($$v) {
        _vm.$set(_vm.order, "remark", $$v)
      },
      expression: "order.remark"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex2"
  }, [_c('div', {
    staticClass: "font"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addProduct()
      }
    }
  }, [_vm._v("\n              添加商品")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lineBorder"
  }), _vm._v(" "), _vm._l((_vm.order.detailList), function(value, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "flex3"
    }, [_c('div', [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-55px"
      },
      attrs: {
        "prop": 'detailList.' + index + '.productName',
        "rules": [{
          required: true,
          message: '商品名称不能为空',
          trigger: 'blur',
        } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (value.productName),
        callback: function($$v) {
          _vm.$set(value, "productName", $$v)
        },
        expression: "value.productName"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-left": "-75px"
      },
      attrs: {
        "prop": 'detailList.' + index + '.productNum',
        "rules": [{
            required: true,
            message: '商品数量不能为空',
            trigger: 'blur',
          },
          {
            type: 'number',
            message: '商品数量必须为数字值'
          } ]
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "placeholder": "商品数量"
      },
      model: {
        value: (value.productNum),
        callback: function($$v) {
          _vm.$set(value, "productNum", _vm._n($$v))
        },
        expression: "value.productNum"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "line",
      staticStyle: {
        "margin-left": "25px"
      }
    }, [(_vm.order.detailList.length > 1) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDialog(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)])])
  })], 2)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("提交")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "340px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v("您确定移除该商品信息嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.indexA)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.adminDeleteDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.adminDeleteDialog.showB,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.adminDeleteDialog, "showB", $event)
      }
    }
  }, [_c('div', {
    staticClass: "minWidth"
  }, [_c('el-form', {
    ref: "search_data",
    staticClass: "demo-form-inline search-form",
    attrs: {
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入客户名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWordB),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordB", $$v)
      },
      expression: "searchData.keyWordB"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入昵称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWord", $$v)
      },
      expression: "searchData.keyWord"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入手机号",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomer()
      }
    },
    model: {
      value: (_vm.searchData.keyWordC),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "keyWordC", $$v)
      },
      expression: "searchData.keyWordC"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getCustomer()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-row')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerList,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adminId",
      "label": "序号",
      "align": "center",
      "min-width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getIndex(scope.$index))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n                " + _vm._s(scope.row.nickname) + "\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "真实姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.realName) ? _c('div', [_vm._v(_vm._s(scope.row.realName))]) : _c('div', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrl-flex",
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "wrl-name"
        }, [_vm._v("\n                " + _vm._s(scope.row.mobile) + "\n              ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "VIP号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.seleVipCode(scope.row.vipCode)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "paginationC"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bread.vue": 418,
	"./content.vue": 1212,
	"./headNav.vue": 419,
	"./home.vue": 52,
	"./leftMenu.vue": 420,
	"./route.vue": 1213
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1311;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": 283,
	"./components/face.vue": 284,
	"./delivery/book.vue": 1214,
	"./delivery/config.vue": 1215,
	"./delivery/deliveryList.vue": 421,
	"./delivery/dispatchList.vue": 422,
	"./delivery/fastIn.vue": 423,
	"./delivery/list.vue": 424,
	"./delivery/newCustomer.vue": 425,
	"./delivery/order.vue": 426,
	"./delivery/orderList.vue": 427,
	"./demo.vue": 428,
	"./distribution/fastInStorage.vue": 429,
	"./distribution/list.vue": 430,
	"./distribution/order.vue": 431,
	"./distribution/outStorage.vue": 432,
	"./face.vue": 433,
	"./freightage/houserAddress.vue": 434,
	"./freightage/priceContort.vue": 435,
	"./freightage/priceGoods.vue": 436,
	"./login.vue": 437,
	"./order/addOrder.vue": 438,
	"./order/boxOrderList.vue": 439,
	"./order/checkExpress.vue": 440,
	"./order/dispatchList.vue": 441,
	"./order/orderList.vue": 442,
	"./personnel/addEditComponent.vue": 443,
	"./personnel/adminList.vue": 444,
	"./personnel/announcement.vue": 445,
	"./personnel/customerList.vue": 446,
	"./recharge/account.vue": 447,
	"./recharge/adjust.vue": 448,
	"./recharge/charge.vue": 449,
	"./recharge/flows.vue": 450,
	"./recharge/rate.vue": 451,
	"./repertory/goOutList.vue": 452,
	"./repertory/repertoryList.vue": 453,
	"./statistical/cost.vue": 454,
	"./statistical/runningWater.vue": 1216,
	"./statistical/wayBill.vue": 455,
	"./system/agree.vue": 456,
	"./system/notice.vue": 457,
	"./transport/list.vue": 458,
	"./workOrder/workOrderList.vue": 459,
	"./workOrder/workOrderRemark.vue": 460
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1312;

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[588]);


// WEBPACK FOOTER //
// static/js/app.b7354d78e8eecc367c21.js